export default {
    "ar": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "هل أنت متأكد من رغبتك في حذف هذا المستخدم نهائياً؟ إذا إخترت المتابعة سيتم ظهور خطأ في أي مكان يتعلق برقم ID هذا المستخدم.تابع بحذر وعلى مسؤوليتك الكاملة. لايمكن إستعادة المستخدم مرة أخرى إذا إخترت المتابعة.",
                        "if_confirmed_off": "(إذا كان خيار التفعيل مفعلاً في الإعدادات)",
                        "restore_user_confirm": "إستعادة هذا المستخدم إلى حالته الأصلية؟"
                    }
                },
                "dashboard": {
                    "title": "لوحة تحكم الإدارة",
                    "welcome": "أهلاً وسهلاً"
                },
                "general": {
                    "all_rights_reserved": "جميع الحقوق محفوظة.",
                    "are_you_sure": "هل أنت متأكد؟",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "متابعة",
                    "member_since": "عضو منذ",
                    "minutes": " minutes",
                    "search_placeholder": "بحث...",
                    "timeout": "You were automatically logged out for security reasons since you had no activity in ",
                    "see_all": {
                        "messages": "رؤية جميع الرسائل",
                        "notifications": "عرض الكل",
                        "tasks": "عرض جميع المهمات"
                    },
                    "status": {
                        "online": "موجود",
                        "offline": "غير موجود"
                    },
                    "you_have": {
                        "messages": "{0} ليس لديك أي رسائل ::: {1} لديك رسالة واحدة ::: {2} لديك رسالتان ::: [3,10] لديك {number} رسائل ::: [11,inf] لديك {number} رسالة",
                        "notifications": "{0} ليس لديك أي إشعارات ::: {1} لديك إشعار واحد ::: {2} لديك إشعاران ::: [3,10] لديك {number} إشعارات ::: [11,inf] لديك {number} إشعاراً",
                        "tasks": "{0} ليس لديك أي مهمات ::: {1} لديك مهمة واحدة ::: {2} لديك مهمتان ::: [3,10] لديك {number} مهمات ::: [11,inf] لديك {number} مهمة"
                    }
                },
                "search": {
                    "empty": "Please enter a search term.",
                    "incomplete": "You must write your own search logic for this system.",
                    "title": "Search Results",
                    "results": "Search Results for {query}"
                },
                "welcome": "<p>هذا هو ثيم CoreUI المصمم من قبل <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. هذه مجرد نسخة جردت من الكثير من الأشياء وتركت فقط ال Styles وال Scripts التي تجعلها تعمل بأقل الإمكانيات. يجب عليك تحميل النسخة الكاملة حتى تستطيع إضافة المكونات للوحة تحكمك.\n</p>\n<p>جميع الإمكانيات المتوافرة هنا هي للعرض فقط بإستثناء <strong>إدارة المستخدمين</strong> المتواجدة على اليمين و <strong>عارض السجلات</strong> الموجودة بالأسفل. هذا النمط يأتي مع مكتبة وظيفية بالكامل للتحكم في الوصول إلى إدارة المستخدمين / الأدوار / الصلاحيات.</p>\n<p>ضع في الإعتبار أن العمل لا يزال مستمراً وقد تتواجد بعض المشاكل أو الأخطاء التي لم تصادفنا. سأقوم بكل جهدي لإصلاحها حالما أتوصل إليها.</p>\n<p>أتمنى أن تستمع بالمجهود الذي بذلته في هذا العمل. الرجاء زيارة صفحة <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> للمزيد من المعلومات أو <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">الإبلاغ عن الأخطاء أو المشاكل</a>.</p>\n<p><strong>هذا المشروع من الصعب عليه جدا مواكبة المعدل الذي يتغير عليه فرع Laravel الرئيسي، لذلك أي مساعدة سوف تكون محل تقدير.</strong></p>\n<p>- أنتوني ربّا</p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Whoops!",
                    "greeting": "Hello!",
                    "regards": "Regards,",
                    "trouble_clicking_button": "If you’re having trouble clicking the \"{action_text}\" button, copy and paste the URL below into your web browser:",
                    "thank_you_for_using_app": "Thank you for using our application!",
                    "password_reset_subject": "رابط إعادة تعيين كلمة المرور",
                    "password_cause_of_email": "You are receiving this email because we received a password reset request for your account.",
                    "password_if_not_requested": "If you did not request a password reset, no further action is required.",
                    "reset_password": "إضغط هنا لإعادة تعيين كلمة مرورك",
                    "click_to_confirm": "إضغط هنا لتفعيل account:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "تجربة",
                "tests": {
                    "based_on": {
                        "permission": "صلاحية بناء ًعلى - ",
                        "role": "دور بناء ًعلى - "
                    },
                    "js_injected_from_controller": "Javascript Injected from a Controller",
                    "using_blade_extensions": "إستخدام Blade Extensions",
                    "using_access_helper": {
                        "array_permissions": "Using Access Helper with Array of Permission Names or ID's where the user does have to possess all.",
                        "array_permissions_not": "Using Access Helper with Array of Permission Names or ID's where the user does not have to possess all.",
                        "array_roles": "Using Access Helper with Array of Role Names or ID's where the user does have to possess all.",
                        "array_roles_not": "Using Access Helper with Array of Role Names or ID's where the user does not have to possess all.",
                        "permission_id": "Using Access Helper with Permission ID",
                        "permission_name": "Using Access Helper with Permission Name",
                        "role_id": "Using Access Helper with Role ID",
                        "role_name": "Using Access Helper with Role Name"
                    },
                    "view_console_it_works": "View console, you should see 'it works!' which is coming from FrontendController@index",
                    "you_can_see_because": "أنت ترى هذا لأن لديك دور '{role}'!",
                    "you_can_see_because_permission": "أنت ترى هذا لإن لديك صلاحية '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "تم تحديث الملف الشخصي بنجاح.",
                    "password_updated": "تم تحديث كلمة المرور بنجاح."
                },
                "welcome_to": "مرحبا بك في {place}"
            }
        },
        "auth": {
            "failed": "البيانات المدخلة لا تتطابق مع قاعدة بيناتنا.",
            "general_error": "ليس لديك صلاحية الوصول إلى هذا.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} ليس نوع تسجيل دخول صحيح."
            },
            "throttle": "ثانية من محاولات تسجيل الدخول الفاشلة، برجاء المحاولة مرة أخرى بعد {seconds} seconds.",
            "unknown": "لقد حدث خطأ غير معروف."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "إدارة المستخدمين",
                    "roles": {
                        "all": "جميع الأدوار",
                        "create": "إنشاء دور جديد",
                        "edit": "تعديل دور",
                        "management": "إدارة الأدوار",
                        "main": "أدوار المتسخدمين"
                    },
                    "users": {
                        "all": "جميع المستخدمين",
                        "change-password": "تغيير كلمة السر",
                        "create": "إنشاء مستخدم جديد",
                        "deactivated": "المستخدمون المعطلون",
                        "deleted": "المستخدمون المحذفون",
                        "edit": "تعديل مستخدم",
                        "main": "المستخدمين",
                        "view": "View User"
                    }
                },
                "log-viewer": {
                    "main": "عارض السجلات",
                    "dashboard": "اللوحة الرئيسية",
                    "logs": "السجلات"
                },
                "sidebar": {
                    "dashboard": "اللوحة الرئيسية",
                    "general": "عام",
                    "system": "System"
                }
            },
            "language-picker": {
                "language": "اللغة",
                "langs": {
                    "ar": "العربية (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "الدنماركية (Danish)",
                    "de": "الألمانية (German)",
                    "el": "(Greek)",
                    "en": "الإنجليزية (English)",
                    "es": "الأسبانية (Spanish)",
                    "fa": "الفارسیة (Persian)",
                    "fr": "الفرنسية (French)",
                    "he": "العبرية (Hebrew)",
                    "id": "الأندونيسية (Indonesian)",
                    "it": "الإيطالية (Italian)",
                    "ja": "(Japanese)",
                    "nl": "هولندي (Dutch)",
                    "no": "(Norwegian)",
                    "pt_BR": "البرازيلية البرتغالية (Brazilian Portuguese)",
                    "ru": "(Russian) الروسية",
                    "sv": "السويسرية (Swedish)",
                    "th": "(Thai)",
                    "tr": "اللغة التركية(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "تفعيل",
                        "change_password": "تغيير كلمة المرور",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "تعطيل",
                        "delete_permanently": "حذف نهائي",
                        "login_as": "تسجيل الدخول كـ {user}",
                        "resend_email": "إعادة إرسالة بريد التفعيل",
                        "restore_user": "إستعادة المستخدم",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Confirm Account",
                    "reset_password": "Reset Password"
                }
            },
            "general": {
                "cancel": "إلغاء",
                "continue": "Continue",
                "crud": {
                    "create": "إنشاء",
                    "delete": "حذف",
                    "edit": "تعديل",
                    "update": "تحديث",
                    "view": "View"
                },
                "save": "حفظ",
                "view": "عرض"
            }
        },
        "passwords": {
            "password": "كلمة المرور يجب أن تحتوي على 6 أحرف على الأقل وتطابق التأكيد.",
            "reset": "لقد تم إعادة تعيين كلمة مرورك!",
            "sent": "قمنا بإرسال رابط إعادة تعيين كلمة مرورك إلى بريدك الإلكتروني!",
            "token": "رمز إعادة تعيين كلمة المرور هذا غير صالح.",
            "user": "لم نستطع إيجاد مستخدم ينتمي إليه هذا البريد الإلكتروني."
        },
        "http": {
            "404": {
                "title": "صفحة غير متوفرة",
                "description": "نعتذر ولكن الصفحة المطلوبة غير موجودة."
            },
            "503": {
                "title": "سنعود قريبا.",
                "description": "سنعود قريبا."
            }
        },
        "labels": {
            "general": {
                "all": "الكل",
                "yes": "نعم",
                "no": "لا",
                "custom": "مخصص",
                "actions": "إجراءات",
                "active": "Active",
                "buttons": {
                    "save": "حفظ",
                    "update": "تحديث"
                },
                "hide": "إخفاء",
                "inactive": "Inactive",
                "none": "لا شيء",
                "show": "إظاهر",
                "toggle_navigation": "تبديل شريط التنقل"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "إنشاء دور جديد",
                        "edit": "تعديل دور",
                        "management": "إدارة الأدوار",
                        "table": {
                            "number_of_users": "عدد المستخدمين",
                            "permissions": "الصلاحيات",
                            "role": "الدور",
                            "sort": "الترتيب",
                            "total": "مجموع الدور ::: مجموع الأدوار"
                        }
                    },
                    "users": {
                        "active": "المستخدمون النشطون",
                        "all_permissions": "جميع الصلاحيات",
                        "change_password": "تغيير كلمة المرور",
                        "change_password_for": "تغيير كلمة المرور للمستخدم {user}",
                        "create": "إنشاء مستخدم جديد",
                        "deactivated": "المستخدمون المعطلون",
                        "deleted": "المستخدمون المحذوفون",
                        "edit": "تعديل المستخدم",
                        "management": "إدارة المستخدمين",
                        "no_permissions": "بدون صلاحيات",
                        "no_roles": "بدون أي أدوار.",
                        "permissions": "صلاحيات",
                        "table": {
                            "confirmed": "مؤكد",
                            "created": "تم الإنشاء",
                            "email": "البريد الإلكتروني",
                            "id": "ID",
                            "last_updated": "آخر تحديث",
                            "name": "الإسم",
                            "no_deactivated": "لا يوجد أي مستخدمين معطلين",
                            "no_deleted": "لا يوحد أي مستخدمين محذوفين",
                            "roles": "الأدوار",
                            "social": "Social",
                            "total": "مجموع المستخدم ::: مجموع المستخدمين"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overview",
                                "history": "History"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmed",
                                    "created_at": "Created At",
                                    "deleted_at": "Deleted At",
                                    "email": "E-mail",
                                    "last_updated": "Last Updated",
                                    "name": "Name",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "View User"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "تسجيل الدخول",
                    "login_button": "تسجيل الدخول",
                    "login_with": "تسجيل الدخول بواسطة {social_media}",
                    "register_box_title": "تسجيل",
                    "register_button": "تسجيل",
                    "remember_me": "تذكرني"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "نسيت كلمة مرورك؟",
                    "reset_password_box_title": "إعادة تعيين كلمة المرور",
                    "reset_password_button": "إعادة تعيين كلمة المرور",
                    "send_password_reset_link_button": "إرسال رابط إعادة تعيين كلمة المرور"
                },
                "user": {
                    "passwords": {
                        "change": "تغيير كلمة المرور"
                    },
                    "profile": {
                        "avatar": "الصورة الشخصية",
                        "created_at": "تم الإنشاء في",
                        "edit_information": "تعديل البيانات",
                        "email": "البريد الإلكتروني",
                        "last_updated": "آخر تحديث تم في",
                        "name": "الإسم",
                        "update_information": "تحديث البيانات"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": ".لقد تم إضافة الدور الجديد بنجاح",
                    "deleted": "لقد تم مسح الدور بنجاح.",
                    "updated": "تم تعديل الدور بنجاح."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "لقد تم إرسال رسالة تأكيد جديدة إلى عنوان البريد الألكتروني الموجود في الملف الشخصي.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "لقد تم إنشاء المستخدم الجديد بنجاح.",
                    "deleted": "لقد تم إزالة المستخدم بنجاح.",
                    "deleted_permanently": "لقد تم حذف المستخدم نهائيا بنجاح.",
                    "restored": "لقد تمت استعادة المستخدم بنجاح.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "لقد تم تعديل المستخدم بنجاح.",
                    "updated_password": "لقد تم تعديل كلمة مرور المستخدم بنجاح."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "يجب قبول الحقل {attribute}",
            "active_url": "الحقل {attribute} لا يُمثّل رابطًا صحيحًا",
            "after": "يجب على الحقل {attribute} أن يكون تاريخًا لاحقًا للتاريخ {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "يجب أن لا يحتوي الحقل {attribute} سوى على حروف",
            "alpha_dash": "يجب أن لا يحتوي الحقل {attribute} على حروف، أرقام ومطّات.",
            "alpha_num": "يجب أن يحتوي {attribute} على حروفٍ وأرقامٍ فقط",
            "array": "يجب أن يكون الحقل {attribute} ًمصفوفة",
            "before": "يجب على الحقل {attribute} أن يكون تاريخًا سابقًا للتاريخ {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "يجب أن تكون قيمة {attribute} محصورة ما بين {min} و {max}.",
                "file": "يجب أن يكون حجم الملف {attribute} محصورًا ما بين {min} و {max} كيلوبايت.",
                "string": "يجب أن يكون عدد حروف النّص {attribute} محصورًا ما بين {min} و {max}",
                "array": "يجب أن يحتوي {attribute} على عدد من العناصر محصورًا ما بين {min} و {max}"
            },
            "boolean": "يجب أن تكون قيمة الحقل {attribute} إما true أو false ",
            "confirmed": "حقل التأكيد غير مُطابق للحقل {attribute}",
            "date": "الحقل {attribute} ليس تاريخًا صحيحًا",
            "date_format": "لا يتوافق الحقل {attribute} مع الشكل {format}.",
            "different": "يجب أن يكون الحقلان {attribute} و {other} مُختلفان",
            "digits": "يجب أن يحتوي الحقل {attribute} على {digits} رقمًا/أرقام",
            "digits_between": "يجب أن يحتوي الحقل {attribute} ما بين {min} و {max} رقمًا/أرقام ",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "للحقل {attribute} قيمة مُكرّرة.",
            "email": "يجب أن يكون {attribute} عنوان بريد إلكتروني صحيح البُنية",
            "exists": "الحقل {attribute} لاغٍ",
            "file": "The {attribute} must be a file.",
            "filled": "الحقل {attribute} إجباري",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "يجب أن يكون الحقل {attribute} صورةً",
            "in": "الحقل {attribute} لاغٍ",
            "in_array": "الحقل {attribute} غير موجود في {other}.",
            "integer": "يجب أن يكون الحقل {attribute} عددًا صحيحًا",
            "ip": "يجب أن يكون الحقل {attribute} عنوان IP ذي بُنية صحيحة",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "يجب أن يكون الحقل {attribute} نصآ من نوع JSON.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "يجب أن تكون قيمة الحقل {attribute} أصغر من {max}.",
                "file": "يجب أن يكون حجم الملف {attribute} أصغر من {max} كيلوبايت",
                "string": "يجب أن لا يتجاوز طول النّص {attribute} {max} حروفٍ/حرفًا",
                "array": "يجب أن لا يحتوي الحقل {attribute} على أكثر من {max} عناصر/عنصر."
            },
            "mimes": "يجب أن يكون الحقل ملفًا من نوع : {values}.",
            "min": {
                "numeric": "يجب أن تكون قيمة الحقل {attribute} أكبر من {min}.",
                "file": "يجب أن يكون حجم الملف {attribute} أكبر من {min} كيلوبايت",
                "string": "يجب أن يكون طول النص {attribute} أكبر من {min} حروفٍ/حرفًا",
                "array": "يجب أن يحتوي الحقل {attribute} على الأقل على {min} عُنصرًا/عناصر"
            },
            "not_in": "الحقل {attribute} لاغٍ",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "يجب على الحقل {attribute} أن يكون رقمًا",
            "present": "The {attribute} field must be present.",
            "regex": "صيغة الحقل {attribute} .غير صحيحة",
            "required": "الحقل {attribute} مطلوب.",
            "required_if": "الحقل {attribute} مطلوب في حال ما إذا كان {other} يساوي {value}.",
            "required_unless": "الحقل {attribute} مطلوب في حال ما لم يكن {other} يساوي {values}.",
            "required_with": "الحقل {attribute} إذا توفّر {values}.",
            "required_with_all": "الحقل {attribute} إذا توفّر {values}.",
            "required_without": "الحقل {attribute} إذا لم يتوفّر {values}.",
            "required_without_all": "الحقل {attribute} إذا لم يتوفّر {values}.",
            "same": "يجب أن يتطابق الحقل {attribute} مع {other}",
            "size": {
                "numeric": "يجب أن تكون قيمة {attribute} أكبر من {size}.",
                "file": "يجب أن يكون حجم الملف {attribute} أكبر من {size} كيلو بايت.",
                "string": "يجب أن يحتوي النص {attribute} عن ما لا يقل عن  {size} حرفٍ/أحرف.",
                "array": "يجب أن يحتوي الحقل {attribute} عن ما لا يقل عن{min} عنصرٍ/عناصر"
            },
            "string": "يجب أن يكون الحقل {attribute} نصآ.",
            "timezone": "يجب أن يكون {attribute} نطاقًا زمنيًا صحيحًا",
            "unique": "قيمة الحقل {attribute} مُستخدمة من قبل",
            "url": "صيغة الرابط {attribute} غير صحيحة",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "الأدوار المرفقة",
                            "dependencies": "المتعلقات",
                            "display_name": "إسم العرض",
                            "group": "المجموعة",
                            "group_sort": "ترتيب المجموعة",
                            "groups": {
                                "name": "إسم المجموعة"
                            },
                            "name": "الإسم",
                            "system": "نظام؟"
                        },
                        "roles": {
                            "associated_permissions": "الصلاحيات المرفقة",
                            "name": "الإسم",
                            "sort": "الترتيب"
                        },
                        "users": {
                            "active": "مفعل",
                            "associated_roles": "الأدوار المرفقة",
                            "confirmed": "مؤكد",
                            "email": "عنوان البريد الإلكتروني",
                            "name": "الإسم",
                            "other_permissions": "الصلاحيات الأخرى",
                            "password": "كلمة المرور",
                            "password_confirmation": "تأكيد كلمة المرور",
                            "send_confirmation_email": "إرسال رسالة التفعيل"
                        }
                    }
                },
                "frontend": {
                    "email": "عنوان البريد الإلكتروني",
                    "name": "الإسم",
                    "password": "كلمة المرور",
                    "password_confirmation": "تأكيد كلمة المرور",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "كلمة المرور القديمة",
                    "new_password": "كلمة المرور الجديدة",
                    "new_password_confirmation": "تأكيد كلمة المرور الجديدة"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "هذا الدور موجود مسبقا. برجاء إختيار إسم آخر.",
                        "cant_delete_admin": "لا يمكنك إزالة دور الإداري.",
                        "create_error": "حدثت مشكلة أثناء إنشاء الدور، برجاء المحاولة مرة أخرى.",
                        "delete_error": "حدثت مشكلة أثناء مسح الدور، برجاء إعادة المحاولة مرى أخرى.",
                        "has_users": "لا يمكنك مسح هذا الدور وهناك مستخدمين مرتبطين به.",
                        "needs_permission": "يجب عليك على الأقل إختيار صلاحية واحدة لهذا الدور.",
                        "not_found": "هذا الدور غير موجود.",
                        "update_error": "هناك مشكلة في تحديث هذا الدور، برجاء المحاولة مرة أخرى."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "لا يمكنك فعل هذا بنفسك.",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "لا يمكنك مسح نفسك.",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "cant_restore": "This user is not deleted so it can not be restored.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "حدثت مشكلة أثناء إنشاء المستخدم، برجاء المحاولة مرة أخرى.",
                        "delete_error": "حدثت مشكلة أثناء مسح المستخدم، برجاء المحاولة مرى أخرى .",
                        "delete_first": "This user must be deleted first before it can be destroyed permanently.",
                        "email_error": "هذا البريد الإلكتروني ينتمي إلا مستخدم آخر.",
                        "mark_error": "حدثت مشكلة أثناء تحديث هذا المستخدم، برجاء المحاولة مرى أخرى.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "هذا المستخدم غير موجود.",
                        "restore_error": "حدثت مشكلة أثناء إستعادة المستخدم، برجاء المحاولة مرة أخرى",
                        "role_needed_create": "يجب عليك اختيار دور واحد.",
                        "role_needed": "يجب عليك إختيار دور واحد على الأقل.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "حدثت مشكلة أثناء تحديث المستخدم، برجاء المحاولة مرة أخرى.",
                        "update_password_error": "حدثت مشكلة أثناء تغيير كلمة مرور المستخدم، برجاء المحاولة مرة أخرى."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "حسابك مفعل بالفعل.",
                        "confirm": "برجاء القيام بتفعيل حسابك!",
                        "created_confirm": "لقد تم إنشاء حسابك بنجاح. لقد تم إرسال بريد التفعيل إلى بريدك الإلكتروني.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "كود التفعيل هذا غير متطابق!",
                        "not_found": "كود التفعيل هذا غير موجود!",
                        "pending": "Your account is currently pending approval.",
                        "resend": "حسابك غير مفعل. برجاء الضغط على رابط التفعيل الذي تم إرساله إلى بريدك الإلكتروني, أو <a href=\"{url}\">إضغط هنا</a> لإعادة إرسال رابط التفعيل مجددا.",
                        "success": "تم تفعيل حسابك بنجاح!",
                        "resent": "تم إرسال رابط التفعيل مجددا إلى عنوان بريدك الإلكتروني الموجود في حسابك."
                    },
                    "deactivated": "لقد تم تعطيل حسابك.",
                    "email_taken": "هذا البريد الإلكتروني موجود مسبقا.",
                    "password": {
                        "change_mismatch": "هذه ليست كلمة مرورك القديمة.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; السابق",
            "next": "التالي &raquo;"
        },
        "roles": {
            "administrator": "مدير",
            "user": "مستخدم"
        },
        "navs": {
            "general": {
                "home": "الرئيسية",
                "logout": "تسجيل خروج"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "لوحة التحكم",
                "login": "تسجيل دخول",
                "macros": "ماكرو",
                "register": "تسجيل",
                "user": {
                    "account": "My Account",
                    "administration": "الإدارة",
                    "change_password": "تغيير كلمة المرور",
                    "my_information": "بياناتي",
                    "profile": "Profile"
                }
            }
        }
    },
    "da": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Er du sikker på at du vil slette denne bruger permanent? Alle steder hvor denne bruger er refereret vil sandsynligvis give en fejl. Fortsæt på eget ansvar. Denne handling kan ikke fortrydes.",
                        "if_confirmed_off": "(Hvis bekræftelse er slået fra)",
                        "restore_user_confirm": "Genskab brugeren til dens oprindelige tilstand?"
                    }
                },
                "dashboard": {
                    "title": "Administrativ betjeningspanel",
                    "welcome": "Velkommen"
                },
                "general": {
                    "all_rights_reserved": "Alle rettigheder forbeholdes.",
                    "are_you_sure": "Er du sikker?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Fortsæt",
                    "member_since": "Medlem siden",
                    "minutes": " minutter",
                    "search_placeholder": "Søg...",
                    "timeout": "Du er af sikkerhedsmæssige årsager blevet logget ud automatisk, da du ikke har været aktiv i ",
                    "see_all": {
                        "messages": "Se alle beskeder",
                        "notifications": "Vis alle",
                        "tasks": "Vis alle opgaver"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} Du har ingen beskeder ::: {1} Du hare 1 besked ::: [2,Inf] Du har {number} beskeder",
                        "notifications": "{0} Du har ingen notifikationer ::: {1} Du har 1 notifikation ::: [2,Inf] Du har {number} notifikationer",
                        "tasks": "{0} Du har ingen opgaver ::: {1} Du har 1 opgave ::: [2,Inf] Du har {number} opgaver"
                    }
                },
                "search": {
                    "empty": "Please enter a search term.",
                    "incomplete": "You must write your own search logic for this system.",
                    "title": "Search Results",
                    "results": "Search Results for {query}"
                },
                "welcome": "<p>Dette er temaet CoreUI som er udviklet af <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. Dette er en skrabet udgave med kun det nødvendige design og kode for at få det hele til at fungere. Download den fulde version for at tilføje flere komponenter til dit betjeningspanel.</p>\n<p>Alle funktionaliteter er blot til fremvisning med undtagelse af <strong>Brugeradministrationen</strong> til venstre. Denne opsætning indeholder derfor en fuld funktionel adgangskontrol til at administrere brugere/roller/rettigheder.</p>\n<p>Vær opmærksom på at dette er et videregående projekt og der kan derfor forekomme fejl eller andre problemer, som jeg ikke er stødt på endnu. Jeg vil gøre mit bedste for at rette dem når jeg modtager dem.</p>\n<p>Håber at du er glad for indsatsen jeg har givet dette projekt. Du er velkommen til at besøge os på <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> for mere information og du kan samtidig med indberette <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">fejl her</a>.</p>\n<p><strong>Dette projekt er rimelig omfattende at vedligeholde med de mange opdateringer Laravel indfører i deres master branch, så alle former for hjælp er værdsat.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Whoops!",
                    "greeting": "Hello!",
                    "regards": "Regards,",
                    "trouble_clicking_button": "If you’re having trouble clicking the \"{action_text}\" button, copy and paste the URL below into your web browser:",
                    "thank_you_for_using_app": "Thank you for using our application!",
                    "password_reset_subject": "Dit link til at nulstille adgangskoden",
                    "password_cause_of_email": "You are receiving this email because we received a password reset request for your account.",
                    "password_if_not_requested": "If you did not request a password reset, no further action is required.",
                    "reset_password": "Klik her for at nulstille din adgangskode",
                    "click_to_confirm": "Klik her for at bekræfte din konto:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Rettighedsbaseret - ",
                        "role": "Rollebasseret - "
                    },
                    "js_injected_from_controller": "Javascript indsat fra en Controller",
                    "using_blade_extensions": "Anvender Blade-udvidelser",
                    "using_access_helper": {
                        "array_permissions": "Anvender 'Acess Helper' med en liste af rettighedsnavne eller rettighedsid'er hvor brugeren skal opfylde alle rettigheder.",
                        "array_permissions_not": "Anvender 'Access Helper' med en liste af rettighedsnavne eller id'er hvor brugeren ikke behøver at opfylde alle rettigheder.",
                        "array_roles": "Anvender 'Access Helper' med en liste af rollenavne eller rolleid'er hvor brugeren skal opfylde alle rettigheder.",
                        "array_roles_not": "Anvender 'Access Helper' med en liste af rollenavne eller rolleid'er hvor brugeren ikke behøver at opfylde alle rettigheder.",
                        "permission_id": "Anvender 'Access Helper' med rettighedsid",
                        "permission_name": "Anvender 'Access Helper' med rettighedsnavn",
                        "role_id": "Anvender 'Access Helper' med rolleid",
                        "role_name": "Anvender 'Access Helper' med rollenavn"
                    },
                    "view_console_it_works": "Vis konsol og du burde kunne se 'it works!', som kommer fra FrontendController@index",
                    "you_can_see_because": "Du kan se dette fordi du har rollen '{role}'!",
                    "you_can_see_because_permission": "Du kan se dette fordi du har rettigheden '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "Profil opdateret.",
                    "password_updated": "Adgangskode opdateret."
                },
                "welcome_to": "Velkommen til {place}"
            }
        },
        "auth": {
            "failed": "Disse legitimationsoplysninger passer ikke vores optegnelser.",
            "general_error": "Du har ikke adgang til at udføre denne handling.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} kan ikke anvendes som login."
            },
            "throttle": "For mange mislykkede forsøg. Prøv igen om {seconds} sekunder.",
            "unknown": "Der opstod en ukendt fejl."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Adgangsadministration",
                    "roles": {
                        "all": "Alle Roller",
                        "create": "Opret Rolle",
                        "edit": "Rediger Rolle",
                        "management": "Rolleadministration",
                        "main": "Roller"
                    },
                    "users": {
                        "all": "Alle Brugere",
                        "change-password": "Skift Adgangskode",
                        "create": "Opret Bruger",
                        "deactivated": "Deaktiverede Brugere",
                        "deleted": "Slet Bruger",
                        "edit": "Rediger Bruger",
                        "main": "Brugere",
                        "view": "View User"
                    }
                },
                "log-viewer": {
                    "main": "Logbog",
                    "dashboard": "Dashboard",
                    "logs": "Logbog"
                },
                "sidebar": {
                    "dashboard": "Betjeningspanel",
                    "general": "Generelt",
                    "system": "System"
                }
            },
            "language-picker": {
                "language": "Sprog",
                "langs": {
                    "ar": "Arabisk (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Dansk (Danish)",
                    "de": "Tysk (German)",
                    "el": "(Greek)",
                    "en": "Engelsk (English)",
                    "es": "Spansk (Spanish)",
                    "fa": "Persisk (Persian)",
                    "fr": "Fransk (French)",
                    "he": "Hebraisk (Hebrew)",
                    "id": "Indonesisk (Indonesian)",
                    "it": "Italiensk (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Hollandsk (Dutch)",
                    "no": "Noors (Norwegian)",
                    "pt_BR": "Brasiliansk portugisisk (Brazilian Portuguese)",
                    "ru": "Russisk (Russian)",
                    "sv": "Svensk (Swedish)",
                    "th": "(Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Aktivér",
                        "change_password": "Skift adgangskode",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "Deaktiver",
                        "delete_permanently": "Slet permanent",
                        "login_as": "Log ind som {user}",
                        "resend_email": "Gensend bekræftelsesmail",
                        "restore_user": "Genskab bruger",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Confirm Account",
                    "reset_password": "Reset Password"
                }
            },
            "general": {
                "cancel": "Fortryd",
                "continue": "Continue",
                "crud": {
                    "create": "Opret",
                    "delete": "Slet",
                    "edit": "Rediger",
                    "update": "Opdater",
                    "view": "View"
                },
                "save": "Gem",
                "view": "Vis"
            }
        },
        "passwords": {
            "password": "Adgangskoder skal være mindst seks tegn og matche bekræftelsen.",
            "reset": "Din adgangskode er blevet nulstillet!",
            "sent": "Vi har sendt dig et link til at nulstille din adgangskode!",
            "token": "Dette link til at nulstille din adgangskode er ugyldig.",
            "user": "Vi kan ikke finde en bruger med denne e-mailadresse."
        },
        "http": {
            "404": {
                "title": "Siden findes ikke",
                "description": "Beklager, men siden, du forsøgte at se, findes ikke."
            },
            "503": {
                "title": "Er snart tilbage.",
                "description": "Er snart tilbage."
            }
        },
        "labels": {
            "general": {
                "all": "Alle",
                "yes": "Ja",
                "no": "Nej",
                "custom": "Brugerdefineret",
                "actions": "Handlinger",
                "active": "Active",
                "buttons": {
                    "save": "Gem",
                    "update": "Opdater"
                },
                "hide": "Skjul",
                "inactive": "Inactive",
                "none": "Ingen",
                "show": "Vis",
                "toggle_navigation": "Navigation"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Opret Rolle",
                        "edit": "Opdater Rolle",
                        "management": "Rolleadministration",
                        "table": {
                            "number_of_users": "Antal Brugere",
                            "permissions": "Rettigheder",
                            "role": "Rolle",
                            "sort": "Sortér",
                            "total": "rolle i alt ::: roller i alt"
                        }
                    },
                    "users": {
                        "active": "Aktive Brugere",
                        "all_permissions": "Alle Rettigheder",
                        "change_password": "Skift Adgangskode",
                        "change_password_for": "Skift Adgangskode for {user}",
                        "create": "Opret Bruger",
                        "deactivated": "Deaktiverde Brugere",
                        "deleted": "Slettede Brugere",
                        "edit": "Rediger Bruger",
                        "management": "Brugeradministration",
                        "no_permissions": "Ingen Rettigheder",
                        "no_roles": "Ingen Rolle valgt.",
                        "permissions": "Rettigheder",
                        "table": {
                            "confirmed": "Bekræftet",
                            "created": "Oprettet",
                            "email": "Email",
                            "id": "Id",
                            "last_updated": "Sidst Opdateret",
                            "name": "Navn",
                            "no_deactivated": "Ingen Deaktiverede Brugere",
                            "no_deleted": "Ingen Slettede Brugere",
                            "roles": "Roller",
                            "social": "Social",
                            "total": "bruger i alt ::: brugere i alt"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overview",
                                "history": "History"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmed",
                                    "created_at": "Created At",
                                    "deleted_at": "Deleted At",
                                    "email": "E-mail",
                                    "last_updated": "Last Updated",
                                    "name": "Name",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "View User"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Log ind",
                    "login_button": "Log ind",
                    "login_with": "Log ind med {social_media}",
                    "register_box_title": "Opret",
                    "register_button": "Opret",
                    "remember_me": "Husk mig"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Glemt din adgangskode?",
                    "reset_password_box_title": "Nulstil adgangskode",
                    "reset_password_button": "Nulstil adgangskode",
                    "send_password_reset_link_button": "Send link til at nulstille adgangskoden"
                },
                "user": {
                    "passwords": {
                        "change": "Skift adgangskode"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Oprettet den",
                        "edit_information": "Rediger information",
                        "email": "Email",
                        "last_updated": "Sidst opdateret",
                        "name": "Navn",
                        "update_information": "Opdater information"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Rollen blev oprettet.",
                    "deleted": "Rollen blev slettet.",
                    "updated": "Rollen blev opdateret."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "En ny bekræftelsesmail er blevet sendt til adressen for brugeren.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "Brugeren blev oprettet.",
                    "deleted": "Brugeren blev slettet.",
                    "deleted_permanently": "Brugeren blev slettet permanent.",
                    "restored": "Brugeren blev genskabt.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "Brugeren blev opdateret.",
                    "updated_password": "Brugerens adgangskode blev opdateret."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} skal accepteres.",
            "active_url": "{attribute} er ikke en gyldig adresse.",
            "after": "{attribute} skal være en dato efter {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "{attribute} må kun indeholde bogstaver.",
            "alpha_dash": "{attribute} må kun indeholde bogstaver, tal og mellemstreger.",
            "alpha_num": "{attribute} må kun indeholde bogstaver og tal.",
            "array": "{attribute} skal være en liste.",
            "before": "{attribute} skal være en dato før {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "{attribute} skal være mellem {min} og {max}.",
                "file": "{attribute} skal være mellem {min} og {max} kilobytes.",
                "string": "{attribute} skal være mellem {min} og {max} tegn.",
                "array": "{attribute} skal have mellem {min} og {max} elementer."
            },
            "boolean": "{attribute} skal være sandt eller falsk.",
            "confirmed": "{attribute} bekræftelse passer ikke sammen.",
            "date": "{attribute} er ikke en gyldig dato.",
            "date_format": "{attribute} passer ikke til formatet {format}.",
            "different": "{attribute} og {other} skal være forskellige.",
            "digits": "{attribute} skal være på {digits} cifre.",
            "digits_between": "{attribute} skal være mellem {min} og {max} cifre.",
            "dimensions": "{attribute} har ugyldige dimensioner.",
            "distinct": "{attribute} skal være unik.",
            "email": "{attribute} skal være en gyldig e-mailaddresse.",
            "exists": "{attribute} findes ikke.",
            "file": "{attribute} skal være en fil.",
            "filled": "{attribute} skal udfyldes.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} skal være et billed.",
            "in": "{attribute} er ikke gyldig.",
            "in_array": "{attribute} findes ikke i {other}.",
            "integer": "{attribute} skal være et heltal.",
            "ip": "{attribute} skal være en gyldig IP-adresse.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "{attribute} skal være gyldig JSON format.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} må ikke være større end {max}.",
                "file": "{attribute} må ikke være større end {max} kilobytes.",
                "string": "{attribute} må ikke være længere end {max} tegn.",
                "array": "{attribute} må ikke have flere end {max} elementer."
            },
            "mimes": "{attribute} skal være filtypen: {values}.",
            "min": {
                "numeric": "{attribute} skal være mindst {min}.",
                "file": "{attribute} skal være mindst {min} kilobytes.",
                "string": "{attribute} skal mindts være {min} tegn.",
                "array": "{attribute} skal have mindst {min} elementer."
            },
            "not_in": "{attribute} er ikke gyldig.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} skal være et tal.",
            "present": "Feltet {attribute} mangler.",
            "regex": "{attribute} er ikke et gyldigt format.",
            "required": "{attribute} er påkrævet.",
            "required_if": "{attribute} er påkrævet når {other} er {value}.",
            "required_unless": "{attribute} er påkrævet med mindre {other} er {values}.",
            "required_with": "{attribute} er påkrævet når {values} er tilgængelig.",
            "required_with_all": "{attribute} er påkrævet når {values} er tilgængelig.",
            "required_without": "{attribute} er påkrævet når {values} ikke er tilgængelig.",
            "required_without_all": "{attribute} er påkrævet når ingen af værdierne {values} er tilgængelig.",
            "same": "{attribute} og {other} skal være ens.",
            "size": {
                "numeric": "{attribute} skal være {size}.",
                "file": "{attribute} skal være {size} kilobytes.",
                "string": "{attribute} skal have {size} tegn.",
                "array": "{attribute} skal indeholde {size} elementer."
            },
            "string": "{attribute} skal være tekst.",
            "timezone": "{attribute} skal være en gyldig tidszone.",
            "unique": "{attribute} er allerede i brug.",
            "url": "{attribute} er ikke i det rigtige format.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Tilknyttede Roller",
                            "dependencies": "Afhængigheder",
                            "display_name": "Visningsnavn",
                            "group": "Gruppe",
                            "group_sort": "Gruppesortering",
                            "groups": {
                                "name": "Gruppenavn"
                            },
                            "name": "Navn",
                            "system": "System?"
                        },
                        "roles": {
                            "associated_permissions": "Tilknyttede Rettigheder",
                            "name": "Navn",
                            "sort": "Sortér"
                        },
                        "users": {
                            "active": "Aktiv",
                            "associated_roles": "Tilknyttede Roller",
                            "confirmed": "Bekræftet",
                            "email": "E-mailadresse",
                            "name": "Navn",
                            "other_permissions": "Andre Rettigheder",
                            "password": "Adgangskode",
                            "password_confirmation": "Bekræft adgangskode",
                            "send_confirmation_email": "Send bekræfelsesmail"
                        }
                    }
                },
                "frontend": {
                    "email": "E-mailadresse",
                    "name": "Navn",
                    "password": "Adgangskode",
                    "password_confirmation": "Bekræft adgangskode",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "Gammel adgangskode",
                    "new_password": "Ny adgangskode",
                    "new_password_confirmation": "Bekræft ny adgangskode"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Rolle findes allerede. Vælg et andet navn.",
                        "cant_delete_admin": "Du kan ikke slette rollen \"Administrator\".",
                        "create_error": "Der opstod et problem ved oprettelse af denne rolle. Prøv venligst igen.",
                        "delete_error": "Der opstod et problem ved sletning af denne rolle. Prøv venligst igen.",
                        "has_users": "Du kan ikke slette en rolle med tilhørende brugere.",
                        "needs_permission": "Du skal vælge mindst én tilladelse til denne rolle.",
                        "not_found": "Denne rolle findes ikke.",
                        "update_error": "Der opstod et problem ved opdatering af denne rolle. Prøv venligst igen."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_deactivate_self": "Du kan ikke udføre denne handling på dig selv.",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "Du kan ikke slette dig selv.",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "create_error": "Der opstod et problem ved oprettelsen af denne bruger. Prøv venligst igen.",
                        "delete_error": "Der opstod et problem ved sletning af denne bruger. Prøv venligst igen.",
                        "delete_first": "This user must be deleted first before it can be destroyed permanently.",
                        "email_error": "Denne e-mailadresse tilhører en anden bruger.",
                        "mark_error": "Der opstod et problem ved opdatering af denne bruger. Prøv venligst igen.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "Denne bruger eksisterer ikke.",
                        "restore_error": "Der opstod et problem ved genskabelse af denne bruger. Prøv venligst igen.",
                        "role_needed_create": "Du skal vælge mindst én rolle.",
                        "role_needed": "Du skal vælge mindst én rolle.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "Der opstod et problem ved opdatering af denne bruger. Prøv venligst igen.",
                        "update_password_error": "Der opstod et problem ved ændring af brugerens adgangskode. Prøv venligst igen."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Din konto er allerede bekræftet.",
                        "confirm": "Bekræft din konto!",
                        "created_confirm": "Din konto blev oprettet. Vi har sendt dig en email for at bekræfte din konto.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Din bekræftelseskode matcher ikke.",
                        "not_found": "Denne bekræftelseskode findes ikke.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Din konto er ikke bekræftet. Klik på linket i bekræftelsesmailen eller <a href=\"{url}\">klik her</a> for at gensende bekræftelsesmailen.",
                        "success": "Din konto er blevet bekræftet!",
                        "resent": "En ny bekræftelsesmail er blevet sendt til den kendte e-mailadresse."
                    },
                    "deactivated": "Din konto er blevet deaktiveret.",
                    "email_taken": "Denne e-mailadresse er allerede i brug.",
                    "password": {
                        "change_mismatch": "Dette er ikke din gamle adgangskode.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Forrige",
            "next": "Næste &raquo;"
        },
        "roles": {
            "administrator": "Administrator",
            "user": "Bruger"
        },
        "navs": {
            "general": {
                "home": "Hjem",
                "logout": "Log ud"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Betjeningspanel",
                "login": "Log ind",
                "macros": "Makroer",
                "register": "Opret",
                "user": {
                    "account": "My Account",
                    "administration": "Administration",
                    "change_password": "Skift adgangskode",
                    "my_information": "Min information",
                    "profile": "Profile"
                }
            }
        }
    },
    "de": {
        "strings": {
            "backend": {
                "course": {
                    "installment_type": {
                        "none": "Keine Raten",
                        "fixed_3": "3 Raten (6-wöchentlich)",
                        "allowed": "Normale Ratenzahlung"
                    }
                },
                "access": {
                    "users": {
                        "delete_user_confirm": "Bist du dir sicher, dass du diesen Benutzer permanent löschen möchtest? Überall wo die Benutzer-ID referenziert ist, wird es höchstwahrscheinlich zu Fehlern kommen. Fortfahren auf eigenes Risiko. Dies kann nicht rückgängig gemacht werden.",
                        "if_confirmed_off": "(Wenn nicht bestätigt)",
                        "no_deactivated": "Es gibt keine inaktiven Nutzer.",
                        "no_deleted": "Es gibt keine gelöschten Nutzer.",
                        "restore_user_confirm": "Benutzer in den Originalzustand wiederherstellen?"
                    }
                },
                "countries": {
                    "germany": "Deutschland",
                    "switzerland": "Schweiz"
                },
                "dashboard": {
                    "title": "Administratives Dashboard",
                    "welcome": "Willkommen"
                },
                "general": {
                    "all_rights_reserved": "Alle Rechte vorbehalten.",
                    "are_you_sure": "Bist du dir sicher?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Fortsetzen",
                    "member_since": "Mitglied seit",
                    "minutes": " Minuten",
                    "search_placeholder": "Suchen...",
                    "timeout": "Du wurdest aus Sicherheitsgründen automatisch abgemeldet weil du inaktiv warst seit ",
                    "see_all": {
                        "messages": "Alle Nachrichten anzeigen",
                        "notifications": "Alle anzeigen",
                        "tasks": "Alle Aufgaben anzeigen"
                    },
                    "status": {
                        "online": "Angemeldet",
                        "offline": "Abgemeldet"
                    },
                    "you_have": {
                        "messages": "{0} Du hast keine Nachrichten ::: {1} Du hast 1 Nachricht ::: [2,Inf] Du hast {number} Nachrichten",
                        "notifications": "{0} Du hast keine Benachrichtigungen ::: {1} Du hast 1 Benachrichtigung ::: [2,Inf] Du hast {number} Benachrichtigungen",
                        "tasks": "{0} Du hast keine Aufgaben ::: {1} Du hast 1 Aufgabe ::: [2,Inf] Du hast {number} Aufgaben"
                    }
                },
                "search": {
                    "empty": "Bitte gib einen Suchbegriff ein.",
                    "incomplete": "Du musst deinen eigenen Such-Algorithmus für dieses System schreiben.",
                    "title": "Suchergebnisse",
                    "results": "Suchergebnisse für {query}"
                },
                "welcome": "<p>Dies ist das CoreUI theme von <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. Dies ist eine abgestufte Version mit nur den nötigsten Styles und Scripten, damit es läuft. Lade die Vollversion herunter, um Komponenten zum Dashboard hinzufügen zu können.</p>\n<p>Alle Funktionen sind statisch mit Ausnahme der <strong>Benutzer Verwaltung</strong> auf der linken Seite. Dieser Boilerplate kommt mit einer voll funktionsfähigen Zugangskontroll-Bibliothek, um Benutzer/Rollen und Berechtigungen zu verwalten.</p>\n<p>Denken Sie daran, es ist 'work in progress' und möglicherweise gibt es Fehler oder andere Probleme die ich noch nicht gesehen habe. Ich werde mein Bestes tun, um sie zu beheben, sowie sie gemeldet werden.</p>\n<p>Ich hoffe, du geniesst die Arbeit, die ich hier reingesteckt habe. Bitte besuche die <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> Seite für weitere Informationen und meldet alle <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">Fehler hier</a>.</p>\n<p><strong>Es bedeutet für dieses Projekt sehr viel Aufwand, mit dem sich schnell ändernden Hauptzweig von Laravel mitzuhalten, deshalb ist jede Hilfe Willkommen.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Hoppla!",
                    "greeting": "Hallo!",
                    "regards": "Viele Grüße,",
                    "trouble_clicking_button": "Wenn du Probleme hast den \"{action_text}\"-Knopf zu drücken, kopiere die URL unten in deinen Web Browser:",
                    "thank_you_for_using_app": "Danke, dass du diese Anwendung benutzst!",
                    "password_reset_subject": "Dein Link zum Zurücksetzen des Kennworts",
                    "password_cause_of_email": "Du erhältst diese Email weil wir eine Anforderung erhalten haben, das Kennwort für dieses Konto zurückzusetzen.",
                    "password_if_not_requested": "Wenn du keine Zurücksetzung deines Kennworts angefordert hast, ist keine weitere Aktion erforderlich.",
                    "reset_password": "Klick hier, um dein Passwort zurückzusetzen",
                    "click_to_confirm": "Klick hier, um dein Konto zu aktivieren:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                },
                "frontend": {
                    "booking": {
                        "subject": "Ihre Heilpferde-Onlineausbildung Buchung"
                    },
                    "invoice": {
                        "subject": "Ihre Heilpferde-Onlineausbildung Rechnung"
                    }
                },
                "backend": {
                    "subject": "neue Online-Kurs-Buchung"
                }
            },
            "general": {
                "dialog": {
                    "confirm": {
                        "message": "Aktion wirklich durchführen?",
                        "title": "Bestätigung erfolderlich!"
                    }
                }
            },
            "frontend": {
                "yes": "ja",
                "no": "nein",
                "tests": {
                    "based_on": {
                        "permission": "Anhand von Berechtigungen - ",
                        "role": "Anhand von Rollen - "
                    },
                    "js_injected_from_controller": "Javascript von einem Controller eingefügt",
                    "using_blade_extensions": "Verwenden von Blade-Erweiterungen",
                    "using_access_helper": {
                        "array_permissions": "Verwenden von Access Helper mit Array von Berechtigungs-Namen oder ID's bei der der Benutzer alle besitzen muss.",
                        "array_permissions_not": "Verwenden von Access Helper mit Array von Berechtigungs-Namen oder ID's bei der der Benutzer nicht alle besitzen muss.",
                        "array_roles": "Verwenden von Access Helper mit Array von Rollen-Namen oder ID's bei der der Benutzer alle besitzen muss.",
                        "array_roles_not": "Verwenden von Access Helper mit Array von Rolen-Namen oder ID's bei der der Benutzer nicht alle besitzen muss.",
                        "permission_id": "Verwenden von Access Helper mit Berechtigungs-ID",
                        "permission_name": "Verwenden von Access Helper mit Berechtigungs-Name",
                        "role_id": "Verwenden von Access Helper mit Rollen-ID",
                        "role_name": "Verwenden von Access Helper mit Rollen-Name"
                    },
                    "view_console_it_works": "Schaue in die Konsole, du solltest 'it works!' sehen, welches vom FrontendController@index kommt",
                    "you_can_see_because": "Du kannst dies sehen, da du folgende Rolle besitzt '{role}'!",
                    "you_can_see_because_permission": "Du kannst dies sehen, da du folgende Berechtigung besitzt '{permission}'!"
                },
                "general": {
                    "joined": "Joined",
                    "book": "Buchen",
                    "pay": "Jetzt kostenpflichtig bestellen!"
                },
                "checkout": {
                    "header": "Kasse",
                    "method": {
                        "elv": {
                            "title": "Elektronische Lastschrift"
                        },
                        "cc": {
                            "title": "Kreditkarte Visa / Mastercard",
                            "cardtype": "Kartentyp",
                            "cardpan": "Cardpan",
                            "cvc": "CVC",
                            "expire": {
                                "month": "Ablaufmonat",
                                "year": "Ablaufjahr"
                            }
                        },
                        "rec": {
                            "title": "Kauf auf Rechnung"
                        },
                        "vor": {
                            "title": "Vorkasse"
                        },
                        "cod": {
                            "title": "Nachnahme"
                        },
                        "sb": {
                            "title": "Sofortüberweisung / Giropay",
                            "type": {
                                "pnt": {
                                    "title": " Sofortbanking"
                                },
                                "gpy": {
                                    "title": "giropay"
                                },
                                "eps": {
                                    "title": "eps - online transfer"
                                },
                                "pff": {
                                    "title": "PostFinance E-Finance"
                                },
                                "pfc": {
                                    "title": "PostFinance Card"
                                },
                                "idl": {
                                    "title": "Przelewy24"
                                }
                            }
                        },
                        "wlt": {
                            "title": "Paypal / paydirekt"
                        },
                        "fnc": {
                            "title": "Finanzierung"
                        }
                    },
                    "country": {
                        "de": "Deutschland",
                        "at": "Österreich",
                        "ch": "Schweiz",
                        "nl": "Niederlande"
                    },
                    "labels": {
                        "accountOwner": "Kontoinhaber",
                        "iban": "IBAN",
                        "bic": "BIC",
                        "firstname": "Vorname",
                        "lastname": "Nachname"
                    },
                    "placeholders": {
                        "accountOwner": "Vorname Nachname"
                    },
                    "price": "Preis: {price} {currency}",
                    "deposit": "Anzahlung:",
                    "installment": "{installments} Raten a {installment} {currency}",
                    "loan_amount": "Höhe des Darlehens:",
                    "loan_amount_price": "{price} {currency}",
                    "pay": "Jetzt kostenpflichtig bestellen",
                    "totals": {
                        "grandtotal": {
                            "incl": "Gesamtsumme (inkl. MwSt.)",
                            "excl": "Gesamtsumme (exkl. MwSt.)"
                        },
                        "tax": "MwSt.",
                        "processingfee": "Bearbeitungsgebühr"
                    },
                    "feedescription": "Durch Ihre gewählte Raten-Laufzeit entfällt eine Bearbeitungsgebühr von {percent}% auf die Gesamtsumme"
                },
                "user": {
                    "change_email_notice": "Wenn du deine Email-Adresse änderst, wirst du abgemeldet, bis du deine neue Email-Adresse bestätigt hast.",
                    "email_changed_notice": "Du musst deine neue Email-Adresse bestätigen, bevor du dich wieder anmelden kannst.",
                    "profile_updated": "Profil aktualisiert.",
                    "password_updated": "Passwort aktualisiert."
                },
                "dashboard": {
                    "course": {
                        "header": "Derzeit angebotene Kurse"
                    },
                    "taskHeading": "Aktuelle Aufgaben und Nachrichten",
                    "details": "Details"
                },
                "welcome_to": "Wilkommen bei {place}",
                "booking": {
                    "booked_at": "Gebucht am:",
                    "none": "Bisher wurden keine Kurse gebucht.",
                    "paymentstatus": "Bezahlstatus:",
                    "status": {
                        "pending": "ausstehend",
                        "failed": "fehlgeschlagen",
                        "complete": "bezahlt",
                        "canceled": "abgebrochen"
                    }
                },
                "progress": {
                    "current": "Aktuelle Lerneinheit:",
                    "resume": "Zur nächsten Lerneinheit",
                    "progressbar": {
                        "title": "Lerneinheiten absolviert."
                    }
                },
                "course": {
                    "view": "Kurs ansehen",
                    "outline": "Kurs Übersicht",
                    "courses": "Kurse",
                    "disabledNote": "Sie müssen die vorherigen Lerneinheiten abschliessen, bevor Sie diese Lernheiten bearbeiten können",
                    "moduleDescription": "Modul-Beschreibung:",
                    "learningUnits": "Lerneinheiten:",
                    "installment_type": {
                        "none": "Keine Raten",
                        "fixed_3": "3 Raten (6-wöchentlich)",
                        "allowed": "Normale Ratenzahlung"
                    }
                },
                "learningUnit": {
                    "paperApplication": {
                        "instructions": "Bitte tragen sie im folgenden Formular Ihr gewünschtes Theme für Ihre Facharbeit ein. Ein Partner wird Ihren Vorschlag prüfen.",
                        "label": "Themenvorschlag:",
                        "submit": "Abschicken",
                        "currentLabel": "Ihr Vorschlag:",
                        "approved": "Angenommen:"
                    },
                    "next": "Nächste offene Lerneinheit",
                    "video": "Video:",
                    "backToDashboard": "Zurück zum Dashboard",
                    "backToCourse": "Zurück zum Kurs"
                },
                "module": {
                    "outline": "Modul-Übersicht:"
                },
                "test": {
                    "instructions": "Hier könnte Ihre Anleitung stehen!",
                    "view": "Zum Test",
                    "attempt": "Ergebnis zu Versuch {index} ansehen",
                    "passed": "bestanden",
                    "failed": "durchgefallen",
                    "points": "Punkte",
                    "result": "Ergebnis",
                    "grade": "Note",
                    "answeredQuestions": "Fragen richtig beantwortet:"
                },
                "block": {
                    "unauthorized": "Sie sind nicht authorisiert diese Seite zu sehen!",
                    "title": "Diese Seite ist für Sie leider nicht verfügbar",
                    "return": "Zum Dashboard zurückkehren"
                },
                "appointment": {
                    "approved": "Ihr Termin wurde bestätigt.",
                    "notApproved": "Ihr Termin wurde noch nicht bestätigt.",
                    "disapproved": "Ihr Termin wurde abgelehnt, bitte wählen sie einen neuen Termin:"
                }
            }
        },
        "auth": {
            "failed": "Zugangsdaten nicht gefunden.",
            "general_error": "Du hast keine Berechtigung um dies zu machen.",
            "password_used": "Du kannst kein Passwort benutzen, das du schon einmal verwendet hast.",
            "socialite": {
                "unacceptable": "{provider} ist kein akzeptierter Anmeldetyp."
            },
            "throttle": "Zuviele Anmeldeversuche. Bitte warte {seconds} Sekunden.",
            "unknown": "Ein unbekannter Fehler ist aufgetreten"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Zugriffsverwaltung",
                    "roles": {
                        "all": "Alle Rollen",
                        "create": "Rolle erstellen",
                        "edit": "Rolle bearbeiten",
                        "management": "Rollen verwalten",
                        "main": "Rollen"
                    },
                    "users": {
                        "all": "Alle Benutzer",
                        "change-password": "Kennwort ändern",
                        "create": "Benutzer erstellen",
                        "deactivated": "Deaktivierte Benutzer",
                        "deleted": "Gelöschte Benutzer",
                        "edit": "Benutzer bearbeiten",
                        "main": "Benutzer",
                        "view": "Benutzer anzeigen"
                    }
                },
                "content": {
                    "title": "Inhalte",
                    "course": {
                        "management": "Kurse",
                        "edit": "Kurs bearbeiten",
                        "create": "Kurs erstellen"
                    },
                    "module": {
                        "index": "Module",
                        "create": "Modul Erstellen",
                        "edit": "Modul bearbeiten"
                    },
                    "learning_unit": {
                        "index": "Lerneinheiten",
                        "create": "Lerneinheit erstellen",
                        "edit": "Lerneinheit bearbeiten"
                    }
                },
                "booking": {
                    "title": "Buchungen"
                },
                "log-viewer": {
                    "main": "Logbuch",
                    "dashboard": "Dashboard",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Dashboard",
                    "general": "Allgemein",
                    "system": "System",
                    "content": "Inhalte",
                    "booking": "Buchungen",
                    "log": "Logs"
                }
            },
            "language-picker": {
                "language": "Sprache",
                "langs": {
                    "ar": "العربية (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Dänisch (Danish)",
                    "de": "Deutsch (German)",
                    "el": "(Greek)",
                    "en": "Englisch (English)",
                    "es": "Spanisch (Spanish)",
                    "fa": "Persisch (Persian)",
                    "fr": "Französisch (French)",
                    "he": "Hebräisch (Hebrew)",
                    "id": "Indonesisch (Indonesian)",
                    "it": "Italienisch (Italian)",
                    "ja": "Japanisch (Japanese)",
                    "nl": "Niederländisch (Dutch)",
                    "no": "Norwegisch (Norwegian)",
                    "pt_BR": "Brasilianisches Portugiesisch (Brazilian Portuguese)",
                    "ru": "Russisch (Russian)",
                    "sv": "Schwedisch (Swedish)",
                    "th": "(Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Aktivieren",
                        "change_password": "Kennwort Ändern",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "Deaktivieren",
                        "delete_permanently": "Permanent löschen",
                        "login_as": "Anmelden als {user}",
                        "resend_email": "Aktivierungsmail erneut senden",
                        "restore_user": "Benutzer wiederherstellen",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Konto bestätigen",
                    "reset_password": "Kennwort zurücksetzen"
                }
            },
            "general": {
                "cancel": "Abbrechen",
                "continue": "Fortsetzen",
                "crud": {
                    "create": "Erstellen",
                    "delete": "Löschen",
                    "edit": "Bearbeiten",
                    "update": "Aktualisieren",
                    "view": "Anzeigen"
                },
                "import": "Importieren",
                "save": "Speichern",
                "view": "Anzeigen"
            }
        },
        "passwords": {
            "password": "Kennwörter müssen mind. 6 Zeichen haben und gleich der Wiederholung sein.",
            "reset": "Dein Kennwort wurde zurückgesetzt!",
            "sent": "Wir haben dir einen Link zum Zurücksetzen deines Kennworts gesendet!",
            "token": "Der Token zum Zurücksetzen des Kennworts ist ungültig.",
            "user": "Wir können keinen Benutzer mit der E-Mailadresse finden."
        },
        "http": {
            "404": {
                "title": "Seite nicht gefunden",
                "description": "Wir konnten die angegebene Seite nicht finden."
            },
            "503": {
                "title": "Wir sind gleich wieder da.",
                "description": "Wir sind gleich wieder da."
            }
        },
        "labels": {
            "general": {
                "all": "Alle",
                "yes": "Ja",
                "no": "Nein",
                "custom": "Erweitert",
                "actions": "Aktionen",
                "active": "Aktiv",
                "buttons": {
                    "save": "Speichern",
                    "update": "Aktualisieren",
                    "delete": "Löschen"
                },
                "hide": "Verstecken",
                "inactive": "Inaktiv",
                "none": "Keine",
                "show": "Anzeigen",
                "toggle_navigation": "Navigation umschalten"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Rolle erstellen",
                        "edit": "Rolle bearbeiten",
                        "management": "Rollen verwalten",
                        "table": {
                            "number_of_users": "Anzahl Benutzer",
                            "permissions": "Berechtigungen",
                            "role": "Rolle",
                            "sort": "Sortierung",
                            "total": "Rolle ::: Rollen"
                        }
                    },
                    "users": {
                        "active": "Aktive Benutzer",
                        "all_permissions": "Alle Berechtigungen",
                        "change_password": "Kennwort ändern",
                        "change_password_for": "Kennwort für {user} ändern",
                        "create": "Benutzer erstellen",
                        "deactivated": "Deaktivierte Benutzer",
                        "deleted": "Gelöschte Benutzer",
                        "edit": "Benutzer bearbeiten",
                        "management": "Benutzer verwalten",
                        "no_permissions": "Keine Berechtigungen",
                        "no_roles": "Keine Rollen vorhanden.",
                        "permissions": "Berechtigungen",
                        "table": {
                            "confirmed": "Bestätigt",
                            "created": "Erstellt",
                            "email": "E-Mail",
                            "id": "ID",
                            "last_updated": "Letzte Aktualisierung",
                            "name": "Name",
                            "first_name": "Vorname",
                            "last_name": "Nachname",
                            "no_deactivated": "Keine deaktivierten Benutzer",
                            "no_deleted": "Keine gelöschten Benutzer",
                            "other_permissions": "Andere Berechtigungen",
                            "permissions": "Berechtigungen",
                            "roles": "Rollen",
                            "social": "Social",
                            "total": "Benutzer ::: Benutzer"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Übersicht",
                                "history": "Verlauf"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Bestätigt",
                                    "created_at": "Erstellt am",
                                    "deleted_at": "Gelöscht am",
                                    "email": "E-mail",
                                    "last_updated": "Zuletzt aktualisiert",
                                    "name": "Name",
                                    "first_name": "Vorname",
                                    "last_name": "Nachname",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "Benutzer anzeigen"
                    }
                },
                "content": {
                    "course": {
                        "management": "Kurse verwalten",
                        "edit": "Kurs bearbeiten",
                        "create": "Kurs erstellen",
                        "import": "Kurs Importe",
                        "table": {
                            "active": "Aktiv",
                            "id": "ID",
                            "title": "Titel",
                            "description": "Beschreibung",
                            "price": "Preis",
                            "vat": "MwSt.",
                            "last_updated": "zuletzt geändert",
                            "total": "Kurs(e) gesamt.",
                            "order": "Reihenfolge"
                        }
                    },
                    "module": {
                        "edit": "Modul bearbeiten",
                        "create": "Neues Modul erstellen",
                        "table": {
                            "title": "Titel",
                            "description": "Beschreibung",
                            "last_updated": "zuletzt geändert",
                            "id": "ID",
                            "parent_course": "Verknüpfter Kurs",
                            "order": "Reihenfolge"
                        },
                        "script": {
                            "table": {
                                "title": "Titel",
                                "size": "Größe",
                                "last_updated": "zuletzt geändert"
                            }
                        },
                        "management": "Module verwalten",
                        "documents": "Dokumente"
                    },
                    "learning_unit": {
                        "edit": "Lerneinheit bearbeiten",
                        "create": "Lerneinheit erstellen",
                        "title": "Titel",
                        "order": "Reihenfolge",
                        "description": "Beschreibung",
                        "table": {
                            "title": "Titel",
                            "description": "Beschreibung",
                            "last_updated": "zuletzt geändert",
                            "order": "Reihenfolge",
                            "type": "Typ",
                            "id": "ID",
                            "module_id": "Modul-ID",
                            "course_id": "Kurs-ID"
                        },
                        "type_label": "Typ",
                        "module": "Modul",
                        "type": {
                            "0": "label",
                            "1": "Typ",
                            "video": "Video",
                            "test": "Test",
                            "presence_appointment": "Anwesenheitstermin",
                            "paper_application": "Dokumentenabgabe",
                            "talk_appointment": "Terminvereinbarung"
                        },
                        "management": "Lerneinheiten verwalten"
                    },
                    "test": {
                        "required_questions": "Anzahl Benötigter Fragen",
                        "displayed_questions": "Anzahl angezeigter Fragen",
                        "available_time": "Verfügbare Bearbeitungszeit (Minuten)",
                        "choice": {
                            "new": "Neue Antwort",
                            "text": "Text",
                            "points": "Punkte",
                            "choices": "Antworten"
                        },
                        "question": {
                            "new": "Neue Frage",
                            "text": "Text",
                            "required_points": "Benötigte Punkte"
                        }
                    }
                },
                "booking": {
                    "management": "Buchungen verwalten",
                    "edit": "Buchung bearbeiten",
                    "user": "Benutzer",
                    "course": "Kurs",
                    "residual_amount": "Restbetrag",
                    "installment": "Rate",
                    "status": "Status",
                    "table": {
                        "id": "ID",
                        "uuid": "UUID",
                        "course": "Kurs",
                        "user": "Benutzer",
                        "total": "Gesamtpreis",
                        "residual_amount": "Restbetrag",
                        "installment": "Rate",
                        "status": "Status",
                        "empty": "Aktuell liegen keine Buchungen vor.",
                        "totals": "Buchungen gesamt"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Anmeldung",
                    "login_button": "Anmelden",
                    "login_with": "Anmelden mit {social_media}",
                    "register_box_title": "Registrieren",
                    "register_button": "Registrieren",
                    "remember_me": "An mich errinnern"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Kennwort vergessen?",
                    "reset_password_box_title": "Kennwort zurücksetzen",
                    "reset_password_button": "Kennwort zurücksetzen",
                    "update_password_button": "Kennwort aktualisieren",
                    "send_password_reset_link_button": "Link zum zurücksetzen des Kennworts senden"
                },
                "user": {
                    "passwords": {
                        "change": "Kennwort ändern"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Erstellt am",
                        "edit_information": "Informationen bearbeiten",
                        "email": "E-Mail",
                        "last_updated": "Letzte Aktualisierung",
                        "name": "Name",
                        "first_name": "Vorname",
                        "last_name": "Nachname",
                        "update_information": "Informationen aktualisieren"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Rolle erstellt.",
                    "deleted": "Rolle gelöscht.",
                    "updated": "Rolle aktualisiert."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "Eine Aktivierungsmail wurde an die angegebene E-Mailadresse gesendet.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "Benutzer erstellt.",
                    "deleted": "Benutzer gelöscht.",
                    "deleted_permanently": "Benutzer permanent gelöscht.",
                    "restored": "Benutzer wiederhergestellt.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "Benutzer aktualisiert.",
                    "updated_password": "Kennwort des Benutzers aktualisiert."
                },
                "course": {
                    "updated": "Kurs aktualisiert",
                    "deleted": "Kurs gelöscht"
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} muss akzeptiert werden.",
            "active_url": "{attribute} ist keine gültige URL.",
            "after": "{attribute} muss ein Datun nach dem {date} sein.",
            "after_or_equal": "Das {attribute} muss ein Datum nach oder gleich {date} sein.",
            "alpha": "{attribute} darf nur Buchstaben enthalten.",
            "alpha_dash": "{attribute} darf nur Buchstaben, Nummern und Bindestriche enthalten.",
            "alpha_num": "{attribute} darf nur Buchstaben und Nummern enthalten.",
            "array": "{attribute} muss ein Array sein.",
            "before": "{attribute} muss ein Datum vor dem {date} sein.",
            "before_or_equal": "Das {attribute} muss ein Datum vor oder gleich dem {date} sein.",
            "between": {
                "numeric": "{attribute} muss zwischen {min} und {max} sein.",
                "file": "{attribute} muss zwischen {min} und {max} Kilobytes gross sein.",
                "string": "{attribute} muss zwischen {min} und {max} Zeichen lang sein.",
                "array": "{attribute} muss zwischen {min} und {max} Einträge enthalten."
            },
            "boolean": "{attribute} darf nur Wahr oder Falsch sein.",
            "confirmed": "{attribute} Wiederholung stimmt nicht überein.",
            "date": "{attribute} ist kein gültiges Datum.",
            "date_format": "{attribute} ist nicht im Format: {format}.",
            "different": "{attribute} und {other} müssen unterschiedlich sein.",
            "digits": "{attribute} muss {digits} Ziffern enthalten.",
            "digits_between": "{attribute} muss zwischen {min} und {max} Ziffern enthalten.",
            "dimensions": "Das {attribute} hat ungültige Bildabmessungen.",
            "distinct": "Das {attribute} Feld hat einen Wert, der bereits verwendet wurde.",
            "email": "{attribute} muss eine gültige E-Mailadresse sein.",
            "exists": "{attribute} ist ungültig.",
            "file": "Das {attribute} muss eine Datei sein.",
            "filled": "{attribute} ist erforderlich.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} muss ein Bild sein.",
            "in": "{attribute} ist ungültig.",
            "in_array": "Das {attribute}-Feld existiert nicht in {other}.",
            "integer": "{attribute} muss eine Ganzzahl sein.",
            "ip": "{attribute} muss eine gültige IP-Adresse sein.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "{attribute} muss eine gültige JSON-Zeichenkette sein.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} darf nicht grösser sein als {max}.",
                "file": "{attribute} darf nicht grösser sein als {max} Kilobytes.",
                "string": "{attribute} darf nicht grösser sein als {max} Zeichen.",
                "array": "{attribute} darf nicht mehr Einträge enthalten als {max} Einträge."
            },
            "mimes": "{attribute} muss eine Datei des folgenden Typs sein: {values}.",
            "mimetypes": "{attribute} muss eine Datei des folgenden Typs sein: {values}.",
            "min": {
                "numeric": "{attribute} muss mindestens {min} sein.",
                "file": "{attribute} muss mindestens {min} Kilobytes gross sein.",
                "string": "{attribute} muss mindestens {min} Zeichen lang sein.",
                "array": "{attribute} muss mindestens {min} Einträge enthalten."
            },
            "not_in": "{attribute} ist ungültig.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} muss eine Zahl sein.",
            "present": "Das {attribute}-Feld muss vorhanden sein.",
            "regex": "{attribute} enthält ein ungültiges Format.",
            "required": "{attribute} ist erforderlich.",
            "required_if": "{attribute} ist erforderlich, wenn {other} folgenden Wert hat: {value}.",
            "required_unless": "{attribute} ist erforderlich, ausser {other} enthält {values}.",
            "required_with": "{attribute} ist erforderlich, wenn {values} vorhanden ist.",
            "required_with_all": "{attribute} ist erforderlich, wenn {values} vorhanden ist.",
            "required_without": "{attribute} ist erforderlich, wenn {values} nicht vorhanden ist.",
            "required_without_all": "{attribute} ist erforderlich, wenn keine von {values} vorhanden ist.",
            "same": "{attribute} und {other} müssen gleich sein.",
            "size": {
                "numeric": "{attribute} muss {size} gross ein.",
                "file": "{attribute} muss {size} Kilobytes gross sein.",
                "string": "{attribute} muss {size} Zeichen enthalten.",
                "array": "{attribute} muss {size} Einträge enthalten."
            },
            "string": "{attribute} muss eine Zeichenkette sein.",
            "timezone": "{attribute} muss eine gültige Zeitzone sein.",
            "unique": "{attribute} ist schon vergeben.",
            "uploaded": "{attribute} wurde nicht hochgeladen.",
            "url": "{attribute} Format ist ungültig.",
            "custom": {
                "attribute-name": {
                    "rule-name": "Individuelle-Nachricht"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Zugeordnete Rollen",
                            "dependencies": "Abhängigkeiten",
                            "display_name": "Anzeige-Name",
                            "group": "Gruppe",
                            "group_sort": "Gruppen-Sortierung",
                            "groups": {
                                "name": "Gruppen-Name"
                            },
                            "name": "Name",
                            "first_name": "Vorname",
                            "last_name": "Nachname",
                            "system": "System?"
                        },
                        "roles": {
                            "associated_permissions": "Zugeordnerte Berechtigungen",
                            "name": "Name",
                            "sort": "Sortierung"
                        },
                        "users": {
                            "active": "Aktiv",
                            "associated_roles": "Zugeordnerte Rollen",
                            "confirmed": "Bestätigt",
                            "email": "E-Mailadresse",
                            "name": "Name",
                            "last_name": "Vorname",
                            "first_name": "Nachname",
                            "other_permissions": "Andere Berechtigungen",
                            "password": "Kennwort",
                            "password_confirmation": "Kennwort (Wdh.)",
                            "send_confirmation_email": "Bestätigungs E-Mail senden",
                            "timezone": "Zeitzone"
                        }
                    },
                    "content": {
                        "course": {
                            "active": "Aktiv",
                            "title": "Titel",
                            "description": "Beschreibung",
                            "price": "Preis",
                            "vat": "MwSt.",
                            "conduction_from": "Verfügbar von",
                            "conduction_to": "Verfügbar bis",
                            "bookable_from": "Buchbar von",
                            "bookable_to": "Buchbar bis",
                            "yaml": "Inhalt",
                            "country": "Land",
                            "installment_type": "Ratenzahlung"
                        },
                        "module": {
                            "title": "Titel",
                            "description": "Beschreibung",
                            "order": "Reihenfolge",
                            "name": "Name",
                            "parent_course": "Übergeordneter Kurs"
                        },
                        "learning_unit": {
                            "title": "Titel",
                            "description": "Beschreibung",
                            "order": "Reihenfolge",
                            "provider": "Anbieter",
                            "embed_id": "Embed ID"
                        }
                    }
                },
                "frontend": {
                    "avatar": "Avatar Adresse",
                    "email": "E-Mailadresse",
                    "first_name": "Vorname",
                    "last_name": "Nachname",
                    "street": "Straße",
                    "house_number": "Hausnummer",
                    "postal_code": "Postleitzahl",
                    "city": "Stadt",
                    "country": "Land",
                    "password": "Kennwort",
                    "password_confirmation": "Kennwort (Wdh.)",
                    "phone": "Phone",
                    "message": "Message",
                    "new_password": "Neues Kennwort",
                    "new_password_confirmation": "Neues Kennwort (Wdh.)",
                    "old_password": "Altes Kennwort",
                    "timezone": "Zeitzone"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Diese Rolle existert schon. Bitte wähle einen anderen Namen.",
                        "cant_delete_admin": "Du kannst die Administrator-Rolle nicht löschen.",
                        "create_error": "Beim Erstellen der Rolle ist ein Fehler aufgetreten. Bitte versuche es erneut.",
                        "delete_error": "Beim Löschen der Rolle ist ein Fehler aufgetrten. Bitte versuche es erneut.",
                        "has_users": "Eine Rolle mit zugeordneten Benutzern kann nicht gelöscht werden.",
                        "needs_permission": "Für diese Rolle muss mind. eine Berechtigung ausgewählt sein.",
                        "not_found": "Diese Rolle existiert nicht.",
                        "update_error": "Beim Aktualisieren der Rolle ist ein Fehler aufgetreten. Bitte versuche es erneut."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "Du kannst das nicht mit dir selber machen.",
                        "cant_delete_admin": "Du kannst den Haupt-Administrator nicht löschen.",
                        "cant_delete_self": "Du kannst dich nicht selbst löschen.",
                        "cant_delete_own_session": "Du kannst nicht deine eigene Sitzung löschen.",
                        "cant_restore": "Dieser Benutzer wurde nicht gelöscht und kann daher nicht wiederhergestellt werden.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "Beim Erstellen des Benutzers ist ein Fehler aufgetreten. Bitte versuche es erneut.",
                        "delete_error": "Beim Löschen des Benutzers ist ein Fehler aufgetreten. Bitte versuche es erneut.",
                        "delete_first": "Dieser Benutzer muß zuerst gelöscht werden bevor er endgültig entfernt werden kann.",
                        "email_error": "Diese E-Mailadresse ist einem anderem Benutzer zugeordnet.",
                        "mark_error": "Beim Aktualisieren des Benutzers ist ein Fehler aufgetreten. Bitte versuche es erneut.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "Dieser Benutzer existiert nicht.",
                        "restore_error": "Beim Wiederherstelen des Benutzers ist ein Fehler aufgetreten. Bitte versuche es erneut.",
                        "role_needed_create": "Du musst mind. eine Rolle auswählen.",
                        "role_needed": "Du musst mind. eine Rolle auswählen.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "Beim Aktualisieren des Benutzers ist ein Fehler aufgetrten. Bitte versuche es erneut.",
                        "update_password_error": "Das Kennwort den Benutzers konnte nicht geändert werden. Bitte versuche es erneut."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Dein Benutzerkonto wurde schon aktiviert.",
                        "confirm": "Benutzerkonto aktivieren!",
                        "created_confirm": "Dein Benutzerkonto wurde erstellt. Wir haben dir eine Aktivierungsmail gesendet.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Der Aktivierungscode ist nicht korrekt.",
                        "not_found": "Der Aktivierungscode existiert nicht.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Dein Benutzerkonto ist nicht aktiviert. Bitte klicke auf den Link in der Aktivierungsmail, oder <a href=\"{url}\">klicke hier</a> um die Aktivierungsmail erneut zu senden.",
                        "success": "Dein Benutzerkonto wurde aktiviert!",
                        "resent": "Eine neue Aktivierungsmail wurde an die hinterlegte E-Mailadresse gesendet."
                    },
                    "deactivated": "Dein Benutzerkonto wurde deaktiviert.",
                    "email_taken": "Diese E-Mailadresse wird schon verwendet.",
                    "password": {
                        "change_mismatch": "Das ist nicht dein altes Kennwort.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registrierung ist momentan nicht möglich."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Vorherige",
            "next": "Nächste &raquo;"
        },
        "roles": {
            "administrator": "Administrator",
            "user": "Benutzer"
        },
        "messages": {
            "frontend": {
                "task": {
                    "username": "Benutzer",
                    "date": "Datum",
                    "partner": {
                        "title": "Partner",
                        "appointment": {
                            "approve": "genehmigen",
                            "disapprove": "ablehnen"
                        },
                        "presence_appointment": "Ein Benutzer hat einen Anwesenheitstermin bei Ihnen beantragt."
                    },
                    "user": {
                        "appointmentApproved": "Ihrer Anfrage auf einen Anwesenheitstermin wurde zugestimmt. "
                    }
                }
            }
        },
        "navs": {
            "general": {
                "home": "Startseite",
                "logout": "Abmelden"
            },
            "frontend": {
                "bookable": "Buchbare Kurse",
                "booked": "Gebuchte Kurse",
                "contact": "Contact",
                "dashboard": "Dashboard",
                "login": "Anmelden",
                "macros": "Makros",
                "register": "Registrieren",
                "user": {
                    "account": "Mein Konto",
                    "administration": "Administration",
                    "change_password": "Kennwort ändern",
                    "my_information": "Meine Informationen",
                    "profile": "Profile"
                }
            }
        }
    },
    "el": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Are you sure you want to delete this user permanently? Anywhere in the application that references this user's id will most likely error. Proceed at your own risk. This can not be un-done.",
                        "if_confirmed_off": "(If confirmed is off)",
                        "restore_user_confirm": "Restore this user to its original state?"
                    }
                },
                "dashboard": {
                    "title": "Dashboard",
                    "welcome": "Welcome"
                },
                "general": {
                    "all_rights_reserved": "All Rights Reserved.",
                    "are_you_sure": "Are you sure?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Continue",
                    "member_since": "Member since",
                    "minutes": " minutes",
                    "search_placeholder": "Search...",
                    "timeout": "You were automatically logged out for security reasons since you had no activity in ",
                    "see_all": {
                        "messages": "See all messages",
                        "notifications": "View all",
                        "tasks": "View all tasks"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} You don't have messages ::: {1} You have 1 message ::: [2,Inf] You have {number} messages",
                        "notifications": "{0} You don't have notifications ::: {1} You have 1 notification ::: [2,Inf] You have {number} notifications",
                        "tasks": "{0} You don't have tasks ::: {1} You have 1 task ::: [2,Inf] You have {number} tasks"
                    }
                },
                "search": {
                    "empty": "Please enter a search term.",
                    "incomplete": "You must write your own search logic for this system.",
                    "title": "Search Results",
                    "results": "Search Results for {query}"
                },
                "welcome": "<p>This is the CoreUI theme by <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. This is a stripped down version with only the necessary styles and scripts to get it running. Download the full version to start adding components to your dashboard.</p>\n<p>All the functionality is for show with the exception of the <strong>Access</strong> to the left. This boilerplate comes with a fully functional access control library to manage users/roles/permissions.</p>\n<p>Keep in mind it is a work in progress and their may be bugs or other issues I have not come across. I will do my best to fix them as I receive them.</p>\n<p>Hope you enjoy all of the work I have put into this. Please visit the <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> page for more information and report any <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">issues here</a>.</p>\n<p><strong>This project is very demanding to keep up with given the rate at which the master Laravel branch changes, so any help is appreciated.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Whoops!",
                    "greeting": "Hello!",
                    "regards": "Regards,",
                    "trouble_clicking_button": "If you’re having trouble clicking the \"{action_text}\" button, copy and paste the URL below into your web browser:",
                    "thank_you_for_using_app": "Thank you for using our application!",
                    "password_reset_subject": "Reset Password",
                    "password_cause_of_email": "You are receiving this email because we received a password reset request for your account.",
                    "password_if_not_requested": "If you did not request a password reset, no further action is required.",
                    "reset_password": "Click here to reset your password",
                    "click_to_confirm": "Click here to confirm your account:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Permission Based - ",
                        "role": "Role Based - "
                    },
                    "js_injected_from_controller": "Javascript Injected from a Controller",
                    "using_blade_extensions": "Using Blade Extensions",
                    "using_access_helper": {
                        "array_permissions": "Using Access Helper with Array of Permission Names or ID's where the user does have to possess all.",
                        "array_permissions_not": "Using Access Helper with Array of Permission Names or ID's where the user does not have to possess all.",
                        "array_roles": "Using Access Helper with Array of Role Names or ID's where the user does have to possess all.",
                        "array_roles_not": "Using Access Helper with Array of Role Names or ID's where the user does not have to possess all.",
                        "permission_id": "Using Access Helper with Permission ID",
                        "permission_name": "Using Access Helper with Permission Name",
                        "role_id": "Using Access Helper with Role ID",
                        "role_name": "Using Access Helper with Role Name"
                    },
                    "view_console_it_works": "View console, you should see 'it works!' which is coming from FrontendController@index",
                    "you_can_see_because": "You can see this because you have the role of '{role}'!",
                    "you_can_see_because_permission": "You can see this because you have the permission of '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "Profile successfully updated.",
                    "password_updated": "Password successfully updated."
                },
                "welcome_to": "Welcome to {place}"
            }
        },
        "auth": {
            "failed": "Αυτά τα διαπιστευτήρια δεν ταιριάζουν με τα αρχεία μας.",
            "general_error": "Δεν έχετε πρόσβαση σε αυτό.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} δεν είναι αποδεκτός τρόπος σύνδεσης."
            },
            "throttle": "Πολλές προσπάθειες σύνδεσης. Παρακαλούμε προσπαθήστε πάλι σε {seconds} δευτερόλεπτα.",
            "unknown": "Προέκυψε άγνωστο σφάλμα."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Access",
                    "roles": {
                        "all": "Όλοι οι ρόλοι",
                        "create": "Δημιουργία ρόλου",
                        "edit": "Επεξεργασία ρόλου",
                        "management": "Διαχείρηση ρόλων",
                        "main": "Ρόλοι"
                    },
                    "users": {
                        "all": "Όλοι οι χρήστες",
                        "change-password": "Αλλαγή κωδικού",
                        "create": "Δημιουργία χρήστη",
                        "deactivated": "Ανενεργοί χρήστες",
                        "deleted": "Διεγραμμένοι χρήστες",
                        "edit": "Επεξεργασία χρήστη",
                        "main": "Χρήστες",
                        "view": "Δες το χρήστη"
                    }
                },
                "log-viewer": {
                    "main": "Log Viewer",
                    "dashboard": "Dashboard",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Dashboard",
                    "general": "Γενικά",
                    "system": "Σύστημα"
                }
            },
            "language-picker": {
                "language": "Γλώσσα",
                "langs": {
                    "ar": "Αραβικά (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Δανέζικα (Danish)",
                    "de": "Γερμανικά (German)",
                    "el": "Ελληνικά (Greek)",
                    "en": "Αγγλικά (English)",
                    "es": "Ισπανικά (Spanish)",
                    "fa": "περσικός (Persian)",
                    "fr": "Γαλλικά (French)",
                    "he": "Εβραϊκά (Hebrew)",
                    "id": "Ινδονησίας (Indonesian)",
                    "it": "Ιταλικά (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Ολλανδικά (Dutch)",
                    "no": "(Norwegian)",
                    "pt_BR": "(Brazilian Portuguese)",
                    "ru": "Ρωσικός (Russian)",
                    "sv": "Σουηδικά (Swedish)",
                    "th": "Ταιλανδέζικα (Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Ενεργοποίησε",
                        "change_password": "Άλλαξε κωδικό",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "Απενεργοποίησε",
                        "delete_permanently": "Διέγραψε μόνιμα",
                        "login_as": "Συνδέσου σαν {user}",
                        "resend_email": "Ξαναστείλε email επιβεβαίωσης",
                        "restore_user": "Επαναφορά χρήστη",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Επιβεβαίωσε τον λογαριασμό",
                    "reset_password": "Επαναφορά κωδικού"
                }
            },
            "general": {
                "cancel": "Άκυρο",
                "continue": "Continue",
                "crud": {
                    "create": "Δημιουργία",
                    "delete": "Διαγραφή",
                    "edit": "Διαμόρφωση",
                    "update": "Ανανέωση",
                    "view": "Προβολή"
                },
                "save": "Αποθήκευση",
                "view": "Προβολή"
            }
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "http": {
            "404": {
                "title": "Η σελίδα δεν βρέθηκε.",
                "description": "Sorry, but the page you were trying to view does not exist."
            },
            "503": {
                "title": "Be right back.",
                "description": "Be right back."
            }
        },
        "labels": {
            "general": {
                "all": "Όλα",
                "yes": "Ναι",
                "no": "Όχι",
                "custom": "Custom",
                "actions": "Ενέργειες",
                "active": "Ενεργό",
                "buttons": {
                    "save": "Αποθήκευση",
                    "update": "Ανανέωση"
                },
                "hide": "Απόκρυψη",
                "inactive": "Ανενεργό",
                "none": "Κανένα",
                "show": "Εμφάνιση",
                "toggle_navigation": "Αλλαγή περιήγησης"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Δημιουργία ρόλου",
                        "edit": "Επεξεργασία ρόλου",
                        "management": "Διαχείριση ρόλων",
                        "table": {
                            "number_of_users": "Αριθμός χρηστών",
                            "permissions": "Άδειες",
                            "role": "Ρόλος",
                            "sort": "Ταξινόμησε",
                            "total": "σύνολο ρόλου ::: σύνολο ρόλων"
                        }
                    },
                    "users": {
                        "active": "Ενεργοί χρήστες",
                        "all_permissions": "Όλες οι άδειες",
                        "change_password": "Αλλαγή κωδικού",
                        "change_password_for": "Αλλαγή κωδικού για τον {user}",
                        "create": "Δημιουργία χρήστη",
                        "deactivated": "Ανενεργοί χρήστες",
                        "deleted": "΄Διεγραμμένοι χρήστες",
                        "edit": "Έπεξεργασία χρήστη",
                        "management": "΄Διαχείριση χρήστη",
                        "no_permissions": "Χωρίς άδειες",
                        "no_roles": "No Roles to set.",
                        "permissions": "Άδειες",
                        "table": {
                            "confirmed": "Επιβεβαιώθηκε",
                            "created": "Δημιουργήθηκε",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "Τελευταία ενημέρωση",
                            "name": "Όνομα",
                            "no_deactivated": "Δεν υπάρχουν ανενεργοί χρήστες",
                            "no_deleted": "Δεν υπάρχουν διεγραμμένοι χρήστες",
                            "roles": "΄Ρόλοι",
                            "social": "Social",
                            "total": "user total ::: users total"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overview",
                                "history": "Ιστορία"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Επιβεβαιωμένο",
                                    "created_at": "Δημιουργήθηκε την",
                                    "deleted_at": "Διαγράφηκε την",
                                    "email": "E-mail",
                                    "last_updated": "Τελευταία ενημέρωση",
                                    "name": "Όνομα",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "Δες το χρήστη"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Σύνδεση",
                    "login_button": "Σύνδεση",
                    "login_with": "Συνδέσου με {social_media}",
                    "register_box_title": "Εγγραφή",
                    "register_button": "Εγγραφή",
                    "remember_me": "Θυμήσου με"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Forgot Your Password?",
                    "reset_password_box_title": "Reset Password",
                    "reset_password_button": "Reset Password",
                    "send_password_reset_link_button": "Send Password Reset Link"
                },
                "user": {
                    "passwords": {
                        "change": "Αλλαγή κωδικού"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Δημιουργήθηκε την",
                        "edit_information": "Επεξεργασία πληροφοριών",
                        "email": "E-mail",
                        "last_updated": "Τελευταία ανανέωση",
                        "name": "Name",
                        "update_information": "Ανανέωση πληροφοριών"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Ο ρόλος δημιουργήθηκε επιτυχώς.",
                    "deleted": "Ο ρόλος διαγράφηκε επιτυχώς.",
                    "updated": "Ο ρόλος ανανεώθηκε επιτυχώς."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "A new confirmation e-mail has been sent to the address on file.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "Ο χρήστης δημιουργήθηκε επιτυχώς.",
                    "deleted": "Ο χρήστης διαγράφηκε επιτυχώς.",
                    "deleted_permanently": "Ο χρήστης διαγράφηκε μόνιμα.",
                    "restored": "Ο χρήστης επαναφέρθηκε επιτυχώς.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "Ο χρήστης ανανεώθηκε επιτυχώς.",
                    "updated_password": "Ο κωδικός χρήστη ανανεώθηκε επιτυχώς."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field is required.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Associated Roles",
                            "dependencies": "Dependencies",
                            "display_name": "Display Name",
                            "group": "Group",
                            "group_sort": "Group Sort",
                            "groups": {
                                "name": "Group Name"
                            },
                            "name": "Name",
                            "system": "System?"
                        },
                        "roles": {
                            "associated_permissions": "Associated Permissions",
                            "name": "Name",
                            "sort": "Sort"
                        },
                        "users": {
                            "active": "Active",
                            "associated_roles": "Associated Roles",
                            "confirmed": "Confirmed",
                            "email": "E-mail Address",
                            "name": "Name",
                            "other_permissions": "Other Permissions",
                            "password": "Password",
                            "password_confirmation": "Password Confirmation",
                            "send_confirmation_email": "Send Confirmation E-mail"
                        }
                    }
                },
                "frontend": {
                    "email": "E-mail Address",
                    "name": "Name",
                    "password": "Password",
                    "password_confirmation": "Password Confirmation",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "Old Password",
                    "new_password": "New Password",
                    "new_password_confirmation": "New Password Confirmation"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Αυτός ο ρόλος υπάρχει ήδη. Παρακαλώ διάλεξε άλλο όνομα.",
                        "cant_delete_admin": "Δεν μπορείτε να διαγράψετε το ρόλο του διαχειριστή.",
                        "create_error": "Παρουσιάστηκε πρόβλημα κατά τη δημιουργία του ρόλου. Παρακαλώ ξαναπροσπαθήστε.",
                        "delete_error": "Παρουσιάστηκε πρόβλημα κατά τη διαγραφή του ρόλου. Παρακαλώ ξαναπροσπαθήστε.",
                        "has_users": "Δεν μπορείτε να διαγράψετε ρόλο με συνδεδεμένους χρήστες.",
                        "needs_permission": "Πρέπει να επιλέξετε τουλάχιστον μια άδεια για αυτό το ρόλο.",
                        "not_found": "Άυτός ο ρόλος δεν υπάρχει.",
                        "update_error": "Παρουσιάστηκε πρόβλημα κατά την ανανέωση του ρόλου. Παρακαλώ ξαναπροσπαθήστε."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "Δεν μπορείτε να το κάνετε αυτό στον εαυτό σας.",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "Δεν μπορείτε να διαγράψετε τον εαυτό σας.",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "cant_restore": "This user is not deleted so it can not be restored.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "There was a problem creating this user. Please try again.",
                        "delete_error": "There was a problem deleting this user. Please try again.",
                        "delete_first": "This user must be deleted first before it can be destroyed permanently.",
                        "email_error": "That email address belongs to a different user.",
                        "mark_error": "There was a problem updating this user. Please try again.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "That user does not exist.",
                        "restore_error": "There was a problem restoring this user. Please try again.",
                        "role_needed_create": "You must choose at lease one role.",
                        "role_needed": "You must choose at least one role.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "There was a problem updating this user. Please try again.",
                        "update_password_error": "There was a problem changing this users password. Please try again."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Your account is already confirmed.",
                        "confirm": "Confirm your account!",
                        "created_confirm": "Your account was successfully created. We have sent you an e-mail to confirm your account.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Your confirmation code does not match.",
                        "not_found": "That confirmation code does not exist.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Your account is not confirmed. Please click the confirmation link in your e-mail, or <a href=\"{url}\">click here</a> to resend the confirmation e-mail.",
                        "success": "Your account has been successfully confirmed!",
                        "resent": "A new confirmation e-mail has been sent to the address on file."
                    },
                    "deactivated": "Ο λογαριασμός σας απενεργοποιήθηκε.",
                    "email_taken": "Αυτό το e-mail χρησιμοποιείται ήδη.",
                    "password": {
                        "change_mismatch": "Αυτός δεν είναι ο παλιός σου κωδικός.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "roles": {
            "administrator": "Διαχειριστής",
            "user": "Χρήστης"
        },
        "navs": {
            "general": {
                "home": "Αρχική",
                "logout": "Αποσύνδεση"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Dashboard",
                "login": "Σύνδεση",
                "macros": "Macros",
                "register": "Εγγραφή",
                "user": {
                    "account": "Ο λογαριασμός μου",
                    "administration": "Διαχείριση",
                    "change_password": "Αλλαγή κωδικού",
                    "my_information": "Οι πληροφορίες μου",
                    "profile": "Προφίλ"
                }
            }
        }
    },
    "en": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Are you sure you want to delete this user permanently? Anywhere in the application that references this user's id will most likely error. Proceed at your own risk. This can not be un-done.",
                        "if_confirmed_off": "(If confirmed is off)",
                        "no_deactivated": "There are no deactivated users.",
                        "no_deleted": "There are no deleted users.",
                        "restore_user_confirm": "Restore this user to its original state?"
                    }
                },
                "dashboard": {
                    "title": "Dashboard",
                    "welcome": "Welcome"
                },
                "general": {
                    "all_rights_reserved": "All Rights Reserved.",
                    "are_you_sure": "Are you sure you want to do this?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Continue",
                    "member_since": "Member since",
                    "minutes": " minutes",
                    "search_placeholder": "Search...",
                    "timeout": "You were automatically logged out for security reasons since you had no activity in ",
                    "see_all": {
                        "messages": "See all messages",
                        "notifications": "View all",
                        "tasks": "View all tasks"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} You don't have messages ::: {1} You have 1 message ::: [2,Inf] You have {number} messages",
                        "notifications": "{0} You don't have notifications ::: {1} You have 1 notification ::: [2,Inf] You have {number} notifications",
                        "tasks": "{0} You don't have tasks ::: {1} You have 1 task ::: [2,Inf] You have {number} tasks"
                    }
                },
                "search": {
                    "empty": "Please enter a search term.",
                    "incomplete": "You must write your own search logic for this system.",
                    "title": "Search Results",
                    "results": "Search Results for {query}"
                },
                "welcome": "<p>This is the CoreUI theme by <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. This is a stripped down version with only the necessary styles and scripts to get it running. Download the full version to start adding components to your dashboard.</p>\n<p>All the functionality is for show with the exception of the <strong>Access</strong> to the left. This boilerplate comes with a fully functional access control library to manage users & roles powered by <a href=\"https://github.com/spatie/laravel-permission\" target=\"_blank\">spatie/laravel-permission</a>.</p>\n<p>Keep in mind it is a work in progress and their may be bugs or other issues I have not come across. I will do my best to fix them as I receive them.</p>\n<p>Hope you enjoy all of the work I have put into this. Please visit the <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> page for more information and report any <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">issues here</a>.</p>\n<p><strong>This project is very demanding to keep up with given the rate at which the master Laravel branch changes, so any help is appreciated.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Whoops!",
                    "greeting": "Hello!",
                    "regards": "Regards,",
                    "trouble_clicking_button": "If you’re having trouble clicking the \"{action_text}\" button, copy and paste the URL below into your web browser:",
                    "thank_you_for_using_app": "Thank you for using our application!",
                    "password_reset_subject": "Reset Password",
                    "password_cause_of_email": "You are receiving this email because we received a password reset request for your account.",
                    "password_if_not_requested": "If you did not request a password reset, no further action is required.",
                    "reset_password": "Click here to reset your password",
                    "click_to_confirm": "Click here to confirm your account:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Permission Based - ",
                        "role": "Role Based - "
                    },
                    "js_injected_from_controller": "Javascript Injected from a Controller",
                    "using_blade_extensions": "Using Blade Extensions",
                    "using_access_helper": {
                        "array_permissions": "Using Access Helper with Array of Permission Names or ID's where the user does have to possess all.",
                        "array_permissions_not": "Using Access Helper with Array of Permission Names or ID's where the user does not have to possess all.",
                        "array_roles": "Using Access Helper with Array of Role Names or ID's where the user does have to possess all.",
                        "array_roles_not": "Using Access Helper with Array of Role Names or ID's where the user does not have to possess all.",
                        "permission_id": "Using Access Helper with Permission ID",
                        "permission_name": "Using Access Helper with Permission Name",
                        "role_id": "Using Access Helper with Role ID",
                        "role_name": "Using Access Helper with Role Name"
                    },
                    "view_console_it_works": "View console, you should see 'it works!' which is coming from FrontendController@index",
                    "you_can_see_because": "You can see this because you have the role of '{role}'!",
                    "you_can_see_because_permission": "You can see this because you have the permission of '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "checkout": {
                    "header": "Checkout",
                    "title": "Checkout",
                    "pay": "Pay",
                    "method": {
                        "sb": {
                            "title": "Online Bank Transfer",
                            "type": {
                                "pnt": {
                                    "title": "Sofortbanking (DE, AT, CH, NL)"
                                },
                                "gpy": {
                                    "title": "giropay (DE)"
                                },
                                "eps": {
                                    "title": "eps - online transfer (AT)"
                                },
                                "pff": {
                                    "title": "PostFinance E-Finance (CH)"
                                },
                                "pfc": {
                                    "title": "PostFinance Card (CH)"
                                },
                                "idl": {
                                    "title": "iDEAL(NL)"
                                },
                                "p24": {
                                    "title": "Przelewy24 (PL)"
                                }
                            },
                            "bankgrouptype": {
                                "title": "Bank Group Type"
                            }
                        },
                        "cc": {
                            "title": "Credit Card",
                            "cardpan": "Number",
                            "cvc": "Card Validation Code (CVC)",
                            "expire": {
                                "month": "Month",
                                "year": "Year"
                            },
                            "cardtype": "Card type"
                        },
                        "vor": {
                            "title": "Prepayment"
                        },
                        "elv": {
                            "title": "Debit Payment"
                        },
                        "rec": {
                            "title": "Invoice"
                        },
                        "wlt": {
                            "title": "e-wallet"
                        }
                    },
                    "country": {
                        "de": "Germany",
                        "at": "Austria",
                        "ch": "Swiss",
                        "nl": "Netherland"
                    },
                    "labels": {
                        "amount": "Amount",
                        "firstname": "Firstname",
                        "lastname": "Lastname",
                        "invoiceNo": "Invoice #",
                        "invoiceDate": "Invoice Date",
                        "iban": "IBAN",
                        "bic": "BIC"
                    },
                    "placeholders": {
                        "amount": "Amount",
                        "invoiceNo": "Invoice #",
                        "invoiceDate": "Invoice Date"
                    },
                    "success": {
                        "header": "Checkout Success"
                    },
                    "error": {
                        "header": "Checkout Failed"
                    }
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "Profile successfully updated.",
                    "password_updated": "Password successfully updated."
                },
                "welcome_to": "Welcome to {place}"
            }
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "general_error": "You do not have access to do that.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} is not an acceptable login type."
            },
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "unknown": "An unknown error occurred"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Access",
                    "roles": {
                        "all": "All Roles",
                        "create": "Create Role",
                        "edit": "Edit Role",
                        "management": "Role Management",
                        "main": "Roles"
                    },
                    "users": {
                        "all": "All Users",
                        "change-password": "Change Password",
                        "create": "Create User",
                        "deactivated": "Deactivated Users",
                        "deleted": "Deleted Users",
                        "edit": "Edit User",
                        "main": "Users",
                        "view": "View User"
                    }
                },
                "log-viewer": {
                    "main": "Log Viewer",
                    "dashboard": "Dashboard",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Dashboard",
                    "general": "General",
                    "system": "System"
                }
            },
            "language-picker": {
                "language": "Language",
                "langs": {
                    "ar": "Arabic",
                    "zh": "Chinese Simplified",
                    "zh-TW": "Chinese Traditional",
                    "da": "Danish",
                    "de": "German",
                    "el": "Greek",
                    "en": "English",
                    "es": "Spanish",
                    "fa": "Persian",
                    "fr": "French",
                    "he": "Hebrew",
                    "id": "Indonesian",
                    "it": "Italian",
                    "ja": "Japanese",
                    "nl": "Dutch",
                    "no": "Norwegian",
                    "pt_BR": "Brazilian Portuguese",
                    "ru": "Russian",
                    "sv": "Swedish",
                    "th": "Thai",
                    "tr": "Turkish"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Activate",
                        "change_password": "Change Password",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "Deactivate",
                        "delete_permanently": "Delete Permanently",
                        "login_as": "Login As {user}",
                        "resend_email": "Resend Confirmation E-mail",
                        "restore_user": "Restore User",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Confirm Account",
                    "reset_password": "Reset Password"
                }
            },
            "general": {
                "cancel": "Cancel",
                "continue": "Continue",
                "crud": {
                    "create": "Create",
                    "delete": "Delete",
                    "edit": "Edit",
                    "update": "Update",
                    "view": "View"
                },
                "save": "Save",
                "view": "View"
            }
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "http": {
            "404": {
                "title": "Page Not Found",
                "description": "Sorry, but the page you were trying to view does not exist."
            },
            "503": {
                "title": "Be right back.",
                "description": "Be right back."
            }
        },
        "labels": {
            "general": {
                "all": "All",
                "yes": "Yes",
                "no": "No",
                "copyright": "Copyright",
                "custom": "Custom",
                "actions": "Actions",
                "active": "Active",
                "buttons": {
                    "save": "Save",
                    "update": "Update"
                },
                "hide": "Hide",
                "inactive": "Inactive",
                "none": "None",
                "show": "Show",
                "toggle_navigation": "Toggle Navigation"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Create Role",
                        "edit": "Edit Role",
                        "management": "Role Management",
                        "table": {
                            "number_of_users": "Number of Users",
                            "permissions": "Permissions",
                            "role": "Role",
                            "sort": "Sort",
                            "total": "role total ::: roles total"
                        }
                    },
                    "users": {
                        "active": "Active Users",
                        "all_permissions": "All Permissions",
                        "change_password": "Change Password",
                        "change_password_for": "Change Password for {user}",
                        "create": "Create User",
                        "deactivated": "Deactivated Users",
                        "deleted": "Deleted Users",
                        "edit": "Edit User",
                        "management": "User Management",
                        "no_permissions": "No Permissions",
                        "no_roles": "No Roles to set.",
                        "permissions": "Permissions",
                        "table": {
                            "confirmed": "Confirmed",
                            "created": "Created",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "Last Updated",
                            "name": "Name",
                            "first_name": "First Name",
                            "last_name": "Last Name",
                            "no_deactivated": "No Deactivated Users",
                            "no_deleted": "No Deleted Users",
                            "other_permissions": "Other Permissions",
                            "permissions": "Permissions",
                            "roles": "Roles",
                            "social": "Social",
                            "total": "user total ::: users total"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overview",
                                "history": "History"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmed",
                                    "created_at": "Created At",
                                    "deleted_at": "Deleted At",
                                    "email": "E-mail",
                                    "last_updated": "Last Updated",
                                    "name": "Name",
                                    "first_name": "First Name",
                                    "last_name": "Last Name",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "View User"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Login",
                    "login_button": "Login",
                    "login_with": "Login with {social_media}",
                    "register_box_title": "Register",
                    "register_button": "Register",
                    "remember_me": "Remember Me"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "expired_password_box_title": "Your password has expired.",
                    "forgot_password": "Forgot Your Password?",
                    "reset_password_box_title": "Reset Password",
                    "reset_password_button": "Reset Password",
                    "update_password_button": "Update Password",
                    "send_password_reset_link_button": "Send Password Reset Link"
                },
                "user": {
                    "passwords": {
                        "change": "Change Password"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Created At",
                        "edit_information": "Edit Information",
                        "email": "E-mail",
                        "last_updated": "Last Updated",
                        "name": "Name",
                        "first_name": "First Name",
                        "last_name": "Last Name",
                        "update_information": "Update Information"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "The role was successfully created.",
                    "deleted": "The role was successfully deleted.",
                    "updated": "The role was successfully updated."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "A new confirmation e-mail has been sent to the address on file.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "The user was successfully created.",
                    "deleted": "The user was successfully deleted.",
                    "deleted_permanently": "The user was deleted permanently.",
                    "restored": "The user was successfully restored.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "The user was successfully updated.",
                    "updated_password": "The user's password was successfully updated."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Associated Roles",
                            "dependencies": "Dependencies",
                            "display_name": "Display Name",
                            "group": "Group",
                            "group_sort": "Group Sort",
                            "groups": {
                                "name": "Group Name"
                            },
                            "name": "Name",
                            "first_name": "First Name",
                            "last_name": "Last Name",
                            "system": "System"
                        },
                        "roles": {
                            "associated_permissions": "Associated Permissions",
                            "name": "Name",
                            "sort": "Sort"
                        },
                        "users": {
                            "active": "Active",
                            "associated_roles": "Associated Roles",
                            "confirmed": "Confirmed",
                            "email": "E-mail Address",
                            "name": "Name",
                            "last_name": "Last Name",
                            "first_name": "First Name",
                            "other_permissions": "Other Permissions",
                            "password": "Password",
                            "password_confirmation": "Password Confirmation",
                            "send_confirmation_email": "Send Confirmation E-mail",
                            "timezone": "Timezone",
                            "language": "Language"
                        }
                    }
                },
                "frontend": {
                    "avatar": "Avatar Location",
                    "email": "E-mail Address",
                    "first_name": "First Name",
                    "last_name": "Last Name",
                    "name": "Full Name",
                    "password": "Password",
                    "password_confirmation": "Password Confirmation",
                    "phone": "Phone",
                    "message": "Message",
                    "new_password": "New Password",
                    "new_password_confirmation": "New Password Confirmation",
                    "old_password": "Old Password",
                    "timezone": "Timezone",
                    "language": "Language"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "That role already exists. Please choose a different name.",
                        "cant_delete_admin": "You can not delete the Administrator role.",
                        "create_error": "There was a problem creating this role. Please try again.",
                        "delete_error": "There was a problem deleting this role. Please try again.",
                        "has_users": "You can not delete a role with associated users.",
                        "needs_permission": "You must select at least one permission for this role.",
                        "not_found": "That role does not exist.",
                        "update_error": "There was a problem updating this role. Please try again."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "You can not do that to yourself.",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "You can not delete yourself.",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "cant_restore": "This user is not deleted so it can not be restored.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "There was a problem creating this user. Please try again.",
                        "delete_error": "There was a problem deleting this user. Please try again.",
                        "delete_first": "This user must be deleted first before it can be destroyed permanently.",
                        "email_error": "That email address belongs to a different user.",
                        "mark_error": "There was a problem updating this user. Please try again.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "That user does not exist.",
                        "restore_error": "There was a problem restoring this user. Please try again.",
                        "role_needed_create": "You must choose at lease one role.",
                        "role_needed": "You must choose at least one role.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "There was a problem updating this user. Please try again.",
                        "update_password_error": "There was a problem changing this users password. Please try again."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Your account is already confirmed.",
                        "confirm": "Confirm your account!",
                        "created_confirm": "Your account was successfully created. We have sent you an e-mail to confirm your account.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Your confirmation code does not match.",
                        "not_found": "That confirmation code does not exist.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Your account is not confirmed. Please click the confirmation link in your e-mail, or <a href=\"{url}\">click here</a> to resend the confirmation e-mail.",
                        "success": "Your account has been successfully confirmed!",
                        "resent": "A new confirmation e-mail has been sent to the address on file."
                    },
                    "deactivated": "Your account has been deactivated.",
                    "email_taken": "That e-mail address is already taken.",
                    "password": {
                        "change_mismatch": "That is not your old password.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "roles": {
            "administrator": "Administrator",
            "user": "User"
        },
        "navs": {
            "general": {
                "home": "Home",
                "logout": "Logout"
            },
            "frontend": {
                "bookable": "Bookable Courses",
                "booked": "Booked Courses",
                "contact": "Contact",
                "dashboard": "Dashboard",
                "login": "Login",
                "macros": "Macros",
                "register": "Register",
                "user": {
                    "account": "My Account",
                    "administration": "Administration",
                    "change_password": "Change Password",
                    "my_information": "My Information",
                    "profile": "Profile"
                }
            }
        }
    },
    "es": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Estás seguro de querer eliminar este Usuario de forma permanente? Esto puede producir un error grave en aquéllas partes de la aplicación que hagan referencia al mismo. Proceda con cautela. Esta operación no puede ser revertida.",
                        "if_confirmed_off": "(Si la confirmación está desactivada)",
                        "no_deactivated": "No hay usuarios desactivados.",
                        "no_deleted": "No hay usuarios eliminados.",
                        "restore_user_confirm": "Restaurar este Usuario a su estado original?"
                    }
                },
                "dashboard": {
                    "title": "Panel de Administración",
                    "welcome": "Bienvenido"
                },
                "general": {
                    "all_rights_reserved": "Todos los derechos reservados.",
                    "are_you_sure": "Está seguro?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Continuar",
                    "member_since": "Miembro desde",
                    "minutes": " minutos",
                    "search_placeholder": "Buscar...",
                    "timeout": "Usted ha sido automaticamente desconectado por razones de seguridad ya que no tuvo actividad en ",
                    "see_all": {
                        "messages": "Ver todos los mensajes",
                        "notifications": "Ver todo",
                        "tasks": "Ver todas las tareas"
                    },
                    "status": {
                        "online": "Conectado",
                        "offline": "Desconectado"
                    },
                    "you_have": {
                        "messages": "{0} No tiene nuevos mensajes ::: {1} Tiene 1 nuevo mensaje ::: [2,Inf] Tiene {number} mensajes nuevos",
                        "notifications": "{0} No tiene nuevas notificaciones ::: {1} Tiene 1 nueva notificación ::: [2,Inf] Tiene {number} notificaciones",
                        "tasks": "{0} No tiene nuevas tareas ::: {1} Tiene 1 nueva tarea ::: [2,Inf] Tiene {number} nuevas tareas"
                    }
                },
                "search": {
                    "empty": "Favor escribir un término de busqueda.",
                    "incomplete": "Debes escribir tu propia lógica de busqueda para este sistema.",
                    "title": "Resultados de la Busqueda",
                    "results": "Resultados de la busqueda para {query}"
                },
                "welcome": "<p>Este es el tema CoreUI por <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. Esta versión no está completa, descargue la versión completa para añadir mas componentes.</p>\n<p>Toda la funcionalidad es de prueba, a excepción de la <strong>Administración de acceso</strong> a la izquierda. Esta plantilla viene pre-configurada y funcional para total gestión de usuarios/roles/permisos.</p>\n<p>Tenga presente que esta plantilla sigue estando en desarrollo y puede contener errores. Hare lo que este en mis manos para corregirlos.</p>\n<p>Espero que disfrute y aprecie el trabajo depositado en este proyecto. Por favor, visite <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> para mas información o reportar error <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">aquí</a>.</p>\n<p><strong>Este proyecto es muy demandante para mantenerse al día con la frecuencia en que el master branch de laravel va cambiando, por tanto cualquier ayuda será apreciada.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Su cuenta ha sido confirmada.",
                    "error": "Ups!",
                    "greeting": "Hola!",
                    "regards": "Saludos,",
                    "trouble_clicking_button": "Si está presentando problemas haciendo clic en el botón \"{action_text}\", copia y pega el enlace en su navegador:",
                    "thank_you_for_using_app": "Gracias por utilizar nuestra aplicación!",
                    "password_reset_subject": "Su enlace de reinicio de contraseña",
                    "password_cause_of_email": "Usted está recibiendo este correo porque hemos recibido una solicitud de reinicio de contraseña para su cuenta.",
                    "password_if_not_requested": "Si usted no hizo la solicitud, ninguna acción es requerida.",
                    "reset_password": "Pulse aquí para reiniciar su contraseña",
                    "click_to_confirm": "Pulse aquí para verificar su cuenta:"
                },
                "contact": {
                    "email_body_title": "Tiene una nueva solicitud del formulario de contacto: a continuación los detalles:",
                    "subject": "¡Nueva solicitud del formulario de contacto {app_name}!"
                }
            },
            "frontend": {
                "test": "Prueba",
                "tests": {
                    "based_on": {
                        "permission": "Basado en el Permiso - ",
                        "role": "Basado en el Rol - "
                    },
                    "js_injected_from_controller": "Javascript inyectado desde el Controlador",
                    "using_blade_extensions": "Usando las extensiones de Blade",
                    "using_access_helper": {
                        "array_permissions": "Uso de Access Helper con lista de nombres de Permisos o ID's donde el usuario tiene que tenerlos todos.",
                        "array_permissions_not": "Uso de Access Helper con lista de nombres de Permisos o ID's donde el usuario no tiene por que tenerlos todos.",
                        "array_roles": "Uso de Access Helper con lista de nombres de Roles o ID's donde el usuario tiene que tenerlos todos.",
                        "array_roles_not": "Uso de Access Helper con lista de nombres de Roles o ID's donde el usuario no tiene que tenerlos todos.",
                        "permission_id": "Uso de Access Helper mediante ID de Permiso",
                        "permission_name": "Uso de Access Helper mediante nombre de Permiso",
                        "role_id": "Uso de Access Helper mediante ID de Rol",
                        "role_name": "Uso de Access Helper mediante nombre de Rol"
                    },
                    "view_console_it_works": "Mire la consola del navegador, deberia ver 'Funciona!!' que tiene su origen en FrontendController@index",
                    "you_can_see_because": "Puede ver esto, por que dispone del Rol '{role}'!",
                    "you_can_see_because_permission": "Puede ver esto, por que dispone del Permiso '{permission}'!"
                },
                "general": {
                    "joined": "Afiliado"
                },
                "user": {
                    "change_email_notice": "Si cambia su correo electrónico, se cerrará la sesión hasta que confirme su nueva dirección de correo electrónico.",
                    "email_changed_notice": "Debe confirmar su nueva dirección de correo electrónico antes de poder iniciar sesión de nuevo.",
                    "profile_updated": "Perfil actualizado satisfactoriamente.",
                    "password_updated": "Contraseña actualizada satisfactoriamente."
                },
                "welcome_to": "Bienvenido a {place}"
            }
        },
        "auth": {
            "failed": "Las credenciales no se han encontrado.",
            "general_error": "No tiene suficientes permisos..",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} no es un tipo de autenticación válida."
            },
            "throttle": "Demasiados intentos de inicio de sesión. Vuelva a intentarlo en {seconds} segundos.",
            "unknown": "Se ha producido un error desconocido."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Administración de acceso",
                    "roles": {
                        "all": "Todos los Roles",
                        "create": "Nuevo Rol",
                        "edit": "Modificar Rol",
                        "management": "Administración de Roles",
                        "main": "Roles"
                    },
                    "users": {
                        "all": "Todos los Usuarios",
                        "change-password": "Cambiar la contraseña",
                        "create": "Nuevo Usuario",
                        "deactivated": "Usuarios Desactivados",
                        "deleted": "Usuarios Eliminados",
                        "edit": "Modificar Usuario",
                        "main": "Usuario",
                        "view": "Ver Usuario"
                    }
                },
                "log-viewer": {
                    "main": "Gestór de Logs",
                    "dashboard": "Principal",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Principal",
                    "general": "General",
                    "system": "Sistema"
                }
            },
            "language-picker": {
                "language": "Idioma",
                "langs": {
                    "ar": "العربية (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Danés (Danish)",
                    "de": "Alemán (German)",
                    "el": "(Greek)",
                    "en": "Inglés (English)",
                    "es": "Español (Spanish)",
                    "fa": "Persa (Persian)",
                    "fr": "Francés (French)",
                    "he": "Hebreo (Hebrew)",
                    "id": "Indonesio (Indonesian)",
                    "it": "Italiano (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Holandés (Dutch)",
                    "no": "Noruego (Norwegian)",
                    "pt_BR": "Portugués Brasileño",
                    "ru": "Russian (Russian)",
                    "sv": "Sueco (Swedish)",
                    "th": "(Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Activar",
                        "change_password": "Cambiar contraseña",
                        "clear_session": "Eliminar Sesión",
                        "confirm": "Confirmar",
                        "deactivate": "Desactivar",
                        "delete_permanently": "Eliminar de forma permanente",
                        "login_as": "Iniciar sesión como {user}",
                        "resend_email": "Reenviar E-mail de confirmación",
                        "restore_user": "Restaurar Usuario",
                        "unconfirm": "Deshacer",
                        "unlink": "Desactivar"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Confirmar Cuenta",
                    "reset_password": "Resetear Contraseña"
                }
            },
            "general": {
                "cancel": "Cancelar",
                "continue": "Continue",
                "crud": {
                    "create": "Crear",
                    "delete": "Eliminar",
                    "edit": "Modificar",
                    "update": "Actualizar",
                    "view": "Visualizar"
                },
                "save": "Guardar",
                "view": "Visualizar"
            }
        },
        "passwords": {
            "password": "La contraseña debe tener al menos seis caracteres y coincidir con la de su confirmación.",
            "reset": "Su contraseña se ha reiniciado!",
            "sent": "Le hemos enviado el enlace para el reinicio de la contraseña!",
            "token": "El código del reinicio de la contraseña es incorrecto.",
            "user": "El Usuario con este Correo no se ha encontrado."
        },
        "http": {
            "404": {
                "title": "La Página que intento acceder no ha sido encontrada.",
                "description": "Parece ser que la página que buscas no existe."
            },
            "503": {
                "title": "Servicio no disponible.",
                "description": "Volveremos en breve."
            }
        },
        "labels": {
            "general": {
                "all": "Todos",
                "yes": "Sí",
                "no": "No",
                "copyright": "Copyright",
                "custom": "Personalizado",
                "actions": "Acciones",
                "active": "Activo",
                "buttons": {
                    "save": "Guardar",
                    "update": "Actualizar"
                },
                "hide": "Ocultar",
                "inactive": "Inactivo",
                "none": "Ningúno",
                "show": "Mostrar",
                "toggle_navigation": "Abrir/Cerrar menú de navegación"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Crear Rol",
                        "edit": "Modificar Rol",
                        "management": "Administración de Roles",
                        "table": {
                            "number_of_users": "Número de Usuarios",
                            "permissions": "Permisos",
                            "role": "Rol",
                            "sort": "Orden",
                            "total": "Todos los Roles"
                        }
                    },
                    "users": {
                        "active": "Usuarios activos",
                        "all_permissions": "Todos los Permisos",
                        "change_password": "Cambiar la contraseña",
                        "change_password_for": "Cambiar la contraseña para {user}",
                        "create": "Crear Usuario",
                        "deactivated": "Usuarios desactivados",
                        "deleted": "Usuarios eliminados",
                        "edit": "Modificar Usuario",
                        "management": "Administración de Usuarios",
                        "no_permissions": "Sin Permisos",
                        "no_roles": "No hay Roles disponibles.",
                        "permissions": "Permisos",
                        "table": {
                            "confirmed": "Confirmado",
                            "created": "Creado",
                            "email": "Correo",
                            "id": "ID",
                            "last_updated": "Última modificación",
                            "name": "Nombre",
                            "first_name": "Nombre",
                            "last_name": "Apellidos",
                            "no_deactivated": "Ningún Usuario desactivado disponible",
                            "no_deleted": "Ningún Usuario eliminado disponible",
                            "other_permissions": "Otros Permisos",
                            "permissions": "Permisos",
                            "roles": "Roles",
                            "social": "Cuenta Social",
                            "total": "Todos los Usuarios"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Resúmen",
                                "history": "Historia"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmado",
                                    "created_at": "Creación",
                                    "deleted_at": "Eliminación",
                                    "email": "E-mail",
                                    "last_updated": "Última Actualización",
                                    "name": "Nombre",
                                    "first_name": "Nombre",
                                    "last_name": "Apellidos",
                                    "status": "Estatus"
                                }
                            }
                        },
                        "view": "Ver Usuario"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Iniciar Sesión",
                    "login_button": "Iniciar Sesión",
                    "login_with": "Iniciar Sesión mediante {social_media}",
                    "register_box_title": "Registrarse",
                    "register_button": "Registrarse",
                    "remember_me": "Recordarme"
                },
                "contact": {
                    "box_title": "Contáctenos",
                    "button": "Enviar información"
                },
                "passwords": {
                    "expired_password_box_title": "Tu contraseña a expirado.",
                    "forgot_password": "Has olvidado la contraseña?",
                    "reset_password_box_title": "Reiniciar contraseña",
                    "reset_password_button": "Reiniciar contraseña",
                    "update_password_button": "Actualizar contraseña",
                    "send_password_reset_link_button": "Enviar el correo de verificación"
                },
                "user": {
                    "passwords": {
                        "change": "Cambiar la contraseña"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Creado el",
                        "edit_information": "Modificar la información",
                        "email": "Correo",
                        "last_updated": "Última modificación",
                        "name": "Nombre",
                        "first_name": "Nombre",
                        "last_name": "Apellidos",
                        "update_information": "Actualizar la información"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Rol creado satisfactoriamente.",
                    "deleted": "Rol eliminado satisfactoriamente.",
                    "updated": "Rol actualizado satisfactoriamente."
                },
                "users": {
                    "cant_resend_confirmation": "La aplicación esta actualmente configurada para aprobación manual de usuarios.",
                    "confirmation_email": "Un nuevo mensaje de confirmación ha sido enviado a tu correo.",
                    "confirmed": "El usuario fue confirmado exitosamente.",
                    "created": "Usuario creado satisfactoriamente.",
                    "deleted": "Usuario eliminado satisfactoriamente.",
                    "deleted_permanently": "Usuario eliminado de forma permanente.",
                    "restored": "Usuario restaurado satisfactoriamente.",
                    "session_cleared": "La sesión del usuario se borró exitosamente.",
                    "social_deleted": "Cuenta social removida exitosamente.",
                    "unconfirmed": "El usuario fue desconfirmado exitosamente",
                    "updated": "Usuario actualizado satisfactoriamente.",
                    "updated_password": "Contraseña actualizada satisfactoriamente."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Tu información fue enviada exitosamente. Responderemos tan pronto sea posible al e-mail que proporcionaste."
                }
            }
        },
        "validation": {
            "accepted": "El campo {attribute} debe ser aceptado.",
            "active_url": "El campo {attribute} no es una URL válida.",
            "after": "El campo {attribute} debe ser una fecha posterior a {date}.",
            "after_or_equal": "El campo {attribute} debe ser una fecha posterior o igual a {date}.",
            "alpha": "El campo {attribute} sólo debe contener letras.",
            "alpha_dash": "El campo {attribute} sólo debe contener letras, números y barras.",
            "alpha_num": "El campo {attribute} sólo debe contener letras y números.",
            "array": "El campo {attribute} debe ser una lista.",
            "before": "El campo {attribute} debe ser una fecha anterior a {date}.",
            "before_or_equal": "El campo {attribute} debe ser una fecha anterior o igual a {date}.",
            "between": {
                "numeric": "El campo {attribute} debe ser un número entre {min} y {max}.",
                "file": "El campo {attribute} debe ser entre {min} y {max} kilobytes.",
                "string": "El campo {attribute} debe ser entre {min} y {max} caracteres.",
                "array": "El campo {attribute} debe contener entre {min} y {max} elementos."
            },
            "boolean": "El campo {attribute} debe ser booleano.",
            "confirmed": "El campo {attribute} de confirmación no coincide.",
            "date": "El campo {attribute} no es una fecha válida.",
            "date_format": "La fecha {attribute} debe coincidir con el formato {format}.",
            "different": "El campo {attribute} y {other} deben ser diferentes.",
            "digits": "El número {attribute} debe tener {digits} dígitos.",
            "digits_between": "El número {attribute} debe tener entre {min} y {max} dígitos.",
            "dimensions": "El {attribute} contiene dimensiones de imagen invalidas.",
            "distinct": "El campo {attribute} contiene un valor duplicado.",
            "email": "El campo {attribute} debe contener un e-mail válido.",
            "exists": "El campo {attribute} seleccionado es inválido.",
            "file": "El {attribute} debe ser un archivo.",
            "filled": "El campo {attribute} es obligatorio.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "El campo {attribute} debe contener una imagen.",
            "in": "El {attribute} seleccionado no es válido.",
            "in_array": "El campo {attribute} no existen en {other}.",
            "integer": "El campo {attribute} debe ser un número entero.",
            "ip": "El campo {attribute} debe contener una dirección IP válida.",
            "ipv4": "El campo {attribute} debe contener una Dirección IPv4 válida.",
            "ipv6": "El campo {attribute} debe contener una Dirección IPv6 válida.",
            "json": "El campo {attribute} debe contener un JSON válido.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "El número {attribute} no debe ser mayor que {max}.",
                "file": "El fichero {attribute} no debe ser mayor que {max} kilobytes.",
                "string": "El texto {attribute} debe tener menos de {max} caracteres.",
                "array": "La lista {attribute} debe contener menos de {max} elemnetos."
            },
            "mimes": "El fichero {attribute} debe tener el formato/s {values}.",
            "min": {
                "numeric": "El número {attribute} debe ser mayor o igual a {min}.",
                "file": "El fichero {attribute} debe ser mayor o igual a {min} kilobytes.",
                "string": "El texto {attribute} debe tener, al menos, {min} caracteres.",
                "array": "La lista {attribute} debe contener, al menos {min} elemnetos."
            },
            "not_in": "El {attribute} seleccionado no es válido.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "El campo {attribute} debe ser un número.",
            "present": "El campo {attribute} debe estar presente.",
            "regex": "El formato de {attribute} no es válido.",
            "required": "El campo {attribute} es obligatorio.",
            "required_if": "El campo {attribute} es obligatorio cuando {other} tiene valor {value}.",
            "required_unless": "El campo {attribute} es obligatorio, excepto cuando {other} esta en {values}.",
            "required_with": "El campo {attribute} es obligatorio cuando {values} están presentes.",
            "required_with_all": "El campo {attribute} es obligatorio cuando {values} están presentes.",
            "required_without": "El campo {attribute} es obligatorio cuando {values} no están presentes.",
            "required_without_all": "El campo {attribute} es obligatorio cuando ninguno de {values} están presentes.",
            "same": "El campo {attribute} y {other} deben coincidir.",
            "size": {
                "numeric": "El número {attribute} debe tener {size} caracteres.",
                "file": "El fichero {attribute} debe tener {size} kilobytes.",
                "string": "El texto {attribute} debe tener {size} caracteres.",
                "array": "La lista {attribute} debe contener {size} elemnetos."
            },
            "string": "El campo {attribute} debe contener texto.",
            "timezone": "El campo {attribute} debe contener una zona horaria válida.",
            "unique": "El campo {attribute} ya está en uso.",
            "uploaded": "El campo {attribute} no se pudo actualizar.",
            "url": "El enlace {attribute} debe tener un formato válido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "mensaje-personalizado"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Roles asociados",
                            "dependencies": "Dependencias",
                            "display_name": "Nombre a mostrar",
                            "group": "Grupo",
                            "group_sort": "Orden del Grupo",
                            "groups": {
                                "name": "Nombre del Grupo"
                            },
                            "name": "Nombre",
                            "first_name": "Nombre",
                            "last_name": "Apellidos",
                            "system": "Sistema?"
                        },
                        "roles": {
                            "associated_permissions": "Permisos asociados",
                            "name": "Nombre",
                            "sort": "Orden"
                        },
                        "users": {
                            "active": "Activo",
                            "associated_roles": "Roles asociados",
                            "confirmed": "Confirmado",
                            "email": "Dirección de Correo",
                            "name": "Nombre",
                            "last_name": "Apellidos",
                            "first_name": "Nombre",
                            "other_permissions": "Otros Permisos",
                            "password": "Contraseña",
                            "password_confirmation": "Confirmación de la Contraseña",
                            "send_confirmation_email": "Enviar Correo de confirmación",
                            "timezone": "Zona Horaria",
                            "language": "Lenguaje"
                        }
                    }
                },
                "frontend": {
                    "avatar": "Localización Avatar",
                    "email": "Dirección de Correo",
                    "first_name": "Nombre",
                    "last_name": "Apellidos",
                    "name": "Nombre completo",
                    "password": "Contraseña",
                    "password_confirmation": "Confirmación de la Contraseña",
                    "phone": "Telefono",
                    "message": "Mensaje",
                    "old_password": "Antigua Contraseña",
                    "new_password": "Nueva Contraseña",
                    "new_password_confirmation": "Confirmación de la Nueva Contraseña",
                    "timezone": "Zona Horaria",
                    "language": "Lenguaje"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Este Rol ya existe. Por favor, especifique un nombre de Rol diferente.",
                        "cant_delete_admin": "No puede eliminar el Rol de Administrador.",
                        "create_error": "Hubo un problema al crear el Rol. Intentelo de nuevo.",
                        "delete_error": "Hubo un problema al eliminar el Rol. Intentelo de nuevo.",
                        "has_users": "No puede eliminar un Rol que tenga usuarios asignados.",
                        "needs_permission": "Debe seleccionar al menos un permiso para cada Rol.",
                        "not_found": "El Rol requerido no existe.",
                        "update_error": "Hubo un problema al modificar el Rol. Intentelo de nuevo."
                    },
                    "users": {
                        "already_confirmed": "Este usuario ya fue confirmado",
                        "cant_confirm": "Hubo un problema al confirmar la cuenta de usuario.",
                        "cant_deactivate_self": "No puede desactivarse a sí mismo.",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "No puede eliminarse usted mismo.",
                        "cant_delete_own_session": "No puedes borrar tu propia sesión.",
                        "cant_restore": "Este usuario no fue eliminado, por lo que no se puede restaurar.",
                        "cant_unconfirm_admin": "No puede anular la confirmación del superadministrador.",
                        "cant_unconfirm_self": "No puedes anular tu propia confirmación.",
                        "create_error": "Hubo un problema al crear el Usuario. Intentelo de nuevo.",
                        "delete_error": "Hubo un problema al eliminar el Usuario. Intentelo de nuevo.",
                        "delete_first": "Este usuario debe ser eliminado primero antes de que pueda ser destruido permanentemente.",
                        "email_error": "Ya hay un Usuario con la dirección de E-Mail especificada.",
                        "mark_error": "Hubo un problema al modificar el Usuario. Intentelo de nuevo.",
                        "not_confirmed": "Este usuario no está confirmado.",
                        "not_found": "El Usuario requerido no existe.",
                        "restore_error": "Hubo un problema al restaurar el Usuario. Intentelo de nuevo.",
                        "role_needed_create": "Los Usuarios deben tener al menos un Rol.",
                        "role_needed": "Debes elegir al menos un Rol.",
                        "session_wrong_driver": "Su controlador de sesión debe configurarse en la base de datos para usar esta característica.",
                        "social_delete_error": "Hubo un problema al eliminar la cuenta social del usuario.",
                        "update_error": "Hubo un problema al modificar el Usuario. Intentelo de nuevo.",
                        "update_password_error": "Hubo un problema al cambiar la contraseña. Intentelo de nuevo."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Su cuenta ya ha sido verificada.",
                        "confirm": "Revise su correo y verifique su cuenta!",
                        "created_confirm": "Su cuenta ha sido creada. Le hemos enviado un e-mail con un enlace de verificación.",
                        "created_pending": "Su cuenta fue creada con éxito y está pendiente de aprobación. Se enviará un correo electrónico cuando su cuenta sea aprobada.",
                        "mismatch": "El código de verificación no coincide.",
                        "not_found": "El código de verificación especificado no existe.",
                        "pending": "Su cuenta esta actualmente pendiente de aprobación",
                        "resend": "Su cuenta no ha sido verificada todavía. Por favor, revise su e-mail, o <a href=\"{url}\">pulse aquí</a> para re-enviar el correo de verificación.",
                        "success": "Su cuenta ha sido verificada satisfactoriamente!",
                        "resent": "Un nuevo correo de verificación le ha sido enviado."
                    },
                    "deactivated": "Su cuenta ha sido desactivada.",
                    "email_taken": "El correo especificado ya está registrado.",
                    "password": {
                        "change_mismatch": "La contraseña antigua no coincide.",
                        "reset_problem": "Hubo un problema al restablecer su contraseña. Por favor, vuelva a enviar el correo electrónico de restablecimiento de contraseña"
                    },
                    "registration_disabled": "Los registros se encuentran actualmente cerrado."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Anterior",
            "next": "Siguiente &raquo;"
        },
        "roles": {
            "administrator": "Administrador",
            "user": "Usuario"
        },
        "navs": {
            "general": {
                "home": "Inicio",
                "logout": "Cerrar Sesión"
            },
            "frontend": {
                "contact": "Contacto",
                "dashboard": "Principal",
                "login": "Iniciar Sesión",
                "macros": "Macros",
                "register": "Registrarse",
                "user": {
                    "account": "Mi Cuenta",
                    "administration": "Administración",
                    "change_password": "Cambiar la contraseña",
                    "my_information": "Mi Cuenta",
                    "profile": "Perfil"
                }
            }
        }
    },
    "fa": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "آیا مطمئن هستید که می‌خواهید این کاربر را به طور دائم حذف کنید؟ هر کدام از قسمت‌هایی که به این کاربر ارجاع داده می‌شود احتمالا در معرض خطا خواهد بود و این کار قابل بازگشت نیست.",
                        "if_confirmed_off": "(اگر تاییده غیر فعال است)",
                        "no_deactivated": "کاربر غیر فعالی وجود ندارد.",
                        "no_deleted": "کاربر حذف شده‌ای وجود ندارد.",
                        "restore_user_confirm": "آیا کاربر به حالت اصلی برگردانده شود?"
                    }
                },
                "dashboard": {
                    "title": "داشبورد",
                    "welcome": "خوش‌آمدید"
                },
                "general": {
                    "all_rights_reserved": "همه حقوق محفوظ است.",
                    "are_you_sure": "آیا مطمئن هستید که می‌خواهید این کار را انجام دهید؟",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "ادامه",
                    "member_since": "عضویت از",
                    "minutes": " دقیقه",
                    "search_placeholder": "جستجو ...",
                    "timeout": "از آنجا که هیچ فعالیتی نداشتید، به دلایل امنیتی، به طور خودکار از سیستم خارج شدید ",
                    "see_all": {
                        "messages": "نمایش همه پیام‌ها",
                        "notifications": "نمایش همه",
                        "tasks": "نمایش همه وظایف"
                    },
                    "status": {
                        "online": "برخط",
                        "offline": "برون‌خط"
                    },
                    "you_have": {
                        "messages": "{0} هیچ پیامی ندارید ::: {1} شما یک پیام دارید ::: [2,Inf] شما {number} پیام دارید",
                        "notifications": "{0} هیچ اطلاعیه‌ای ندارید ::: {1} شما یک اطلاعیه دارید ::: [2,Inf] شما {number} اطلاعیه دارید",
                        "tasks": "{0} هیچ وظیفه‌ای ندارید ::: {1} شما یک وظیفه دارید ::: [2,Inf] شما {number} وظیفه دارید"
                    }
                },
                "search": {
                    "empty": "لطفا یک واژه برای جستجو وارد کنید.",
                    "incomplete": "شما باید منطق جستجوی خود را برای این سامانه بنویسید.",
                    "title": "نتایج جستجو",
                    "results": "نتایج جستجو برای {query}"
                },
                "welcome": "<p>تم CoreUI توسط <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a> ایجاد شده است. این یک نسخه دسته پایین با تنها سبک و اسکریپت‌های لازم برای اجرای آن است. نسخه کامل را برای شروع افزودن اجزای به داشبورد خود دانلود کنید.\n</p>\n<p>تمام قابلیت‌ها برای نمایش است به استثنای <strong> مدیریت دسترسی </strong> که در سمت چپ است. این بسته همراه با یک کتابخانه کنترل دسترسی کامل به منظور مدیریت کاربران و نقش‌ها توسط <a href=\"https://github.com/spatie/laravel-permission\" target=\"_blank\">spatie/laravel-permission</a> ایجاد شده است. </p>\n<p>به خاطر داشته باشید که این کار در حال انجام است و ممکن است اشکالات یا مسائل دیگری را که من ندیده‌ام، داشته باشد. من بهترین کار خود را برای اصلاح آنها وقتی که آنها را دریافت کردم، انجام خواهم داد. </p>\n<p>امیدوارم از تمام کارهایی که من در این زمینه انجام داده‌ام لذت ببرید. لطفا برای اطلاعات بیشتر <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> را ببینید و مشکلات  را در <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues \"target =\"_ blank\">اینجا</a> گزارش کنید. </p>\n<p><strong> این پروژه  به شدت نیازمند نگه داشتن نرخ تغییر بر اساس نرخ تغییرات شاخه اصلی لاروول است، بنابراین از هر گونه کمک شما قدردانی می‌شود.</strong></p>\n<p> - آنتونی رپا </p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "حساب شما تایید شده است.",
                    "error": "اوپس!",
                    "greeting": "سلام!",
                    "regards": "با احترام,",
                    "trouble_clicking_button": "If you’re having trouble clicking the \"{action_text}\" button, copy and paste the URL below into your web browser:",
                    "thank_you_for_using_app": "تشکر از شما برای استفاده از برنامه ما!",
                    "password_reset_subject": "باز نشانی گذرواژه",
                    "password_cause_of_email": "You are receiving this email because we received a password reset request for your account.",
                    "password_if_not_requested": "If you did not request a password reset, no further action is required.",
                    "reset_password": "برای بازنشانی گذرواژه اینجا را کلیک کنید",
                    "click_to_confirm": "برای تایید حساب خود، اینجا را کلیک کنید:"
                },
                "contact": {
                    "email_body_title": "شما یک درخواست تماس دارید: در زیر جرئیات آن آمده است:",
                    "subject": "یک {app_name} ارسال درخواست تماس نو!"
                }
            },
            "frontend": {
                "test": "تست",
                "tests": {
                    "based_on": {
                        "permission": "بر اساس مجوز - ",
                        "role": "بر اساس نقش - "
                    },
                    "js_injected_from_controller": "Javascript Injected from a Controller",
                    "using_blade_extensions": "Using Blade Extensions",
                    "using_access_helper": {
                        "array_permissions": "Using Access Helper with Array of Permission Names or ID's where the user does have to possess all.",
                        "array_permissions_not": "Using Access Helper with Array of Permission Names or ID's where the user does not have to possess all.",
                        "array_roles": "Using Access Helper with Array of Role Names or ID's where the user does have to possess all.",
                        "array_roles_not": "Using Access Helper with Array of Role Names or ID's where the user does not have to possess all.",
                        "permission_id": "Using Access Helper with Permission ID",
                        "permission_name": "Using Access Helper with Permission Name",
                        "role_id": "Using Access Helper with Role ID",
                        "role_name": "Using Access Helper with Role Name"
                    },
                    "view_console_it_works": "View console, you should see 'it works!' which is coming from FrontendController@index",
                    "you_can_see_because": "You can see this because you have the role of '{role}'!",
                    "you_can_see_because_permission": "You can see this because you have the permission of '{permission}'!"
                },
                "general": {
                    "joined": "متصل"
                },
                "user": {
                    "change_email_notice": "اگر شما رایانامه خود را تغییر دهید، تا زمانی که رایانامه جدید خود را تایید نکرده‌اید از سامانه خارج می‌شوید",
                    "email_changed_notice": "شما باید قبل از ورود مجدد به سامانه، رایانامه جدید خود را تایید نمایید.",
                    "profile_updated": "اطلاعات کاربری با موفقیت به‌روز شد.",
                    "password_updated": "گذرواژه با موفقیت به‌روز شد."
                },
                "welcome_to": "خوش‌آمدید به {place}"
            }
        },
        "auth": {
            "failed": "این اعتبارات با سوابق ما مطابقت ندارد.",
            "general_error": "شما مجوز انجام این کار را ندارید.",
            "socialite": {
                "unacceptable": "نوع ورود {provider} قابل قبول نیست."
            },
            "throttle": "تلاش های زیادی برای ورود به سیستم. لطفا {seconds} ثانیه دیگر مجددا امتحان کنید.",
            "unknown": "یک خطای ناشناخته رخ داده است"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "مدیریت دسترسی",
                    "roles": {
                        "all": "همه نقش‌ها",
                        "create": "ایجاد نقش",
                        "edit": "ویرایش نقش",
                        "management": "مدیریت نقش",
                        "main": "نقش‌ها"
                    },
                    "users": {
                        "all": "همه کاربران",
                        "change-password": "تغییر گذرواژه",
                        "create": "ایجاد کاربر",
                        "deactivated": "کاربران غیرفعال",
                        "deleted": "کاربران حذف شده",
                        "edit": "ویرایش کاربر",
                        "main": "کاربران",
                        "view": "نمایش کاربر"
                    }
                },
                "log-viewer": {
                    "main": "نمایش لاگ",
                    "dashboard": "داشبورد",
                    "logs": "لاگ‌ها"
                },
                "sidebar": {
                    "dashboard": "داشبورد",
                    "general": "عمومی",
                    "system": "سامانه"
                }
            },
            "language-picker": {
                "language": "زبان",
                "langs": {
                    "ar": "عربی (Arabic)",
                    "zh": "چینی ساده (Chinese Simplified)",
                    "zh-TW": "چینی سنتی (Chinese Traditional)",
                    "da": "دانمارکی (Danish)",
                    "de": "آلمانی (German)",
                    "el": "یونانی (Greek)",
                    "en": "انگلیسی (English)",
                    "es": "اسپانیولی (Spanish)",
                    "fa": "فارسی",
                    "fr": "فرانسوی (French)",
                    "he": "عبری (Hebrew)",
                    "id": "اندونزیایی (Indonesian)",
                    "it": "ایتالیایی (Italian)",
                    "ja": "ژاپنی (Japanese)",
                    "nl": "هلندی (Dutch)",
                    "no": "نروژی (Norwegian)",
                    "pt_BR": "پرتغالی برزیلی (Brazilian Portuguese)",
                    "ru": "روسی (Russian)",
                    "sv": "سوئدی (Swedish)",
                    "th": "تایلندی (Thai)",
                    "tr": "ترکی (Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "فعال‌سازی",
                        "change_password": "تغییر گذرواژه",
                        "clear_session": "پاک کردن جلسه",
                        "confirm": "تایید",
                        "deactivate": "غیرفعال‌سازی",
                        "delete_permanently": "حذف همیشگی",
                        "login_as": "ورود با {user}",
                        "resend_email": "ارسال دوباره تایید ایمیل",
                        "restore_user": "بازگرداندن کاربر",
                        "unconfirm": "عدم تائید",
                        "unlink": "لغو پیوند"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "تأیید حساب",
                    "reset_password": "بازنشانی گذرواژه"
                }
            },
            "general": {
                "cancel": "انصراف",
                "continue": "ادامه",
                "crud": {
                    "create": "ایجاد",
                    "delete": "حذف",
                    "edit": "ویرایش",
                    "update": "به‌روز رسانی",
                    "view": "نمایش"
                },
                "save": "ذخیره",
                "view": "نمایش"
            }
        },
        "passwords": {
            "password": "گذرواژه‌ها باید حداقل داری شش نویسه باشند و با گذرواژه تاییدی، مطابقت داشته باشند.",
            "reset": "گذرواژه شما تنظیم بازنشانی شد!",
            "sent": "ما پیوند بازنشانی گذرواژه شما را ایمیل کردیم!",
            "token": "این نشانگر بازنشانی گذرواژه نامعتبر است.",
            "user": "ما نمی‌توانیم کاربری با این ایمیل پیدا کنیم."
        },
        "http": {
            "404": {
                "title": "صفحه یافت نشد",
                "description": "با عرض پوزش، صفحه‌ای که سعی در مشاهده آن دارید؛ وجود ندارد."
            },
            "503": {
                "title": "الآن برمی‌گردم.",
                "description": "الآن برمی‌گردم."
            }
        },
        "labels": {
            "general": {
                "all": "همه",
                "yes": "آری",
                "no": "خیر",
                "copyright": "کپی‌رایت",
                "custom": "سفارشی",
                "actions": "اعمال",
                "active": "فعال",
                "buttons": {
                    "save": "ثبت",
                    "update": "به‌روز رسانی"
                },
                "hide": "مخفی",
                "inactive": "غیرفعال",
                "none": "هیچ",
                "show": "نمایش",
                "toggle_navigation": "تغییر ناوبری"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "ایجاد نقش",
                        "edit": "ویرایش نقش",
                        "management": "مدیریت نقش",
                        "table": {
                            "number_of_users": "تعداد کاربران",
                            "permissions": "مجوزها",
                            "role": "نقش",
                            "sort": "مرتب‌سازی",
                            "total": "تعداد نقش ::: تعداد نقش‌ها"
                        }
                    },
                    "users": {
                        "active": "کاربران فعال",
                        "all_permissions": "همه‌ی مجوزها",
                        "change_password": "تغییر گذرواژه",
                        "change_password_for": "تغییر گذرواژه‌ی {user}",
                        "create": "ایجاد کاربر",
                        "deactivated": "کاربران غیر فعال",
                        "deleted": "کاربران حذف‌شده",
                        "edit": "ویرایش کاربر",
                        "management": "مدیریت کاربر",
                        "no_permissions": "بدون مجوز",
                        "no_roles": "بدون نقش",
                        "permissions": "مجوزها",
                        "table": {
                            "confirmed": "تاییدشده",
                            "created": "تاریخ ایجاد",
                            "email": "رایانامه",
                            "id": "شناسه",
                            "last_updated": "آخرین تغییر",
                            "name": "نام",
                            "first_name": "نام",
                            "last_name": "نام خانوادگی",
                            "no_deactivated": "هیچ کاربر غیرفعالی نیست",
                            "no_deleted": "هیچ کاربری حذف نشده",
                            "other_permissions": "دیگر مجوزها",
                            "permissions": "مجوزها",
                            "roles": "نقش‌ها",
                            "social": "شبکه‌اجتماعی",
                            "total": "تعداد کاربر ::: تعداد کاربران"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "دید کلی",
                                "history": "تاریخچه"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "تصویر",
                                    "confirmed": "تاییدشده",
                                    "created_at": "تاریخ ایجاد",
                                    "deleted_at": "تاریخ حذف",
                                    "email": "ایمیل",
                                    "last_updated": "آخرین تغییر",
                                    "name": "نام",
                                    "first_name": "نام",
                                    "last_name": "نام خانوادگی",
                                    "status": "وضعیت"
                                }
                            }
                        },
                        "view": "نمایش کاربر"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "ورود",
                    "login_button": "ورود",
                    "login_with": "ورود با {social_media}",
                    "register_box_title": "ثبت نام",
                    "register_button": "ثبت نام",
                    "remember_me": "مرا به خاطر بسپار"
                },
                "contact": {
                    "box_title": "تماس با ما",
                    "button": "ارسال اطلاعات"
                },
                "passwords": {
                    "expired_password_box_title": "گذرواژه شما منقضی شده است.",
                    "forgot_password": "گذرواژه‌ی خود را فراموش کرده‌اید؟",
                    "reset_password_box_title": "بازنشانی گذرواژه",
                    "reset_password_button": "بازنشانی گذرواژه",
                    "update_password_button": "به‌روز رسانی گذرواژه",
                    "send_password_reset_link_button": "ارسال پیوند بازنشانی گذرواژه"
                },
                "user": {
                    "passwords": {
                        "change": "تغییر گذرواژه"
                    },
                    "profile": {
                        "avatar": "تصویر",
                        "created_at": "تاریخ ایجاد",
                        "edit_information": "ویرایش اطلاعات",
                        "email": "ایمیل",
                        "last_updated": "آخرین تغییر",
                        "name": "نام",
                        "first_name": "نام",
                        "last_name": "نام خانوادگی",
                        "update_information": "به‌روز رسانی اطلاعات"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "نقش کاربر با موفقیت ایجاد شد.",
                    "deleted": "نقش کاربر با موفقیت حذف شد.",
                    "updated": "نقش کاربر با موفقیت به‌روز رسانی شد."
                },
                "users": {
                    "cant_resend_confirmation": "برنامه در حال حاضر به صورت دستی کاربران را تأیید می‌کند.",
                    "confirmation_email": "یک ایمیل تأیید جدید به آدرس داخل فایل فرستاده شده است.",
                    "confirmed": "کاربر با موفقیت تایید شد.",
                    "created": "کاربر با موفقیت ایجاد شد.",
                    "deleted": "کاربر با موفقیت حذف شد.",
                    "deleted_permanently": "کاربر برای همیشه حذف شد.",
                    "restored": "کاربر با موفقیت بازیابی شد.",
                    "session_cleared": "جلسه کاربر موفقیت پاک شد.",
                    "social_deleted": "حساب شبکه اجتماعی حذف شد",
                    "unconfirmed": "کاربر با موفقیت تأیید نشد",
                    "updated": "کاربر با موفقیت به‌روز رسانی شد.",
                    "updated_password": "گذرواژه‌ی کاربر با موفقیت به‌روز رسانی شد."
                },
                "document": {
                    "created": "پرونده با موفقیت ایجاد شد.",
                    "deleted": "پرونده با موفقیت حذف شد.",
                    "deleted_permanently": "پرونده برای همیشه حذف شد.",
                    "restored": "پرونده با موفقیت بازیابی شد.",
                    "updated": "پرونده با موفقیت به‌روز رسانی شد."
                },
                "center": {
                    "created": "مرکز با موفقیت ایجاد شد.",
                    "deleted": "مرکز با موفقیت حذف شد.",
                    "deleted_permanently": "مرکز برای همیشه حذف شد.",
                    "restored": "مرکز با موفقیت بازیابی شد.",
                    "updated": "مرکز با موفقیت به‌روز رسانی شد."
                },
                "station": {
                    "created": "ایستگاه با موفقیت ایجاد شد.",
                    "deleted": "ایستگاه با موفقیت حذف شد.",
                    "deleted_permanently": "ایستگاه برای همیشه حذف شد.",
                    "restored": "ایستگاه با موفقیت بازیابی شد.",
                    "updated": "ایستگاه با موفقیت به‌روز رسانی شد."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "اطلاعات شما با موفقیت ارسال شد. ما در اسرع وقت، به ایمیل شما پاسخ خواهیم داد."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} باید پذیرفته شود.",
            "active_url": "{attribute} یک نشانی معتبر اینترنتی نیست",
            "after": "{attribute} باید یک تاریخ بعد از {date} باشد.",
            "after_or_equal": "{attribute} باید یک تاریخ مساوی یا بعد از {date} باشد.",
            "alpha": "{attribute} می‌تواند فقط شامل حروف باشد.",
            "alpha_dash": "{attribute} می‌تواند فقط شامل حروف، اعداد و - باشد.",
            "alpha_num": "{attribute} می‌تواند فقط شامل حروف و اعداد باشد.",
            "array": "{attribute} باید یک آرایه باشد.",
            "before": "{attribute} باید یک تاریخ قبل از {date} باشد.",
            "before_or_equal": "{attribute} باید یک تاریخ مساوی یا قبل از {date} باشد.",
            "between": {
                "numeric": "{attribute} باید بین {min} و {max} باشد.",
                "file": "{attribute} باید بین {min} و {max} کیلو بایت باشد.",
                "string": "{attribute} باید بین {min} و {max} نویسه‌ها باشد.",
                "array": "{attribute} باید شامل {min} و {max} آیتم‌ها باشد."
            },
            "boolean": "{attribute} فیلد باید درست باشد یا نادرست باشد",
            "confirmed": "{attribute} تأییدیه مطابقت ندارد",
            "date": "{attribute} یک تاریخ معتبر نیست.",
            "date_format": "{attribute} با قالب {format} تطابق ندارد.",
            "different": "{attribute} و {other} باید متفاوت باشند.",
            "digits": "{attribute} باید {digits} رقم داشته باشد.",
            "digits_between": "{attribute} باید بین {min} و {max} رقم داشته باشد.",
            "dimensions": "{attribute} ابعاد نامعتبر دارد.",
            "distinct": "{attribute} فیلد مقدار تکراری دارد.",
            "email": "{attribute} باید یک رایانامه معتبر باشد.",
            "exists": "{attribute} انتخاب شده نامعتبر است.",
            "file": "{attribute} باید یک فایل باشد.",
            "filled": "{attribute} فیلد باید یک مقدار داشته باشد.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} باید یک تصویر باشد.",
            "in": "{attribute} انتخاب شده نامعتبر است.",
            "in_array": "{attribute} فیلد در {other}. وجود ندارد",
            "integer": "{attribute} باید عددی باشد.",
            "ip": "{attribute} باید یک آدرس آی.پی معتبر باشد.",
            "ipv4": "{attribute} باید یک آدرس IPv4 معتبر باشد.",
            "ipv6": "{attribute} باید یک آدرس IPv6 معتبر باشد.",
            "json": "{attribute} باید یک رشته json معتبر باشد.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} نباید بزرگتر از {max} باشد.",
                "file": "{attribute} نباید بزرگتر از {max} کیلوبایت باشد.",
                "string": "{attribute} نباید بیشتر از {max} نویسه داشته باشد.",
                "array": "{attribute} نباید بیشتر از {max} عدد آیتم داشته باشد."
            },
            "mimes": "{attribute} باید یک فایل با نوع: {values} باشد.",
            "mimetypes": "{attribute} باید یک فایل با نوع: {values} باشد.",
            "min": {
                "numeric": "{attribute} باید حداقل {min} باشد.",
                "file": "{attribute} باید حداقل {min} کیلوبایت باشد.",
                "string": "{attribute} باید حداقل {min} نویسه داشته باشد.",
                "array": "{attribute} باید حداقل {min} آیتم داشته باشد."
            },
            "not_in": "{attribute} نامعتبر است.",
            "numeric": "{attribute} باید یک عدد باشد.",
            "present": "{attribute} فیلد باید موجود باشد.",
            "regex": "{attribute} قالب نامعتبر است.",
            "required": "{attribute} فیلد مورد نیاز است.",
            "required_if": "{attribute} فیلد مورد نیاز است وقتی که {other} برابر با {value} باشد.",
            "required_unless": "{attribute} فیلد مورد نیاز است مگر اینکه {other} داخل {values} باشد.",
            "required_with": "{attribute} فیلد مورد نیاز است وقتی که {values} موجود است.",
            "required_with_all": "{attribute} فیلد مورد نیاز است وقتی که {values} موجود است.",
            "required_without": "{attribute} فیلد مورد نیاز است وقتی که {values} موجود نیست.",
            "required_without_all": "{attribute} فیلد مورد نیاز است وقتی که هیچکدام از {values} موجود نباشد.",
            "same": "{attribute} و {other} باید تطابق داشته باشند.",
            "size": {
                "numeric": "{attribute} باید {size} باشد.",
                "file": "{attribute} باید {size} کیلو بایت باشد.",
                "string": "{attribute} باید {size} نویسه‌ای باشد.",
                "array": "{attribute} باید شامل {size} آیتم باشد."
            },
            "string": "{attribute} باید یک رشته باشد.",
            "timezone": "{attribute} باید یک منطقه زمانی باشد.",
            "unique": "{attribute} قبلا گرفته شده است.",
            "uploaded": "{attribute} بارگذاری نشد.",
            "url": "{attribute} قالب نامعتبر است.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "نقش‌های مرتبط",
                            "dependencies": "وابستگی‌ها",
                            "display_name": "نام",
                            "group": "گروه",
                            "group_sort": "نوع گروه",
                            "groups": {
                                "name": "نام گروه"
                            },
                            "name": "نام",
                            "first_name": "نام",
                            "last_name": "نام خانوادگی",
                            "system": "سامانه"
                        },
                        "roles": {
                            "associated_permissions": "مجوزها",
                            "name": "نام",
                            "sort": "مرتب سازی"
                        },
                        "users": {
                            "active": "فعال",
                            "associated_roles": "نقش‌ها",
                            "confirmed": "تائید شده؟",
                            "email": "رایانامه",
                            "name": "نام",
                            "last_name": "نام خانوادگی",
                            "first_name": "نام",
                            "other_permissions": "دیگر مجوزها",
                            "password": "گذرواژه",
                            "password_confirmation": "تکرار گذرواژه",
                            "send_confirmation_email": "ارسال ایمیل تاییدیه",
                            "timezone": "منطقه زمانی",
                            "language": "زبان"
                        }
                    }
                },
                "frontend": {
                    "avatar": "آواتار",
                    "email": "رایانامه",
                    "first_name": "نام",
                    "last_name": "نام خانوادگی",
                    "name": "نام",
                    "password": "گذرواژه",
                    "password_confirmation": "تکرار گذرواژه",
                    "phone": "تلفن",
                    "message": "پیام",
                    "new_password": "گذرواژه جدید",
                    "new_password_confirmation": "تکرار گذرواژه جدید",
                    "old_password": "گذرواژه قبلی",
                    "timezone": "منطقه زمانی",
                    "language": "زبان"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "این نقش در حال حاضر وجود دارد. لطفا نام دیگری را انتخاب کنید.",
                        "cant_delete_admin": "شما نمی‌توانید نقش مدیر را حذف کنید.",
                        "create_error": "مشکلی در ایجاد این نقش وجود داشت. لطفا دوباره تلاش کنید.",
                        "delete_error": "مشکلی در حذف این نقش وجود داشت. لطفا دوباره تلاش کنید.",
                        "has_users": "شما نمی‌توانید یک نقش را با کاربران مرتبط حذف کنید.",
                        "needs_permission": "شما باید حداقل یک مجوز برای این نقش انتخاب کنید.",
                        "not_found": "این نقش وجود ندارد.",
                        "update_error": "مشکلی در به‌روز رسانی این نقش وجود داشت. لطفا دوباره تلاش کنید."
                    },
                    "users": {
                        "already_confirmed": "این کاربر قبلا تایید شده است.",
                        "cant_confirm": "مشکلی در تأیید حساب کاربری وجود داشت.",
                        "cant_deactivate_self": "شما نمی‌توانید این کار را برای خود انجام دهید.",
                        "cant_delete_admin": "شما نمی‌توانید مدیر کل را حذف کنید.",
                        "cant_delete_self": "شما نمی‌توانید خودتان را حذف کنید",
                        "cant_delete_own_session": "شما نمی‌توانید جلسه خود را حذف کنید.",
                        "cant_restore": "این کاربر حذف نشده است بنابراین نمی‌توان آن را بازیابی کرد.",
                        "cant_unconfirm_admin": "شما نمی‌توانید مدیر کل را رد یا تأیید کنید",
                        "cant_unconfirm_self": "شما نمی‌توانید خودتان را رد یا تأیید کنید.",
                        "create_error": "مشکلی در ایجاد این کاربر ایجاد شد. لطفا دوباره تلاش کنید.",
                        "delete_error": "مشکلی در حذف این کاربر ایجاد شد. لطفا دوباره تلاش کنید.",
                        "delete_first": "این کاربر قبل از اینکه بتواند حذف همیشگی شود ابتدا باید حذف شود.",
                        "email_error": "این رایانامه متعلق به کاربر دیگری است.",
                        "mark_error": "مشکلی در ویرایش این کاربر ایجاد شد. لطفا دوباره تلاش کنید.",
                        "not_confirmed": "این کاربر تائید نشده است.",
                        "not_found": "این کاربر وجود ندارد.",
                        "restore_error": "مشکلی در بازیابی این کاربر ایجاد شد. لطفا دوباره تلاش کنید.",
                        "role_needed_create": "شما باید حداقل یک نقش را انتخاب کنید.",
                        "role_needed": "شما باید حداقل یک نقش را انتخاب کنید.",
                        "session_wrong_driver": "راه‌انداز جلسه شما باید برای استفاده از این ویژگی به پایگاه داده تنظیم شود.",
                        "social_delete_error": "مشکلی در حذف حساب کاربری شبکه اجتماعی کاربر وجود داشت.",
                        "update_error": "مشکلی در ویرایش این کاربر ایجاد شد. لطفا دوباره تلاش کنید.",
                        "update_password_error": "مشکلی در تغییر گذرواژه این کاربر ایجاد شد. لطفا دوباره تلاش کنید."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "حساب کاربری شما قبلا تایید شده است.",
                        "confirm": "اکانت خود را تائید کنید!",
                        "created_confirm": "حساب شما با موفقیت ایجاد شد. ما برای تأیید حساب کاربری، یک رایانامه فرستادیم",
                        "created_pending": "حساب شما با موفقیت ایجاد شد و مورد تایید قرار دارد. در صورت تأیید حساب شما، یک رایانامه ارسال می‌شود.",
                        "mismatch": "کد تأیید شما مطابقت ندارد.",
                        "not_found": "این کد تأیید وجود ندارد.",
                        "pending": "حساب شما در حال تایید است.",
                        "resend": "حساب شما تأیید نشده است لطفا روی پیوند تأیید در رایانامه خود کلیک کنید یا برای ارسال مجدد تأیید رایانامه <a href=\"https://elearning.heilpferde.de/account/confirm/resend/{user_uuid}\">اینجا</a> را کلیک کنید.",
                        "success": "حساب شما با موفقیت تایید شده است!",
                        "resent": "یک رایانامه تایید جدید به آدرس در فایل فرستاده شده است."
                    },
                    "deactivated": "حساب کاربری شما غیرفعال شده است.",
                    "email_taken": "این رایانامه قبلا گرفته شده است.",
                    "password": {
                        "change_mismatch": "این گذرواژه قدیمی شما نیست.",
                        "reset_problem": "یک مشکل بازنشانی گذرواژه شما وجود داشت. لطفا رایانامه بازنشانی گذرواژه را دوباره ارسال کنید."
                    },
                    "registration_disabled": "ثبت نام در حال حاضر بسته است."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; قبلی",
            "next": "بعدی &raquo;"
        },
        "roles": {
            "administrator": "مدیرکل",
            "user": "کاربر"
        },
        "navs": {
            "general": {
                "home": "خانه",
                "logout": "خروج"
            },
            "frontend": {
                "contact": "تماس",
                "dashboard": "داشبورد",
                "login": "ورود",
                "macros": "ماکرو",
                "register": "ثبت نام",
                "user": {
                    "account": "حساب من",
                    "administration": "مدیریت",
                    "change_password": "تغییر گذرواژه",
                    "my_information": "اطلاعات من",
                    "profile": "پروفایل"
                }
            }
        }
    },
    "fr": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Êtes-vous sûr de vouloir supprimer cet utilisateur de façon permanente ? Toutes les références à cet utilisateur dans cette application peuvent provoquer des erreurs et cette opération ne peut être annullée.",
                        "if_confirmed_off": "(pour le mode sans confirmation)",
                        "restore_user_confirm": "Restaurer cet utilisateur à son statut original ?"
                    }
                },
                "dashboard": {
                    "title": "Tableau de bord de l'administration",
                    "welcome": "Bienvenue"
                },
                "general": {
                    "all_rights_reserved": "Tous droits réservés.",
                    "are_you_sure": "Êtes-vous sûr ?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Continuer",
                    "member_since": "Membre depuis",
                    "minutes": " minutes.",
                    "search_placeholder": "Rechercher...",
                    "timeout": "Vous avez été automatiquement déconnecté pour cause d'inactivité pendant ",
                    "see_all": {
                        "messages": "Voir tous les messages",
                        "notifications": "Voir toutes les notifications",
                        "tasks": "Voir les nouvelles tâches"
                    },
                    "status": {
                        "online": "En ligne",
                        "offline": "Hors ligne"
                    },
                    "you_have": {
                        "messages": "{0} Vous n'avez pas de message ::: {1} Vous avez 1 message ::: [2,Inf] Vous avez {number} messages",
                        "notifications": "{0} Vous n'avez pas de notification ::: {1} Vous avez 1 notification ::: [2,Inf] Vous avez {number} notifications",
                        "tasks": "{0} Vous n'avez pas de tâche affectée ::: {1} Vous avez 1 tâche affectée ::: [2,Inf] Vous avez {number} tâches affectées"
                    }
                },
                "search": {
                    "empty": "Veuillez entrer un terme de recherche.",
                    "incomplete": "Vous devez mettre en place votre propre logique pour ce système.",
                    "title": "Résultats de recherche",
                    "results": "Résultats de la recherche {query}"
                },
                "welcome": "<p>Le thème CoreUI est créé par <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. Ceci est une version allégée avec seulement les styles et les scripts nécessaires pour le faire fonctionner. Téléchargez la version complète pour commencer à ajouter des composants à votre tableau de bord.</p>\n<p>Toutes les fonctionnalités sont dédiées à l'affichage, à l'exception de la <strong>Gestion des utilisateurs</strong> à gauche. Ce projet boilerplate est livré avec une bibliothèque de contrôle d'accès entièrement fonctionnelle pour gérer les utilisateurs / rôles / permmissions.</p>\n<p>Gardez à l'esprit que c'est un travail en cours et qu'il peut subsister quelques anomalies ou bugs qui n'ont pas été corrigés. Je ferai de mon mieux pour y remédier.</p>\n<p>J'espère que vous apprécierez le travail que j'ai mis dans ce projet. Visitez la page <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> pour plus d'informations et enregistrez les <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">anomalies ici</a>.</p>\n<p><strong>Ce projet demande beaucoup d'efforts au vu du rythme soutenu des changements apportés à la branche master de Laravel, toute aide est bienvenue.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Votre compte a été confirmé.",
                    "error": "Oups !",
                    "greeting": "Bonjour !",
                    "regards": "Salutations,",
                    "trouble_clicking_button": "Si vous ne pouvez pas cliquer sur le bouton '{action_text}', copiez et collez l'URL ci-dessous dans un navigateur:",
                    "thank_you_for_using_app": "Merci d'utiliser notre application !",
                    "password_reset_subject": "Votre lien de réinitialisation",
                    "password_cause_of_email": "Vous recevez cet email car nous avons reçu une demande de réinitialisation de mot de passe pour ce compte.",
                    "password_if_not_requested": "Si vous n'avez pas effectué cette demande, aucune autre action n'est requise.",
                    "reset_password": "Cliquez ici pour réinitialiser votre mot de passe",
                    "click_to_confirm": "Cliquez ici pour confirmer votre compte :"
                },
                "contact": {
                    "email_body_title": "Vous avez une nouvelle prise de contact dont voici les détails :",
                    "subject": "Nouvelle soumission du formulaire de contact sur {app_name} !"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Helper sur la base de la permissions : ",
                        "role": "Helper sur la base du rôle : "
                    },
                    "js_injected_from_controller": "Javascript injecté depuis un contrôleur",
                    "using_blade_extensions": "Utilisation des extensions Blade",
                    "using_access_helper": {
                        "array_permissions": "L'utilisateur doit disposer de toutes les permissions d'un tableau, identifiées soit par leur ID, soit par leur nom.",
                        "array_permissions_not": "L'utilisateur doit disposer d'au moins une des permissions d'un tableau, identifiées soit par leur ID, soit par leur nom.",
                        "array_roles": "L'utilisateur doit disposer de tous les rôles d'un tableau, identifiés soit par leur ID, soit par leur nom.",
                        "array_roles_not": "L'utilisateur doit disposer d'au moins un des rôles d'un tableau, identifiés soit par leur ID, soit par leur nom.",
                        "permission_id": "L'utilisateur doit disposer d'une permission identifiée par son ID",
                        "permission_name": "L'utilisateur doit disposer d'une permission identifiée par son nom",
                        "role_id": "L'utilisateur doit disposer d'un rôle identifié par son ID",
                        "role_name": "L'utilisateur doit disposer d'un rôle identifié par son nom"
                    },
                    "view_console_it_works": "Sur la console du navigateur, vous devriez voir 'it works!', ce qui est produit depuis le FrontendController@index",
                    "you_can_see_because": "Vous voyez ce message car vous disposez du rôle '{role}' !",
                    "you_can_see_because_permission": "Vous voyez ce message car vous disposez de la permission '{permission}' !"
                },
                "general": {
                    "joined": "Membre depuis"
                },
                "user": {
                    "change_email_notice": "Si vous changez votre adresse email vous serez déconnecté jusqu'à que vous confirmiez votre nouvelle adresse email.",
                    "email_changed_notice": "Vous devez confirmer votre nouvelle adresse email avant de pouvoir vous connecter de nouveau.",
                    "profile_updated": "Profil modifié avec succès.",
                    "password_updated": "Mot de passe modifié avec succès."
                },
                "welcome_to": "Bienvenue sur {place}"
            }
        },
        "auth": {
            "failed": "Ces informations de connexion ne correspondent pas.",
            "general_error": "Vous n'avez pas les droits requis pour cette action.",
            "password_used": "Vous ne pouvez pas utiliser un mot de passe que vous avez déjà utilisé",
            "socialite": {
                "unacceptable": "Le login {provider} est de type incorrect."
            },
            "throttle": "Vous avez effectué trop de tentatives de connexion. Veuillez ré-essayer dans {seconds} secondes.",
            "unknown": "Une erreur inconnue est survenue."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Gestion des accès",
                    "roles": {
                        "all": "Tous les rôles",
                        "create": "Créer un rôle",
                        "edit": "Éditer un rôle",
                        "management": "Gestion des rôles",
                        "main": "Rôles"
                    },
                    "users": {
                        "all": "Tous les utilisateurs",
                        "change-password": "Changer le mot de passe",
                        "create": "Créer un utilisateur",
                        "deactivated": "Utilisateurs désactivés",
                        "deleted": "Utilisateurs supprimés",
                        "edit": "Éditer un utilisateur",
                        "main": "Utilisateurs",
                        "view": "Voir un utilisateur"
                    }
                },
                "log-viewer": {
                    "main": "Consulter les logs",
                    "dashboard": "Tableau de bord",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Tableau de bord",
                    "general": "Général",
                    "system": "Système"
                }
            },
            "language-picker": {
                "language": "Langue",
                "langs": {
                    "ar": "العربية (Arabic)",
                    "zh": "Chinois simplifié (Chinese Simplified)",
                    "zh-TW": "Chinois traditionnel (Chinese Traditional)",
                    "da": "Danois (Danish)",
                    "de": "Allemand (German)",
                    "el": "Grec (Greek)",
                    "en": "Anglais (English)",
                    "es": "Espagnol (Spanish)",
                    "fa": "Persan (Persian)",
                    "fr": "Français (French)",
                    "he": "Hébreu (Hebrew)",
                    "id": "Indonésien (Indonesian)",
                    "it": "Italien (Italian)",
                    "ja": "Japonais (Japanese)",
                    "nl": "Hollandais (Dutch)",
                    "no": "Norvégien (Norwegian)",
                    "pt_BR": "Portugais (Brazilian Portuguese)",
                    "ru": "Russe (Russian)",
                    "sv": "Suédois (Swedish)",
                    "th": "Thaïlandais (Thai)",
                    "tr": "Turc (Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Activer",
                        "change_password": "Changer de mot de passe",
                        "clear_session": "Effacer la session",
                        "confirm": "Confirmer",
                        "deactivate": "Désactiver",
                        "delete_permanently": "Supprimer définitivement",
                        "login_as": "Se connecter an tant que {user}",
                        "resend_email": "Renvoyer le mail de confirmation",
                        "restore_user": "Réactiver l'utilisateur",
                        "unconfirm": "Infirmer",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Confirmer le compte",
                    "reset_password": "Réinitialiser le mot de passe"
                }
            },
            "general": {
                "cancel": "Annuler",
                "continue": "Continuer",
                "crud": {
                    "create": "Créer",
                    "delete": "Supprimer",
                    "edit": "Editer",
                    "update": "Mettre à jour",
                    "view": "Voir"
                },
                "save": "Sauvegarder",
                "view": "Voir"
            }
        },
        "passwords": {
            "password": "Les mots de passe doivent contenir au moins six caractères et doivent être identiques.",
            "reset": "Votre mot de passe a été modifié !",
            "sent": "Un email contenant un lien de réinitialisation vous a été envoyé !",
            "token": "Ce jeton de réinitialisation du mot de passe n'est pas valide.",
            "user": "Aucun utilisateur n'est enregistré avec cette adresse email."
        },
        "http": {
            "404": {
                "title": "Page introuvable",
                "description": "Désolé, cette page n'existe pas."
            },
            "503": {
                "title": "Bientôt de retour.",
                "description": "Bientôt de retour."
            }
        },
        "labels": {
            "general": {
                "all": "Tout",
                "yes": "Oui",
                "no": "Non",
                "custom": "Personnalisé",
                "actions": "Actions",
                "active": "Active",
                "buttons": {
                    "save": "Enregistrer",
                    "update": "Mettre à jour"
                },
                "hide": "Cacher",
                "inactive": "Inactive",
                "none": "Aucun",
                "show": "Voir",
                "toggle_navigation": "Navigation"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Créer un rôle",
                        "edit": "Editer un rôle",
                        "management": "Gestion des rôles",
                        "table": {
                            "number_of_users": "Nombre d'utilisateurs",
                            "permissions": "Permissions",
                            "role": "Rôle",
                            "sort": "Ordre",
                            "total": "rôle total ::: rôles total"
                        }
                    },
                    "users": {
                        "active": "Utilisateurs actifs",
                        "all_permissions": "Toutes les permissions",
                        "change_password": "Modifier le mot de passe",
                        "change_password_for": "Modifier le mot de passe pour {user}",
                        "create": "Créer un utilisateur",
                        "deactivated": "Utilisateurs désactivés",
                        "deleted": "Utilisateurs supprimés",
                        "edit": "Éditer un utilisateur",
                        "management": "Gestion des utilisateurs",
                        "no_permissions": "Aucune permission",
                        "no_roles": "Aucun rôle à affecter.",
                        "permissions": "Permissions",
                        "table": {
                            "confirmed": "Confirmé",
                            "created": "Création",
                            "email": "Adresse email",
                            "id": "ID",
                            "last_updated": "Mise à jour",
                            "name": "Nom",
                            "first_name": "Prénom",
                            "last_name": "Nom",
                            "no_deactivated": "Pas d'utilisateurs désactivés",
                            "no_deleted": "Pas d'utilisateurs supprimés",
                            "other_permissions": "Autres permissions",
                            "permissions": "Permissions",
                            "roles": "Rôles",
                            "social": "Réseau social",
                            "total": "utilisateur total ::: utilisateurs total"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Résumé",
                                "history": "Historique"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmé",
                                    "created_at": "Créé le",
                                    "deleted_at": "Supprimé le",
                                    "email": "Adresse email",
                                    "last_updated": "Mise à jour",
                                    "name": "Nom complet",
                                    "first_name": "Prénom",
                                    "last_name": "Nom",
                                    "status": "Statut"
                                }
                            }
                        },
                        "view": "Voir un utilisateur"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Connexion",
                    "login_button": "Entrer",
                    "login_with": "Se connecter avec {social_media}",
                    "register_box_title": "S'enregistrer",
                    "register_button": "Créer le compte",
                    "remember_me": "Se souvenir de moi"
                },
                "contact": {
                    "box_title": "Nous contacter",
                    "button": "Envoyer le message"
                },
                "passwords": {
                    "forgot_password": "Avez-vous oublié votre mot de passe&nbsp;?",
                    "reset_password_box_title": "Réinitialisation du mot de passe",
                    "reset_password_button": "Réinitialiser le mot de passe",
                    "send_password_reset_link_button": "Envoyer le lien de réinitialisation"
                },
                "user": {
                    "passwords": {
                        "change": "Modifier le mot de passe"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Date de création",
                        "edit_information": "Éditer les informations",
                        "email": "Adresse email",
                        "last_updated": "Date de mise à jour",
                        "name": "Nom complet",
                        "first_name": "Prénom",
                        "last_name": "Nom",
                        "update_information": "Mettre à jour les informations"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Rôle créé avec succès.",
                    "deleted": "Rôle supprimé avec succès.",
                    "updated": "Rôle mis à jour avec succès."
                },
                "users": {
                    "cant_resend_confirmation": "L'application est actuellement paramétrée avec une validation manuelle des utilisateurs.",
                    "confirmation_email": "Un email de confirmation a été adressé à l'adresse indiquée.",
                    "confirmed": "Le compte de l'utilisateur a été confirmé avec succès.",
                    "created": "Utilisateur créé avec succès.",
                    "deleted": "Utilisateur supprimé avec succès.",
                    "deleted_permanently": "L'utilisateur a été supprimé définitivement.",
                    "restored": "L'utilisateur a été ré-activé.",
                    "session_cleared": "La session de l'utilisateur a été effacé avec succès.",
                    "social_deleted": "Le compte de réseau social a été effacé avec succès.",
                    "unconfirmed": "Le compte de l'utilisateur a été infirmé avec succès.",
                    "updated": "Utilisateur mis à jour avec succès.",
                    "updated_password": "Le mot de passe utilisateur a été mis à jour avec succès."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Votre message a été envoyé avec succès. Nous répondrons à l'adresse email que vous nous avez fourni dès que nous le pourrons."
                }
            }
        },
        "validation": {
            "accepted": "Le champ {attribute} doit être accepté.",
            "active_url": "Le champ {attribute} n'est pas une URL valide.",
            "after": "Le champ {attribute} doit être une date postérieure au {date}.",
            "after_or_equal": "Le champ {attribute} doit être une date postérieure ou égale au {date}.",
            "alpha": "Le champ {attribute} doit seulement contenir des lettres.",
            "alpha_dash": "Le champ {attribute} doit seulement contenir des lettres, des chiffres et des tirets.",
            "alpha_num": "Le champ {attribute} doit seulement contenir des chiffres et des lettres.",
            "array": "Le champ {attribute} doit être un tableau.",
            "before": "Le champ {attribute} doit être une date antérieure au {date}.",
            "before_or_equal": "Le champ {attribute} doit être une date antérieure ou égale au {date}.",
            "between": {
                "numeric": "La valeur de {attribute} doit être comprise entre {min} et {max}.",
                "file": "La taille du fichier de {attribute} doit être comprise entre {min} et {max} kilo-octets.",
                "string": "Le texte {attribute} doit contenir entre {min} et {max} caractères.",
                "array": "Le tableau {attribute} doit contenir entre {min} et {max} éléments."
            },
            "boolean": "Le champ {attribute} doit être vrai ou faux.",
            "confirmed": "Le champ de confirmation {attribute} ne correspond pas.",
            "date": "Le champ {attribute} n'est pas une date valide.",
            "date_format": "Le champ {attribute} ne correspond pas au format {format}.",
            "different": "Les champs {attribute} et {other} doivent être différents.",
            "digits": "Le champ {attribute} doit contenir {digits} chiffres.",
            "digits_between": "Le champ {attribute} doit contenir entre {min} et {max} chiffres.",
            "dimensions": "Les dimensions de l'image {attribute} ne sont pas conformes.",
            "distinct": "Le champ {attribute} doit être une valeur unique.",
            "email": "Le champ {attribute} doit être une adresse email valide.",
            "exists": "Le champ {attribute} n'existe pas.",
            "file": "Le champ {attribute} doit être un fichier.",
            "filled": "Le champ {attribute} est obligatoire.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "Le champ {attribute} doit être une image.",
            "in": "Le champ {attribute} est invalide.",
            "in_array": "Le champ {attribute} n'existe pas dans {other}.",
            "integer": "Le champ {attribute} doit être un entier.",
            "ip": "Le champ {attribute} doit être une adresse IP valide.",
            "ipv4": "Le champ {attribute} doit être une adresse IPv4 valide.",
            "ipv6": "Le champ {attribute} doit être une adresse IPv6 valide.",
            "json": "Le champ {attribute} doit être un document JSON valide.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "La valeur de {attribute} ne peut être supérieure à {max}.",
                "file": "La taille du fichier de {attribute} ne peut pas dépasser {max} kilo-octets.",
                "string": "Le texte de {attribute} ne peut contenir plus de {max} caractères.",
                "array": "Le tableau {attribute} ne peut contenir plus de {max} éléments."
            },
            "mimes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "mimetypes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "min": {
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {min}.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {min} kilo-octets.",
                "string": "Le texte {attribute} doit contenir au moins {min} caractères.",
                "array": "Le tableau {attribute} doit contenir au moins {min} éléments."
            },
            "not_in": "Le champ {attribute} sélectionné n'est pas valide.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "Le champ {attribute} doit contenir un nombre.",
            "present": "Le champ {attribute} doit être présent.",
            "regex": "Le format du champ {attribute} est invalide.",
            "required": "Le champ {attribute} est obligatoire.",
            "required_if": "Le champ {attribute} est obligatoire lorsque {other} est {value}.",
            "required_unless": "Le champ {attribute} est obligatoire sauf si {other} est {value}.",
            "required_with": "Le champ {attribute} est obligatoire lorsque {values} a une valeur.",
            "required_with_all": "Le champ {attribute} est obligatoire lorsque {values} existe.",
            "required_without": "Le champ {attribute} est obligatoire lorsque {values} n'a pas de valeur.",
            "required_without_all": "Le champ {attribute} est obligatoire lorsque {values} n'existe pas.",
            "same": "Les champs {attribute} et {other} doivent être identiques.",
            "size": {
                "numeric": "Le champ {attribute} doit avoir une taille de {size}.",
                "file": "La taille du fichier de {attribute} doit être de {size} kilo-octets.",
                "string": "Le texte de {attribute} doit contenir {size} caractères.",
                "array": "Le tableau {attribute} doit contenir {size} éléments."
            },
            "string": "Le champ {attribute} doit être une chaîne de caractères.",
            "timezone": "Le champ {attribute} doit être un fuseau horaire valide.",
            "unique": "La valeur du champ {attribute} est déjà utilisée.",
            "uploaded": "Le fichier du champ {attribute} n'a pu être téléchargé.",
            "url": "Le format de 'URL de {attribute} n'est pas valide.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Rôles associés",
                            "dependencies": "Dépendances",
                            "display_name": "Nom affiché",
                            "group": "Groupe",
                            "group_sort": "Ordre du groupe",
                            "groups": {
                                "name": "Nom du groupe"
                            },
                            "name": "Nom complet",
                            "first_name": "Prénom",
                            "last_name": "Nom",
                            "system": "Système"
                        },
                        "roles": {
                            "associated_permissions": "Permissions associées",
                            "name": "Nom",
                            "sort": "Ordre"
                        },
                        "users": {
                            "active": "Actif",
                            "associated_roles": "Rôles associés",
                            "confirmed": "Confirmé",
                            "email": "Adresse email",
                            "name": "Nom complet",
                            "first_name": "Prénom",
                            "last_name": "Nom",
                            "other_permissions": "Autres permissions",
                            "password": "Mot de passe",
                            "password_confirmation": "Confirmation du mot de passe",
                            "send_confirmation_email": "Envoyer un email de confirmation"
                        }
                    }
                },
                "frontend": {
                    "avatar": "Avatar",
                    "email": "Adresse email",
                    "last_name": "Nom",
                    "first_name": "Prénom",
                    "name": "Nom complet",
                    "password": "Mot de passe",
                    "password_confirmation": "Confirmation",
                    "phone": "Téléphone",
                    "message": "Message",
                    "new_password": "Nouveau mot de passe",
                    "new_password_confirmation": "Confirmation du nouveau mot de passe",
                    "old_password": "Ancien mot de passe",
                    "timezone": "Fuseau Horaire"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Un rôle portant ce nom existe déjà.",
                        "cant_delete_admin": "Le rôle Administrator ne peut être supprimé.",
                        "create_error": "Un problème est survenu lors de la création du rôle. Veuillez réessayer.",
                        "delete_error": "Un problème est survenu lors de la suppression du rôle. Veuillez réessayer.",
                        "has_users": "Ce rôle est associé à des utilisateurs et ne peut être supprimé.",
                        "needs_permission": "Vous devez sélectionner au moins une permission pour ce rôle.",
                        "not_found": "Ce rôle n'existe pas.",
                        "update_error": "Un problème est survenu lors de la mise à jour du rôle. Veuillez réessayer."
                    },
                    "users": {
                        "already_confirmed": "Le compte de cet utilisateur est déjà confirmé.",
                        "cant_confirm": "Un problème est survenu lors de la confirmation du compte de l'utilisateur.",
                        "cant_deactivate_self": "Vous ne pouvez pas désactiver votre propre compte d'utilisateur.",
                        "cant_delete_admin": "Vous ne pouvez pas supprimer le compte d'utilisateur du super administrateur.",
                        "cant_delete_self": "Vous ne pouvez pas supprimer votre propre compte d'utilisateur.",
                        "cant_delete_own_session": "Vous ne pouvez pas supprimer votre propre session.",
                        "cant_restore": "Cet utilisateur n'est pas effacé et ne peut être restauré.",
                        "cant_unconfirm_admin": "Vous ne pouvez pas infirmer le compte d'utilisateur du super administrateur.",
                        "cant_unconfirm_self": "Vous ne pouvez pas infirmer votre propre compte d'utilisateur.",
                        "create_error": "Un problème est survenu lors de la création de l'utilisateur. Veuillez réessayer.",
                        "delete_error": "Un problème est survenu lors de la suppression de l'utilisateur. Veuillez réessayer.",
                        "delete_first": "Cet utilisateur doit d'abord être supprimé avant de pouvoir être supprimé de façon permanente.",
                        "email_error": "Cette adresse email appartient à un autre utilisateur.",
                        "mark_error": "Un problème est survenu lors de la mise à jour de l'utilisateur. Veuillez réessayer.",
                        "not_confirmed": "Le compte de cet utilisateur n'est pas confirmé.",
                        "not_found": "Cet utilisateur n'existe pas.",
                        "restore_error": "Un problème est survenu lors de la restauration de l'utilisateur. Veuillez réessayer.",
                        "role_needed_create": "Vous devez sélectionner au moins un rôle.",
                        "role_needed": "Vous devez sélectionner au moins un rôle.",
                        "session_wrong_driver": "Votre pilote de session doit être configuré avec une base de données pour utiliser cette fonctionalité.",
                        "social_delete_error": "Un problème est survenu lors de la suppression du compte de réseau social de l'utilisateur.",
                        "update_error": "Un problème est survenu lors de la mise à jour de l'utilisateur. Veuillez réessayer.",
                        "update_password_error": "Un problème est survenu lors du changement du mot de passe de l'utilisateur. Veuillez réessayer."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Votre compte est déjà confirmé.",
                        "confirm": "Confirmez votre compte !",
                        "created_confirm": "Votre compte a été créé avec succès.  Un email de confirmation vous a été envoyé.",
                        "created_pending": "Votre compte a été créé avec succès et est en attente de validation. Un email vous sera envoyé quand votre compte sera validé.",
                        "mismatch": "Votre code de confirmation est invalide.",
                        "not_found": "Votre code de confirmation n'existe pas.",
                        "pending": "Votre compte est actuellement en attente de validation.",
                        "resend": "Votre compte n'est pas confirmé. Veuillez utiliser le lien qui vous a été envoyé par email, ou <a href=\"{url}\">cliquez ici </a> pour recevoir un nouvel email.",
                        "success": "Votre compte est maintenant confirmé !",
                        "resent": "Un nouvel email a été envoyé à l'adresse enregistrée."
                    },
                    "deactivated": "Votre compte a été désactivé.",
                    "email_taken": "Cet email est déjà utilisé par un compte existant.",
                    "password": {
                        "change_mismatch": "L'ancien mot de passe est incorrect.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Précédent",
            "next": "Suivant &raquo;"
        },
        "roles": {
            "administrator": "Administrateur",
            "user": "Utilisateur"
        },
        "navs": {
            "general": {
                "home": "Accueil",
                "logout": "Déconnexion"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Tableau de bord",
                "login": "Connexion",
                "macros": "Macros",
                "register": "S'enregistrer",
                "user": {
                    "account": "Mon compte",
                    "administration": "Administration",
                    "change_password": "Changer mon mot de passe",
                    "my_information": "Mes informations",
                    "profile": "Profil"
                }
            }
        }
    },
    "he": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "האם את/ה בטוח/ה שברצונך למחוק את המשתמש לצמיתות? כל מקום באפליקציה שקשור למשתמש זה כנראה יסבול מתקלות. ראו הוזהרתם, מחיקה לצמיתות היא בלתי הפיכה.",
                        "if_confirmed_off": "(אם האימות כבוי)",
                        "no_deactivated": "אין משתמשים מכובים.",
                        "no_deleted": "אין משתמשים מחוקים.",
                        "restore_user_confirm": "לשחזר את המשתמש למצבו המקורי?"
                    }
                },
                "dashboard": {
                    "title": "לוח בקרה",
                    "welcome": "ברוכים הבאים"
                },
                "general": {
                    "all_rights_reserved": "כל הזכויות שמורות.",
                    "are_you_sure": "האם את/ה בטוח/ה שאת/ה רוצה לעשות את זה?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "המשך",
                    "member_since": "חבר מאז",
                    "minutes": " דקות",
                    "search_placeholder": "חיפוש...",
                    "timeout": "המשתמש שלך נותק אוטומטית מטעמי אבטחה, כי הוא לא פעיל כבר ",
                    "see_all": {
                        "messages": "הצג את כל ההודעות",
                        "notifications": "הצג הכל",
                        "tasks": "הצג את כל המשימות"
                    },
                    "status": {
                        "online": "מחובר/ת",
                        "offline": "מנותק/ת"
                    },
                    "you_have": {
                        "messages": "{0} אין לך הודעות ::: {1} יש לך הודעה אחת ::: [2,Inf] יש לך {number} הודעות",
                        "notifications": "{0} אין לך התראות ::: {1} יש לך התראה אחת ::: [2,Inf] יש לך {number} התראות",
                        "tasks": "{0} אין לך משימות ::: {1} יש לך משימה אחת ::: [2,Inf] יש לך {number} משימות"
                    }
                },
                "search": {
                    "empty": "יש להקליד מילת חיפוש.",
                    "incomplete": "אתה צריך לכתוב לוגיקת חיפוש משלך למערכת הזו.",
                    "title": "תוצאות חיפוש",
                    "results": "תוצאות חיפוש עבור {query}"
                },
                "welcome": "<p>This is the CoreUI theme by <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. This is a stripped down version with only the necessary styles and scripts to get it running. Download the full version to start adding components to your dashboard.</p>\n<p>All the functionality is for show with the exception of the <strong>Access</strong> to the left. This boilerplate comes with a fully functional access control library to manage users/roles/permissions.</p>\n<p>Keep in mind it is a work in progress and their may be bugs or other issues I have not come across. I will do my best to fix them as I receive them.</p>\n<p>Hope you enjoy all of the work I have put into this. Please visit the <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> page for more information and report any <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">issues here</a>.</p>\n<p><strong>This project is very demanding to keep up with given the rate at which the master Laravel branch changes, so any help is appreciated.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "החשבון שלך אומת.",
                    "error": "אופס!",
                    "greeting": "אהלן!",
                    "regards": "בברכה,",
                    "trouble_clicking_button": "אם יש סיבוך בלחיצה על הכפתור \"{action_text}\", אפשר להדביק את הקישור הבא בשורת הכתובת בדפדפן:",
                    "thank_you_for_using_app": "תודה על השימוש באפליקציה שלנו!",
                    "password_reset_subject": "איפוס סיסמה",
                    "password_cause_of_email": "המייל הזה הגיע אליך כי מישהו ביקש לאפס את הסיסמה של החשבון שלך.",
                    "password_if_not_requested": "אם לא ביקשת איפוס סיסמה, אין צורך בפעולה נוספת.",
                    "reset_password": "לחצו כאן לאיפוס הסיסמה",
                    "click_to_confirm": "לחץ/י כאן לאימות החשבון:"
                },
                "contact": {
                    "email_body_title": "מישהו השאיר פנייה בטופס צור קשר. הנה הפרטים:",
                    "subject": "פנייה חדשה מטופס צור קשר - {app_name}"
                }
            },
            "frontend": {
                "test": "בדיקה",
                "tests": {
                    "based_on": {
                        "permission": "מבוסס הרשאה - ",
                        "role": "מבוסס תפקיד - "
                    },
                    "js_injected_from_controller": "ג'אווה סקריפט הוזרק מהקונטרולר",
                    "using_blade_extensions": "שימוש בהרחבות בלייד",
                    "using_access_helper": {
                        "array_permissions": "Using Access Helper with Array of Permission Names or ID's where the user does have to possess all.",
                        "array_permissions_not": "Using Access Helper with Array of Permission Names or ID's where the user does not have to possess all.",
                        "array_roles": "Using Access Helper with Array of Role Names or ID's where the user does have to possess all.",
                        "array_roles_not": "Using Access Helper with Array of Role Names or ID's where the user does not have to possess all.",
                        "permission_id": "Using Access Helper with Permission ID",
                        "permission_name": "Using Access Helper with Permission Name",
                        "role_id": "Using Access Helper with Role ID",
                        "role_name": "Using Access Helper with Role Name"
                    },
                    "view_console_it_works": "View console, you should see 'it works!' which is coming from FrontendController@index",
                    "you_can_see_because": "את/ה יכול/ה לראות את זה כי יש לך את התפקיד '{role}'!",
                    "you_can_see_because_permission": "את/ה יכול/ה לראות את זה כי יש לך את ההרשאה '{permission}'!"
                },
                "general": {
                    "joined": "צורף"
                },
                "user": {
                    "change_email_notice": "בהחלפת כתובת מייל תנותקו מהמערכת, ותצטרכו לאמת את הכתובת החדשה כדי להתחבר שוב.",
                    "email_changed_notice": "נשלח מייל אימות לכתובת החדשה. כדי להתחבר שוב, חובה לאמת את כתובת הדוא\"ל.",
                    "profile_updated": "הפרופיל עודכן בהצלחה.",
                    "password_updated": "הסיסמה עודכנה בהצלחה."
                },
                "welcome_to": "ברוכים הבאים ל{place}"
            }
        },
        "auth": {
            "failed": "פרטי ההתחברות שהזנת לא נכונים.",
            "general_error": "אין לך גישה לפה.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "לא ניתן להתחבר באמצעות {provider}."
            },
            "throttle": "יותר מדי ניסיונות התחברות. אפשר לנסות שוב בעוד {seconds} שניות.",
            "unknown": "התרחשה שגיאה."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "ניהול גישה",
                    "roles": {
                        "all": "כל התפקידים",
                        "create": "יצירת תפקיד",
                        "edit": "עריכת תפקיד",
                        "management": "ניהול תפקידים",
                        "main": "תפקידים"
                    },
                    "users": {
                        "all": "כל המשתמשים",
                        "change-password": "עדכון סיסמה",
                        "create": "יצירת משתמש",
                        "deactivated": "משתמשים לא פעילים",
                        "deleted": "משתמשים שנמחקו",
                        "edit": "עריכת משתמשים",
                        "main": "משתמשים",
                        "view": "הצג משתמש"
                    }
                },
                "log-viewer": {
                    "main": "קורא דו&quot;חות",
                    "dashboard": "לוח בקרה",
                    "logs": "דו&quot;חות"
                },
                "sidebar": {
                    "dashboard": "לוח בקרה",
                    "general": "כללי",
                    "system": "מערכת"
                }
            },
            "language-picker": {
                "language": "שפה",
                "langs": {
                    "ar": "ערבית (Arabic)",
                    "zh": "סינית מופשטת (Chinese Simplified)",
                    "zh-TW": "סינית מסורתית (Chinese Traditional)",
                    "da": "דנית (Danish)",
                    "de": "גרמנית (German)",
                    "el": "יוונית (Greek)",
                    "en": "אנגלית (English)",
                    "es": "ספרדית (Spanish)",
                    "fa": "פַּרסִית (Persian)",
                    "fr": "צרפתית (French)",
                    "he": "עברית (Hebrew)",
                    "id": "אינדונזית (Indonesian)",
                    "it": "איטלקית (Italian)",
                    "ja": "יפנית (Japanese)",
                    "nl": "הולנדית (Dutch)",
                    "no": "נורווגית (Norwegian)",
                    "pt_BR": "פורטוגזית ברזילאית (Brazilian Portuguese)",
                    "ru": "רוסית (Russian)",
                    "sv": "שוודית (Swedish)",
                    "th": "תאית (Thai)",
                    "tr": "תורכית (Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "הפעל",
                        "change_password": "שינוי סיסמא",
                        "clear_session": "נקה סשן התחברות",
                        "confirm": "אישור",
                        "deactivate": "ביטול הפעלה",
                        "delete_permanently": "מחיקה לצמיתות",
                        "login_as": "התחברות בתור {user}",
                        "resend_email": "שלח לי שוב מייל הפעלה",
                        "restore_user": "שחזור משתמש",
                        "unconfirm": "בטל אישור",
                        "unlink": "נתק"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "אישור חשבון",
                    "reset_password": "איפוס סיסמה"
                }
            },
            "general": {
                "cancel": "ביטול",
                "continue": "המשך",
                "crud": {
                    "create": "צור",
                    "delete": "מחק",
                    "edit": "עריכה",
                    "update": "עדכון",
                    "view": "הצג"
                },
                "save": "שמור",
                "view": "הצג"
            }
        },
        "passwords": {
            "password": "סיסמאות חייבות להיות באורך 6 תווים לפחות, ותואמות את האימות.",
            "reset": "הסיסמה שלך אופסה!",
            "sent": "שלחנו קישור לאיפוס סיסמה לכתובת הדוא\"ל שלך!",
            "token": "אסימון (טוקן) איפוס סיסמה לא תקין.",
            "user": "המייל הזה לא משוייך לאף משתמש שרשום במערכת."
        },
        "http": {
            "404": {
                "title": "העמוד לא נמצא",
                "description": "סליחה, אבל העמוד שאתם מנסים לראות לא קיים"
            },
            "503": {
                "title": "מיד נשוב.",
                "description": "מיד נשוב."
            }
        },
        "labels": {
            "general": {
                "all": "All",
                "yes": "Yes",
                "no": "No",
                "copyright": "Copyright",
                "custom": "Custom",
                "actions": "Actions",
                "active": "Active",
                "buttons": {
                    "save": "Save",
                    "update": "Update"
                },
                "hide": "Hide",
                "inactive": "Inactive",
                "none": "None",
                "show": "Show",
                "toggle_navigation": "Toggle Navigation"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Create Role",
                        "edit": "Edit Role",
                        "management": "Role Management",
                        "table": {
                            "number_of_users": "Number of Users",
                            "permissions": "Permissions",
                            "role": "Role",
                            "sort": "Sort",
                            "total": "role total ::: roles total"
                        }
                    },
                    "users": {
                        "active": "Active Users",
                        "all_permissions": "All Permissions",
                        "change_password": "Change Password",
                        "change_password_for": "Change Password for {user}",
                        "create": "Create User",
                        "deactivated": "Deactivated Users",
                        "deleted": "Deleted Users",
                        "edit": "Edit User",
                        "management": "User Management",
                        "no_permissions": "No Permissions",
                        "no_roles": "No Roles to set.",
                        "permissions": "Permissions",
                        "table": {
                            "confirmed": "Confirmed",
                            "created": "Created",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "Last Updated",
                            "name": "Name",
                            "first_name": "First Name",
                            "last_name": "Last Name",
                            "no_deactivated": "No Deactivated Users",
                            "no_deleted": "No Deleted Users",
                            "other_permissions": "Other Permissions",
                            "permissions": "Permissions",
                            "roles": "Roles",
                            "social": "Social",
                            "total": "user total ::: users total"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overview",
                                "history": "History"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmed",
                                    "created_at": "Created At",
                                    "deleted_at": "Deleted At",
                                    "email": "E-mail",
                                    "last_updated": "Last Updated",
                                    "name": "Name",
                                    "first_name": "First Name",
                                    "last_name": "Last Name",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "View User"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Login",
                    "login_button": "Login",
                    "login_with": "Login with {social_media}",
                    "register_box_title": "Register",
                    "register_button": "Register",
                    "remember_me": "Remember Me"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "expired_password_box_title": "Your password has expired.",
                    "forgot_password": "Forgot Your Password?",
                    "reset_password_box_title": "Reset Password",
                    "reset_password_button": "Reset Password",
                    "update_password_button": "Update Password",
                    "send_password_reset_link_button": "Send Password Reset Link"
                },
                "user": {
                    "passwords": {
                        "change": "Change Password"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Created At",
                        "edit_information": "Edit Information",
                        "email": "E-mail",
                        "last_updated": "Last Updated",
                        "name": "Name",
                        "first_name": "First Name",
                        "last_name": "Last Name",
                        "update_information": "Update Information"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "התפקיד נוצר בהצלחה.",
                    "deleted": "התפקיד נמחק בהצלחה.",
                    "updated": "התפקיד עודכן בהצלחה."
                },
                "users": {
                    "cant_resend_confirmation": "האפליקציה מוגדרת לאישור ידני של משתמשים בלבד.",
                    "confirmation_email": "מייל אימות חדש נשלח לכתובת השמורה במערכת.",
                    "confirmed": "המשתמש אומת בהצלחה.",
                    "created": "המשתמש נוצר בהצלחה.",
                    "deleted": "המשתמש נמחק בהצלחה.",
                    "deleted_permanently": "המשתמש נמחק לצמיתות.",
                    "restored": "המשתמש שוחזר בהצלחה.",
                    "session_cleared": "הסשן של המשתמש נמחק בהצלחה.",
                    "social_deleted": "חשבון סושיאל נמחק בהצלחה",
                    "unconfirmed": "האישור של המשתמש בוטל בהצלחה.",
                    "updated": "המשתמש עודכן בהצלחה.",
                    "updated_password": "הסיסמה עודכנה בהצלחה עבור המשתמש."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "הפנייה נשלחה בהצלחה, נחזור אליך בהקדם."
                }
            }
        },
        "validation": {
            "accepted": "השדה {attribute} חייב להכיל תקין.",
            "active_url": "השדה {attribute} אינו קישור תקין.",
            "after": "השדה {attribute} חייב להכיל תאריך אחרי {date}.",
            "after_or_equal": "השדה {attribute} חייב להכיל התאריך {date} או מאוחר יותר.",
            "alpha": "השדה {attribute} יכול להכיל אותיות בלבד.",
            "alpha_dash": "השדה {attribute} יכול להכיל אותיות, מספרים ומקפים בלבד.",
            "alpha_num": "השדה {attribute} יכול להכיל אותיות ומספרים בלבד.",
            "array": "השדה {attribute} חייב להכיל מערך.",
            "before": "השדה {attribute} חייב להכיל תאריך לפני {date}.",
            "before_or_equal": "השדה {attribute} חייב להכיל התאריך {date} או מוקדם יותר.",
            "between": {
                "numeric": "השדה {attribute} חייב להכיל בין {min} ל-{max}.",
                "file": "השדה {attribute} חייב להכיל בין {min} ל-{max} קילובייט.",
                "string": "השדה {attribute} חייב להכיל בין {min} ל-{max} תווים.",
                "array": "השדה {attribute} חייב להכיל בין {min} ל-{max} פריטים."
            },
            "boolean": "השדה {attribute} חייב להכיל אמת או שקר.",
            "confirmed": "אימות {attribute} לא מתאים.",
            "date": "השדה {attribute} אינו תאריך תקין.",
            "date_format": "השדה {attribute} לא תואם את הפורמט {format}.",
            "different": "השדה {attribute} ו-{other} חייבים להיות שונים זה מזה.",
            "digits": "השדה {attribute} חייב להכיל באורך {digits} ספרות.",
            "digits_between": "השדה {attribute} חייב להכיל בין {min} ל-{max} digits.",
            "dimensions": "מימדי התמונה בשדה {attribute} לא תקינים.",
            "distinct": "יש כפילות בשדה {attribute}.",
            "email": "השדה {attribute} חייב להכיל כתובת דוא\"ל תקינה.",
            "exists": "נבחר {attribute} לא תקין.",
            "file": "השדה {attribute} חייב להכיל קובץ.",
            "filled": "השדה {attribute} לא יכול להיות ריק.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "השדה {attribute} חייב להכיל תמונה.",
            "in": "נבחר {attribute} לא תקין.",
            "in_array": "השדה {attribute} לא קיים ב {other}.",
            "integer": "השדה {attribute} חייב להכיל מספר שלם.",
            "ip": "השדה {attribute} חייב להכיל כתובת IP תקינה.",
            "ipv4": "השדה {attribute} חייב להכיל כתובת IPv4 תקינה.",
            "ipv6": "השדה {attribute} חייב להכיל כתובת IPv6 תקינה.",
            "json": "השדה {attribute} חייב להכיל מחרוזת JSON.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "השדה {attribute} לא יכול להיות גדול מ-{max}.",
                "file": "השדה {attribute} לא יכול להיות גדול מ-{max} קילובייט.",
                "string": "השדה {attribute} לא יכול להיות גדול מ-{max} תווים.",
                "array": "השדה {attribute} לא יכול להכיל יותר מ-{max} פריטים."
            },
            "mimes": "השדה {attribute} חייב להיות קובץ מהסוג: {values}.",
            "mimetypes": "השדה {attribute} חייב להיות קובץ מהסוג: {values}.",
            "min": {
                "numeric": "השדה {attribute} חייב להכיל לפחות {min}.",
                "file": "השדה {attribute} חייב להכיל לפחות {min} קילובייט.",
                "string": "השדה {attribute} חייב להכיל לפחות {min} תווים.",
                "array": "השדה {attribute} חייב להכיל לפחות {min} פריטים."
            },
            "not_in": "נבחר {attribute} לא תקין.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "השדה {attribute} חייב להיות מספר.",
            "present": "השדה {attribute} חייב להיות נוכח.",
            "regex": "השדה {attribute} מכיל פורמט לא תקין.",
            "required": "השדה {attribute} הוא שדה חובה.",
            "required_if": "השדה {attribute} הוא שדה חובה כאשר {other} הינו {value}.",
            "required_unless": "השדה {attribute} הוא שדה חובה אלא אם {other} הינו {values}.",
            "required_with": "השדה {attribute} הוא שדה חובה כאשר {values} קיים.",
            "required_with_all": "השדה {attribute} הוא שדה חובה כאשר {values} קיים.",
            "required_without": "השדה {attribute} הוא שדה חובה כאשר {values} אינו קיים.",
            "required_without_all": "השדה {attribute} הוא שדה חובה כאשר אף אחד מהערכים {values} קיימים.",
            "same": "השדה {attribute} והשדה {other} חייבים להתאים זה לזה.",
            "size": {
                "numeric": "השדה {attribute} חייב להיות {size}.",
                "file": "השדה {attribute} חייב להיות {size} קילובייט.",
                "string": "השדה {attribute} חייב להיות {size} תווים.",
                "array": "השדה {attribute} חייב להכיל {size} פריטים."
            },
            "string": "השדה {attribute} חייב להיות מחרוזת.",
            "timezone": "השדה {attribute} חייב להיות איזור זמן.",
            "unique": "{attribute} זה כבר נתפס.",
            "uploaded": "הקובץ {attribute} לא הועלה.",
            "url": "הפורמט בשדה {attribute} לא תקין.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "תפקידים משוייכים",
                            "dependencies": "דרישות סף",
                            "display_name": "שם לתצוגה",
                            "group": "קבוצה",
                            "group_sort": "מיון קבוצות",
                            "groups": {
                                "name": "שם קבוצה"
                            },
                            "name": "שם",
                            "first_name": "שם פרטי",
                            "last_name": "שם משפחה",
                            "system": "מערכת"
                        },
                        "roles": {
                            "associated_permissions": "הרשאות משוייכות",
                            "name": "שם",
                            "sort": "מיון"
                        },
                        "users": {
                            "active": "פעיל",
                            "associated_roles": "תפקידים משוייכים",
                            "confirmed": "מאומת",
                            "email": "כתובת דוא\"ל",
                            "name": "שם",
                            "last_name": "שם משפחה",
                            "first_name": "שם פרטי",
                            "other_permissions": "הרשאות אחרות",
                            "password": "סיסמה",
                            "password_confirmation": "אימות סיסמה",
                            "send_confirmation_email": "שליחת מייל אימות",
                            "timezone": "איזור זמן"
                        }
                    }
                },
                "frontend": {
                    "avatar": "תמונה",
                    "email": "כתובת דוא\"ל",
                    "first_name": "שם פרטי",
                    "last_name": "שם משפחה",
                    "name": "שם מלא",
                    "password": "סיסמה",
                    "password_confirmation": "אימות סיסמה",
                    "phone": "Phone",
                    "message": "Message",
                    "new_password": "סיסמה חדשה",
                    "new_password_confirmation": "אימות סיסמה חדשה",
                    "old_password": "סיסמה ישנה",
                    "timezone": "איזור זמן"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "כבר יש תפקיד בשם הזה. נסו שם אחר.",
                        "cant_delete_admin": "אי אפשר למחוק את התפקיד \"מנהל\".",
                        "create_error": "הייתה בעיה ביצירת התפקיד. אנא נסו שוב.",
                        "delete_error": "הייתה בעיה במחיקת התפקיד. אנא נסו שוב.",
                        "has_users": "אי אפשר למחוק תפקיד שמשוייכים אליו משתמשים.",
                        "needs_permission": "חייבים לבחור לפחות הרשאה אחת לתפקיד.",
                        "not_found": "אין תפקיד כזה.",
                        "update_error": "הייתה בעיה בעדכון התפקיד. אנא נסו שוב."
                    },
                    "users": {
                        "already_confirmed": "המשתמש הזה כבר אומת.",
                        "cant_confirm": "הייתה בעיה באימות חשבון המשתמש.",
                        "cant_deactivate_self": "אי אפשר לכבות את החשבון של עצמך.",
                        "cant_delete_admin": "אי אפשר למחוק את המנהל הראשי.",
                        "cant_delete_self": "אי אפשר למחוק את עצמך.",
                        "cant_delete_own_session": "אי אפשר למחוק את הסשן של עצמך.",
                        "cant_restore": "אי אפשר לשחזר את המשתמש הזה, הוא לא מחוק.",
                        "cant_unconfirm_admin": "אי אפשר לבטל את האימות של המנהל הראשי.",
                        "cant_unconfirm_self": "אי אפשר לבטל את האימות של עצמך.",
                        "create_error": "הייתה בעיה ביצירת המשתמש. אנא נסו שוב.",
                        "delete_error": "הייתה בעיה במחיקת המשתמש. אנא נסו שוב.",
                        "delete_first": "יש למחוק את המשתמש מחיקה רגילה לפני שמוחקים אותו לצמיתות.",
                        "email_error": "כתובת המייל הזו שייכת למשתמש אחר.",
                        "mark_error": "הייתה בעיה בעדכון המשתמש. אנא נסו שוב.",
                        "not_confirmed": "המשתמש הזה לא מאומת.",
                        "not_found": "המשתמש לא נמצא במערכת.",
                        "restore_error": "הייתה בעיה בשחזור המשתמש. אנא נסו שוב.",
                        "role_needed_create": "משתמש חייב לפחות תפקיד אחד.",
                        "role_needed": "משתמש חייב לפחות תפקיד אחד.",
                        "session_wrong_driver": "כדי להשתמש בתכונה הזו, צריך שה-session driver יהיה database",
                        "social_delete_error": "הייתה בעיה בהסרת הפרופיל החברתי של המשתמש.",
                        "update_error": "הייתה בעיה בעדכון המשתמש. אנא נסו שוב.",
                        "update_password_error": "הייתה בעיה בעדכון סיסמת המשתמש. אנא נסו שוב."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "החשבון שלך כבר מאומת.",
                        "confirm": "אמת/י את החשבון שלך!",
                        "created_confirm": "החשבון שלך נוצר בהצלחה. שלחנו מייל אימות לכתובת שלך.",
                        "created_pending": "החשבון שלך נוצר בהצלחה והוא ממתין לאישור מנהל מערכת. מייל יישלח לכתובת שלך כשהחשבון יאושר.",
                        "mismatch": "קוד האימות לא נכון.",
                        "not_found": "קוד האימות לא קיים.",
                        "pending": "החשבון שלך בהמתנה לאישור.",
                        "resend": "החשבון שלך לא אומת. יש להקליק על הקישור לאימות בדוא\"ל שלך, או <a href=\"{url}\"> להקליק כאן</a> כדי לשלוח מייל אימות חדש.",
                        "success": "החשבון שלך אומת בהצלחה!",
                        "resent": "מייל אימות חדש נשלח לכתובת שלך."
                    },
                    "deactivated": "החשבון שלך בוטל.",
                    "email_taken": "כתובת המייל הזו כבר משוייכת למשתמש אחר.",
                    "password": {
                        "change_mismatch": "זו לא הסיסמה הישנה שלך.",
                        "reset_problem": "הייתה בעיה באיפוס הסיסמה. אנא נסו שוב מאוחר יותר."
                    },
                    "registration_disabled": "ההרשמה סגורה."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; הקודם",
            "next": "הבא &raquo;"
        },
        "roles": {
            "administrator": "מנהל",
            "user": "משתמש"
        },
        "navs": {
            "general": {
                "home": "בית",
                "logout": "התנתקות"
            },
            "frontend": {
                "contact": "צרו קשר",
                "dashboard": "לוח בקרה",
                "login": "התחברות",
                "macros": "מאקרו",
                "register": "הרשמה",
                "user": {
                    "account": "החשבון שלי",
                    "administration": "ניהול",
                    "change_password": "החלפת סיסמה",
                    "my_information": "המידע שלי",
                    "profile": "פרופיל"
                }
            }
        }
    },
    "id": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Apakah Anda yakin ingin menghapus pengguna ini secara permanen? Di mana saja di aplikasi yang merujuk id pengguna ini kemungkinan besar akan error. Lanjutkan risiko Anda sendiri. Ini tidak dapat dibatalkan.",
                        "if_confirmed_off": "(Jika konfirmasi dimatikan)",
                        "restore_user_confirm": "Kembalikan pengguna ini ke keadaan semula?"
                    }
                },
                "dashboard": {
                    "title": "Dasbor Administrasi",
                    "welcome": "Selamat Datang"
                },
                "general": {
                    "all_rights_reserved": "Hak Cipta Dilindungi.",
                    "are_you_sure": "Anda yakin?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Lanjutjan",
                    "member_since": "Anggota sejak",
                    "minutes": " menit",
                    "search_placeholder": "Cari...",
                    "timeout": "Anda secara otomatis log out untuk alasan keamanan karena Anda tidak punya aktivitas dalam ",
                    "see_all": {
                        "messages": "Lihat semua pesan",
                        "notifications": "Lihat semua",
                        "tasks": "Lihat semua tugas"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} Anda tidak memiliki pesan ::: {1} Anda memiliki 1 pesan ::: [2,Inf] Anda memiliki {number} pesan",
                        "notifications": "{0} Anda tidak memiliki notifikasi ::: {1} Anda memiliki 1 notifikasi ::: [2,Inf] Anda memiliki {number} notifikasi",
                        "tasks": "{0} Anda tidak memiliki tugas ::: {1} Anda memiliki 1 tugas ::: [2,Inf] Anda memiliki {number} tugas"
                    }
                },
                "search": {
                    "empty": "Harap masukkan kata pencarian.",
                    "incomplete": "Anda harus menulis logika pencarian Anda sendiri untuk sistem ini.",
                    "title": "Hasil Pencarian",
                    "results": "Hasil Pencarian untuk {query}"
                },
                "welcome": "<p>Ini adalah tema CoreUI theme oleh <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. Ini adalah versi yang dipreteli dengan hanya gaya dan skrip yang diperlukan untuk membuatnya berjalan. Download versi lengkap untuk mulai menambahkan komponen ke dasbor Anda.</p>\n<p>Semua fungsi tersebut adalah untuk menunjukkan dengan pengecualian <strong>Manajemen Pengguna</strong>. boilerplate ini dilengkapi dengan library access control yang berfungsi penuh untuk mengelola pengguna/peran/izin.</p>\n<p>Perlu diingat ini adalah sebuah pekerjaan yang sedang berjalan dan mungkin ada bug atau masalah lain yang saya belum temukan. Saya akan melakukan yang terbaik untuk memperbaikinya saat saya menemukannya.</p>\n<p>Harap Anda menikmati semua pekerjaan yang saya telah lakukan disini. Silakan kunjungi ke halaman <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> untuk informasi lebih lanjut dan melaporkan masalah apapun <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">di sini</a>.</p>\n<p><strong>Proyek ini sangat menuntut untuk menjaga kelangsungan dengan perubahan yang diberikan branch master Laravel, sehingga bantuan dihargai.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Aduh!",
                    "greeting": "Halo!",
                    "regards": "Salam,",
                    "trouble_clicking_button": "Jika Anda mengalami kesulitan mengklik tombol \"{action_text}\", copy dan paste URL di bawah ini ke browser Anda:",
                    "thank_you_for_using_app": "Terima kasih telah menggunakan aplikasi kami!",
                    "password_reset_subject": "Ubah Sandi",
                    "password_cause_of_email": "Anda menerima email ini karena kami menerima permintaan reset sandi untuk akun Anda.",
                    "password_if_not_requested": "Jika Anda tidak meminta reset sandi, tidak ada tindakan lebih lanjut diperlukan.",
                    "reset_password": "Klik di sini untuk reset sandi Anda",
                    "click_to_confirm": "Klik di sini untuk mengkonfirmasi akun Anda:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Tes",
                "tests": {
                    "based_on": {
                        "permission": "Berdasarkan Izin - ",
                        "role": "Berdasarkan Peran - "
                    },
                    "js_injected_from_controller": "Javascript Disuntikkan dari Controller",
                    "using_blade_extensions": "Gunakan Ekstensi Blade",
                    "using_access_helper": {
                        "array_permissions": "Menggunakan Access Helper dengan Array dari Nama Izin atau ID dimana pengguna tidak harus memiliki semua.",
                        "array_permissions_not": "Menggunakan Access Helper dengan Array dari Nama Izin atau ID dimana pengguna tidak perlu memiliki semua.",
                        "array_roles": "Menggunakan Access Helper dengan Array dari Nama Peran atau ID dimana pengguna tidak harus memiliki semua.",
                        "array_roles_not": "Menggunakan Access Helper dengan Array dari Nama Peran atau ID dimana pengguna tidak perlu memiliki semua.",
                        "permission_id": "Menggunakan Access Helper dengan ID Izin",
                        "permission_name": "Menggunakan Access Helper dengan Nama Izin",
                        "role_id": "Menggunakan Access Helper dengan ID Peran",
                        "role_name": "Menggunakan Access Helper dengan Nama Peran"
                    },
                    "view_console_it_works": "Lihat konsol, Anda akan melihat 'it works!' yang datang dari FrontendController@index",
                    "you_can_see_because": "Anda dapat melihat ini karena Anda memiliki peran '{role}'!",
                    "you_can_see_because_permission": "Anda dapat melihat ini karena Anda memiliki izin '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "Profil berhasil diperbarui.",
                    "password_updated": "Sandi berhasil diperbarui."
                },
                "welcome_to": "Selamat Datang di {place}"
            }
        },
        "auth": {
            "failed": "Identitas tersebut tidak cocok dengan catatan kami.",
            "general_error": "Anda tidak memiliki akses untuk melakukan itu.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} bukanlah jenis login diterima."
            },
            "throttle": "Terlalu banyak usaha login. Coba lagi dalam {seconds} detik.",
            "unknown": "Terjadi kesalahan yang tidak diketahui"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Manajemen Akses",
                    "roles": {
                        "all": "Semua Peran",
                        "create": "Buat Peran",
                        "edit": "Edit Peran",
                        "management": "Manajemen Peran",
                        "main": "Peran"
                    },
                    "users": {
                        "all": "Semua Pengguna",
                        "change-password": "Ubah Sandi",
                        "create": "Buat Pengguna",
                        "deactivated": "Pengguna Dinonaktifkan",
                        "deleted": "Pengguna Dihapus",
                        "edit": "Edit Pengguna",
                        "main": "Pengguna",
                        "view": "Lihat Pengguna"
                    }
                },
                "log-viewer": {
                    "main": "Pengamat Catatan",
                    "dashboard": "Dasbor",
                    "logs": "Catatan"
                },
                "sidebar": {
                    "dashboard": "Dasbor",
                    "general": "Umum",
                    "system": "Sistem"
                }
            },
            "language-picker": {
                "language": "Bahasa",
                "langs": {
                    "ar": "(Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "(Danish)",
                    "de": "Jerman (German)",
                    "el": "Yunani (Greek)",
                    "en": "Inggris (English)",
                    "es": "Spanyol (Spanish)",
                    "fa": "Persia (Persian)",
                    "fr": "Perancis (French)",
                    "he": "Ibrani (Hebrew)",
                    "id": "Bahasa Indonesia (Indonesian)",
                    "it": "Italia (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Belanda (Dutch)",
                    "no": "Norwegia (Norwegian)",
                    "pt_BR": "Bahasa Portugis Brasil (Brazilian Portuguese)",
                    "ru": "Rusia (Russian)",
                    "sv": "Swedia (Swedish)",
                    "th": "Bahasa (Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Aktifkan",
                        "change_password": "Ubah Sandi",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "Lumpuhkan",
                        "delete_permanently": "Hapus Permanen",
                        "login_as": "Login sebagai {user}",
                        "resend_email": "Kirim Ulang Email Konfirmasi",
                        "restore_user": "Restorasi Pengguna",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Konfirmasi Akun",
                    "reset_password": "Reset Sandi"
                }
            },
            "general": {
                "cancel": "Batal",
                "continue": "Continue",
                "crud": {
                    "create": "Buat",
                    "delete": "Hapus",
                    "edit": "Edit",
                    "update": "Perbarui",
                    "view": "Lihat"
                },
                "save": "Simpan",
                "view": "Lihat"
            }
        },
        "passwords": {
            "password": "Sandi minimal enam karakter dan cocok dengan konfirmasi.",
            "reset": "Sandi Anda sudah direset!",
            "sent": "Kami sudah mengirim email yang berisi tautan untuk mereset kata sandi Anda!",
            "token": "Token reset sandi tidak benar.",
            "user": "Kami tidak dapat menemukan pengguna dengan alamat e-mail tersebut."
        },
        "http": {
            "404": {
                "title": "Halaman tidak ditemukan",
                "description": "Maaf, halaman yang Anda coba lihat tidak ada."
            },
            "503": {
                "title": "Segera kembali.",
                "description": "Segera kembali."
            }
        },
        "labels": {
            "general": {
                "all": "Semua",
                "yes": "Ya",
                "no": "Tidak",
                "custom": "Kustom",
                "actions": "Tindakan",
                "active": "Aktif",
                "buttons": {
                    "save": "Simpan",
                    "update": "Perbarui"
                },
                "hide": "Sembunyi",
                "inactive": "Non-aktif",
                "none": "Tidak ada",
                "show": "Tunjukkan",
                "toggle_navigation": "Alihkan Navigasi"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Buat Peran",
                        "edit": "Edit Peran",
                        "management": "Manajemen Peran",
                        "table": {
                            "number_of_users": "Jumlah Pengguna",
                            "permissions": "Izin",
                            "role": "Peran",
                            "sort": "Sortir",
                            "total": "total peran ::: total peran"
                        }
                    },
                    "users": {
                        "active": "Pengguna Aktif",
                        "all_permissions": "Semua Izin",
                        "change_password": "Ubah Sandi",
                        "change_password_for": "Ubah Sandi untuk {user}",
                        "create": "Buat Pengguna",
                        "deactivated": "Pengguna Dinonaktifkan",
                        "deleted": "Pengguna Dihapus",
                        "edit": "Edit Pengguna",
                        "management": "Manajemen Pengguna",
                        "no_permissions": "Tidak Ada Izin",
                        "no_roles": "Tidak Ada Peran untuk Ditetapkan.",
                        "permissions": "Izin",
                        "table": {
                            "confirmed": "Dikonfirmasi",
                            "created": "Dibuat",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "Terakhir Diperbarui",
                            "name": "Nama",
                            "no_deactivated": "Tidak Ada Pengguna Dinonaktifkan",
                            "no_deleted": "Tidak Ada Pengguna Dihapus",
                            "roles": "Peran",
                            "social": "Social",
                            "total": "total pengguna ::: total pengguna"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Ikhtisar",
                                "history": "Riwayat"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Dikonfirmasi",
                                    "created_at": "Dibuat Pada",
                                    "deleted_at": "Dihapus Pada",
                                    "email": "E-mail",
                                    "last_updated": "Terakhir Diperbarui",
                                    "name": "Nama",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "Lihat Pengguna"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Login",
                    "login_button": "Login",
                    "login_with": "Login dengan {social_media}",
                    "register_box_title": "Daftar",
                    "register_button": "Daftar",
                    "remember_me": "Ingat Saya"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Lupa Sandi Anda?",
                    "reset_password_box_title": "Reset Sandi",
                    "reset_password_button": "Reset Sandi",
                    "send_password_reset_link_button": "Kirim Tautan Reset Sandi"
                },
                "user": {
                    "passwords": {
                        "change": "Ubah Sandi"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Dibuat Pada",
                        "edit_information": "Edit Informasi",
                        "email": "E-mail",
                        "last_updated": "Terakhir diperbarui",
                        "name": "Nama",
                        "update_information": "Perbarui Informasi"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Peran telah berhasil dibuat.",
                    "deleted": "Peran telah berhasil dihapus.",
                    "updated": "Peran telah berhasil diperbarui."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "Sebuah e-mail konfirmasi baru telah dikirim ke alamat bersangkutan.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "Pengguna telah berhasil dibuat.",
                    "deleted": "Pengguna telah berhasil dihapus.",
                    "deleted_permanently": "Pengguna telah dihapus secara permanen.",
                    "restored": "Pengguna telah berhasil direstorasi.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "Pengguna telah berhasil diperbarui.",
                    "updated_password": "Sandi pengguna telah berhasil diperbarui."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} harus diterima.",
            "active_url": "{attribute} bukan URL yang benar.",
            "after": "{attribute} harus tanggal setelah {date}.",
            "after_or_equal": "{attribute} harus berupa tanggal setelah atau sama dengan tanggal {date}.",
            "alpha": "{attribute} hanya boleh berisi huruf.",
            "alpha_dash": "{attribute} hanya boleh berisi huruf, angka, dan strip.",
            "alpha_num": "{attribute} hanya boleh berisi huruf dan angka.",
            "array": "{attribute} harus berupa sebuah array.",
            "before": "{attribute} harus tanggal sebelum {date}.",
            "before_or_equal": "{attribute} harus berupa tanggal sebelum atau sama dengan tanggal {date}.",
            "between": {
                "numeric": "{attribute} harus diantara {min} dan {max}.",
                "file": "{attribute} harus diantara {min} dan {max} kilobytes.",
                "string": "{attribute} harus diantara {min} dan {max} karakter.",
                "array": "{attribute} harus diantara {min} dan {max} item."
            },
            "boolean": "{attribute} harus berupa true atau false",
            "confirmed": "Konfirmasi {attribute} tidak cocok.",
            "date": "{attribute} bukan tanggal yang benar.",
            "date_format": "{attribute} tidak cocok dengan format {format}.",
            "different": "{attribute} dan {other} harus berbeda.",
            "digits": "{attribute} harus berupa angka {digits}.",
            "digits_between": "{attribute} harus antara angka {min} dan {max}.",
            "dimensions": "{attribute} tidak memiliki dimensi gambar yang benar.",
            "distinct": "{attribute} memiliki nilai yang duplikat.",
            "email": "{attribute} harus berupa alamat surel yang benar.",
            "exists": "{attribute} yang dipilih tidak benar.",
            "file": "{attribute} harus berupa sebuah berkas.",
            "filled": "{attribute} wajib diisi.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} harus berupa gambar.",
            "in": "{attribute} yang dipilih tidak benar.",
            "in_array": "{attribute} tidak terdapat dalam {other}.",
            "integer": "{attribute} harus merupakan bilangan bulat.",
            "ip": "{attribute} harus berupa alamat IP yang benar.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "{attribute} harus berupa JSON string yang benar.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} seharusnya tidak lebih dari {max}.",
                "file": "{attribute} seharusnya tidak lebih dari {max} kilobytes.",
                "string": "{attribute} seharusnya tidak lebih dari {max} karakter.",
                "array": "{attribute} seharusnya tidak lebih dari {max} item."
            },
            "mimes": "{attribute} harus dokumen berjenis : {values}.",
            "mimetypes": "{attribute} harus dokumen berjenis : {values}.",
            "min": {
                "numeric": "{attribute} harus minimal {min}.",
                "file": "{attribute} harus minimal {min} kilobytes.",
                "string": "{attribute} harus minimal {min} karakter.",
                "array": "{attribute} harus minimal {min} item."
            },
            "not_in": "{attribute} yang dipilih tidak benar.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} harus berupa angka.",
            "present": "{attribute} wajib ada.",
            "regex": "Format {attribute} tidak benar.",
            "required": "{attribute} wajib diisi.",
            "required_if": "{attribute} wajib diisi bila {other} adalah {value}.",
            "required_unless": "{attribute} wajib diisi kecuali {other} memiliki nilai {values}.",
            "required_with": "{attribute} wajib diisi bila terdapat {values}.",
            "required_with_all": "{attribute} wajib diisi bila terdapat {values}.",
            "required_without": "{attribute} wajib diisi bila tidak terdapat {values}.",
            "required_without_all": "{attribute} wajib diisi bila tidak terdapat ada {values}.",
            "same": "{attribute} dan {other} harus sama.",
            "size": {
                "numeric": "{attribute} harus berukuran {size}.",
                "file": "{attribute} harus berukuran {size} kilobyte.",
                "string": "{attribute} harus berukuran {size} karakter.",
                "array": "{attribute} harus mengandung {size} item."
            },
            "string": "{attribute} harus berupa string.",
            "timezone": "{attribute} harus berupa zona waktu yang benar.",
            "unique": "{attribute} sudah ada sebelumnya.",
            "uploaded": "{attribute} gagal diunggah.",
            "url": "Format {attribute} tidak benar.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Asosiasi Peran",
                            "dependencies": "Dependensi",
                            "display_name": "Nama Tampilan",
                            "group": "Grup",
                            "group_sort": "Urut Grup",
                            "groups": {
                                "name": "Nama Grup"
                            },
                            "name": "Nama",
                            "system": "Sistem?"
                        },
                        "roles": {
                            "associated_permissions": "Asosiasi Izin",
                            "name": "Nama",
                            "sort": "Urutkan"
                        },
                        "users": {
                            "active": "Aktif",
                            "associated_roles": "Asosiasi Peran",
                            "confirmed": "Dikonfirmasi",
                            "email": "Alamat E-mail",
                            "name": "Nama",
                            "other_permissions": "Izin Lain",
                            "password": "Sandi",
                            "password_confirmation": "Sandi Konfirmasi",
                            "send_confirmation_email": "Kirim E-mail Konfirmasi"
                        }
                    }
                },
                "frontend": {
                    "email": "Alamat E-mail",
                    "name": "Nama",
                    "password": "Sandi",
                    "password_confirmation": "Konfirmasi Sandi",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "Sandi Lama",
                    "new_password": "Sandi Baru",
                    "new_password_confirmation": "Konfirmasi Sandi Baru"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Peran tersebut sudah ada. Pilihlah nama yang berbeda.",
                        "cant_delete_admin": "Anda tidak dapat menhapus Peran Administrator.",
                        "create_error": "Ada masalah saat membuat peran ini. Silakan coba lagi.",
                        "delete_error": "Ada masalah saat menghapus peran ini. Silakan coba lagi.",
                        "has_users": "Anda tidak dapat menghapus peran dengan pengguna yang berkaitan.",
                        "needs_permission": "Anda harus memilih setidaknya satu izin untuk peran ini.",
                        "not_found": "Peran tersebut tidak ada.",
                        "update_error": "Ada masalah saat memperbarui peran ini. Silakan coba lagi."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_deactivate_self": "Anda tidak dapat melakukan itu kepada diri sendiri.",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "Anda tidak dapat menghapus diri sendiri.",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "cant_restore": "Pengguna ini tidak dihapus sehingga tidak dapat dikembalikan.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "create_error": "Ada masalah saat membuat pengguna ini. Silakan coba lagi.",
                        "delete_error": "Ada masalah saat menghapus pengguna ini. Silakan coba lagi.",
                        "delete_first": "Pengguna ini harus dihapus terlebih dahulu sebelum dapat dihancurkan secara permanen.",
                        "email_error": "Alamat email milik pengguna yang berbeda.",
                        "mark_error": "Ada masalah saat memperbarui pengguna ini. Silakan coba lagi.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "Pengguna tersebut tidak ada.",
                        "restore_error": "Ada masalah memulihkan pengguna ini. Silakan coba lagi.",
                        "role_needed_create": "Anda harus memilih setidaknya satu peran.",
                        "role_needed": "Anda harus memilih setidaknya satu peran.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "Ada masalah saat memperbarui pengguna ini. Silakan coba lagi.",
                        "update_password_error": "Ada masalah mengubah sandi pengguna ini. Silakan coba lagi."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Akun Anda sudah dikonfirmasi.",
                        "confirm": "Konfirmasi akun Anda!",
                        "created_confirm": "Akun Anda berhasil dibuat. Kami telah mengirim e-mail untuk konfirmasi akun Anda.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Kode konfirmasi Anda tidak cocok.",
                        "not_found": "Kode konfirmasi tersebut tidak ada.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Akun Anda belum dikonfirmasi. Silakan klik link konfirmasi di e-mail Anda, atau <a href=\"{url}\">klik disini</a> untuk mengirim ulang e-mail konfirmasi.",
                        "success": "Akun Anda telah berhasil dikonfirmasi!",
                        "resent": "Sebuah e-mail konfirmasi baru telah dikirimkan ke alamat terkait."
                    },
                    "deactivated": "Akun Anda telah dinonaktifkan.",
                    "email_taken": "Alamat e-mail tersebut sudah pakai.",
                    "password": {
                        "change_mismatch": "Itu bukan sandi lama Anda.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Sebelumnya",
            "next": "Selanjutnya &raquo;"
        },
        "roles": {
            "administrator": "Administrator",
            "user": "Pengguna"
        },
        "navs": {
            "general": {
                "home": "Beranda",
                "logout": "Keluar"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Dasbor",
                "login": "Masuk",
                "macros": "Makro",
                "register": "Daftar",
                "user": {
                    "account": "Akunku",
                    "administration": "Administrasi",
                    "change_password": "Ubah Sandi",
                    "my_information": "Informasiku",
                    "profile": "Profil"
                }
            }
        }
    },
    "it": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Sei sicuro di voler eliminare definitivamente questo utente? Ovunque ci sia un riferimento a questo utente all'interno dell'applicazione si vedrà un errore. Procedi a tuo rischio e pericolo, non si potrà annullare questa operazione.",
                        "if_confirmed_off": "(Se non è confermato)",
                        "restore_user_confirm": "Ripristinare l'utente al suo stato originario?"
                    }
                },
                "dashboard": {
                    "title": "Dashboard Amministrazione",
                    "welcome": "Benvenuto"
                },
                "general": {
                    "all_rights_reserved": "Tutti i diritti riservati.",
                    "are_you_sure": "Sei sicuro?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Continua",
                    "member_since": "Membro dal",
                    "minutes": " minutes",
                    "search_placeholder": "Cerca...",
                    "timeout": "You were automatically logged out for security reasons since you had no activity in ",
                    "see_all": {
                        "messages": "Visualizza tutti i messaggi",
                        "notifications": "Visualizza tutte",
                        "tasks": "Visualizza tutti i compiti"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} Non hai messaggi ::: {1} Hai un messaggio ::: [2,Inf] Hai {number} messaggi",
                        "notifications": "{0} Non hai notifiche ::: {1} Hai una notifica ::: [2,Inf] Hai {number} notifiche",
                        "tasks": "{0} Non hai compiti ::: {1} Hai un compito ::: [2,Inf] Hai {number} compiti"
                    }
                },
                "search": {
                    "empty": "Please enter a search term.",
                    "incomplete": "You must write your own search logic for this system.",
                    "title": "Search Results",
                    "results": "Search Results for {query}"
                },
                "welcome": "<p>Quello che vedi è il tema CoreUI sviluppato da <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>.\n    Si tratta di una versione ridotta al minimo che include solo gli stili e gli script necessari per il funzionamento.\n    Scarica la versione completa per aggiungere componenti alla dashboard.</p>\n<p>Tutte le funzioni che vedi sono simulate, ad eccezione della <strong>Gestione utenti</strong> sulla sinistra.\n    Questo modello comprende una libreria completa per il controllo degli accessi tramite utenti/ruoli/permessi.</p>\n<p>Questo si tratta comunque di un work-in-progress, perciò ci potrebbero essere dei bug o altri problemi che non ho ancora risolto.\n    Farò del mio meglio per risolverli mano a mano che riceverò le segnalazioni.</p>\n<p>Spero che tu gradisca quanto lavoro e impegno ho messo in questo progetto.\n    Per cortesia vai su <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a>\n    per ulteriori informazioni e per segnalare qualsiasi <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">problema</a>.</p>\n<p><strong>This project is very demanding to keep up with given the rate at which the master Laravel branch changes, so any help is appreciated.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Whoops!",
                    "greeting": "Hello!",
                    "regards": "Regards,",
                    "trouble_clicking_button": "If you’re having trouble clicking the \"{action_text}\" button, copy and paste the URL below into your web browser:",
                    "thank_you_for_using_app": "Thank you for using our application!",
                    "password_reset_subject": "Il tuo link per il reset della password",
                    "password_cause_of_email": "You are receiving this email because we received a password reset request for your account.",
                    "password_if_not_requested": "If you did not request a password reset, no further action is required.",
                    "reset_password": "Clicca qui per resettare la tua password",
                    "click_to_confirm": "Clicca qui per confermare il tuo account:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Basato su permessi - ",
                        "role": "Basato su ruoli - "
                    },
                    "js_injected_from_controller": "Javascript iniettato da un controller",
                    "using_blade_extensions": "Usando estensioni Blade",
                    "using_access_helper": {
                        "array_permissions": "Si sta usando l'Access Helper con un array di nomi o ID di permessi, l'utente li deve possedere tutti.",
                        "array_permissions_not": "Si sta usando l'Access Helper con un array di nomi o ID di permessi, l'utente non li deve possedere tutti.",
                        "array_roles": "Si sta usando l'Access Helper con un array di nomi o ID di ruoli, l'utente li deve possedere tutti.",
                        "array_roles_not": "Si sta usando l'Access Helper con un array di nomi o ID di ruoli, l'utente non li deve possedere tutti.",
                        "permission_id": "Si sta usando l'Access Helper con un ID di permesso",
                        "permission_name": "Si sta usando l'Access Helper con un nome di permesso",
                        "role_id": "Si sta usando l'Access Helper con un ID di ruolo",
                        "role_name": "Si sta usando l'Access Helper con un nome di ruolo"
                    },
                    "view_console_it_works": "Apri la console Javascript del browser, dovresti vedere 'it works!' generato da FrontendController@index",
                    "you_can_see_because": "Puoi vedere questo perché il tuo ruolo è '{role}'!",
                    "you_can_see_because_permission": "Puoi vedere questo perché hai il permesso '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "Profilo aggiornato con successo.",
                    "password_updated": "Password aggiornata con successo."
                },
                "welcome_to": "Benvenuto su {place}"
            }
        },
        "auth": {
            "failed": "Le credenziali non corrispondono a quelle registrate.",
            "general_error": "Non hai diritti sufficienti per questa operazione.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} non è supportato."
            },
            "throttle": "Troppi tentativi di login. Si prega di riprovare tra {seconds} secondi.",
            "unknown": "Si è verificato un errore sconosciuto"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Gestione accessi",
                    "roles": {
                        "all": "Tutti i ruoli",
                        "create": "Crea ruolo",
                        "edit": "Modifica ruolo",
                        "management": "Gestione ruoli",
                        "main": "Ruoli"
                    },
                    "users": {
                        "all": "Tutti gli utenti",
                        "change-password": "Cambia password",
                        "create": "Crea utente",
                        "deactivated": "Utenti disattivati",
                        "deleted": "Utenti eliminati",
                        "edit": "Modifica utente",
                        "main": "Utenti",
                        "view": "View User"
                    }
                },
                "log-viewer": {
                    "main": "Log",
                    "dashboard": "Dashboard",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Dashboard",
                    "general": "Generale",
                    "system": "System"
                }
            },
            "language-picker": {
                "language": "Lingua",
                "langs": {
                    "ar": "العربية (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Danese (Danish)",
                    "de": "Tedesco (German)",
                    "el": "(Greek)",
                    "en": "Inglese (English)",
                    "es": "Spagnol (Spanish)",
                    "fa": "Persiano (Persian)",
                    "fr": "Francese (French)",
                    "he": "Ebraico (Hebrew)",
                    "id": "Indonesiano (Indonesian)",
                    "it": "Italiano (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Olandese (Dutch)",
                    "no": "Norvegese (Norwegian)",
                    "pt_BR": "Portoghese Brasiliano (Brazilian Portuguese)",
                    "ru": "Russo (Russian)",
                    "sv": "Svedese (Swedish)",
                    "th": "(Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Attiva",
                        "change_password": "Cambia password",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "Disattiva",
                        "delete_permanently": "Elimina definitivamente",
                        "login_as": "Login As {user}",
                        "resend_email": "Reinvia e-mail di conferma",
                        "restore_user": "Ripristina utente",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Confirm Account",
                    "reset_password": "Reset Password"
                }
            },
            "general": {
                "cancel": "Annulla",
                "continue": "Continue",
                "crud": {
                    "create": "Crea",
                    "delete": "Elimina",
                    "edit": "Modifica",
                    "update": "Aggiorna",
                    "view": "View"
                },
                "save": "Salva",
                "view": "Visualizza"
            }
        },
        "passwords": {
            "password": "Le password devono essere di almeno 6 caratteri e devono coincidere.",
            "reset": "La password è stata reimpostata!",
            "sent": "E-mail per il reset della password inviata!",
            "token": "Questo token per il reset della password non è valido.",
            "user": "Non esiste alcun utente associato a questo indirizzo e-mail."
        },
        "http": {
            "404": {
                "title": "Pagina Non Trovata",
                "description": "Spiacenti, la pagina che stavi cercando di visualizzare non esiste."
            },
            "503": {
                "title": "Torniamo subito.",
                "description": "Torniamo subito."
            }
        },
        "labels": {
            "general": {
                "all": "Tutti",
                "yes": "Sì",
                "no": "No",
                "custom": "Custom",
                "actions": "Azioni",
                "active": "Active",
                "buttons": {
                    "save": "Salva",
                    "update": "Aggiorna"
                },
                "hide": "Nascondi",
                "inactive": "Inactive",
                "none": "Nessuno",
                "show": "Visualizza",
                "toggle_navigation": "Menu Navigazione"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Crea ruolo",
                        "edit": "Modifica ruolo",
                        "management": "Gestione ruolo",
                        "table": {
                            "number_of_users": "Numero di utenti",
                            "permissions": "Permessi",
                            "role": "Ruolo",
                            "sort": "Ordina",
                            "total": "Ruolo ::: Totale ruoli"
                        }
                    },
                    "users": {
                        "active": "Utenti attivi",
                        "all_permissions": "Tutti i permessi",
                        "change_password": "Cambia password",
                        "change_password_for": "Cambia password per {user}",
                        "create": "Crea utente",
                        "deactivated": "Utenti disattivati",
                        "deleted": "Utenti eliminati",
                        "edit": "Modifica utente",
                        "management": "Gestione utente",
                        "no_permissions": "Nessun permesso",
                        "no_roles": "Nessuno ruolo da assegnare.",
                        "permissions": "Permessi",
                        "table": {
                            "confirmed": "Confermato",
                            "created": "Creato",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "Ultimo aggiornamento",
                            "name": "Nome",
                            "no_deactivated": "Nessun utente disattivato",
                            "no_deleted": "Nessun utente eliminato",
                            "roles": "Ruoli",
                            "social": "Social",
                            "total": "utente(i) totali"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overview",
                                "history": "History"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmed",
                                    "created_at": "Created At",
                                    "deleted_at": "Deleted At",
                                    "email": "E-mail",
                                    "last_updated": "Last Updated",
                                    "name": "Name",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "View User"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Login",
                    "login_button": "Login",
                    "login_with": "Login tramite {social_media}",
                    "register_box_title": "Registrazione",
                    "register_button": "Registrati",
                    "remember_me": "Ricordami"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Password dimenticata?",
                    "reset_password_box_title": "Reset password",
                    "reset_password_button": "Reset password",
                    "send_password_reset_link_button": "Invia link per il reset della password"
                },
                "user": {
                    "passwords": {
                        "change": "Change Password"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Data di creazione",
                        "edit_information": "Modifica informazioni",
                        "email": "E-mail",
                        "last_updated": "Ultimo aggiornamento",
                        "name": "Nome",
                        "update_information": "Aggiorna informazioni"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Ruolo creato con successo.",
                    "deleted": "Ruolo cancellato con successo.",
                    "updated": "Ruolo aggiornato con successo."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "Una nuova e-mail di conferma è stata inviata all'indirizzo registrato.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "L'utente è stato creato con successo",
                    "deleted": "L'utente è stato eliminato con successo.",
                    "deleted_permanently": "L'utente è stato eliminato definitivamente.",
                    "restored": "L'utente è stato ripristinato con successo.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "L'utente è stato aggiornato con successo.",
                    "updated_password": "La password dell'utente è stata aggiornata con successo."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} deve essere accettato.",
            "active_url": "{attribute} non è un URL valido.",
            "after": "{attribute} deve essere una data successiva a {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "{attribute} può contenere solo lettere.",
            "alpha_dash": "{attribute} può contenere solo lettere, numeri e trattini.",
            "alpha_num": "{attribute} può contenere solo lettere e numeri.",
            "array": "{attribute} deve essere un array.",
            "before": "{attribute} deve essere una data precedente al {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "{attribute} deve avere un valore tra {min} e {max}.",
                "file": "{attribute} deve essere tra {min} e {max} kilobytes.",
                "string": "{attribute} deve avere tra {min} e {max} caratteri.",
                "array": "{attribute} deve contenere tra {min} e {max} elementi."
            },
            "boolean": "{attribute} può essere solo vero o falso.",
            "confirmed": "La conferma di {attribute} non corrisponde.",
            "date": "{attribute} non è una data valida.",
            "date_format": "{attribute} non corrisponde al formato {format}.",
            "different": "{attribute} e {other} devono essere diversi.",
            "digits": "{attribute} deve avere {digits} cifre.",
            "digits_between": "{attribute} deve avere tra {min} e {max} cifre.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "{attribute} deve essere un indirizzo email valido.",
            "exists": "La selezione per {attribute} non è valida.",
            "file": "The {attribute} must be a file.",
            "filled": "{attribute} è obbligatorio.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} deve essere un'immagine.",
            "in": "La selezione per {attribute} non è valida.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "{attribute} deve essere un numero intero.",
            "ip": "{attribute} deve essere un indirizzo IP valido.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "{attribute} deve essere una stringa JSON valida.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} non può essere più grande di {max}.",
                "file": "{attribute} non può superare i {max} kilobytes.",
                "string": "{attribute} non può superare i {max} caratteri.",
                "array": "{attribute} non può avere più di {max} elementi."
            },
            "mimes": "{attribute} deve essere un file di questo formato: {values}.",
            "min": {
                "numeric": "{attribute} deve essere almeno {min}.",
                "file": "{attribute} deve essere di almeno {min} kilobytes.",
                "string": "{attribute} deve contenere almeno {min} caratteri.",
                "array": "{attribute} deve avere almeno {min} elementi."
            },
            "not_in": "Il valore selezionato per {attribute} non è valido.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} deve essere un numero.",
            "present": "The {attribute} field must be present.",
            "regex": "Il formato di {attribute} non è valido.",
            "required": "{attribute} è richiesto.",
            "required_if": "{attribute} è richiesto quando {other} è {value}.",
            "required_unless": "{attribute} è richiesto se {other} non è tra {values}.",
            "required_with": "{attribute} è richiesto quando {values} è presente.",
            "required_with_all": "{attribute} è richiesto quando {values} è presente.",
            "required_without": "{attribute} è richiesto quando {values} non è presente.",
            "required_without_all": "{attribute} è richiesto quando nessuno tra {values} è presente.",
            "same": "{attribute} e {other} devono essere identici.",
            "size": {
                "numeric": "{attribute} deve essere {size}.",
                "file": "{attribute} deve essere di {size} kilobytes.",
                "string": "{attribute} deve contenere {size} caratteri.",
                "array": "{attribute} deve contenere {size} elementi."
            },
            "string": "{attribute} deve essere una stringa.",
            "timezone": "{attribute} deve essere un fuso orario valido.",
            "unique": "{attribute} è già stato utilizzato.",
            "url": "Il formato di {attribute} non è valido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Ruoli associati",
                            "dependencies": "Dipendenze",
                            "display_name": "Nome visualizzato",
                            "group": "Gruppo",
                            "group_sort": "Ordina gruppo",
                            "groups": {
                                "name": "Nome gruppo"
                            },
                            "name": "Nome",
                            "system": "Sistema?"
                        },
                        "roles": {
                            "associated_permissions": "Permessi associati",
                            "name": "Nome",
                            "sort": "Ordina"
                        },
                        "users": {
                            "active": "Attivo",
                            "associated_roles": "Ruoli associati",
                            "confirmed": "Confermato",
                            "email": "Indirizzo e-mail",
                            "name": "Nome",
                            "other_permissions": "Altri permessi",
                            "password": "Password",
                            "password_confirmation": "Conferma password",
                            "send_confirmation_email": "Invia e-mail di conferma"
                        }
                    }
                },
                "frontend": {
                    "email": "Indirizzo e-mail",
                    "name": "Nome",
                    "password": "Password",
                    "password_confirmation": "Conferma password",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "Vecchia password",
                    "new_password": "Nuova password",
                    "new_password_confirmation": "Conferma nuova password"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Questo ruolo esiste già. Si prega di scegliere un nome diverso.",
                        "cant_delete_admin": "Non è possibile eliminare il ruolo di Amministratore.",
                        "create_error": "C'è stato un problema durante la creazione di questo ruolo. Si prega di riprovare più tardi.",
                        "delete_error": "C'è stato un problema durante l'eliminazione di questo ruolo. Si prega di riprovare più tardi.",
                        "has_users": "Non è possibile cancellare un ruolo associato a degli utenti.",
                        "needs_permission": "Bisogna selezionare almeno un permesso per questo ruolo.",
                        "not_found": "Questo ruolo non esiste.",
                        "update_error": "C'è stato un problema durante l'aggiornamento di questo ruolo. Si prega di riprovare più tardi."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_deactivate_self": "Non puoi eseguire questa operazione su te stesso.",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "Non puoi cancellare te stesso.",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "cant_restore": "This user is not deleted so it can not be restored.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "create_error": "C'è stato un problema durante la creazione dell'utente. Si prega di riprovare.",
                        "delete_error": "C'è stato un problema durante l'eliminazione dell'utente. Si prega di riprovare.",
                        "delete_first": "This user must be deleted first before it can be destroyed permanently.",
                        "email_error": "Questo indirizzo e-mail appartiene ad un altro utente.",
                        "mark_error": "C'è stato un problema durante l'aggiornamento dell'utente. Si prega di riprovare.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "Questo utente non esiste.",
                        "restore_error": "C'è stato un problema durante il ripristino dell'utente. Si prega di riprovare.",
                        "role_needed_create": "Devi scegliere almeno un ruolo.",
                        "role_needed": "Devi scegliere almeno un ruolo",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "C'è stato un problema durante l'aggiornamento dell'utente. Si prega di riprovare",
                        "update_password_error": "C'è stato un problema durante il cambio di password per l'utente. Si prega di riprovare."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Il tuo account è già confermato",
                        "confirm": "Conferma il tuo account!",
                        "created_confirm": "Il tuo account è stato creato con successo. Ti abbiamo inviato un'email per confermare il tuo account.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Il tuo codice di conferma non corrisponde",
                        "not_found": "Questo codice di conferma non esiste.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Il tuo account non è confermato. Per cortesia clicca sul link di conferma nell'email che ti abbiamo mandato, o <a href=\"{url}\">clicca qui</a> per rimandare l'email di conferma.",
                        "success": "Il tuo account è stato confermato con successo!",
                        "resent": "Una nuova e-mail di conferma è stata inviata all'indirizzo registrato."
                    },
                    "deactivated": "Il tuo account è stato disattivato.",
                    "email_taken": "Questo indirizzo e-mail è stato già utilizzato.",
                    "password": {
                        "change_mismatch": "Questa non è la tua vecchia password.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Precedente",
            "next": "Successiva &raquo;"
        },
        "roles": {
            "administrator": "Amministratore",
            "user": "Utente"
        },
        "navs": {
            "general": {
                "home": "Home",
                "logout": "Logout"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Dashboard",
                "login": "Login",
                "macros": "Macro",
                "register": "Registrazione",
                "user": {
                    "account": "My Account",
                    "administration": "Amministrazione",
                    "change_password": "Cambio Password",
                    "my_information": "Profilo",
                    "profile": "Profile"
                }
            }
        }
    },
    "ja": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "このユーザーを永久に削除してもよろしいですか？ このユーザーのIDを参照するアプリケーションのどこでもエラーが発生します。 自己責任で行ってください。 これは、元に戻すことはできません。",
                        "if_confirmed_off": "(確認済みの場合)",
                        "restore_user_confirm": "このユーザーを元の状態に戻しますか？"
                    }
                },
                "dashboard": {
                    "title": "Dashboard",
                    "welcome": "Welcome"
                },
                "general": {
                    "all_rights_reserved": "All Rights Reserved.",
                    "are_you_sure": "本当ですか？",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Continue",
                    "member_since": "会員登録日",
                    "minutes": " 分",
                    "search_placeholder": "検索中...",
                    "timeout": "あなたは活動がなかったのでセキュリティ上の理由から自動的にログアウトされました。",
                    "see_all": {
                        "messages": "すべてのメッセージを見る",
                        "notifications": "すべて表示",
                        "tasks": "すべてのタスク表示"
                    },
                    "status": {
                        "online": "オンライン",
                        "offline": "オフライン"
                    },
                    "you_have": {
                        "messages": "{0} メッセージなし ::: {1} １件メッセージあり ::: [2,Inf] {number}件のメッセージあり",
                        "notifications": "{0} 通知なし ::: {1} １件通知あり ::: [2,Inf] {number}件の通知あり",
                        "tasks": "{0} タスクなし ::: {1} １件タスクあり ::: [2,Inf] {number}件のタスクあり"
                    }
                },
                "search": {
                    "empty": "検索テキストを入力してください。",
                    "incomplete": "このシステムに独自の検索ロジックを記述する必要があります。",
                    "title": "検索結果",
                    "results": "検索結果 {query}"
                },
                "welcome": "<p>This is the CoreUI theme by <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. This is a stripped down version with only the necessary styles and scripts to get it running. Download the full version to start adding components to your dashboard.</p>\n<p>All the functionality is for show with the exception of the <strong>Access</strong> to the left. This boilerplate comes with a fully functional access control library to manage users/roles/permissions.</p>\n<p>Keep in mind it is a work in progress and their may be bugs or other issues I have not come across. I will do my best to fix them as I receive them.</p>\n<p>Hope you enjoy all of the work I have put into this. Please visit the <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> page for more information and report any <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">issues here</a>.</p>\n<p><strong>This project is very demanding to keep up with given the rate at which the master Laravel branch changes, so any help is appreciated.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Whoops!",
                    "greeting": "Hello!",
                    "regards": "Regards,",
                    "trouble_clicking_button": "\"{action_text}\" ボタンをクリックしても問題が解決しない場合は、以下のURLをコピーしてウェブブラウザに貼り付けてください:",
                    "thank_you_for_using_app": "このアプリケーションを使用していただきありがとうございます！",
                    "password_reset_subject": "パスワードのリセット",
                    "password_cause_of_email": "あなたのアカウントのパスワードリセットリクエストを受け取りましたので、このメールをお送りしています。",
                    "password_if_not_requested": "パスワードリセットを要求しなかった場合、これ以上の操作は必要ありません。",
                    "reset_password": "パスワードをリセットするにはここをクリック",
                    "click_to_confirm": "あなたのアカウントを確認するにはここをクリックしてください:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Permission Based - ",
                        "role": "Role Based - "
                    },
                    "js_injected_from_controller": "Javascript Injected from a Controller",
                    "using_blade_extensions": "Using Blade Extensions",
                    "using_access_helper": {
                        "array_permissions": "Using Access Helper with Array of Permission Names or ID's where the user does have to possess all.",
                        "array_permissions_not": "Using Access Helper with Array of Permission Names or ID's where the user does not have to possess all.",
                        "array_roles": "Using Access Helper with Array of Role Names or ID's where the user does have to possess all.",
                        "array_roles_not": "Using Access Helper with Array of Role Names or ID's where the user does not have to possess all.",
                        "permission_id": "Using Access Helper with Permission ID",
                        "permission_name": "Using Access Helper with Permission Name",
                        "role_id": "Using Access Helper with Role ID",
                        "role_name": "Using Access Helper with Role Name"
                    },
                    "view_console_it_works": "View console, you should see 'it works!' which is coming from FrontendController@index",
                    "you_can_see_because": "You can see this because you have the role of '{role}'!",
                    "you_can_see_because_permission": "You can see this because you have the permission of '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "profile_updated": "プロフィール更新に成功しました。",
                    "password_updated": "パスワード更新に成功しました。"
                },
                "welcome_to": "Welcome to {place}"
            }
        },
        "auth": {
            "failed": "これらの資格情報は記録と一致しません。",
            "general_error": "あなたはアクセスできません。",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} 受け入れ可能なログインタイプではありません。"
            },
            "throttle": "ログイン試行が多すぎます。 {seconds} 後にもう一度お試しください。",
            "unknown": "不明なエラーが発生しました。"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "アクセス管理",
                    "roles": {
                        "all": "全ロール",
                        "create": "ロール作成",
                        "edit": "ロール編集",
                        "management": "ロール管理",
                        "main": "ロール"
                    },
                    "users": {
                        "all": "全ユーザ",
                        "change-password": "パスワード変更",
                        "create": "ユーザ作成",
                        "deactivated": "ユーザ非アクティブ",
                        "deleted": "削除済のユーザ",
                        "edit": "ユーザ編集",
                        "main": "ユーザ",
                        "view": "ユーザ表示"
                    }
                },
                "log-viewer": {
                    "main": "Log Viewer",
                    "dashboard": "Dashboard",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Dashboard",
                    "general": "一般",
                    "system": "システム"
                }
            },
            "language-picker": {
                "language": "言語",
                "langs": {
                    "ar": "アラビア語（Arabic）",
                    "zh": "中国語（Chinese Simplified）",
                    "zh-TW": "中国語（Chinese Traditional）",
                    "da": "デンマーク語（Danish）",
                    "de": "ドイツ人（German）",
                    "el": "ギリシャ語（Greek）",
                    "en": "英語（English）",
                    "es": "スペイン語（Spanish）",
                    "fa": "ペルシア語 (Persian)",
                    "fr": "フランス語（French）",
                    "he": "ヘブライ語 (Hebrew)",
                    "id": "インドネシア語（Indonesian）",
                    "it": "イタリア語（Italian）",
                    "ja": "日本語（Japanese）",
                    "nl": "オランダ語（Dutch）",
                    "no": "ノルウェーの (Norwegian)",
                    "pt_BR": "ブラジルポルトガル語（Brazilian Portuguese）",
                    "ru": "ロシア語（Russian）",
                    "sv": "スウェーデン語（Swedish）",
                    "th": "タイ語（Thai）",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Activate",
                        "change_password": "パスワードの変更",
                        "deactivate": "Deactivate",
                        "delete_permanently": "Delete Permanently",
                        "login_as": "Login As {user}",
                        "resend_email": "再確認メール",
                        "restore_user": "ユーザーの復元",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "アカウントの確認",
                    "reset_password": "パスワードのリセット"
                }
            },
            "general": {
                "cancel": "キャンセル",
                "crud": {
                    "create": "作成",
                    "delete": "削除",
                    "edit": "編集",
                    "update": "更新",
                    "view": "表示"
                },
                "save": "保存",
                "view": "表示"
            }
        },
        "passwords": {
            "password": "パスワードは6文字以上で、確認と一致している必要があります。",
            "reset": "あなたのパスワードはリセットされました！",
            "sent": "パスワードリセットリンクをメールで送信しました！",
            "token": "このパスワードリセットトークンは無効です。",
            "user": "その電子メールアドレスを持つユーザーは見つかりません"
        },
        "http": {
            "404": {
                "title": "Page Not Found",
                "description": "Sorry, but the page you were trying to view does not exist."
            },
            "503": {
                "title": "Be right back.",
                "description": "Be right back."
            }
        },
        "labels": {
            "general": {
                "all": "すべて",
                "yes": "OK",
                "no": "No",
                "custom": "カスタム",
                "actions": "各種変更",
                "active": "アクテイブ",
                "buttons": {
                    "save": "保存",
                    "update": "更新"
                },
                "hide": "非表示",
                "inactive": "アクテイブ中",
                "none": "なし",
                "show": "表示",
                "toggle_navigation": "ナビゲーション切り替え"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "ロール作成",
                        "edit": "ロール編集",
                        "management": "ロール管理",
                        "table": {
                            "number_of_users": "ユーザ数",
                            "permissions": "権限",
                            "role": "ロール",
                            "sort": "ソート",
                            "total": "ロール合計 ::: ロール合計"
                        }
                    },
                    "users": {
                        "active": "アクテイブユーザ",
                        "all_permissions": "全権限",
                        "change_password": "パスワード変更",
                        "change_password_for": " {user}のパスワードを変更",
                        "create": "ユーザ作成",
                        "deactivated": "非アクティブユーザ",
                        "deleted": "削除されたユーザ",
                        "edit": "ユーザ編集",
                        "management": "ユーザ管理",
                        "no_permissions": "権限存在しない",
                        "no_roles": "設定するロールが存在なし",
                        "permissions": "権限",
                        "table": {
                            "confirmed": "確認済",
                            "created": "作成済",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "最終更新日",
                            "name": "名前",
                            "no_deactivated": "非アクティブユーザが存在しない",
                            "no_deleted": "削除されたユーザが存在しない",
                            "roles": "ロール",
                            "social": "Social",
                            "total": "ユーザ合計 ::: ユーザ合計"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "概要",
                                "history": "履歴"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "確認済",
                                    "created_at": "作成日",
                                    "deleted_at": "削除日",
                                    "email": "E-mail",
                                    "last_updated": "最終更新日",
                                    "name": "名前",
                                    "status": "ステータス"
                                }
                            }
                        },
                        "view": "ユーザ表示"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "ログイン",
                    "login_button": "ログイン",
                    "login_with": " {social_media}でログイン",
                    "register_box_title": "登録",
                    "register_button": "登録",
                    "remember_me": "Remember Me"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "パスワード忘れ",
                    "reset_password_box_title": "パスワードリセット",
                    "reset_password_button": "パスワードリセット",
                    "send_password_reset_link_button": "パスワードリセットリンクを送る"
                },
                "user": {
                    "passwords": {
                        "change": "パスワード変更"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "作成日",
                        "edit_information": "情報編集",
                        "email": "E-mail",
                        "last_updated": "最終更新日",
                        "name": "名前",
                        "update_information": "情報更新"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "ロールが正常に作成されました。",
                    "deleted": "ロールが削除されました。",
                    "updated": "ロールが正常に更新されました。"
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "新しい確認メールがファイルのアドレスに送信されました。",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "ユーザーが正常に作成されました。",
                    "deleted": "ユーザーが削除されました。",
                    "deleted_permanently": "ユーザーが完全に削除されました。",
                    "restored": "ユーザーが正常に復元されました。",
                    "updated": "ユーザーが正常に更新されました。",
                    "updated_password": "ユーザーのパスワードが正常に更新されました。"
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "{attribute}を承認してください。",
            "active_url": "{attribute}は、有効なURLではありません。",
            "after": "{attribute}には、{date}以降の日付を指定してください。",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "{attribute}には、アルファベッドのみ使用できます。",
            "alpha_dash": "{attribute}には、英数字('A-Z','a-z','0-9')とハイフンと下線('-','_')が使用できます。",
            "alpha_num": "{attribute}には、英数字('A-Z','a-z','0-9')が使用できます。",
            "array": "{attribute}には、配列を指定してください。",
            "before": "{attribute}には、{date}以前の日付を指定してください。",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "{attribute}には、{min}から、{max}までの数字を指定してください。",
                "file": "{attribute}には、{min} KBから{max} KBまでのサイズのファイルを指定してください。",
                "string": "{attribute}は、{min}文字から{max}文字にしてください。",
                "array": "{attribute}の項目は、{min}個から{max}個にしてください。"
            },
            "boolean": "{attribute}には、'true'か'false'を指定してください。",
            "confirmed": "{attribute}と{attribute}確認が一致しません。",
            "date": "{attribute}は、正しい日付ではありません。",
            "date_format": "{attribute}の形式は、'{format}'と合いません。",
            "different": "{attribute}と{other}には、異なるものを指定してください。",
            "digits": "{attribute}は、{digits}桁にしてください。",
            "digits_between": "{attribute}は、{min}桁から{max}桁にしてください。",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "{attribute}は、有効なメールアドレス形式で指定してください。",
            "exists": "選択された{attribute}は、有効ではありません。",
            "file": "The {attribute} must be a file.",
            "filled": "{attribute}は必須です。",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute}には、画像を指定してください。",
            "in": "選択された{attribute}は、有効ではありません。",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "{attribute}には、整数を指定してください。",
            "ip": "{attribute}には、有効なIPアドレスを指定してください。",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "{attribute}には、有効なJSON文字列を指定してください。",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute}には、{max}以下の数字を指定してください。",
                "file": "{attribute}には、{max} KB以下のファイルを指定してください。",
                "string": "{attribute}は、{max}文字以下にしてください。",
                "array": "{attribute}の項目は、{max}個以下にしてください。"
            },
            "mimes": "{attribute}には、{values}タイプのファイルを指定してください。",
            "mimetypes": "{attribute}には、{values}タイプのファイルを指定してください。",
            "min": {
                "numeric": "{attribute}には、{min}以上の数字を指定してください。",
                "file": "{attribute}には、{min} KB以上のファイルを指定してください。",
                "string": "{attribute}は、{min}文字以上にしてください。",
                "array": "{attribute}の項目は、{max}個以上にしてください。"
            },
            "not_in": "選択された{attribute}は、有効ではありません。",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute}には、数字を指定してください。",
            "present": "The {attribute} field must be present.",
            "regex": "{attribute}には、有効な正規表現を指定してください。",
            "required": "{attribute}は、必ず指定してください。",
            "required_if": "{other}が{value}の場合、{attribute}を指定してください。",
            "required_unless": "{other}が{value}以外の場合、{attribute}を指定してください。",
            "required_with": "{values}が指定されている場合、{attribute}も指定してください。",
            "required_with_all": "{values}が全て指定されている場合、{attribute}も指定してください。",
            "required_without": "{values}が指定されていない場合、{attribute}を指定してください。",
            "required_without_all": "{values}が全て指定されていない場合、{attribute}を指定してください。",
            "same": "{attribute}と{other}が一致しません。",
            "size": {
                "numeric": "{attribute}には、{size}を指定してください。",
                "file": "{attribute}には、{size} KBのファイルを指定してください。",
                "string": "{attribute}は、{size}文字にしてください。",
                "array": "{attribute}の項目は、{size}個にしてください。"
            },
            "string": "{attribute}には、文字を指定してください。",
            "timezone": "{attribute}には、有効なタイムゾーンを指定してください。",
            "unique": "指定の{attribute}は既に使用されています。",
            "uploaded": "The {attribute} failed to upload.",
            "url": "{attribute}は、有効なURL形式で指定してください。",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Associated Roles",
                            "dependencies": "Dependencies",
                            "display_name": "Display Name",
                            "group": "Group",
                            "group_sort": "Group Sort",
                            "groups": {
                                "name": "Group Name"
                            },
                            "name": "Name",
                            "system": "System?"
                        },
                        "roles": {
                            "associated_permissions": "Associated Permissions",
                            "name": "Name",
                            "sort": "Sort"
                        },
                        "users": {
                            "active": "Active",
                            "associated_roles": "Associated Roles",
                            "confirmed": "Confirmed",
                            "email": "E-mail Address",
                            "name": "Name",
                            "other_permissions": "Other Permissions",
                            "password": "Password",
                            "password_confirmation": "Password Confirmation",
                            "send_confirmation_email": "Send Confirmation E-mail"
                        }
                    }
                },
                "frontend": {
                    "email": "メールアドレス",
                    "name": "ユーザ名",
                    "password": "パスワード",
                    "password_confirmation": "パスワード（確認）",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "旧パスワード",
                    "new_password": "新パスワード",
                    "new_password_confirmation": "新パスワード（確認）"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "そのロールは既に存在します。 別の名前を選んでください。",
                        "cant_delete_admin": "管理者の役割は削除できません。",
                        "create_error": "このロールを作成する際に問題がありました。 もう一度お試しください。",
                        "delete_error": "このロールを削除する際に問題がありました。 もう一度お試しください。",
                        "has_users": "ユーザーが関連付けられているロールは削除できません。",
                        "needs_permission": "このロールには少なくとも1つの権限を選択する必要があります。",
                        "not_found": "その役割は存在しません。",
                        "update_error": "このロールを更新する際に問題がありました。 もう一度お試しください。 "
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_deactivate_self": "あなたは自分を非アクティブに変更できないです。",
                        "cant_delete_self": "あなた自身を削除できません。",
                        "cant_restore": "このユーザーは削除されてないため、復元できません。",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "create_error": "このユーザーを作成する際に問題がありました。もう一度お試しください。",
                        "delete_error": "このユーザーの削除中に問題が発生しました。もう一度お試しください。",
                        "delete_first": "このユーザーは、永久に削除される前に削除する必要があります。",
                        "email_error": "そのメールアドレスは別のユーザーに属しています。",
                        "mark_error": "このユーザーを更新する際に問題がありました。もう一度お試しください。",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "そのユーザーは存在しません。",
                        "restore_error": "このユーザーを復元する際に問題がありました。もう一度お試しください。",
                        "role_needed_create": "少なくとも1つの役割を選択する必要があります。",
                        "role_needed": "少なくとも1つの役割を選択する必要があります。",
                        "update_error": "このユーザーを更新する際に問題がありました。もう一度お試しください。",
                        "update_password_error": "このユーザーのパスワードを変更する際に問題がありました。もう一度お試しください。"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "あなたのアカウントは既に確認済みです。",
                        "confirm": "あなたのアカウントを確認してください！",
                        "created_confirm": "あなたのアカウントは正常に作成されました。 あなたのアカウントを確認するための電子メールをお送りしました。",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "あなたの確認コードが一致しません。",
                        "not_found": "その確認コードは存在しません。",
                        "pending": "Your account is currently pending approval.",
                        "resend": "あなたのアカウントは確認されていません。 あなたの電子メールの確認リンクをクリックするか、 <a href=\"{url}\">ここをクリック</a>して再送信してください。",
                        "success": "あなたのアカウントは正常に確認されました！",
                        "resent": "新しい確認メールがファイルのアドレスに送信されました。"
                    },
                    "deactivated": "あなたのアカウントは無効になっています。",
                    "email_taken": "その電子メールアドレスはすでに取得済みです。",
                    "password": {
                        "change_mismatch": "古いパスワードではありません。",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "新規登録は停止中です。"
                }
            }
        },
        "pagination": {
            "previous": "&laquo; 前ページ",
            "next": "次ページ &raquo;"
        },
        "roles": {
            "administrator": "管理者",
            "user": "ユーザ"
        },
        "navs": {
            "general": {
                "home": "ホーム",
                "logout": "ログアウト"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Dashboard",
                "login": "ログイン",
                "macros": "マクロ",
                "register": "登録",
                "user": {
                    "account": "My Account",
                    "administration": "管理",
                    "change_password": "パスワード変更",
                    "my_information": "My Information",
                    "profile": "プロフィール"
                }
            }
        }
    },
    "nl": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Gebruiker permanent verwijderen? Overal in de applicaties waar gerefereerd wordt naar dit gebruikers-ID zal een fout ontstaan. Doorgaan op eigen risico. Dit kan niet ongedaan gemaakt worden.",
                        "if_confirmed_off": "(Als bevestiging uit staat)",
                        "restore_user_confirm": "Herstel deze gebruiker naar de originele staat?"
                    }
                },
                "dashboard": {
                    "title": "Beheer Dashboard",
                    "welcome": "Welkom"
                },
                "general": {
                    "all_rights_reserved": "Alle Rechten Voorbehouden.",
                    "are_you_sure": "Zeker?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Doorgaan",
                    "member_since": "Lid sinds",
                    "minutes": " minuten",
                    "search_placeholder": "Zoeken...",
                    "timeout": "Automatisch uitgelogd vanwege veiligheidsredenen aangezien er geen activiteit was in ",
                    "see_all": {
                        "messages": "Alle messages bekijken",
                        "notifications": "Bekijk alles",
                        "tasks": " Alle taken bekijken"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} U heeft geen berichten ::: {1} U heeft 1 bericht ::: [2,*] U heeft {number} berichten",
                        "notifications": "{0} U heeft geen notificaties ::: {1} U heeft 1 notificatie ::: [2,*] U heeft {number} notificaties",
                        "tasks": "{0} U heeft geen taken ::: {1} U heeft 1 taak ::: [2,*] U heeft {number} taken"
                    }
                },
                "search": {
                    "empty": "Please enter a search term.",
                    "incomplete": "You must write your own search logic for this system.",
                    "title": "Search Results",
                    "results": "Search Results for {query}"
                },
                "welcome": "<p>Dit is het CoreUI thema door <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. Dit is een uitgeklede versie met alleen de stijlen and scripts om het geheel draaiende te krijgen. Download de volledige versie om componenten aan het dashboard toe te voegen.</p>\n<p>Alle functionaliteit is voor de show, met uitzondering van de <strong>Toegangs Beheer</strong> aan de linkerkant. Deze boilerplate komt standaard met een volledig functionele toegangs beheer bibliotheek om gebruikers/rollen/permissies to beheren</p>\n<p>Bedenk wel dat dit werk in uitvoering is en dat er fouten of andere problemen kunnen zijn die ik niet ben tegengekomen. Ik zal mijn best doen om deze te repareren wanneer ik deze ontvang.</p>\n<p>Hopelijk geniet je van alle werk dat ik hierin heb gestopt. Bezoek de <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> pagina voor meer informatie en om <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">problemen</a> te rapporteren.</p>\n<p><strong> Dit project is zeer veeleisend om bij te houden gegeven de snelheid waarmee de master Laravel branch verandert, dus elke vorm van hulp wordt gewaardeert.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Oeps!",
                    "greeting": "Hallo!",
                    "regards": "Groet,",
                    "trouble_clicking_button": "Als u problemen heeft met de \"{action_text}\" button, kopieer en plak dan de onderstaande URL in uw web browser:",
                    "thank_you_for_using_app": "Dank u voor het gebruik van onze applicatie!",
                    "password_reset_subject": "Uw Wachtwoord Reset Link",
                    "password_cause_of_email": "U ontvangt deze email omdat we een wachtwoord reset verzoek hebben ontvangen voor uw account",
                    "password_if_not_requested": "Als u geen wachtwoord reset heeft aangevraagd hoeft geen verdere actie te ondernemen.",
                    "reset_password": "Klik hier om uw wachtwoord te resetten",
                    "click_to_confirm": "Klik hier om uw account te bevestigen:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Permissie Gebaseerd - ",
                        "role": "Rol Gebaseerd - "
                    },
                    "js_injected_from_controller": "Javascript geinjecteerd vanuit de Controller",
                    "using_blade_extensions": "Gebruik makend van Blade Extensies",
                    "using_access_helper": {
                        "array_permissions": "Gebruik makend van Access Helper met Array van Permissies van Namen of id's waar de gebruiker ze allemaal benodigd is.",
                        "array_permissions_not": "Gebruik makend van Access Helper met Array van Permissies van Namen of id's waar de gebruiker ze niet allemaal benodigd is.",
                        "array_roles": "Gebruik makend van Access Helper met Array van Permissies van Rolnamen of id's waar de gebruiker ze allemaal benodigd is.",
                        "array_roles_not": "Gebruik makend van Access Helper met Array van Permissies van Rolnamen of id's waar de gebruiker ze niet allemaal benodigd is.",
                        "permission_id": "Gebruik makend van Access Helper met Permissie ID",
                        "permission_name": "Gebruik makend van Access Helper met Permission Naam",
                        "role_id": "Gebruik makend van Access Helper met Rol ID",
                        "role_name": "Gebruik makend van Access Helper met Rol Naam"
                    },
                    "view_console_it_works": "U zou 'it works!' in de console moeten zien, welke komt vanuit FrontendController@index",
                    "you_can_see_because": "U kunt dit zien omdat u de rol heeft van '{role}'!",
                    "you_can_see_because_permission": "U kunt dit zien omdat u de permissie van '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "Profiel succesvol bijgewerkt.",
                    "password_updated": "Wachtwoord succesvol bijgewerkt."
                },
                "welcome_to": "Welkom bij {place}"
            }
        },
        "auth": {
            "failed": "Toegangsgegevens niet gevonden",
            "general_error": "Je hebt niet de rechten om dat te doen.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} is niet een geaccepteerd login type."
            },
            "throttle": "Te veel aanmeld pogingen, probeer het nog eens na {seconds} seconden.",
            "unknown": "Onbekende fout opgetreden"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Toegangs Beheer",
                    "roles": {
                        "all": "Alle Rollen",
                        "create": "Creëer Rol",
                        "edit": "Rol aanpassen",
                        "management": "Rol Beheer",
                        "main": "Rollen"
                    },
                    "users": {
                        "all": "Alle Gebruikers",
                        "change-password": "Wachtwoord veranderen",
                        "create": "Gebruiker aanmaken",
                        "deactivated": "Gedeactiveerde Gebruikers",
                        "deleted": "Verwijderde Gebruikers",
                        "edit": "Gebruiker aanpassen",
                        "main": "Gebruikers",
                        "view": "Bekijk Gebruiker"
                    }
                },
                "log-viewer": {
                    "main": "Log Viewer",
                    "dashboard": "Dashboard",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Dashboard",
                    "general": "Algemeen",
                    "system": "System"
                }
            },
            "language-picker": {
                "language": "Taal",
                "langs": {
                    "ar": "Arabisch (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Deens (Danish)",
                    "de": "Duits (German)",
                    "el": "(Greek)",
                    "en": "Engels (English)",
                    "es": "Spaans (Spanish)",
                    "fa": "Perzisch (Persian)",
                    "fr": "Frans (French)",
                    "he": "Hebreeuws (Hebrew)",
                    "id": "Indonesisch (Indonesian)",
                    "it": "Italiaans (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Nederlands (Dutch)",
                    "no": "Noors (Norwegin)",
                    "pt_BR": "Braziliaans Portugees (Brazilian Portuguese)",
                    "ru": "Russisch (Russian)",
                    "sv": "Zweeds (Swedish)",
                    "th": "Thais (Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Activeren",
                        "change_password": "Verander Wachtwoord",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "Deactiveren",
                        "delete_permanently": "Permanent verwijderen",
                        "login_as": "Aanmelden als {user}",
                        "resend_email": "Bevestigings email nogmaals zenden",
                        "restore_user": "Gebruiker herstellen",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Account Bevestigen",
                    "reset_password": "Reset Wachtwoord"
                }
            },
            "general": {
                "cancel": "Annuleer",
                "continue": "Continue",
                "crud": {
                    "create": "Creëer",
                    "delete": "Verwijder",
                    "edit": "Aanpassen",
                    "update": "Bijwerken",
                    "view": "Bekijk"
                },
                "save": "Opslaan",
                "view": "Bekijk"
            }
        },
        "passwords": {
            "password": "Wachtwoorden moeten uit ten minste zes karakters bestaan en overeen komen met de herhaling.",
            "reset": "Uw wachtwoord is gereset!",
            "sent": "We hebben uw wachtwoord reset link ge-e-maild!",
            "token": "Dit wachtwoord reset token is ongeldig.",
            "user": "We kunnen geen gebruiker met dat e-mailadres vinden"
        },
        "http": {
            "404": {
                "title": "Pagina Niet Gevonden",
                "description": "Sorry, de pagina die u probeert te bekijken bestaat niet."
            },
            "503": {
                "title": "Ben zo terug.",
                "description": "Ben zo terug."
            }
        },
        "labels": {
            "general": {
                "all": "Alle",
                "yes": "Ja",
                "no": "Nee",
                "custom": "Aangepast",
                "actions": "Acties",
                "active": "Active",
                "buttons": {
                    "save": "Bewaar",
                    "update": "Bijwerken"
                },
                "hide": "Verberg",
                "inactive": "Inactive",
                "none": "Geen",
                "show": "Toon",
                "toggle_navigation": "Navigatie omschakelen"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Rol Creëren",
                        "edit": "Rol Aanpassen",
                        "management": "Rol Beheer",
                        "table": {
                            "number_of_users": "Aantal Gebruikers",
                            "permissions": "Permissies",
                            "role": "Rol",
                            "sort": "Sorteer",
                            "total": "rol ::: rollen"
                        }
                    },
                    "users": {
                        "active": "Actieve Gebruikers",
                        "all_permissions": "Alle Permissies",
                        "change_password": "Wachtwoord veranderen",
                        "change_password_for": "Wachtwoord veranderen voor {user}",
                        "create": "Gebruiker Aanmaken",
                        "deactivated": "Gedeactiveerde Gebruikers",
                        "deleted": "Verwijderde Gebruikers",
                        "edit": "Gebruiker aanpassen",
                        "management": "Gebruikers Beheer",
                        "no_permissions": "Geen Permissie",
                        "no_roles": "Geen rollen beschikbaar.",
                        "permissions": "Permissies",
                        "table": {
                            "confirmed": "Bevestigd",
                            "created": "Gecreëerd",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "Laatst Bijgewerkt",
                            "first_name": "Voornaam",
                            "last_name": "Achternaam",
                            "name": "Naam",
                            "no_deactivated": "Geen gedeactiveerde Gebruikers",
                            "no_deleted": "Geen Verwijderde Gebruikers",
                            "roles": "Rollen",
                            "social": "Social",
                            "total": "gebruiker ::: gebruikers"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overzicht",
                                "history": "Geschiedenis"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Bevesstigd",
                                    "created_at": "Gecreëerd",
                                    "deleted_at": "Verwijdert",
                                    "email": "E-mail",
                                    "last_updated": "Laatst bijgewerkt",
                                    "name": "Naam",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "Bekijk gebruiker"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Inloggen",
                    "login_button": "Inloggen",
                    "login_with": "Inloggen via {social_media}",
                    "register_box_title": "Registreer",
                    "register_button": "Registreer",
                    "remember_me": "Onthoud Mij"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Wachtwoord Vergeten?",
                    "reset_password_box_title": "Wachtwoord Resetten",
                    "reset_password_button": "Reset Wachtwoord",
                    "send_password_reset_link_button": "Stuur Wachtwoord Reset Link"
                },
                "user": {
                    "passwords": {
                        "change": "Wachtwoord veranderen"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Gecreëerd",
                        "edit_information": "Informatie aanpassen",
                        "email": "E-mail",
                        "last_updated": "Voor het laatst aangepast",
                        "name": "Naam",
                        "update_information": "Informatie bijwerken"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "De rol is succesvol aangemaakt.",
                    "deleted": "De rol is succesvol verwijderd.",
                    "updated": "De rol is succesvol bijgewerkt."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "Een nieuwe bevestigings e-mail is verzonden naar het aangegeven adres.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "De gebruiker is succesvol aangemaakt.",
                    "deleted": "De gebruiker is succesvol verwijderd.",
                    "deleted_permanently": "De gebruiker is permanent verwijderd.",
                    "restored": "De gebruiker is met succes hersteld.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "De gebruiker is succesvol bijgewerkt.",
                    "updated_password": "Het wachtwoord van de gebruiker is succesvol bijgewerkt"
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} moet geaccepteerd worden.",
            "active_url": "{attribute} is geen geldige URL.",
            "after": "{attribute} moet een datum na {date} zijn.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "{attribute} mag alleen letters bevatten.",
            "alpha_dash": "{attribute} mag alleen letters, cijfers en koppeltekens bevatten.",
            "alpha_num": "{attribute} mag alleen letters, cijfers bevatten",
            "array": "{attribute} moet een array zijn.",
            "before": "{attribute} moet een datum voor {date} zijn.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "{attribute} moet tussen {min} en {max} liggen.",
                "file": "{attribute} moet tussen {min} and {max} kilobytes liggen.",
                "string": "{attribute} moet tussen de {min} en {max} karakters hebben.",
                "array": "{attribute} moet tussen {min} en {max} items hebben."
            },
            "boolean": "{attribute} veld moet waar of onwaar zijn.",
            "confirmed": "{attribute} bevestiging komt niet overeen.",
            "date": "{attribute} bevat geen geldige datum.",
            "date_format": "{attribute} komt niet overeen met het formaat {format}.",
            "different": "{attribute} en {other} mogen niet gelijk zijn.",
            "digits": "{attribute} moet {digits} cijfers bevatten.",
            "digits_between": "{attribute} moet tussen {min} and {max} cijfers bevatten.",
            "dimensions": "{attribute} heeft ongeldige afbeelding dimensies.",
            "distinct": "{attribute} bevat een duplicate waarde.",
            "email": "{attribute} moet een geldig e-mail adres zijn.",
            "exists": "Het geselecteerde {attribute} is ongeldig.",
            "file": "{attribute} moet een bestand zijn.",
            "filled": "{attribute} veld is verplicht.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} moet een afbeelding zijn.",
            "in": "geselecteerd {attribute} is ongeldig.",
            "in_array": "{attribute} veld bestaat niet in {other}.",
            "integer": "{attribute} moet een heel getal zijn .",
            "ip": "{attribute} moet een geldig IP adres zijn.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "{attribute} moet een geldige JSON string zijn.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} mag niet groter zijn dan {max}.",
                "file": "{attribute} mag niet groter zijn dan {max} kilobytes.",
                "string": "{attribute} mag niet groter zijn dan {max} karakters.",
                "array": "{attribute} mag niet meer dan {max} items bevatten."
            },
            "mimes": "{attribute} moet een bestand zijn van het type: {values}.",
            "min": {
                "numeric": "{attribute} moet minimaal {min} zijn.",
                "file": "{attribute} moet minimaal {min} kilobytes zijn.",
                "string": "{attribute} moet minimaal {min} karakters zijn.",
                "array": "{attribute} moet ten minste {min} items bevatten."
            },
            "not_in": "Het geselcteerde {attribute} is ongeldig.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} moet numeriek zijn.",
            "present": "{attribute} veld is verplicht.",
            "regex": "{attribute} formaat is ongeldig.",
            "required": "{attribute} veld is verplicht.",
            "required_if": "{attribute} veld is verplicht wanneer {other} {value} is.",
            "required_unless": "{attribute} veld is verplicht behalve wanneer{other} {values} is.",
            "required_with": "{attribute} veld is verplicht wanneer {values} aanwezig is.",
            "required_with_all": "{attribute} veld is verplicht wanneer {values} aanwezig is.",
            "required_without": "{attribute} veld is verplicht wanneer {values} niet aanwezig is.",
            "required_without_all": "{attribute} veld is verplicht wanneer geen van {values} aanwezig zijn.",
            "same": "{attribute} en {other} moeten overeenkomen.",
            "size": {
                "numeric": "{attribute} moet {size} zijn.",
                "file": "{attribute} moet {size} kilobytes zijn.",
                "string": "{attribute} moet {size} karakters bevatten.",
                "array": "{attribute} moet {size} items bevatten."
            },
            "string": "{attribute} moet een string zijn.",
            "timezone": "{attribute} moet een geldige tijdzone bevatten.",
            "unique": "{attribute} is al in gebruik.",
            "url": "{attribute} formaat is ongeldig.",
            "custom": {
                "attribute-name": {
                    "rule-name": "Individueel-bericht"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Geassocieerde Rollen",
                            "dependencies": "Afhankelijkheden",
                            "display_name": "Weergave Naam",
                            "group": "Groep",
                            "group_sort": "Groep Sorteren",
                            "groups": {
                                "name": "Groep Naam"
                            },
                            "name": "Naam",
                            "system": "Systeem?"
                        },
                        "roles": {
                            "associated_permissions": "Geassocieerde Permissies",
                            "name": "Naam",
                            "sort": "Sorteren"
                        },
                        "users": {
                            "active": "Actief",
                            "associated_roles": "Geassocieerde Rollen",
                            "confirmed": "Bevestigd",
                            "email": "E-mail Adres",
                            "first_name": "Voornaam",
                            "last_name": "Achternaam",
                            "name": "Naam",
                            "other_permissions": "Overige Permissies",
                            "password": "Wachtwoord",
                            "password_confirmation": "Wachtwoord bevestiging",
                            "send_confirmation_email": "Stuur Bevestigings E-mail"
                        }
                    }
                },
                "frontend": {
                    "email": "E-mail Adres",
                    "first_name": "Voornaam",
                    "last_name": "Achternaam",
                    "name": "Naam",
                    "password": "Wachwoord",
                    "password_confirmation": "Wachtwoord Bevestiging",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "Oud Wachtwoord",
                    "new_password": "Nieuw Wachtwoord",
                    "new_password_confirmation": "Nieuw Wachtwoord Bevestigen"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Die rol bestaat al. Kies een andere naam.",
                        "cant_delete_admin": "De Administrator rol kan niet worden verwijdert.",
                        "create_error": "Er is een probleem opgetreden bij het creëren van deze rol. Probeer het nogmaals.",
                        "delete_error": "Er is een probleem opgetreden bij het verwijderen van deze rol. Probeer het nogmaals.",
                        "has_users": "Een rol met gebruikers kan niet worden verwijdert.",
                        "needs_permission": "Kies ten minste één permissie voor deze rol.",
                        "not_found": "Die rol bestaat niet.",
                        "update_error": "Er is een probleem opgetreden bij het bijwerken van deze rol. Probeer het nogmaals."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "U kunt uzelf niet deactiveren",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "U kunt uzelf niet verwijderen.",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "cant_restore": "This user is not deleted so it can not be restored.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "Er is een probleem opgetreden bij het creëren van de gebruiker. Probeer het nogmaals.",
                        "delete_error": "Er is een probleem opgetreden bij het verwijderen van de gebruiker. Probeer het nogmaals.",
                        "delete_first": "This user must be deleted first before it can be destroyed permanently.",
                        "email_error": "Dit email-adres is al in gebruik.",
                        "mark_error": "Er is een probleem opgetreden bij het bijwerken van de gebruiker. Probeer het nogmaals.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "Die gebruiker bestaat niet.",
                        "restore_error": "Er is een probleem opgetreden bij het herstellen van de gebruiker. Probeer het nogmaals.",
                        "role_needed_create": "U moet ten minste één rol kiezen. De gebruiker is aangemaakt maar gedeactiveerd.",
                        "role_needed": "U moet ten minste één rol kiezen.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "Er is een probleem opgetreden bij het bijwerken van de gebruiker. Probeer het nogmaals.",
                        "update_password_error": "Er is een probleem opgetreden bij het aanpassen van het wachtwoord van de gebruiker. Probeer het nogmaals."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Uw account is reeds bevestigd",
                        "confirm": "Bevestig uw account!",
                        "created_confirm": "Uw account is succesvol aangemaakt. Een bevestigings email is verzonden.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Uw bevestigingscode komt niet overeen.",
                        "not_found": "De bevestigingscode bestaat niet.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Uw account kon niet worden bevestigd. Klik op de informatie link in de email die u heeft ontvangen, of <a href=\"{url}\">klik hier</a> om de bevestigingsemail opnieuw te versturen.",
                        "success": "Uw account is succesvol bevestigd!",
                        "resent": "Een nieuwe bevestigings email is naar het ingegeven adres verstuurd."
                    },
                    "deactivated": "Uw account is gedactiveerd.",
                    "email_taken": "Dat emailadres is al in gebruik.",
                    "password": {
                        "change_mismatch": "Dat is niet uw oude wachtwoord",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Vorige",
            "next": "Volgende &raquo;"
        },
        "roles": {
            "administrator": "Administrator",
            "user": "Gebruiker"
        },
        "navs": {
            "general": {
                "home": "Home",
                "logout": "Uitloggen"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Dashboard",
                "login": "Inloggen",
                "macros": "Macros",
                "register": "Registreer",
                "user": {
                    "account": "Mijn Account",
                    "administration": "Beheer",
                    "change_password": "Verander Wachtwoord",
                    "my_information": "Mijn Informatie",
                    "profile": "Profiel"
                }
            }
        }
    },
    "no": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Er du sikker på at du vil slette denne brukeren permanent? Alle steder hvor denne brukeren er refereret vil sandsynligvis gi en feil. Fortsett på eget ansvar. Denne handlingen kan ikke angres på.",
                        "if_confirmed_off": "(Hvis bekreftelse er avslått)",
                        "restore_user_confirm": "Gjennopprett brukeren til dens opprindelige tilstand?"
                    }
                },
                "dashboard": {
                    "title": "Administrativ betjeningspanel",
                    "welcome": "Velkommen"
                },
                "general": {
                    "all_rights_reserved": "Alle rettigheter forbeholdes.",
                    "are_you_sure": "Er du sikker?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Fortsett",
                    "member_since": "Medlem siden",
                    "minutes": " minutter",
                    "search_placeholder": "Søk...",
                    "timeout": "Du er av sikkerhedsmessige årsaker blitt logget av automatisk, da du ikke har været aktiv i ",
                    "see_all": {
                        "messages": "Se alle meldinger",
                        "notifications": "Vis alle",
                        "tasks": "Vis alle oppgaver"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} Du har ingen meldinger ::: {1} Du hare 1 melding ::: [2,Inf] Du har {number} meldinger",
                        "notifications": "{0} Du har ingen notifikationer ::: {1} Du har 1 notifikation ::: [2,Inf] Du har {number} notifikationer",
                        "tasks": "{0} Du har ingen oppgaver ::: {1} Du har 1 oppgave ::: [2,Inf] Du har {number} oppgaver"
                    }
                },
                "search": {
                    "empty": "Please enter a search term.",
                    "incomplete": "You must write your own search logic for this system.",
                    "title": "Search Results",
                    "results": "Search Results for {query}"
                },
                "welcome": "<p>Dette er temaet AdminLTE som er utviklet av <a href=\"https://almsaeedstudio.com/\" target=\"_blank\">https://almsaeedstudio.com/</a>. Dette er en minimal utgave med kun det nødvendige design og kode for at få det hele til at fungere. Download den fulle version for å tilføre flere komponenter til ditt betjeningspanel.</p>\n<p>Alle funktionaliteter er blot til fremvisning med undtagelse af <strong>Brugeradministrationen</strong> til venstre. Denne opsætning indeholder derfor en fuld funktionel adgangskontrol til at administrere brugere/roller/rettigheder.</p>\n<p>Vær opmærksom på at dette er et videregående projekt og der kan derfor forekomme fejl eller andre problemer, som jeg ikke er stødt på endnu. Jeg vil gøre mit bedste for at rette dem når jeg modtager dem.</p>\n<p>Håber at du er glad for indsatsen jeg har givet dette projekt. Du er velkommen til at besøge os på <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> for mere information og du kan samtidig med indberette <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">fejl her</a>.</p>\n<p><strong>Dette projekt er rimelig omfattende at vedligeholde med de mange opdateringer Laravel indfører i deres master branch, så alle former for hjælp er værdsat.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Din konto har blitt godkjent.",
                    "error": "Whoops!",
                    "greeting": "Hello!",
                    "regards": "Hilsen,",
                    "trouble_clicking_button": "Hvis du har problem med å klikke på \"{action_text}\" knappen, copy and paste URL under in i nettleseren:",
                    "thank_you_for_using_app": "Takk for at du bruker vår applikasjon!",
                    "password_reset_subject": "Din link til å tilbakestille passordet",
                    "password_cause_of_email": "Du får denne mailen fordi vi har motatt en forespørsel om å tilbakestille passordet på din konto.",
                    "password_if_not_requested": "Hvis du ikke ba om dette, trenger du ikke gjøre noe.",
                    "reset_password": "Klikk her for at tilbakestille passordet",
                    "click_to_confirm": "Klikk her for å bekrefte kontoen din:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Rettighetsbaseret - ",
                        "role": "Rollebaseret - "
                    },
                    "js_injected_from_controller": "Javascript satt inn fra en Controller",
                    "using_blade_extensions": "Bruker Blade-utvidelser",
                    "using_access_helper": {
                        "array_permissions": "Bruker 'Acess Helper' med en liste av rettighedsnavne eller rettighedsid'er hvor brukeren skal oppfylde alle rettigheder.",
                        "array_permissions_not": "Bruker 'Access Helper' med en liste av rettighedsnavne eller id'er hvor brukeren ikke behøver at oppfylde alle rettigheder.",
                        "array_roles": "Bruker 'Access Helper' med en liste av rollenavne eller rolleid'er hvor brukeren skal oppfylde alle rettigheder.",
                        "array_roles_not": "Bruker 'Access Helper' med en liste av rollenavne eller rolleid'er hvor brukeren ikke behøver at oppfylde alle rettigheder.",
                        "permission_id": "Bruker 'Access Helper' med rettighedsid",
                        "permission_name": "Bruker 'Access Helper' med rettighedsnavn",
                        "role_id": "Bruker 'Access Helper' med rolleid",
                        "role_name": "Bruker 'Access Helper' med rollenavn"
                    },
                    "view_console_it_works": "Vis konsol og du burde kunne se 'it works!', som kommer fra FrontendController@index",
                    "you_can_see_because": "Du kan se dette fordi du har rollen '{role}'!",
                    "you_can_see_because_permission": "Du kan se dette fordi du har rettigheten '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "Hvis du endrer emailadressen vil du bli logget av til du kan bekrefte din nye emailadresse.",
                    "email_changed_notice": "Du må bekrefte din nye email før du kan logge inn igjen.",
                    "profile_updated": "Profil oppdateret.",
                    "password_updated": "Passord oppdateret."
                },
                "welcome_to": "Velkommen til {place}"
            }
        },
        "auth": {
            "failed": "Brukernavn eller passord stemmer ikke.",
            "general_error": "Du har ikke tilgang til at utføre denne handling.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} kan ikke brukes som login."
            },
            "throttle": "For mange mislykkede forsøk. Prøv igen om {seconds} sekunder.",
            "unknown": "Det oppstod en ukjent feil."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Adgangsadministration",
                    "roles": {
                        "all": "Alle Roller",
                        "create": "Oppret Rolle",
                        "edit": "Rediger Rolle",
                        "management": "Rolleadministration",
                        "main": "Roller"
                    },
                    "users": {
                        "all": "Alle Brukere",
                        "change-password": "Endre Passord",
                        "create": "Oppret Bruker",
                        "deactivated": "Deaktiverede Brukere",
                        "deleted": "Slett Bruker",
                        "edit": "Rediger Bruker",
                        "main": "Brukere",
                        "view": "Se på bruker"
                    }
                },
                "log-viewer": {
                    "main": "Hovedside",
                    "dashboard": "Dashboard",
                    "logs": "Logger"
                },
                "sidebar": {
                    "dashboard": "Dashboard",
                    "general": "Generelt",
                    "system": "System"
                }
            },
            "language-picker": {
                "language": "Språk",
                "langs": {
                    "ar": "Arabisk (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Dansk (Danish)",
                    "de": "Tysk (German)",
                    "el": "(Greek)",
                    "en": "Engelsk (English)",
                    "es": "Spansk (Spanish)",
                    "fa": "Persian (Persian)",
                    "fr": "Fransk (French)",
                    "he": "Hebraisk (Hebrew)",
                    "id": "Indonesisk (Indonesian)",
                    "it": "Italiensk (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Hollandsk (Dutch)",
                    "no": "Norsk (Norwegian)",
                    "pt_BR": "Brasiliansk portugisisk (Brazilian Portuguese)",
                    "ru": "Russisk (Russian)",
                    "sv": "Svensk (Swedish)",
                    "th": "(Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Aktivér",
                        "change_password": "Oppdater passord",
                        "clear_session": "Fjern Sessjonen",
                        "confirm": "Confirm",
                        "deactivate": "Deaktiver",
                        "delete_permanently": "Slett permanent",
                        "login_as": "Logg inn som {user}",
                        "resend_email": "Send ny bekreftelsesmail",
                        "restore_user": "Gjennopprett bruker",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Bekreft Konto",
                    "reset_password": "Send Passord på nytt"
                }
            },
            "general": {
                "cancel": "Cancel",
                "continue": "Fortsett",
                "crud": {
                    "create": "Opprett",
                    "delete": "Slett",
                    "edit": "Rediger",
                    "update": "Oppdater",
                    "view": "View"
                },
                "save": "Lagre",
                "view": "Vis"
            }
        },
        "passwords": {
            "password": "Passordet skal være mindst seks tegn og må matche hverandre.",
            "reset": "Dit passord er blitt tilbakestilt!",
            "sent": "Vi har sendt deg et link til å tilbakestille passordet!",
            "token": "Denne linken til å tilbakestille passordet er ugyldig.",
            "user": "Vi kan ikke finne en bruker med denne adressen."
        },
        "http": {
            "404": {
                "title": "Siden finnes ikke",
                "description": "Beklager, men siden, du forsøkte at se, finnes ikke."
            },
            "503": {
                "title": "Er snart tilbake.",
                "description": "Er snart tilbake."
            }
        },
        "labels": {
            "general": {
                "all": "Alle",
                "yes": "Ja",
                "no": "Nei",
                "custom": "Brukerdefineret",
                "actions": "Handlinger",
                "active": "Aktiv",
                "buttons": {
                    "save": "Lagre",
                    "update": "Oppdater"
                },
                "hide": "Skjul",
                "inactive": "Innaktiv",
                "none": "Ingen",
                "show": "Vis",
                "toggle_navigation": "Navigation"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Opprett Rolle",
                        "edit": "Oppdater Rolle",
                        "management": "Rolleadministration",
                        "table": {
                            "number_of_users": "Antall Brukere",
                            "permissions": "Rettigheter",
                            "role": "Rolle",
                            "sort": "Sortér",
                            "total": "rolle i alt ::: roller i alt"
                        }
                    },
                    "users": {
                        "active": "Aktive Brukere",
                        "all_permissions": "Alle Rettigheter",
                        "change_password": "Endre Passord",
                        "change_password_for": "Endre Passord for {user}",
                        "create": "Opprett Bruker",
                        "deactivated": "Deaktiver Brukere",
                        "deleted": "Slettet Brukere",
                        "edit": "Rediger Bruker",
                        "management": "Brukeradministration",
                        "no_permissions": "Ingen Rettigheter",
                        "no_roles": "Ingen Rolle valgt.",
                        "permissions": "Rettigheter",
                        "table": {
                            "confirmed": "Bekreftet",
                            "created": "Opprettet",
                            "email": "Email",
                            "id": "Id",
                            "last_updated": "Sist Oppdateret",
                            "first_name": "Brukernavn",
                            "last_name": "Etternavn",
                            "no_deactivated": "Ingen Deaktiverede Brukere",
                            "no_deleted": "Ingen Slettede Brukere",
                            "roles": "Roller",
                            "social": "Sosial",
                            "total": "bruker i alt ::: brukere i alt"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overview",
                                "history": "History"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Bekreftet",
                                    "created_at": "Opprettet den",
                                    "deleted_at": "Slettet den",
                                    "email": "E-mail",
                                    "last_updated": "Sist Oppdatert",
                                    "first_name": "Brukernavn",
                                    "last_name": "Etternavn",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "Se på Bruker"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Logg inn",
                    "login_button": "Logg inn",
                    "login_with": "Logg inn med {social_media}",
                    "register_box_title": "Opprett",
                    "register_button": "Opprett",
                    "remember_me": "Husk meg"
                },
                "contact": {
                    "box_title": "Kontakt oss",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Glemt passordet?",
                    "reset_password_box_title": "tilbakestill passordet",
                    "reset_password_button": "tilbakestill passordet",
                    "send_password_reset_link_button": "Send link til å tilbakestille passordet"
                },
                "macros": {
                    "country": {
                        "alpha": "Landkoder",
                        "alpha2": "Landkoder (Alfa-2)",
                        "alpha3": "Landkode (Alfa-3)",
                        "numeric": "Landkoder (Numerisk)"
                    },
                    "macro_examples": "Eksempler på Makroer",
                    "state": {
                        "mexico": "Mexicos stater",
                        "us": {
                            "us": "Amerikanske stater",
                            "outlying": "Amerikanske oversøiske territorier",
                            "armed": "Amerikanske vepnede styrker"
                        }
                    },
                    "territories": {
                        "canada": "Canada's provinser og territorier"
                    },
                    "timezone": "Tidssone"
                },
                "user": {
                    "passwords": {
                        "change": "Endre passord"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Opprettet den",
                        "edit_information": "Rediger information",
                        "email": "Email",
                        "last_updated": "Sist opdateret",
                        "first_name": "Brukernavn",
                        "last_name": "Etternavn",
                        "update_information": "Oppdater information"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Rollen ble opprettet.",
                    "deleted": "Rollen ble slettet.",
                    "updated": "Rollen ble oppdateret."
                },
                "users": {
                    "cant_resend_confirmation": "Applikasjonen er satt til å godkjenne brukere manuelt.",
                    "confirmation_email": "En ny bekreftelsesmail er sendt til brukeren.",
                    "confirmed": "Brukeren ble godkjent.",
                    "created": "Brukeren ble opprettet.",
                    "deleted": "Brukeren ble slettet.",
                    "deleted_permanently": "Brukeren ble slettet permanent.",
                    "restored": "Brukeren ble gjenopprettet.",
                    "session_cleared": "Brukerens sessjon har blitt fjernet.",
                    "social_deleted": "Sosiale kontoer er fjernet.",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "Brukeren ble oppdateret.",
                    "updated_password": "Brukerens passord ble oppdateret."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Din informasjon ble sendt. Vi svarer deg på mail så fort vi kan."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} skal aksepteres.",
            "active_url": "{attribute} er ikke en gyldig adresse.",
            "after": "{attribute} skal være en dato etter {date}.",
            "after_or_equal": "{attribute} må være etter eller lik som {date}.",
            "alpha": "{attribute} må kun inneholde bokstaver.",
            "alpha_dash": "{attribute} må kun inneholde bokstaver, tall og mellemstreger.",
            "alpha_num": "{attribute} må kun inneholde bokstaver og tall.",
            "array": "{attribute} skal være en liste.",
            "before": "{attribute} skal være en dato før {date}.",
            "before_or_equal": "{attribute} må være en dato før eller lik som {date}.",
            "between": {
                "numeric": "{attribute} skal være mellem {min} og {max}.",
                "file": "{attribute} skal være mellem {min} og {max} kilobytes.",
                "string": "{attribute} skal være mellem {min} og {max} tegn.",
                "array": "{attribute} skal være mellem {min} og {max} elementer."
            },
            "boolean": "{attribute} skal være sant eller falsk.",
            "confirmed": "{attribute} bekreftelse passer ikke sammen.",
            "date": "{attribute} er ikke en gyldig dato.",
            "date_format": "{attribute} passer ikke til formatet {format}.",
            "different": "{attribute} og {other} skal være forskjellige.",
            "digits": "{attribute} skal være på {digits} cifre.",
            "digits_between": "{attribute} skal være mellom {min} og {max} siffre.",
            "dimensions": "{attribute} har ugyldige dimensioner.",
            "distinct": "{attribute} skal være unik.",
            "email": "{attribute} skal være en gyldig e-mailaddresse.",
            "exists": "{attribute} finnes ikke.",
            "file": "{attribute} skal være en fil.",
            "filled": "{attribute} skal utfyldes.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} skal være et bilde.",
            "in": "{attribute} er ikke gyldig.",
            "in_array": "{attribute} finnes ikke i {other}.",
            "integer": "{attribute} skal være et heltal.",
            "ip": "{attribute} skal være en gyldig IP-adresse.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "{attribute} skal være gyldig JSON format.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} må ikke være større enn {max}.",
                "file": "{attribute} må ikke være større enn {max} kilobytes.",
                "string": "{attribute} må ikke være længere enn {max} tegn.",
                "array": "{attribute} må ikke ha flere enn {max} elementer."
            },
            "mimes": "{attribute} skal være filtypen: {values}.",
            "min": {
                "numeric": "{attribute} skal være mindst {min}.",
                "file": "{attribute} skal være mindst {min} kilobytes.",
                "string": "{attribute} skal mindts være {min} tegn.",
                "array": "{attribute} skal ha mindst {min} elementer."
            },
            "not_in": "{attribute} er ikke gyldig.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} skal være et tall.",
            "present": "Feltet {attribute} mangler.",
            "regex": "{attribute} er ikke et gyldigt format.",
            "required": "{attribute} er påkrevd.",
            "required_if": "{attribute} er påkrevd når {other} er {value}.",
            "required_unless": "{attribute} er påkrevd med mindre {other} er {values}.",
            "required_with": "{attribute} er påkrevd når {values} er tilgengelig.",
            "required_with_all": "{attribute} er påkrevd når {values} er tilgengelig.",
            "required_without": "{attribute} er påkrevd når {values} ikke er tilgengelig.",
            "required_without_all": "{attribute} er påkrevd når ingen av verdierne {values} er tilgengelig.",
            "same": "{attribute} og {other} skal være ens.",
            "size": {
                "numeric": "{attribute} skal være {size}.",
                "file": "{attribute} skal være {size} kilobytes.",
                "string": "{attribute} skal ha {size} tegn.",
                "array": "{attribute} skal inneholde {size} elementer."
            },
            "string": "{attribute} skal være tekst.",
            "timezone": "{attribute} skal være en gyldig tidssone.",
            "unique": "{attribute} er allerede i bruk.",
            "url": "{attribute} er ikke i det riktig format.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Tilknyttede Roller",
                            "dependencies": "Avengigheter",
                            "display_name": "Visningsnavn",
                            "group": "Gruppe",
                            "group_sort": "Gruppesortering",
                            "groups": {
                                "name": "Gruppenavn"
                            },
                            "name": "Navn",
                            "system": "System?"
                        },
                        "roles": {
                            "associated_permissions": "Tilknyttede Rettigheter",
                            "name": "Navn",
                            "sort": "Sortér"
                        },
                        "users": {
                            "active": "Aktiv",
                            "associated_roles": "Tilknyttede Roller",
                            "confirmed": "Bekreftet",
                            "email": "E-mailadresse",
                            "first_name": "Brukernavn",
                            "last_name": "Etternavn",
                            "other_permissions": "Andre Rettigheter",
                            "password": "Passord",
                            "password_confirmation": "Bekreft passord",
                            "send_confirmation_email": "Send bekrefelsesmail"
                        }
                    }
                },
                "frontend": {
                    "email": "E-mailadresse",
                    "first_name": "Brukernavn",
                    "last_name": "Etternavn",
                    "password": "Passord",
                    "password_confirmation": "Bekreft passord",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "Gammelt passord",
                    "new_password": "Nytt passord",
                    "new_password_confirmation": "Bekreft nytt passord"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Rollen finnes allerede. Velg et annet navn.",
                        "cant_delete_admin": "Du kan ikke slette rollen \"Administrator\".",
                        "create_error": "Det oppstod et problem ved opprettelsen av denne rollen. Prøv igjen.",
                        "delete_error": "Det oppstod et problem ved slettning av denne rollen. Prøv igjen.",
                        "has_users": "Du kan ikke slette en rolle med tilhørende brukere.",
                        "needs_permission": "Du skal velge mindst én tillatelse til denne rollen.",
                        "not_found": "Denne rollen finnes ikke.",
                        "update_error": "Det oppstod et problem ved oppdatering av denne rollen. Prøv igjen."
                    },
                    "users": {
                        "already_confirmed": "Brukeren er allerede bekreftet.",
                        "cant_deactivate_self": "Du kan ikke utføre denne handlingen på deg selv.",
                        "cant_delete_admin": "Du kan ikke slette super administrator.",
                        "cant_delete_self": "Du kan ikke slette deg selv.",
                        "cant_delete_own_session": "Du kan ikke slette din egen sessjon.",
                        "create_error": "Det oppstod et problem ved opprettelsen av denne brukeren. Prøv igjen.",
                        "delete_error": "Det oppstod et problem ved slettning av denne brukeren. Prøv igjen.",
                        "delete_first": "Denne brukeren må slettes først, før den kan bli fjernet permanent.",
                        "email_error": "Denne e-mailadressen tilhører en annen bruker.",
                        "mark_error": "Det oppstod et problem ved oppdatering av denne brukeren. Prøv igjen.",
                        "not_confirmed": "Denne brukeren er ikke bekreftet.",
                        "not_found": "Denne brukeren eksisterer ikke.",
                        "restore_error": "Det oppstod et problem ved gjennoprettelsen av denne brukeren. Prøv igjen.",
                        "role_needed_create": "Du må velge mindst én rolle.",
                        "role_needed": "Du må velge mindst én rolle.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "Det oppstod et problem med fjerningen av de sosiale kontoene til denne brukeren.",
                        "update_error": "Det oppstod et problem ved oppdatering av denne brukeren. Prøv igjen.",
                        "update_password_error": "Det oppstod et problem ved endring av brukerens passord. Prøv igjen."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Din konto er allerede bekreftet.",
                        "confirm": "Bekreft din konto!",
                        "created_confirm": "Din konto ble opprettet. Vi har sendt deg en email for å bekrefte din adresse.",
                        "created_pending": "Din konto ble opprettet og venter på å bli godkjent. Du får en email når den er godkjent.",
                        "mismatch": "Din bekreftelseskode matcher ikke.",
                        "not_found": "Denne bekreftelseskode finnes ikke.",
                        "pending": "Din konto venter på å bli godkjent.",
                        "resend": "Din konto er ikke bekreftet. Klikk på linket i bekreftelsesmailen eller <a href=\"{url}\">klikk her</a> for å sende den på nytt.",
                        "success": "Din konto er blitt godkjent!",
                        "resent": "En ny bekreftelsesmail er blitt sendt til din e-mailadresse."
                    },
                    "deactivated": "Din konto er blitt deaktiveret.",
                    "email_taken": "Denne e-mailadressen er allerede i bruk.",
                    "password": {
                        "change_mismatch": "Dette er ikke ditt gamle passord.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registrering av nye kontoer er fortiden stengt."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Forrige",
            "next": "Neste &raquo;"
        },
        "roles": {
            "administrator": "Administrator",
            "user": "Bruker"
        },
        "navs": {
            "general": {
                "home": "Hjem",
                "logout": "Logg av"
            },
            "frontend": {
                "contact": "Kontakt",
                "dashboard": "Dashboard",
                "login": "Logg inn",
                "macros": "Makroer",
                "register": "Opprett",
                "user": {
                    "account": "Min Konto",
                    "administration": "Administration",
                    "change_password": "Endre passord",
                    "my_information": "Min information",
                    "profile": "Profil"
                }
            }
        }
    },
    "pt_BR": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Tem certeza de que deseja excluir este usuário permanentemente? Em algum lugar do aplicativo pode fazer referência ao id deste usuário e possivelmente pode ocasionar um erro. Prossiga por sua conta e risco. Isso não pode ser desfeito.",
                        "if_confirmed_off": "(Se confirmado estiver desligado)",
                        "restore_user_confirm": "Restaurar esse usuário ao seu estado original?"
                    }
                },
                "dashboard": {
                    "title": "Painel de Controle Administrativo",
                    "welcome": "Bem-vindo"
                },
                "general": {
                    "all_rights_reserved": "Todos os direitos reservados.",
                    "are_you_sure": "Tem certeza?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Continuar",
                    "member_since": "Membro desde",
                    "minutes": " minutos",
                    "search_placeholder": "Buscar...",
                    "timeout": "Você foi automaticamente desconectado por questão de segurança já que você estava inativo por ",
                    "see_all": {
                        "messages": "Ver todas as mensagens",
                        "notifications": "Ver todas as notificações",
                        "tasks": "Ver todas as tarefas"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} Você não tem mensagens ::: {1} Você tem 1 mensagem ::: [2,Inf] Você tem {number} mensagens",
                        "notifications": "{0} Você não tem notificações ::: {1} Você tem 1 notificação ::: [2,Inf] Você tem {number} notificações",
                        "tasks": "{0} Você não tem tarefas ::: {1} Você tem 1 tarefa ::: [2,Inf] Você tem {number} tarefas"
                    }
                },
                "search": {
                    "empty": "Por favor, digite um termo de busca.",
                    "incomplete": "Você deve escrever sua própria lógica de busca para este sistema.",
                    "title": "Resultados da busca",
                    "results": "Resultados da busca por {query}"
                },
                "welcome": "<p>Este é o tema AdminLTE por <a href=\"https://almsaeedstudio.com/\" target=\"_blank\">https://almsaeedstudio.com/</a>. Esta é uma versão reduzida com apenas os estilos e scripts necessários para que o tema funcione. Baixe a versão completa para começar a adicionar componentes a seu painel de controle.</p>\n<p>Todas as funcionalidades são meramente demonstrativas com exceção do menu <strong>Gerenciamento de Usuários</strong> à esquerda. Este <i>boilerplate</i> vem com uma biblioteca totalmente funcional de controle de acesso para gerenciar usuários/papéis/permissões.</p>\n<p>Tenha em mente que este é um trabalho em andamento e podem existir <i>bugs</i> ou outros problemas pelos quais não passei. Farei o meu melhor para corrigí-los à medida em que os recebo.</p>\n<p>Espero que você aproveite todo o trabalho que coloquei nisto. Por favor, visite a página do <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> para maiores informações e reporte quaisquer <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">problemas aqui</a>.</p>\n<p><strong>Este projeto tem alta demanda de atualizações, dada a taxa de novas versões que a master do Laravel vem lançando, então toda ajuda é bem-vinda :).</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Sua conta foi confirmada.",
                    "error": "Oops!",
                    "greeting": "Olá!",
                    "regards": "Nossos cumprimentos,",
                    "trouble_clicking_button": "Se você está com problemas para clicar no botão \"{action_text}\", copie e cole a URL abaixo no seu navegador:",
                    "thank_you_for_using_app": "Obrigado por utilizar o nosso sistema!",
                    "password_reset_subject": "Seu link para redefinição de senha",
                    "password_cause_of_email": "Você recebeu este email porque nós recebemos uma solicitação de redefinição de senha para a sua conta.",
                    "password_if_not_requested": "Se você não solicitou uma redefinição de senha, nenhuma outra ação é necessária.",
                    "reset_password": "Clique aqui para redefinir sua senha",
                    "click_to_confirm": "Clique aqui para confirmar a sua conta:"
                },
                "contact": {
                    "email_body_title": "Você tem um novo contato. Seguem detalhes:",
                    "subject": "Um novo contato de {app_name}!"
                }
            },
            "frontend": {
                "test": "Teste",
                "tests": {
                    "based_on": {
                        "permission": "Baseado na Permissão do Usuário - ",
                        "role": "Baseado no Papel do Usuário - "
                    },
                    "js_injected_from_controller": "Javascript Injetado de um Controller",
                    "using_blade_extensions": "Usando as Extensões Blade",
                    "using_access_helper": {
                        "array_permissions": "Usando o \"Access Helper\" com um Array de Nomes de Permissões ou ID's onde o usuário precisa satisfazer ambas as condições.",
                        "array_permissions_not": "Usando o \"Access Helper\" com um Array de Nomes de Permissões ou ID's onde o usuário não precisa satisfazer ambas as condições.",
                        "array_roles": "Usando o \"Access Helper\" com um Array de Nomes de Papéis ou ID's onde o usuário precisa satisfazer ambas as condições.",
                        "array_roles_not": "Usando o \"Access Helper\" com um Array de Nomes de Papéis ou ID's onde o usuário não precisa satisfazer ambas as condições.",
                        "permission_id": "Usando o \"Access Helper\" com o ID da Permissão",
                        "permission_name": "Usando o \"Access Helper\" com o Nome da Permissão",
                        "role_id": "Usando o \"Access Helper\" com o ID do Papel",
                        "role_name": "Usando o \"Access Helper\" com o Nome do Papel"
                    },
                    "view_console_it_works": "Veja o console, você deverá ver a mensagem 'it works!' que está vindo de FrontendController@index",
                    "you_can_see_because": "Você pode ver isto porque você tem o papel de '{role}'!",
                    "you_can_see_because_permission": "Você pode ver isto porque você tem a permissão de '{permission}'!"
                },
                "general": {
                    "joined": "Entrou"
                },
                "user": {
                    "change_email_notice": "Se você alterar seu e-mail, você será deslogado até que confirme seu novo e-mail.",
                    "email_changed_notice": "Você deve confirmar seu novo e-mail antes de fazer login novamente.",
                    "profile_updated": "Perfil atualizado com sucesso.",
                    "password_updated": "Senha atualizada com sucesso."
                },
                "welcome_to": "Bem-vindo a {place}"
            }
        },
        "auth": {
            "failed": "Estas credenciais não correspondem com nossos registros.",
            "general_error": "Você não tem acesso para fazer isso.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} não é um tipo de login aceitável."
            },
            "throttle": "Você realizou muitas tentativas de login. Favor tentar novamente em {seconds} segundos.",
            "unknown": "Ocorreu um erro desconhecido."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Gerenciamento de Usuários",
                    "roles": {
                        "all": "Todos os Papéis",
                        "create": "Criar Papel",
                        "edit": "Editar Papel",
                        "management": "Gerenciamento de Papéis",
                        "main": "Papéis"
                    },
                    "users": {
                        "all": "Todos os Usuários",
                        "change-password": "Alterar Senha",
                        "create": "Criar Usuário",
                        "deactivated": "Desativar Usuários",
                        "deleted": "Excluir Usuários",
                        "edit": "Editar Usuário",
                        "main": "Usuários",
                        "view": "Visualizar Usuário"
                    }
                },
                "log-viewer": {
                    "main": "Visualizador de Log",
                    "dashboard": "Painel de Controle",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Painel de Controle",
                    "general": "Geral",
                    "system": "Sistema"
                }
            },
            "language-picker": {
                "language": "Idioma",
                "langs": {
                    "ar": "العربية (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Dinamarquês (Danish)",
                    "de": "Alemão (German)",
                    "el": "(Greek)",
                    "en": "Inglês (English)",
                    "es": "Espanhol (Spanish)",
                    "fa": "Persa (Persian)",
                    "fr": "Francês (French)",
                    "he": "Hebraico (Hebrew)",
                    "id": "indonésio (Indonesian)",
                    "it": "Italiano (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Holandês (Dutch)",
                    "no": "Norueguês (Norwegian)",
                    "pt_BR": "Português do Brasil (Brazilian Portuguese)",
                    "ru": "Russo (Russian)",
                    "sv": "Sueco (Swedish)",
                    "th": "(Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Ativar",
                        "change_password": "Alterar senha",
                        "clear_session": "Limpar Sessão",
                        "confirm": "Confirmar",
                        "deactivate": "Desativar",
                        "delete_permanently": "Excluir Permanentemente",
                        "login_as": "Entrar como {user}",
                        "resend_email": "Reenviar e-mail de confirmação",
                        "restore_user": "Restaurar Usuário",
                        "unconfirm": "Des-confirmar",
                        "unlink": "Dissociar"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Confirmar conta",
                    "reset_password": "Reiniciar senha"
                }
            },
            "general": {
                "cancel": "Cancelar",
                "continue": "Continuar",
                "crud": {
                    "create": "Criar",
                    "delete": "Excluir",
                    "edit": "Editar",
                    "update": "Atualizar",
                    "view": "Visualizar"
                },
                "save": "Salvar",
                "view": "Visualizar"
            }
        },
        "passwords": {
            "password": "A senha deverá conter pelo menos seis carateres e ser igual à confirmação.",
            "reset": "Sua senha foi redefinida!",
            "sent": "Nós enviamos um link de recuperação de senha por e-mail.",
            "token": "Este código de recuperação de senha é inválido.",
            "user": "Não conseguimos encontrar nenhum usuário com o endereço de e-mail especificado."
        },
        "http": {
            "404": {
                "title": "Página não encontrada",
                "description": "Desculpe, mas a página que você estava tentando visualizar não existe."
            },
            "503": {
                "title": "Voltamos logo",
                "description": "Voltamos logo."
            }
        },
        "labels": {
            "general": {
                "all": "Todos",
                "yes": "Sim",
                "no": "Não",
                "custom": "Personalizado",
                "actions": "Ações",
                "active": "Ativo",
                "buttons": {
                    "save": "Salvar",
                    "update": "Atualizar"
                },
                "hide": "Esconder",
                "inactive": "Inativo",
                "none": "Nenhum",
                "show": "Mostrar",
                "toggle_navigation": "Mostrar / Esconder Navegação"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Criar Papel",
                        "edit": "Criar Papel",
                        "management": "Gerenciamento de Papéis",
                        "table": {
                            "number_of_users": "Número de Usuários",
                            "permissions": "Permissões",
                            "role": "Papel",
                            "sort": "Ordenar",
                            "total": "total de permissao ::: total de permissões"
                        }
                    },
                    "users": {
                        "active": "Ativar Usuários",
                        "all_permissions": "Todas as Permissões",
                        "change_password": "Alterar Senha",
                        "change_password_for": "Alterar senha para {user}",
                        "create": "Criar Usuário",
                        "deactivated": "Desativar Usuários",
                        "deleted": "Excluir Usuários",
                        "edit": "Editar Usuário",
                        "management": "Gerenciamento Usuários",
                        "no_permissions": "Sem permissões",
                        "no_roles": "Sem papéis para definir.",
                        "permissions": "Permissões",
                        "table": {
                            "confirmed": "Confirmado",
                            "created": "Criado",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "Última atualização",
                            "name": "Nome",
                            "no_deactivated": "Nenhum usuário desativado.",
                            "no_deleted": "Nenhum usuário excluído",
                            "roles": "Papéis",
                            "social": "Social",
                            "total": "total de usuário ::: total de usuários"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Visão Geral",
                                "history": "Histórico"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmado",
                                    "created_at": "Criado em",
                                    "deleted_at": "Apagado em",
                                    "email": "E-mail",
                                    "last_updated": "Última atualização",
                                    "name": "Nome",
                                    "status": "Estado"
                                }
                            }
                        },
                        "view": "Visualizar Usuário"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Entrar",
                    "login_button": "Entrar",
                    "login_with": "Entrar com {social_media}",
                    "register_box_title": "Registrar",
                    "register_button": "Registrar",
                    "remember_me": "Lembrar-me"
                },
                "contact": {
                    "box_title": "Contato",
                    "button": "Enviar"
                },
                "passwords": {
                    "forgot_password": "Esqueceu Sua Senha?",
                    "reset_password_box_title": "Resetar Senha",
                    "reset_password_button": "Resetar Senha",
                    "send_password_reset_link_button": "Enviar link para redefinição de senha"
                },
                "macros": {
                    "country": {
                        "alpha": "Códigos de País Alpha",
                        "alpha2": "Códigos de País Alpha 2",
                        "alpha3": "Códigos de País Alpha 3",
                        "numeric": "Códigos Numéricos País"
                    },
                    "macro_examples": "Exemplo de Macros",
                    "state": {
                        "mexico": "Lista de Estados do México",
                        "us": {
                            "us": "Lista de estados dos EUA",
                            "outlying": "Territórios Distantes EUA",
                            "armed": "Forças Armadas dos EUA"
                        }
                    },
                    "territories": {
                        "canada": "Província do Canadá e Lista de Territórios"
                    },
                    "timezone": "Fuso horário"
                },
                "user": {
                    "passwords": {
                        "change": "Alterar Senha"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Criado em",
                        "edit_information": "Editar informações",
                        "email": "E-mail",
                        "last_updated": "Última atualização",
                        "name": "Nome",
                        "update_information": "Atualizar informação"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "O papel foi criado com sucesso.",
                    "updated": "O papel foi atualizado com sucesso.",
                    "deleted": "O papel foi excluído com sucesso."
                },
                "users": {
                    "cant_resend_confirmation": "A aplicação está configurada para aprovar usuários manualmente.",
                    "confirmation_email": "Uma nova confirmação de e-mail será enviada.",
                    "confirmed": "O usuário foi confirmado com sucesso.",
                    "created": "O usuário foi criado com sucesso.",
                    "deleted": "O usuário foi excluído com sucesso.",
                    "deleted_permanently": "O usuário foi excluído permanentemente.",
                    "restored": "O usuário foi restaurado com sucesso.",
                    "session_cleared": "Sessão do usuário foi removida com sucesso.",
                    "social_deleted": "Mídia Social removida com sucesso.",
                    "unconfirmed": "Confirmação do usuário foi removida com sucesso.",
                    "updated": "O usuário foi atualizado com sucesso.",
                    "updated_password": "A senha do usuário foi atualizada com sucesso."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Suas informações foram enviadas com sucesso. Nós responderemos ao e-mail fornecido assim que possível."
                }
            }
        },
        "validation": {
            "accepted": "O campo {attribute} deve ser aceito.",
            "active_url": "O campo {attribute} não contém um URL válido.",
            "after": "O campo {attribute} deverá conter uma data posterior a {date}.",
            "after_or_equal": "O campo {attribute} deve ser igual ou posterior a {date}.",
            "alpha": "O campo {attribute} deverá conter apenas letras.",
            "alpha_dash": "O campo {attribute} deverá conter apenas letras, números e traços.",
            "alpha_num": "O campo {attribute} deverá conter apenas letras e números .",
            "array": "O campo {attribute} precisa ser um conjunto.",
            "before": "O campo {attribute} deverá conter uma data anterior a {date}.",
            "before_or_equal": "O campo {attribute} deve ser igual ou anterior a {date}.",
            "between": {
                "numeric": "O campo {attribute} deverá ter um valor entre {min} - {max}.",
                "file": "O campo {attribute} deverá ter um tamanho entre {min} - {max} kilobytes.",
                "string": "O campo {attribute} deverá conter entre {min} - {max} caracteres.",
                "array": "O campo {attribute} precisar ter entre {min} - {max} itens."
            },
            "boolean": "O campo {attribute} deverá ter o valor verdadeiro ou falso.",
            "confirmed": "A confirmação para o campo {attribute} não coincide.",
            "date": "O campo {attribute} não contém uma data válida.",
            "date_format": "A data indicada para o campo {attribute} não respeita o formato {format}.",
            "different": "Os campos {attribute} e {other} deverão conter valores diferentes.",
            "digits": "O campo {attribute} deverá conter {digits} dígitos.",
            "digits_between": "O campo {attribute} deverá conter entre {min} a {max} dígitos.",
            "dimensions": "O {attribute} possui dimensões inválidas para a imagem.",
            "distinct": "O campo {attribute} possui um valor duplicado.",
            "email": "O campo {attribute} não contém um endereço de email válido.",
            "exists": "O valor selecionado para o campo {attribute} é inválido.",
            "file": "O {attribute} deve ser um arquivo.",
            "filled": "O campo {attribute} é obrigatório.",
            "image": "O campo {attribute} deverá conter uma imagem.",
            "in": "O campo {attribute} não contém um valor válido.",
            "in_array": "O campo {attribute} não existe em {other}.",
            "integer": "O campo {attribute} deverá conter um número inteiro.",
            "ip": "O campo {attribute} deverá conter um IP válido.",
            "json": "O campo {attribute} deverá conter uma string JSON válida.",
            "max": {
                "numeric": "O campo {attribute} não deverá conter um valor superior a {max}.",
                "file": "O campo {attribute} não deverá ter um tamanho superior a {max} kilobytes.",
                "string": "O campo {attribute} não deverá conter mais de {max} caracteres.",
                "array": "O campo {attribute} deve ter no máximo {max} itens."
            },
            "mimes": "O campo {attribute} deverá conter um arquivo do tipo: {values}.",
            "min": {
                "numeric": "O campo {attribute} deverá ter um valor superior ou igual a {min}.",
                "file": "O campo {attribute} deverá ter no mínimo {min} kilobytes.",
                "string": "O campo {attribute} deverá conter no mínimo {min} caracteres.",
                "array": "O campo {attribute} deve ter no mínimo {min} itens."
            },
            "not_in": "O campo {attribute} contém um valor inválido.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "O campo {attribute} deverá conter um valor numérico.",
            "present": "O campo {attribute} deve existir.",
            "regex": "O formato do valor para o campo {attribute} é inválido.",
            "required": "O campo {attribute} é obrigatório.",
            "required_if": "O campo {attribute} é obrigatório quando o valor do campo {other} é igual a {value}.",
            "required_with": "O campo {attribute} é obrigatório quando {values} está presente.",
            "required_with_all": "O campo {attribute} é obrigatório quando um dos {values} está presente.",
            "required_without": "O campo {attribute} é obrigatório quanto {values} não está presente.",
            "required_without_all": "O campo {attribute} é obrigatório quando nenhum dos {values} está presente.",
            "same": "Os campos {attribute} e {other} deverão conter valores iguais.",
            "size": {
                "numeric": "O campo {attribute} deverá conter o valor {size}.",
                "file": "O campo {attribute} deverá ter o tamanho de {size} kilobytes.",
                "string": "O campo {attribute} deverá conter {size} caracteres.",
                "array": "O campo {attribute} deve ter {size} itens."
            },
            "string": "O campo {attribute} deve ser uma string.",
            "timezone": "O campo {attribute} deverá ter um fuso horário válido.",
            "unique": "O valor indicado para o campo {attribute} já se encontra utilizado.",
            "url": "O formato da URL indicada para o campo {attribute} é inválido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "mensagem-customizada"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Papéis Associados",
                            "dependencies": "Dependências",
                            "display_name": "Nome de Apresentação",
                            "group": "Grupo",
                            "group_sort": "Ordenar Grupo",
                            "groups": {
                                "name": "Nome do Grupo"
                            },
                            "name": "Nome",
                            "system": "Sistema?"
                        },
                        "roles": {
                            "associated_permissions": "Permissões Associadas",
                            "name": "Nome",
                            "sort": "Ordenar"
                        },
                        "users": {
                            "active": "Ativo",
                            "associated_roles": "Papéis Associados",
                            "confirmed": "Confirmado",
                            "email": "Endereço de e-mail",
                            "name": "Nome",
                            "other_permissions": "Outras Permissões",
                            "password": "Senha",
                            "password_confirmation": "Confirme sua senha",
                            "send_confirmation_email": "Enviar E-mail de Confirmação"
                        }
                    }
                },
                "frontend": {
                    "email": "Endereço de e-mail",
                    "name": "Nome",
                    "password": "Senha",
                    "password_confirmation": "Confirme sua senha",
                    "phone": "Telefone",
                    "message": "Mensagem",
                    "old_password": "Senha antiga",
                    "new_password": "Nova Senha",
                    "new_password_confirmation": "Confirme sua nova senha"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Esse papel já existe. Por favor, escolha um nome diferente.",
                        "cant_delete_admin": "Você não pode excluir o papel de Administrador.",
                        "create_error": "Houve um problema ao criar esse papel. Por favor, tente novamente.",
                        "delete_error": "Houve um problema ao excluir esse papel. Por favor, tente novamente.",
                        "has_users": "Você não pode excluir um papel com usuários associados..",
                        "needs_permission": "Você deve selecionar pelo menos uma permissão para este papel.",
                        "not_found": "Este papel não existe.",
                        "update_error": "Houve um problema ao atualizar esse papel. Por favor, tente novamente."
                    },
                    "users": {
                        "already_confirmed": "Este usuário já está confirmado.",
                        "cant_confirm": "Ocorreu um problema ao confirmar este usuário.",
                        "cant_deactivate_self": "Você não pode fazer isso com você mesmo.",
                        "cant_delete_admin": "Você não pode excluir um super administrador.",
                        "cant_delete_self": "Você não pode se excluir.",
                        "cant_delete_own_session": "Você não pode deletar sua própria sessão.",
                        "cant_restore": "Este usuário não encontra-se excluído. Não foi possível restaurá-lo.",
                        "cant_unconfirm_admin": "Você não pode des-confirmar o super administrador.",
                        "cant_unconfirm_self": "Você não pode des-confirmar a si mesmo.",
                        "create_error": "Houve um problema ao criar esse usuário. Por favor, tente novamente.",
                        "delete_error": "Houve um problema ao excluir esse usuário. Por favor, tente novamente.",
                        "delete_first": "Este usuário precisa primeiro ser excluído para poder ser apagado permanentemente.",
                        "email_error": "Esse endereço de e-mail pertence a um usuário diferente.",
                        "mark_error": "Houve um problema ao atualizar esse usuário. Por favor, tente novamente",
                        "not_confirmed": "Este usuário não está confirmado.",
                        "not_found": "Esse usuário não existe.",
                        "restore_error": "Houve um problema ao restaurar esse usuário. Por favor, tente novamente.",
                        "role_needed_create": "Você deve escolher pelo menos uma função.",
                        "role_needed": "Você deve escolher pelo menos uma função.",
                        "session_wrong_driver": "Você deve configurar seu Session Driver para Database para usar esta função.",
                        "social_delete_error": "Houve um problema ao tentar remover a mídia social do usuário.",
                        "update_error": "Houve um problema ao atualizar esse usuário. Por favor, tente novamente.",
                        "update_password_error": "Houve um problema ao alterar a senha do usuário. Por favor, tente novamente."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Sua conta já está confirmada.",
                        "confirm": "Confirme sua conta!",
                        "created_confirm": "Sua conta foi criada com sucesso. Enviamos um e-mail para você confirmar a sua conta.",
                        "created_pending": "Sua conta foi criada com sucesso e aguarda aprovação. Enviaremos um e-mail para você assim que sua conta for aprovada.",
                        "mismatch": "Seu código de confirmação não corresponde.",
                        "not_found": "Esse código de confirmação não existe.",
                        "pending": "Sua conta aguarda aprovação para ser ativada.",
                        "resend": "Sua conta não está confirmada. Por favor, clique no link de confirmação em seu e-mail, ou <a href=\"{url}\">clique aqui</a> para reenviar o e-mail de confirmação.",
                        "success": "Sua conta foi confirmada com sucesso!",
                        "resent": "Um novo e-mail de confirmação foi enviado para você."
                    },
                    "deactivated": "Sua conta foi desativada.",
                    "email_taken": "Esse endereço de e-mail já foi utilizado.",
                    "password": {
                        "change_mismatch": "Essa não é a sua senha antiga.",
                        "reset_problem": "Houve um problema ao redefinir sua senha. Por favor, reinicie o processo de re-definição de senha."
                    },
                    "registration_disabled": "Registro de novas contas está atualmente bloqueado."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Anterior",
            "next": "Próximo &raquo;"
        },
        "roles": {
            "administrator": "Administrador",
            "user": "Usuário"
        },
        "navs": {
            "general": {
                "home": "Início",
                "logout": "Sair"
            },
            "frontend": {
                "contact": "Contato",
                "dashboard": "Painel de Controle",
                "login": "Entrar",
                "macros": "Macros",
                "register": "Registrar",
                "user": {
                    "account": "Minha Conta",
                    "administration": "Administração",
                    "change_password": "Alterar Senha",
                    "my_information": "Minhas Informações",
                    "profile": "Perfil"
                }
            }
        }
    },
    "ru": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Вы уверены, что хотите удалить этого пользователя навсегда? Если в приложении, имеются ссылки на этого пользователя, возможно это приведет к ошибкам. Действуйте на своё усмотрение!",
                        "if_confirmed_off": "(Если чекбоокс 'Подтверждён' неактивен)",
                        "no_deactivated": "Нет деактивированных пользователей.",
                        "no_deleted": "Нет удаленных пользователей.",
                        "restore_user_confirm": "Восстановить этого пользователя?"
                    }
                },
                "dashboard": {
                    "title": "Системная панель",
                    "welcome": "Добро пожаловать"
                },
                "general": {
                    "all_rights_reserved": "Все права защищены.",
                    "are_you_sure": "Вы уверены?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Продолжить",
                    "member_since": "Пользователь с",
                    "minutes": "минут",
                    "search_placeholder": "Поиск...",
                    "timeout": "Вы автоматически выведены из системы из соображений безопасности, так как Вы не были активны в течении",
                    "see_all": {
                        "messages": "Просмотр всех сообщений",
                        "notifications": "Показать все",
                        "tasks": "Показать все задачи"
                    },
                    "status": {
                        "offline": "Офлайн",
                        "online": "Онлайн"
                    },
                    "you_have": {
                        "messages": "{0} У Вас нет сообщений ::: {1} У Вас 1 сообщение ::: [2,Inf] У Вас {number} сообщений",
                        "notifications": "{0} У Вас нет уведомлений ::: {1} У Вас есть 1 уведомление ::: [2,Inf] У Вас {number} уведомлений",
                        "tasks": "{0} У Вас нет заданий ::: {1} У Вас 1 задание ::: [2,Inf] У Вас {number} заданий"
                    }
                },
                "search": {
                    "empty": "Введите слово для поиска.",
                    "incomplete": "Вы должны подключить или создать свою систему поиска для этого приложения.",
                    "results": "Результаты поиска {query}",
                    "title": "Результаты поиска"
                },
                "welcome": "\n<p>В этом проекте использована тема оформления <strong>CoreUI</strong> с минимальным набором стилей и сценариев, необходимых для его работы.</p>\n<p>Используйте полную версию <strong>CoreUI</strong> шаблона по адресу <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a> и добавляйте в это приложение необходимые вам компоненты.</p>\n<p>Проект включает в себя <strong>полнофункциональную библиотеку управления пользователями с разграничением их на основе ролей и разрешений.</strong></p>\n<p>Имейте в виду, что этот проект находится в постоянном производстве и поэтому в нем возможны ошибки. Я делаю все возможное, чтобы их исправлять по мере обнаружения.</p>\n<p>Заходите на <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> страницу для получения дополнительной информации, там же вы можете отавлять свои сообщения.</p>\n<p><strong>Учитывая быстрый темп развития фреймворка Laravel, проект требует много усилий на поддержку, разработку и написание документации, поэтому любая помощь приветствуется.</strong></p>\n<p>Надеюсь, вы останетесь довольны этим проектом.</p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Ваша учетная запись подтверждена.",
                    "error": "Упс!",
                    "greeting": "Здравствуйте!",
                    "regards": "С уважением,",
                    "trouble_clicking_button": "Если у вас возникли проблемы с нажатием \"{action_text}\" кнопки, скопируйте и вставьте URL ниже в адресную строку браузера:",
                    "thank_you_for_using_app": "Спасибо за использование нашего приложения!",
                    "password_reset_subject": "Изменение пароля",
                    "password_cause_of_email": "Вы получили это письмо, потому что мы получили запрос на изменение пароля для Вашей учетной записи.",
                    "password_if_not_requested": "Если вы не запрашивали запрос на изменение пароля, игнорируйте это сообщение и  никаких дополнительных действий не требуется.",
                    "reset_password": "Щелкните для изменения пароля",
                    "click_to_confirm": "Щелкните здесь, чтобы подтвердить вашу учетную запись:"
                },
                "contact": {
                    "email_body_title": "У вас новое сообщение формы обратной связи. Подробности ниже:",
                    "subject": "Новое {app_name} сообщение формы обратной связи!"
                }
            },
            "frontend": {
                "test": "Тест",
                "tests": {
                    "based_on": {
                        "permission": "Система доступа приложения на примере применения разрешения (й) в -",
                        "role": "Система доступа приложения на примере применения роли (ей) в -"
                    },
                    "js_injected_from_controller": "Javascript Injected from a Controller",
                    "using_access_helper": {
                        "array_permissions": "Access Helper с массивом названий разрешений или их ID's, где пользователь обладает всеми правами.",
                        "array_permissions_not": "Access Helper с массивом названий разрешений или их ID's, где пользователь не обладает всеми правами.",
                        "array_roles": "Access Helper с массивом имен ролей или их ID's, где пользователь обладает всеми правами.",
                        "array_roles_not": "Access Helper с массивом имен ролей или их ID's, где пользователь не обладает всеми правами.",
                        "permission_id": "Access Helper с ID названия разрешения",
                        "permission_name": "Access Helper с названием в разрешении",
                        "role_id": "Access Helper с ID роли",
                        "role_name": "Access Helper с именем роли"
                    },
                    "using_blade_extensions": "вьювере Blade Extensions",
                    "view_console_it_works": "Сообщение console, вы должны видеть 'it works!' which is coming from FrontendController@index",
                    "you_can_see_because": "Вы видите это, потому что у вас роль '{role}'!",
                    "you_can_see_because_permission": "Вы видите это, потому что у вас есть разрешение '{permission}'!"
                },
                "general": {
                    "joined": "Зарегистрирован"
                },
                "user": {
                    "change_email_notice": "При смене вашего нового E-mail, он будет перезаписан, и вы должны снова подтвердить свой новый E-mail.",
                    "email_changed_notice": "Вы должны подтвердить Ваш новый E-mail, прежде чем вы сможете войти снова.",
                    "password_updated": "Пароль изменен.",
                    "profile_updated": "Профиль изменен."
                },
                "welcome_to": "Добро пожаловать в приложение {place}"
            }
        },
        "auth": {
            "failed": "Имя пользователя и пароль не совпадают.",
            "general_error": "У вас нет прав для просмотра этой страницы.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} не приемлемый тип для входа."
            },
            "throttle": "Слишком много попыток входа. Пожалуйста, попробуйте еще раз через {seconds} секунд.",
            "unknown": "Упс..., произошла неизвестная ошибка"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Администрирование",
                    "roles": {
                        "all": "Все роли",
                        "create": "Создать роль",
                        "edit": "Редактировать роль",
                        "management": "Управление доступом",
                        "main": "Роли"
                    },
                    "users": {
                        "all": "Все пользователи",
                        "change-password": "Изменить пароль",
                        "create": "Создать пользователя",
                        "deactivated": "Заблокированные пользователи",
                        "deleted": "Удаленные пользователи",
                        "edit": "Редактирование учётной записи",
                        "main": "Пользователи",
                        "view": "Просмотр учётной записи"
                    }
                },
                "log-viewer": {
                    "main": "Журнал ошибок",
                    "dashboard": "Обзор",
                    "logs": "Все записи"
                },
                "sidebar": {
                    "dashboard": "Системная панель",
                    "general": "Главная",
                    "system": "Система"
                }
            },
            "language-picker": {
                "language": "Язык",
                "langs": {
                    "ar": "Арабский (Arabic)",
                    "zh": "Китайский (Chinese Simplified)",
                    "zh-TW": "Китайский (Chinese Traditional)",
                    "da": "Датский (Danish)",
                    "de": "Немецкий (German)",
                    "el": "Греческий (Greek)",
                    "en": "Английский (English)",
                    "es": "Испанский (Spanish)",
                    "fa": "персидский (Persian)",
                    "fr": "Французский (French)",
                    "he": "иврит (Hebrew)",
                    "id": "Индонезийский (Indonesian)",
                    "it": "Итальянский (Italian)",
                    "ja": "Японский (Japanese)",
                    "nl": "Голландский (Dutch)",
                    "no": "норвежский (Norwegian)",
                    "pt_BR": "Бразильский Португальский (Brazilian Portuguese)",
                    "ru": "Русский (Russian)",
                    "sv": "Шведский (Swedish)",
                    "th": "Тайский (Thai)",
                    "tr": "Турецкий (Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Активировать",
                        "change_password": "Изменить пароль",
                        "clear_session": "Очистить Сессию",
                        "confirm": "Подтвержден",
                        "deactivate": "Деактивировать",
                        "delete_permanently": "Удалить навсегда",
                        "login_as": "Войти как {user}",
                        "resend_email": "Повторно отправить подтверждение на E-mail",
                        "restore_user": "Восстановить учетную запись",
                        "unconfirm": "Отменить",
                        "unlink": "Отключить"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Подтвердить учетную запись",
                    "reset_password": "Сбросить пароль"
                }
            },
            "general": {
                "cancel": "Отменa",
                "continue": "Далее",
                "crud": {
                    "create": "Создать",
                    "delete": "Удалить",
                    "edit": "Редактировать",
                    "update": "Применить",
                    "view": "Просмотр"
                },
                "save": "Сохранить",
                "view": "Просмотр"
            }
        },
        "passwords": {
            "password": "Пароль должен быть не менее шести символов и совпадать с подтверждением.",
            "reset": "Ваш пароль был изменен!",
            "sent": "На ваш E-mail отправлена инструкция на изменение пароля!",
            "token": "Ошибочный код изменения пароля.",
            "user": "Не удалось найти пользователя с указанным E-mail."
        },
        "http": {
            "404": {
                "description": "Извините, но страница, которую вы пытаетесь просмотреть, не существует.",
                "title": "Страница не найдена"
            },
            "503": {
                "description": "Назад",
                "title": "Назад"
            }
        },
        "labels": {
            "general": {
                "all": "Все",
                "yes": "Да",
                "no": "Нет",
                "copyright": "Copyright",
                "custom": "Выборочно",
                "actions": "Действие",
                "active": "Активирован",
                "buttons": {
                    "save": "Сохранить",
                    "update": "Обновить"
                },
                "hide": "Скрыть",
                "inactive": "Неактивен",
                "none": "Нет",
                "show": "Показать",
                "toggle_navigation": "Навигация"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Создать новую роль",
                        "edit": "Изменить роль",
                        "management": "Доступ",
                        "table": {
                            "number_of_users": "Пользователей",
                            "permissions": "Разрешения",
                            "role": "Роль",
                            "sort": "Позиция",
                            "total": "ролей всего ::: всего ролей"
                        }
                    },
                    "users": {
                        "active": "Активные пользователи",
                        "all_permissions": "Полный доступ",
                        "change_password": "Изменение пароля",
                        "change_password_for": "Изменить пароль {user}",
                        "create": "Создать учётную запись",
                        "deactivated": "Заблокированные пользователи",
                        "deleted": "Удаленные пользователи",
                        "edit": "Редактирование учётной записи",
                        "management": "Пользователи",
                        "no_permissions": "Нет разрешений",
                        "no_roles": "Невозможно присвоить роль.",
                        "permissions": "Разрешения",
                        "table": {
                            "confirmed": "Подтверждён",
                            "created": "Создан",
                            "email": "E-mail",
                            "id": "ID",
                            "last_updated": "Обновлён",
                            "name": "Логин",
                            "first_name": "Имя",
                            "last_name": "Фамилия",
                            "no_deactivated": "Нет заблокированных пользователей",
                            "no_deleted": "Нет удаленных пользователей",
                            "other_permissions": "Другие Разрешения",
                            "permissions": "Разрешения",
                            "roles": "Роль",
                            "social": "Социальный аккаунт",
                            "total": "пользователей всего ::: всего пользователей"
                        },
                        "tabs": {
                            "titles": {
                                "history": "История",
                                "overview": "Обзор"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Аватар",
                                    "confirmed": "Подтверждён",
                                    "created_at": "Создан",
                                    "deleted_at": "Удалён",
                                    "email": "E-mail",
                                    "last_updated": "Обновлён",
                                    "name": "Логин",
                                    "first_name": "Имя",
                                    "last_name": "Фамилия",
                                    "status": "Статус"
                                }
                            }
                        },
                        "view": "Просмотр учётной записи"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Вход",
                    "login_button": "Вход",
                    "login_with": "Вход из {social_media}",
                    "register_box_title": "Регистрация",
                    "register_button": "Зарегистрироваться",
                    "remember_me": "Запомнить меня"
                },
                "contact": {
                    "box_title": "Контакт",
                    "button": "Отправить"
                },
                "passwords": {
                    "expired_password_box_title": "Срок действия изменения пароля истек.",
                    "forgot_password": "Забыли Пароль?",
                    "reset_password_box_title": "Сброс Пароля",
                    "reset_password_button": "Смена пароля",
                    "update_password_button": "Обновить пароль",
                    "send_password_reset_link_button": "Отправить"
                },
                "user": {
                    "passwords": {
                        "change": "Изменить пароль"
                    },
                    "profile": {
                        "avatar": "Аватар",
                        "created_at": "Создан",
                        "edit_information": "Редактирование информации",
                        "email": "E-mail",
                        "last_updated": "Обновлён",
                        "name": "Логин",
                        "first_name": "Имя",
                        "last_name": "Фамилия",
                        "update_information": "Обновление информации"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Новая роль создана.",
                    "deleted": "Роль удалена.",
                    "updated": "Роль обновлена."
                },
                "users": {
                    "cant_resend_confirmation": "В настоящее время приложение настроено на одобрение пользователей вручную.",
                    "confirmation_email": "Новые параметры для подтверждения отправлены на Ваш E-mail.",
                    "confirmed": "Пользователь подтвержден.",
                    "created": "Новый пользователь создан.",
                    "deleted": "Пользователь удален.",
                    "deleted_permanently": "Пользователь удален навсегда.",
                    "restored": "Пользователь восстановлен.",
                    "session_cleared": "Сессия пользователя очищена.",
                    "social_deleted": "Социальная учетная запись успешно удалена",
                    "unconfirmed": "Пользователь изменен на статус не подтвержден",
                    "updated": "Параметры пользователя обновлены.",
                    "updated_password": "Пароль пользователя обновлен."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Спасибо! Ваша информация принята и будет обработанна в ближайшее время."
                }
            }
        },
        "validation": {
            "accepted": "Вы должны принять {attribute}.",
            "active_url": "Поле {attribute} содержит недействительный URL.",
            "after": "В поле {attribute} должна быть дата после {date}.",
            "after_or_equal": "В поле {attribute} должна быть дата после или равняться {date}.",
            "alpha": "Поле {attribute} может содержать только буквы.",
            "alpha_dash": "Поле {attribute} может содержать только буквы, цифры и дефис.",
            "alpha_num": "Поле {attribute} может содержать только буквы и цифры.",
            "array": "Поле {attribute} должно быть массивом.",
            "before": "В поле {attribute} должна быть дата до {date}.",
            "before_or_equal": "В поле {attribute} должна быть дата до или равняться {date}.",
            "between": {
                "array": "Количество элементов в поле {attribute} должно быть между {min} и {max}.",
                "file": "Размер файла в поле {attribute} должен быть между {min} и {max} Килобайт(а).",
                "numeric": "Поле {attribute} должно быть между {min} и {max}.",
                "string": "Количество символов в поле {attribute} должно быть между {min} и {max}."
            },
            "boolean": "Поле {attribute} должно иметь значение логического типа.",
            "confirmed": "Поле {attribute} не совпадает с подтверждением.",
            "date": "Поле {attribute} не является датой.",
            "date_format": "Поле {attribute} не соответствует формату {format}.",
            "different": "Поля {attribute} и {other} должны различаться.",
            "digits": "Длина цифрового поля {attribute} должна быть {digits}.",
            "digits_between": "Длина цифрового поля {attribute} должна быть между {min} и {max}.",
            "dimensions": "Поле {attribute} имеет недопустимые размеры изображения.",
            "distinct": "Поле {attribute} содержит повторяющееся значение.",
            "email": "Поле {attribute} должно быть действительным электронным адресом.",
            "exists": "Выбранное значение для {attribute} некорректно.",
            "file": "Поле {attribute} должно быть файлом.",
            "filled": "Поле {attribute} обязательно для заполнения.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "Поле {attribute} должно быть изображением.",
            "in": "Выбранное значение для {attribute} ошибочно.",
            "in_array": "Поле {attribute} не существует в {other}.",
            "integer": "Поле {attribute} должно быть целым числом.",
            "ip": "Поле {attribute} должно быть действительным IP-адресом.",
            "ipv4": "Поле {attribute} должно быть действительным IPv4 адресом.",
            "ipv6": "Поле {attribute} должно быть действительным IPv6 адресом.",
            "json": "Поле {attribute} должно быть JSON строкой.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "array": "Количество элементов в поле {attribute} не может превышать {max}.",
                "file": "Размер файла в поле {attribute} не может быть более {max} Килобайт(а).",
                "numeric": "Поле {attribute} не может быть более {max}.",
                "string": "Количество символов в поле {attribute} не может превышать {max}."
            },
            "mimes": "Поле {attribute} должно быть файлом одного из следующих типов: {values}.",
            "mimetypes": "Поле {attribute} должно быть файлом одного из следующих типов: {values}.",
            "min": {
                "array": "Количество элементов в поле {attribute} должно быть не менее {min}.",
                "file": "Размер файла в поле {attribute} должен быть не менее {min} Килобайт(а).",
                "numeric": "Поле {attribute} должно быть не менее {min}.",
                "string": "Количество символов в поле {attribute} должно быть не менее {min}."
            },
            "not_in": "Выбранное значение для {attribute} ошибочно.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "Поле {attribute} должно быть числом.",
            "present": "Поле {attribute} должно присутствовать.",
            "regex": "Поле {attribute} имеет ошибочный формат.",
            "required": "Поле {attribute} обязательно для заполнения.",
            "required_if": "Поле {attribute} обязательно для заполнения, когда {other} равно {value}.",
            "required_unless": "Поле {attribute} обязательно для заполнения, когда {other} не равно {values}.",
            "required_with": "Поле {attribute} обязательно для заполнения, когда {values} указано.",
            "required_with_all": "Поле {attribute} обязательно для заполнения, когда {values} указано.",
            "required_without": "Поле {attribute} обязательно для заполнения, когда {values} не указано.",
            "required_without_all": "Поле {attribute} обязательно для заполнения, когда ни одно из {values} не указано.",
            "same": "Значение {attribute} должно совпадать с {other}.",
            "size": {
                "array": "Количество элементов в поле {attribute} должно быть равным {size}.",
                "file": "Размер файла в поле {attribute} должен быть равен {size} Килобайт(а).",
                "numeric": "Поле {attribute} должно быть равным {size}.",
                "string": "Количество символов в поле {attribute} должно быть равным {size}."
            },
            "string": "Поле {attribute} должно быть строкой.",
            "timezone": "Поле {attribute} должно быть действительным часовым поясом.",
            "unique": "Такое значение поля {attribute} уже существует.",
            "uploaded": "Загрузка поля {attribute} не удалась.",
            "url": "Поле {attribute} имеет ошибочный формат.",
            "custom": {
                "attribute-name": {
                    "rule-name": "сообщение"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Связь с ролями",
                            "dependencies": "Зависимости",
                            "display_name": "Отображаемое имя",
                            "group": "Группа",
                            "group_sort": "Сортировать по Группам",
                            "groups": {
                                "name": "Название Группы"
                            },
                            "name": "Название",
                            "first_name": "Имя",
                            "last_name": "Фамилия",
                            "system": "Системный?"
                        },
                        "roles": {
                            "associated_permissions": "Разрешения",
                            "name": "Название",
                            "sort": "Позиция"
                        },
                        "users": {
                            "active": "Активный",
                            "associated_roles": "Роли",
                            "confirmed": "Подтверждён",
                            "email": "E-mail",
                            "name": "Логин",
                            "last_name": "Фамилия",
                            "first_name": "Имя",
                            "other_permissions": "Прочие разрешения",
                            "password": "Новый пароль",
                            "password_confirmation": "Проверка пароля",
                            "send_confirmation_email": "Отправить подтверждение на E-mail",
                            "timezone": "Часовой пояс"
                        }
                    }
                },
                "frontend": {
                    "avatar": "Аватар",
                    "email": "E-mail",
                    "first_name": "Имя",
                    "last_name": "Фамилия",
                    "name": "Имя",
                    "password": "Пароль",
                    "password_confirmation": "Подтверждение пароля",
                    "phone": "Телефон",
                    "message": "Сообщение",
                    "new_password": "Новый пароль",
                    "new_password_confirmation": "Подтверждение нового пароля",
                    "old_password": "Старый пароль",
                    "timezone": "Часовой пояс"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Такое название роли уже существует. Пожалуйста, выберите другое название.",
                        "cant_delete_admin": "Вы не можете удалить роль администратора.",
                        "create_error": "Невозможно создать роль. Пожалуйста, попробуйте позже.",
                        "delete_error": "Невозможно удалить роль. Пожалуйста, попробуйте позже.",
                        "has_users": "Вы не можете удалить эту роль, она связана с существующими пользователями.",
                        "needs_permission": "Вы должны выбрать по крайней мере одно разрешение для этой роли.",
                        "not_found": "Роль не существует.",
                        "update_error": "Невозможно обновить роль. Пожалуйста, попробуйте позже."
                    },
                    "users": {
                        "already_confirmed": "Этот пользователь уже подтвержден.",
                        "cant_confirm": "Возникла проблема с подтверждением учетной записи пользователя.",
                        "cant_deactivate_self": "Для себя вы не можете это сделать.",
                        "cant_delete_admin": "Вы не можете удалить главного администратора.",
                        "cant_delete_self": "Вы не можете себя удалить.",
                        "cant_delete_own_session": "Вы не можете удалить свою собственную сессию.",
                        "cant_restore": "Этот пользователь не удален, поэтому он не может быть восстановлен.",
                        "cant_unconfirm_admin": "Вы не можете подтвердить супер администратора.",
                        "cant_unconfirm_self": "Вы не можете подтвердить себя же.",
                        "create_error": "Невозможно создать пользователя. Пожалуйста, попробуйте позже.",
                        "delete_error": "Невозможно удалить пользователя. Пожалуйста, попробуйте позже.",
                        "delete_first": "Этот пользователь должен быть мягко удален, прежде чем он может быть окончательно удален.",
                        "email_error": "Этот E-mail адрес принадлежит другому пользователю.",
                        "mark_error": "Невозможно обновить пользователя. Пожалуйста, попробуйте позже.",
                        "not_confirmed": "Этот пользователь не подтвержден.",
                        "not_found": "Такого пользователя не существует.",
                        "restore_error": "Невозможно восстановить пользователя. Пожалуйста, попробуйте позже.",
                        "role_needed_create": "Вы должны выбрать по крайней мере одну роль.",
                        "role_needed": "Вы должны выбрать как минимум одну роль.",
                        "session_wrong_driver": "Для использования этой функции, данные сессии должны использовать базу данных.",
                        "social_delete_error": "Не удалось удалить социальную учетную запись у пользователя.",
                        "update_error": "Невозможно обновить пользователя. Пожалуйста, попробуйте позже.",
                        "update_password_error": "Невозможно изменить пароль пользователя. Пожалуйста, попробуйте позже."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Ваша учетная запись уже подтверждена.",
                        "confirm": "Подтвердите вашу учетную запись!",
                        "created_confirm": "Ваш учетная запись успешно создана. Мы отправили вам уведомление на ваш E-mail для подтверждения вашей учетной записи.",
                        "created_pending": "Ваша учетная запись записана и находится на рассмотрении. После удтверждения вашей учетной записи, вам будет отправлено уведомление на ваш E-mail.",
                        "mismatch": "Неправильный код подтверждения.",
                        "not_found": "Такого кода не существует.",
                        "pending": "В настоящее время ваша учетная запись находится на рассмотрении.",
                        "resend": "Ваша учетная запись не подтверждена. Пожалуйста, нажмите на ссылку для подтверждения в письме высланном на Ваш E-mail, или <a href=\"{url}\">щелкните здесь</a>, чтобы повторно отправить подтверждение на Ваш E-mail.",
                        "success": "Ваша учетная запись успешно подтверждена!",
                        "resent": "Новые параметры подтверждения высланы вам на ваш E-mail адрес."
                    },
                    "deactivated": "Ваша учетная запись была деактивирована.",
                    "email_taken": "Этот E-mail адрес уже занят.",
                    "password": {
                        "change_mismatch": "Неверный старый пароль.",
                        "reset_problem": "Не удалось изменить пароль. Повторите запрос на изменение пароля."
                    },
                    "registration_disabled": "Регистрация в настоящее время закрыта, приходите позже"
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Назад",
            "next": "Вперёд &raquo;"
        },
        "roles": {
            "administrator": "Администратор",
            "user": "Пользователь"
        },
        "navs": {
            "general": {
                "home": "Главная",
                "logout": "Выход"
            },
            "frontend": {
                "contact": "Контакт",
                "dashboard": "Управление",
                "login": "Вход",
                "macros": "Макросы",
                "register": "Регистрация",
                "user": {
                    "account": "Профиль, настройки",
                    "administration": "Управление приложением",
                    "change_password": "Изменить пароль",
                    "my_information": "Моя информация",
                    "profile": "Профиль"
                }
            }
        }
    },
    "sv": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Är du säker på att du vill radera denna användare permanent? Om användaren har material någonstans i programmet som pekar på sitt ID så kommer det troligtvis generera ett felmeddelande. Denna åtgärd går inte att ångra. Du fortsätter på egen risk.",
                        "if_confirmed_off": "(Om bekräftan är avstängt)",
                        "restore_user_confirm": "Återställ användaren till sitt ursprungliga läge."
                    }
                },
                "dashboard": {
                    "title": "Adminpanelen",
                    "welcome": "Välkommen"
                },
                "general": {
                    "all_rights_reserved": "Alla rättigheter förbehålls.",
                    "are_you_sure": "Är du säker?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "Fortsätt",
                    "member_since": "Registrerad",
                    "minutes": " minutes",
                    "search_placeholder": "Sök...",
                    "timeout": "You were automatically logged out for security reasons since you had no activity in ",
                    "see_all": {
                        "messages": "Se alla meddelanden",
                        "notifications": "Se alla notiser",
                        "tasks": "Se alla punkter"
                    },
                    "status": {
                        "online": "Online",
                        "offline": "Offline"
                    },
                    "you_have": {
                        "messages": "{0} Du har inga meddelanden ::: {1} Du har 1 meddelande ::: [2,Inf] Du har {number} meddelanden",
                        "notifications": "{0} Du har inga aviseringar ::: {1} Du har 1 avisering ::: [2,Inf] Du har {number} aviseringar",
                        "tasks": "{0} Du har inga punkter att göra ::: {1} Du har 1 punkt att göra ::: [2,Inf] Du har {number} punkter att göra"
                    }
                },
                "search": {
                    "empty": "Please enter a search term.",
                    "incomplete": "You must write your own search logic for this system.",
                    "title": "Search Results",
                    "results": "Search Results for {query}"
                },
                "welcome": "<p>Detta är CoreUI temat som är skapat av <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>.\nDetta är en avskalad version med enbart de mest nödvändiga stilmallarna och skripten för att få det att fungera.\nLadda ner den fulla versionen och börja lägg till de komponenter du behöver.</p>\n<p>Alla länkar/funktioner är här är bara exempel förutom <strong>Användare och rättigheter</strong> och <strong>Loggöversikten</strong> i sidomenyn\nDenna boilerplate kommer med fullt funktionerande <em>Access Control Library</em> för att hantera användare/roller/tillstånd.</p>\n<p>Tänk på att detta repo fortfarande utvecklas och att det kan förekomma buggar och fel som ännu inte upptäckts. Jag ska göra mitt bästa för att förebygga detta.</p>\n<p>Hoppas att du tycker om detta projekt som jag lagt ner så mycket tid i. Besök repots <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> för att få mer information och rapportera gärna dina tankar/fel som <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">\"issues\" här</a>.</p>\n<p><strong>This project is very demanding to keep up with given the rate at which the master Laravel branch changes, so any help is appreciated.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Hoppsan!",
                    "greeting": "Hej!",
                    "regards": "Hälsningar",
                    "trouble_clicking_button": "Fungerar inte knappen \"{action_text}\"? Kopiera då länken nedan och klistra in den i din webbläsare.",
                    "thank_you_for_using_app": "Tack för att du använder vår hemsida!",
                    "password_reset_subject": "Återställ lösenord",
                    "password_cause_of_email": "Du får detta meddelande eftersom det begärts en återställning av lösenord för ditt konto.",
                    "password_if_not_requested": "Om det inte var du som begärde återställning av lösenord kan du helt bortse från detta mail.",
                    "reset_password": "Klicka här för att återställa ditt lösenord:",
                    "click_to_confirm": "Klicka här för att bekräfta ditt konto:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Tillstånd baserad - ",
                        "role": "Roll baserad - "
                    },
                    "js_injected_from_controller": "Javascript som fått sin data direkt från en controller",
                    "using_blade_extensions": "Avänder utbyggda &#64;Blade-funktioner",
                    "using_access_helper": {
                        "array_permissions": "Använder Access Helper med en array av rättighetens namn eller ID då användaren måste ha alla rättigheter.",
                        "array_permissions_not": "Använder Access Helper med en array av rättighetens namn eller ID då användaren INTE måste ha alla rättigheter.",
                        "array_roles": "Använder Access Helper med en array av rollens namn eller ID då användaren måste ha alla roller.",
                        "array_roles_not": "Använder Access Helper med en array av roll-namn eller roll-ID då användaren INTE måste ha alla roller.",
                        "permission_id": "Använder Access Helper med rättighetens ID",
                        "permission_name": "Använder Access Helper med rättighetens namn",
                        "role_id": "Använder Access Helper med rollens ID",
                        "role_name": "Använder Access Helper med rollens namn"
                    },
                    "view_console_it_works": "Kolla konsollen, du borde se 'it works!' som skickas direkt från FrontendController@index",
                    "you_can_see_because": "Du kan se detta för att du har rollen '{role}'!",
                    "you_can_see_because_permission": "Du kan se detta för att du har rättiheten '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "Din profil är nu uppdaterad.",
                    "password_updated": "Ditt lösenord har nu uppdaterats."
                },
                "welcome_to": "Välkommen till {place}"
            }
        },
        "auth": {
            "failed": "Dessa uppgifter stämmer inte överens med vårt register.",
            "general_error": "Du har inte tillstånd att göra det där.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} kan inte att användas vid inloggning."
            },
            "throttle": "För många misslyckade försök att logga in i rad. Du kan försöka igen om {seconds} sekunder.",
            "unknown": "Hm.. Något gick snett, ett okänt fel."
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Användare och rättigheter",
                    "roles": {
                        "all": "Alla roller",
                        "create": "Skapa roll",
                        "edit": "Redigera roll",
                        "management": "Hantera roller",
                        "main": "Roller"
                    },
                    "users": {
                        "all": "Alla användare",
                        "change-password": "Byt lösenord",
                        "create": "Skapa användare",
                        "deactivated": "Inaktiverade användare",
                        "deleted": "Raderade användare",
                        "edit": "Redigera användare",
                        "main": "Användare",
                        "view": "View User"
                    }
                },
                "log-viewer": {
                    "main": "Loggöversikt",
                    "dashboard": "Huvudpanelen",
                    "logs": "Loggar"
                },
                "sidebar": {
                    "dashboard": "Kontrollpanelen",
                    "general": "Adminpanelen",
                    "system": "System"
                }
            },
            "language-picker": {
                "language": "Språk",
                "langs": {
                    "ar": "Arabiska (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "Danska (Danish)",
                    "de": "Tyska (German)",
                    "el": "(Greek)",
                    "pt_BR": "Brasiliansk portugisiska (Brazilian Portuguese)",
                    "en": "Engelska (English)",
                    "fa": "Perser (Persian)",
                    "fr": "Franska (French)",
                    "he": "Hebreiska (Hebrew)",
                    "id": "Indonesiska (Indonesian)",
                    "it": "Italienska (Italian)",
                    "ja": "(Japanese)",
                    "nl": "Holländska (Dutch)",
                    "no": "Norsk (Norwegian)",
                    "es": "Spanska (Spanish)",
                    "ru": "Ryska (Russian)",
                    "sv": "Svenska (Swedish)",
                    "th": "Thailändska (Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Aktivera",
                        "change_password": "Byt lösenord",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "Inaktivera",
                        "resend_email": "Skicka bekräftelsemail igen.",
                        "delete_permanently": "Radera permanent",
                        "login_as": "Login As {user}",
                        "restore_user": "Återställ",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Bekräfta konto",
                    "reset_password": "Återställ lösenord"
                }
            },
            "general": {
                "cancel": "Avbryt",
                "continue": "Continue",
                "crud": {
                    "create": "Skapa",
                    "delete": "Radera",
                    "edit": "Redigera",
                    "update": "Uppdatera",
                    "view": "View"
                },
                "save": "Spara",
                "view": "Granska"
            }
        },
        "passwords": {
            "password": "Lösenordet måste vara minst sex tecken långt och stämma med bekräftelsen av lösenordet.",
            "reset": "Ditt lösenord har återställts!",
            "sent": "Ett mail med länk för återställning av ditt lösenord har nu skickats!",
            "token": "Denna kod för att återställa lösenord är ogiltig.",
            "user": "Det finns ingen registrerad användare med den e-postadressen."
        },
        "http": {
            "404": {
                "title": "Sidan kunde inte visas.",
                "description": "Sorry, men sidan du försökte nå kunde inte visas."
            },
            "503": {
                "title": "Strax tillbaka!",
                "description": "Strax tillbaka!"
            }
        },
        "labels": {
            "general": {
                "all": "Alla",
                "yes": "Ja",
                "no": "Nej",
                "custom": "Specifika",
                "actions": "Hantera",
                "active": "Active",
                "buttons": {
                    "save": "Spara",
                    "update": "Uppdatera"
                },
                "hide": "Dölj",
                "inactive": "Inactive",
                "none": "Inga",
                "show": "Visa",
                "toggle_navigation": "Växla navigering"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Skapa roll",
                        "edit": "Redigera roll",
                        "management": "Hantera roller",
                        "table": {
                            "number_of_users": "Antal användare",
                            "permissions": "Tillstånd",
                            "role": "Roll",
                            "sort": "Ordning",
                            "total": "roll totalt ::: roller totalt"
                        }
                    },
                    "users": {
                        "active": "Aktiverade användare",
                        "all_permissions": "Alla tillstånd",
                        "change_password": "Byt lösenord",
                        "change_password_for": "Byt lösenord för {user}",
                        "create": "Skapa användare",
                        "deactivated": "Inaktiverade användare",
                        "deleted": "Raderade användare",
                        "edit": "Redigera användare",
                        "management": "Hantera användare",
                        "no_permissions": "Inga tillstånd",
                        "no_roles": "Inga roller att anta.",
                        "permissions": "Tillstånd",
                        "table": {
                            "confirmed": "Bekräftad",
                            "created": "Skapad",
                            "email": "E-post",
                            "id": "ID",
                            "last_updated": "Senast uppdaterad",
                            "name": "Namn",
                            "no_deactivated": "Inga inaktiverade användare",
                            "no_deleted": "Inga raderade användare",
                            "roles": "Roller",
                            "social": "Social",
                            "total": "användare totalt ::: användare totalt"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Overview",
                                "history": "History"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Confirmed",
                                    "created_at": "Created At",
                                    "deleted_at": "Deleted At",
                                    "email": "E-mail",
                                    "last_updated": "Last Updated",
                                    "name": "Name",
                                    "status": "Status"
                                }
                            }
                        },
                        "view": "View User"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Logga in",
                    "login_button": "Logga in",
                    "login_with": "Logga in med {social_media}",
                    "register_box_title": "Registrera",
                    "register_button": "Registrera",
                    "remember_me": "Kom ihåg mig"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Glömt lösenordet?",
                    "reset_password_box_title": "Återställ lösenord",
                    "reset_password_button": "Återställ lösenord",
                    "send_password_reset_link_button": "Skicka länk för att återställa lösenordet."
                },
                "user": {
                    "passwords": {
                        "change": "Byt lösenord"
                    },
                    "profile": {
                        "avatar": "Profilbild",
                        "created_at": "Skapad",
                        "edit_information": "Redigera profil",
                        "email": "E-post",
                        "last_updated": "Senast uppdaterad",
                        "name": "Namn",
                        "update_information": "Uppdatera profil"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Rollen har nu skapats.",
                    "deleted": "Rollen har nu raderats.",
                    "updated": "Rollen har nu uppdaterats."
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "Ett nytt bekräftelsemail har nu skickats till den angivna e-postadressen.",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "Användaren har nu skapats.",
                    "deleted": "Användaren har nu raderats.",
                    "deleted_permanently": "Användaren har nu raderats permanent.",
                    "restored": "Användaren har nu återställts.",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "Användaren har nu uppdaterats.",
                    "updated_password": "Användarens lösenord har nu uppdaterats."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} måste accepteras.",
            "active_url": "{attribute} är inte en giltig webbadress.",
            "after": "{attribute} måste vara ett datum efter den {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "{attribute} får endast innehålla bokstäver.",
            "alpha_dash": "{attribute} får endast innehålla bokstäver, siffror och bindestreck.",
            "alpha_num": "{attribute} får endast innehålla bokstäver och siffror.",
            "array": "{attribute} måste vara en array.",
            "before": "{attribute} måste vara ett datum innan den {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "{attribute} måste vara en siffra mellan {min} och {max}.",
                "file": "{attribute} måste vara mellan {min} till {max} kilobyte stor.",
                "string": "{attribute} måste innehålla {min} till {max} tecken.",
                "array": "{attribute} måste innehålla mellan {min} - {max} objekt."
            },
            "boolean": "{attribute} måste vara sant eller falskt",
            "confirmed": "{attribute} bekräftelsen matchar inte.",
            "date": "{attribute} är inte ett giltigt datum.",
            "date_format": "{attribute} matchar inte formatet {format}.",
            "different": "{attribute} och {other} får inte vara lika.",
            "digits": "{attribute} måste vara minst {digits} tecken.",
            "digits_between": "{attribute} måste vara mellan {min} och {max} tecken.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "Fältet {attribute} måste innehålla en korrekt e-postadress.",
            "exists": "Det valda {attribute} är ogiltigt.",
            "file": "The {attribute} must be a file.",
            "filled": "Fältet {attribute} är obligatoriskt.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} måste vara en bild.",
            "in": "Det valda {attribute} är ogiltigt.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "{attribute} måste vara en siffra.",
            "ip": "{attribute} måste vara en giltig IP-adress.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} får inte vara större än {max}.",
                "file": "{attribute} får max vara {max} kilobyte stor.",
                "string": "{attribute} får max innehålla {max} tecken.",
                "array": "{attribute} får inte innehålla mer än {max} objekt."
            },
            "mimes": "{attribute} måste vara en fil av typen: {values}.",
            "min": {
                "numeric": "{attribute} måste vara större än {min}.",
                "file": "{attribute} måste vara minst {min} kilobyte stor.",
                "string": "{attribute} måste innehålla minst {min} tecken.",
                "array": "{attribute} måste innehålla minst {min} objekt."
            },
            "not_in": "Det valda {attribute} är ogiltigt.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} måste vara en siffra.",
            "present": "The {attribute} field must be present.",
            "regex": "Formatet för {attribute} är ogiltigt.",
            "required": "Fältet {attribute} är obligatoriskt.",
            "required_if": "Fältet {attribute} är obligatoriskt då {other} är {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "Fältet {attribute} är obligatoriskt då {values} är ifyllt.",
            "required_with_all": "Fältet {attribute} är obligatoriskt när {values} är ifyllt.",
            "required_without": "Fältet {attribute} är obligatoriskt då {values} ej är ifyllt.",
            "required_without_all": "Fältet {attribute} är obligatoriskt när ingen av {values} är ifyllt.",
            "same": "{attribute} och {other} måste vara lika.",
            "size": {
                "numeric": "{attribute} måste vara {size}.",
                "file": "{attribute} får endast vara {size} kilobyte stor.",
                "string": "{attribute} måste innehålla {size} tecken.",
                "array": "{attribute} måste innehålla {size} objekt."
            },
            "string": "{attribute} måste vara en sträng.",
            "timezone": "{attribute} måste vara en giltig tidszon.",
            "unique": "{attribute} används redan.",
            "url": "Formatet {attribute} är ogiltigt.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Sammankopplade roller",
                            "dependencies": "Krävda tillstånd",
                            "display_name": "Namn som visas",
                            "group": "Tillståndsgrupp",
                            "group_sort": "Ordning för tillståndsgrupp",
                            "groups": {
                                "name": "Namn för tillståndsgrupp"
                            },
                            "name": "Namn",
                            "system": "System-status?"
                        },
                        "roles": {
                            "associated_permissions": "Sammankopplade tillstånd",
                            "name": "Namn",
                            "sort": "Ordning"
                        },
                        "users": {
                            "active": "Aktiv",
                            "associated_roles": "Sammankopplade roller",
                            "confirmed": "Bekräftad",
                            "email": "E-postadress",
                            "name": "Namn",
                            "other_permissions": "Övriga tillstånd",
                            "password": "Lösenord",
                            "password_confirmation": "Bekräfta lösenord",
                            "send_confirmation_email": "Skicka bekräftelsemail"
                        }
                    }
                },
                "frontend": {
                    "email": "E-postadress",
                    "name": "Namn",
                    "password": "Lösenord",
                    "password_confirmation": "Bekräfta lösenord",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "Gammalt lösenord",
                    "new_password": "Nytt lösenord",
                    "new_password_confirmation": "Bekräfta nytt lösenord"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Det finns redan en roll med detta namn. Välj ett annat namn.",
                        "cant_delete_admin": "Du kan inte radera en administratörsroll.",
                        "create_error": "Det uppstod ett fel då rollen skulle skapas. Försök igen.",
                        "delete_error": "Det uppstod ett fel då rollen skulle raderas. Försök igen.",
                        "has_users": "Du kan inte radera en roll som har tilldelade användare.",
                        "needs_permission": "Du måste välja minst ett tillstånd för en roll.",
                        "not_found": "Det finns inte en sådan roll i systemet.",
                        "update_error": "Det uppstod ett fel då rollen skulle uppdateras. Försök igen."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "Du har inte rättighet att utföra denna handling mot ditt eget konto.",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "Du kan inte radera ditt eget konto.",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "cant_restore": "This user is not deleted so it can not be restored.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "Det uppstod ett fel då användaren skulle skapas. Försök igen.",
                        "delete_error": "Det uppstod ett fel då användaren skulle raderas. Försök igen.",
                        "delete_first": "This user must be deleted first before it can be destroyed permanently.",
                        "email_error": "Den e-post du angav finns redan angiven för en annan användare.",
                        "mark_error": "Det uppstod ett fel då användaren skulle uppdateras. Försök igen.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "Det finns inte någon sådan användare.",
                        "restore_error": "Det uppstod ett fel då användaren skulle återställas. Försök igen.",
                        "role_needed_create": "Du måste välja minst en roll.",
                        "role_needed": "Du måste välja minst en roll.",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "Det uppstod ett fel då användaren skulle uppdateras. Försök igen.",
                        "update_password_error": "Det uppstod ett fel då användarens lösenord skulle ändras. Försök igen."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Ditt konto är redan bekräftat och aktiverat.",
                        "confirm": "Bekräfta och aktivera ditt konto!",
                        "created_confirm": "Ditt konto är nu skapat. Vi har skickat ett mail till dig där du kan bekräfta och aktivera ditt konto.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Din bekräftelsekod för aktivering stämmer inte.",
                        "not_found": "Din bekräftelsekod för aktivering stämmer inte.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Du måste bekräfta och aktivera ditt konto för att fortsätta. Bekräfta och aktivera ditt konto genom länken i mailet vi skickade till dig. <a href=\"{url}\">Klicka här</a> för att skicka mailet en gång till.",
                        "success": "Ditt konto har nu bekräftats och aktiverats.",
                        "resent": "Ett nytt mail med länk för bekräftelse och aktivering har nu skickats till den angivna e-posten."
                    },
                    "deactivated": "Ditt konto har inaktiverats.",
                    "email_taken": "Det finns redan ett konto registrerat med den e-postadressen.",
                    "password": {
                        "change_mismatch": "Det där var inte ditt gamla lösenord.",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Föregående",
            "next": "Nästa &raquo;"
        },
        "roles": {
            "administrator": "Administratör",
            "user": "Användare"
        },
        "navs": {
            "general": {
                "home": "Start",
                "logout": "Logga ut"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Kontrollpanelen",
                "login": "Logga in",
                "macros": "Macros",
                "register": "Registrera",
                "user": {
                    "account": "Mitt konto",
                    "administration": "Adminpanelen",
                    "change_password": "Byt lösenord",
                    "my_information": "Min profil",
                    "profile": "Profil"
                }
            }
        }
    },
    "th": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "คุณแน่ใจว่าต้องการลบผู้ใช้นี้อย่างถาวร? ทุกที่ในระบบที่อ้างอิงถึงผู้ใช้นี้อาจเกิดข้อผิดพลาด ดำเนินการต่อด้วยการตัดสินใจของคุณเอง และการกระทำนี้ไม่สามารถย้อนกลับได้",
                        "if_confirmed_off": "(ถ้าหากการยืนยันตัวตนไม่ถูกเลือก)",
                        "restore_user_confirm": "ต้องการกู้คืนผู้ใช้นี้กลับสู่สถานะดั้งเดิม?"
                    }
                },
                "dashboard": {
                    "title": "แผงควบคุมแอดมิน",
                    "welcome": "ยินดีต้อนรับ"
                },
                "general": {
                    "all_rights_reserved": "ขอสงวนสิทธิ์",
                    "are_you_sure": "คุณแน่ใจหรือ?",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "ทำต่อ",
                    "member_since": "เป็นสมาชิกตั้งแต่",
                    "minutes": " นาที",
                    "search_placeholder": "ค้นหา...",
                    "timeout": "คุณถูกทำให้ออกจากระบบโดยอัตโนมัติเพื่อความปลอดภัย เนื่องจากไม่มีความเคลื่อนไหวใดๆ เกิดขึ้นใน ",
                    "see_all": {
                        "messages": "ดูข้อความทั้งหมด",
                        "notifications": "ดูทั้งหมด",
                        "tasks": "ดูภารกิจทั้งหมด"
                    },
                    "status": {
                        "online": "ออนไลน์",
                        "offline": "ออฟไลน์"
                    },
                    "you_have": {
                        "messages": "{0} คุณไม่มีข้อความใดๆ ::: {1} คุณมี 1 ข้อความ ::: [2,Inf] คุณมี {number} ข้อความ",
                        "notifications": "{0} คุณไม่มีการแจ้งเตือนใดๆ ::: {1} คุณมี 1 การแจ้งเตือน ::: [2,Inf] คุณมี {number} การแจ้งเตือน",
                        "tasks": "{0} คุณไม่มีภารกิจใดๆ ::: {1} คุณมี 1 ภารกิจ ::: [2,Inf] คุณมี {number} ภารกิจ"
                    }
                },
                "search": {
                    "empty": "กรุณาป้อนคำสืบค้น",
                    "incomplete": "สำหรับระบบนี้คุณต้องเขียนเงื่อนไขสำหรับการสืบค้นด้วยตัวเอง",
                    "title": "ผลการสืบค้น",
                    "results": "ผลการสืบค้นสำหรับ {query}"
                },
                "welcome": "<p>นี่คือธีม CoreUI โดย <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a> ซึ่งเป็นเวอร์ชั่นตัดทอน เหลือสไตล์ชีทและสคริปต์ที่จำเป็น คุณสามารถดาวน์โหลดเวอร์ชั่นเต็มเพิ่มเติม เพื่อเพิ่มคอมโพเนนท์ให้กับแผงควบคุม</p>\n<p>การทำงานทั้งหมดเป็นเพียงตัวอย่าง ยกเว้น<strong>การจัดการผู้ใช้</strong>ทางด้านซ้าย Laravel 5 Boilerplate มาพร้อมกับไลบรารี่เต็มรูปแบบเพื่อควบคุมและจัดการ ผู้ใช้/บทบาท/สิทธิ์</p>\n<p>โปรดระลึกว่านี่เป็นงานที่อยู่ระหว่างการพัฒนา และอาจเกิดบั๊กหรือข้อผิดพลาดอื่นๆที่ยังไม่ถูกค้นพบ เมื่อรับทราบ ทางทีมงานจะทำเต็มที่เพื่อแก้ไขปัญหาที่เกิดขึ้น</p>\n<p>หวังว่าคุณจะได้รับประโยชน์จากผลงานทั้งหมดนี้ที่ทางทีมงานทุ่มเทสร้างขึ้น กรุณาเยี่ยมชมหน้าของ <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> เพื่อข้อมูลเพิ่มเติมและ <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">รายงานข้อผิดพลาด</a> ได้ที่นี่</p>\n<p><strong>โปรเจคนี้ต้องการการดูแลอัพเดทอย่างสม่ำเสมอ เนื่องด้วยการเปลี่ยนแปลงและพัฒนาของ master branch ของ Laravel Framework ดังนั้นทางทีมงานยินดีอย่างยิ่ง หากได้รับการช่วยเหลือ</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "โอ้วววว!",
                    "greeting": "สวัสดีจ้า!",
                    "regards": "ด้วยความนับถือ,",
                    "trouble_clicking_button": "เมื่อคุณมีปัญหาในการคลิกปุ่ม \"{action_text}\" , โปรดคัดลอก URL ด้านล่างแล้วนำไปวางในเว็บบราวเซอร์ของคุณ:",
                    "thank_you_for_using_app": "ขอบคุณมากสำหรับการใช้งานแอพพลิเคชั่นของเรา",
                    "password_reset_subject": "ลิงก์สำหรับรีเซ็ตรหัสผ่านของคุณ",
                    "password_cause_of_email": "คุณได้รับอีเมลฉบับนี้เนื่องจากมีการร้องขอการตั้งรหัสผ่านใหม่สำหรับบัญชีผู้ใช้นี้",
                    "password_if_not_requested": "ถ้าหากว่าคุณไม่ได้เป็นคนร้องขอการตั้งรหัสผ่านใหม่ ไม่จำเป็นต้องทำสิ่งใดเพิ่มเติม",
                    "reset_password": "คลิกที่นี่เพื่อรีเซ็ตรหัสผ่านของคุณ",
                    "click_to_confirm": "คลิกที่นี่เพื่อยืนยันตัวตนของคุณ:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "การทดสอบ",
                "tests": {
                    "based_on": {
                        "permission": "เกี่ยวกับสิทธิ์ - ",
                        "role": "เกี่ยวกับบทบาท - "
                    },
                    "js_injected_from_controller": "ใส่ Javascript ผ่าน Controller",
                    "using_blade_extensions": "การใช้ Blade Extensions",
                    "using_access_helper": {
                        "array_permissions": "ใช้ Access Helper กับ Array ของชื่อสิทธิ์ หรือ ID ซึ่งผู้ใช้ต้องเป็นผู้ที่มีสิทธิ์ครบทั้งหมด",
                        "array_permissions_not": "ใช้ Access Helper กับ Array ของชื่อสิทธิ์ หรือ ID ซึ่งผู้ใช้ไม่จำเป็นต้องเป็นผู้ที่มีสิทธิ์ครบทั้งหมด",
                        "array_roles": "ใช้ Access Helper กับ Array ของชื่อบทบาท หรือ ID ซึ่งผู้ใช้ต้องเป็นผู้ที่มีบทบาทครบทั้งหมด",
                        "array_roles_not": "ใช้ Access Helper กับ Array ของชื่อบทบาท หรือ ID ซึ่งผู้ใช้ไม่จำเป็นต้องเป็นผู้ที่มีบทบาทครบทั้งหมด",
                        "permission_id": "ใช้ Access Helper กับ ID ของสิทธิ์",
                        "permission_name": "ใช้ Access Helper กับชื่อของสิทธิ์",
                        "role_id": "ใช้ Access Helper กับ ID ของบทบาท",
                        "role_name": "ใช้ Access Helper กับชื่อของบทบาท"
                    },
                    "view_console_it_works": "ดูที่คอนโซลล็อก คุณจะเห็นข้อความ 'it works!' ซึ่งมาจาก FrontendController@index",
                    "you_can_see_because": "คุณสามารถเห็นข้อความนี้เนื่องจากคุณมีบทบาทของ '{role}'!",
                    "you_can_see_because_permission": "คุณสามารถเห็นข้อความนี้เนื่องจากคุณมีสิทธิ์ของ '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "ข้อมูลโปรไฟล์ถูกอัพเดทสำเร็จแล้ว",
                    "password_updated": "รหัสผ่านถูกอัพเดทสำเร็จแล้ว"
                },
                "welcome_to": "ยินดีต้อนรับสู่ {place}"
            }
        },
        "auth": {
            "failed": "ข้อมูลที่ใช้ในการยืนยันตัวตนไม่ถูกต้อง",
            "general_error": "คุณไม่มีสิทธิ์ในการเข้าถึงหรือกระทำการ",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "ไม่ได้รับการยินยอมให้เข้าสู่ระบบด้วย {provider}"
            },
            "throttle": "คุณได้พยายามเข้าระบบหลายครั้งเกินไป กรุณาลองใหม่ใน {seconds} วินาทีข้างหน้า",
            "unknown": "เกิดข้อผิดพลาดโดยไม่ทราบสาเหตุ"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "การจัดการผู้ใช้และสิทธิ์",
                    "roles": {
                        "all": "บทบาททั้งหมด",
                        "create": "สร้างบทบาท",
                        "edit": "แก้ไขบทบาท",
                        "management": "การจัดการบทบาท",
                        "main": "บทบาท"
                    },
                    "users": {
                        "all": "ผู้ใช้ทั้งหมด",
                        "change-password": "เปลี่ยนรหัสผ่าน",
                        "create": "สร้างผู้ใช้",
                        "deactivated": "ผู้ใช้ที่ถูกพักการใช้งาน",
                        "deleted": "ผู้ใช้ที่ถูกลบ",
                        "edit": "แก้ไขผู้ใช้",
                        "main": "ผู้ใช้",
                        "view": "แสดงผู้ใช้"
                    }
                },
                "log-viewer": {
                    "main": "แสดงข้อมูล Log",
                    "dashboard": "แผงควบคุม",
                    "logs": "รายการล็อก"
                },
                "sidebar": {
                    "dashboard": "แผงควบคุม",
                    "general": "ทั่วไป",
                    "system": "ระบบ"
                }
            },
            "language-picker": {
                "language": "ภาษา",
                "langs": {
                    "ar": "อารบิก (Arabic)",
                    "zh": "(Chinese Simplified)",
                    "zh-TW": "(Chinese Traditional)",
                    "da": "เดนมา์ก (Danish)",
                    "de": "เยอรมัน (German)",
                    "el": "(Greek)",
                    "en": "อังกฤษ (English)",
                    "es": "สเปน (Spanish)",
                    "fa": "เปอร์เซีย (Persian)",
                    "fr": "ฝรั่งเศส (French)",
                    "he": "ชาวอิสราเอล (Hebrew)",
                    "id": "ชาวอินโดนีเซีย (Indonesian)",
                    "it": "อิตาลี (Italian)",
                    "ja": "(Japanese)",
                    "nl": "ดัตช์ (Dutch)",
                    "no": "นอร์เวย์ (Norwegian)",
                    "pt_BR": "โปรตุเกสแบบบราซิล (Brazilian Portuguese)",
                    "ru": "รัสเซีย (Russian)",
                    "sv": "สวีเดน (Swedish)",
                    "th": "ไทย (Thai)",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "เปิดใช้งาน",
                        "change_password": "เปลี่ยนรหัสผ่าน",
                        "clear_session": "Clear Session",
                        "confirm": "Confirm",
                        "deactivate": "พักการใช้งาน",
                        "delete_permanently": "ลบอย่างถาวร",
                        "login_as": "เข้าสู่ระบบเสมือนเป็น {user}",
                        "resend_email": "ส่งอีเมลยืนยันตัวตนอีกครั้ง",
                        "restore_user": "กู้คืนผู้ใช้",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "ยืนยันบัญชี",
                    "reset_password": "ตั้งรหัสผ่านใหม่"
                }
            },
            "general": {
                "cancel": "ยกเลิก",
                "continue": "Continue",
                "crud": {
                    "create": "สร้าง",
                    "delete": "ลบ",
                    "edit": "แก้ไข",
                    "update": "ปรับปรุง",
                    "view": "แสดง"
                },
                "save": "บันทึก",
                "view": "แสดง"
            }
        },
        "passwords": {
            "password": "รหัสผ่านต้องมีความยาวอย่างน้อยหกตัวอักษรและต้องตรงกับช่องยืนยันรหัสผ่าน",
            "reset": "ทำการตั้งค่ารหัสผ่านใหม่แล้ว!",
            "sent": "ระบบได้ส่งอีเมลสำหรับตั้งรหัสผ่านใหม่ให้คุณแล้ว!",
            "token": "ชุดรหัสสำหรับการเปลี่ยนรหัสผ่านไม่ถูกต้อง",
            "user": "ไม่พบผู้ใช้งานที่ตรงกับอีเมล์นี้"
        },
        "http": {
            "404": {
                "title": "ไม่พบหน้า",
                "description": "ขออภัย ไม่พบหน้าทึ่คุณต้องการ"
            },
            "503": {
                "title": "เราจะกลับมาในไม่ช้า",
                "description": "เราจะกลับมาในไม่ช้า"
            }
        },
        "labels": {
            "general": {
                "all": "ทั้งหมด",
                "yes": "ใช่",
                "no": "ไม่",
                "custom": "เลือกเอง",
                "actions": "การกระทำ",
                "active": "ใช้งาน",
                "buttons": {
                    "save": "บันทึก",
                    "update": "แก้ไข"
                },
                "hide": "ซ่อน",
                "inactive": "ไม่ใช้งาน",
                "none": "ไม่มี",
                "show": "แสดง",
                "toggle_navigation": "เปิด/ปิด เมนูนำทาง"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "สร้างบทบาท",
                        "edit": "แก้ไขบทบบาท",
                        "management": "การจัดการบทบาท",
                        "table": {
                            "number_of_users": "จำนวนผู้ใช้",
                            "permissions": "สิทธิ์",
                            "role": "บทบาท",
                            "sort": "เรียงตาม",
                            "total": "บทบาททั้งหมด ::: บทบาททั้งหมด"
                        }
                    },
                    "users": {
                        "active": "ผู้ใช้",
                        "all_permissions": "สิทธิ์ทั้งหมด",
                        "change_password": "เปลี่ยนรหัสผ่าน",
                        "change_password_for": "เปลี่ยนรหัสผ่านสำหรับ {user}",
                        "create": "สร้างผู้ใช้",
                        "deactivated": "ผู้ใช้ที่ถูกพักการใช้งาน",
                        "deleted": "ผู้ใช้ที่ถูกลบ",
                        "edit": "แก้ไขผู้ใช้",
                        "management": "การจัดการผู้ใช้",
                        "no_permissions": "ไม่มีสิทธิ์",
                        "no_roles": "ไม่มีบทบาทให้เลือก",
                        "permissions": "สิทธิ์",
                        "table": {
                            "confirmed": "ยืนยันแล้ว",
                            "created": "สร้างเมื่อ",
                            "email": "อีเมล",
                            "id": "ID",
                            "last_updated": "อัพเดทล่าสุดเมื่อ",
                            "name": "ชื่อ",
                            "no_deactivated": "ไม่มีผู้ใช้ที่ถูกพักการใช้งาน",
                            "no_deleted": "ไม่มีผู้ใช้ที่ถูกลบ",
                            "roles": "บทบาท",
                            "social": "Social",
                            "total": "ผู้ใช้ทั้งหมด ::: ผู้ใช้ทั้งหมด"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "ภาพรวม",
                                "history": "ประวัติ"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "รูปตัวแทน",
                                    "confirmed": "ยืนยันเรียบร้อย",
                                    "created_at": "สร้างแล้วเมื่อ",
                                    "deleted_at": "ลบแล้วเมื่อ",
                                    "email": "อีเมล",
                                    "last_updated": "ปรับปรุงล่าสุด",
                                    "name": "ชื่อ",
                                    "status": "สถานะ"
                                }
                            }
                        },
                        "view": "แสดงผู้ใช้"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "เข้าสู่ระบบ",
                    "login_button": "เข้าสู่ระบบ",
                    "login_with": "เข้าสู่ระบบด้วย {social_media}",
                    "register_box_title": "ลงทะเบียน",
                    "register_button": "ลงทะเบียน",
                    "remember_me": "จดจำฉัน"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "ลืมรหัสผ่าน?",
                    "reset_password_box_title": "รีเซ็ตรหัสผ่าน",
                    "reset_password_button": "รีเซ็ตรหัสผ่าน",
                    "send_password_reset_link_button": "ส่งลิงก์สำหรับรีเซ็ตรหัสผ่าน"
                },
                "user": {
                    "passwords": {
                        "change": "เปลี่ยนรหัสผ่าน"
                    },
                    "profile": {
                        "avatar": "รูปตัวแทน",
                        "created_at": "สร้างเมื่อ",
                        "edit_information": "แก้ไขข้อมูล",
                        "email": "อีเมล",
                        "last_updated": "ปรับปรุงล่าสุดเมื่อ",
                        "name": "ชื่อ",
                        "update_information": "ปรับปรุงข้อมูล"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "บทบาทถูกสร้างสำเร็จแล้ว",
                    "deleted": "บทบาทถูกลบสำเร็จแล้ว",
                    "updated": "บทบาทถูกแก้ไขสำเร็จแล้ว"
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "อีเมลยืนยันตัวตนได้ถูกส่งไปยังปลายทางแล้ว",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "ผู้ใช้ถูกสร้างสำเร็จแล้ว",
                    "deleted": "ผู้ใช้ถูกลบสำเร็จแล้ว",
                    "deleted_permanently": "ผู้ใช้ถูกลบไปอย่างถาวร",
                    "restored": "ผู้ใช้ถูกกู้คืนสำเร็จแล้ว",
                    "session_cleared": "The user's session was successfully cleared.",
                    "social_deleted": "Social Account Successfully Removed",
                    "unconfirmed": "The user was successfully un-confirmed",
                    "updated": "ผู้ใช้ถูกแก้ไขสำเร็จแล้ว",
                    "updated_password": "รหัสผ่านของผู้ใช้ถูกแก้ไขสำเร็จแล้ว"
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "ข้อมูล {attribute} ต้องผ่านการยอมรับก่อน",
            "active_url": "ข้อมูล {attribute} ต้องเป็น URL เท่านั้น",
            "after": "ข้อมูล {attribute} ต้องเป็นวันที่หลังจาก {date}",
            "after_or_equal": "ข้อมูล {attribute} ต้องเป็นวันที่หลังหรือเท่ากันกับ {date}.",
            "alpha": "ข้อมูล {attribute} ต้องเป็นตัวอักษรภาษาอังกฤษเท่านั้น",
            "alpha_dash": "ข้อมูล {attribute} ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข และ _ เท่านั้น",
            "alpha_num": "ข้อมูล {attribute} ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข เท่านั้น",
            "array": "ข้อมูล {attribute} ต้องเป็นอาเรย์เท่านั้น",
            "before": "ข้อมูล {attribute} ต้องเป็นวันที่ก่อน {date}",
            "before_or_equal": "ข้อมูล {attribute} ต้องเป็นวันที่ก่อนหรือเท่ากันกับวันที่ {date}.",
            "between": {
                "numeric": "ข้อมูล {attribute} ต้องอยู่ในช่วงระหว่าง {min} - {max}",
                "file": "ข้อมูล {attribute} ต้องอยู่ในช่วงระหว่าง {min} - {max} กิโลไบต์",
                "string": "ข้อมูล {attribute} ต้องอยู่ในช่วงระหว่าง {min} - {max} ตัวอักษร",
                "array": "ข้อมูล {attribute} ต้องอยู่ในช่วงระหว่าง {min} - {max} ค่า"
            },
            "boolean": "ข้อมูล {attribute} ต้องเป็นจริง หรือเท็จ เท่านั้น",
            "confirmed": "ข้อมูล {attribute} ไม่ตรงกัน",
            "date": "ข้อมูล {attribute} ต้องเป็นวันที่",
            "date_format": "ข้อมูล {attribute} ไม่ตรงกับข้อมูลกำหนด {format}",
            "different": "ข้อมูล {attribute} และ {other} ต้องไม่เท่ากัน",
            "digits": "ข้อมูล {attribute} ต้องเป็น {digits}",
            "digits_between": "ข้อมูล {attribute} ต้องอยู่ในช่วงระหว่าง {min} ถึง {max}",
            "dimensions": "รูปภาพ {attribute} มีขนาดไม่ถูกต้อง",
            "distinct": "ข้อมูล {attribute} มีค่าที่ซ้ำกัน",
            "email": "ข้อมูล {attribute} ต้องเป็นอีเมล์",
            "exists": "ข้อมูล ที่ถูกเลือกจาก {attribute} ไม่ถูกต้อง",
            "file": "ข้อมูล {attribute} ต้องเป็นไฟล์",
            "filled": "ข้อมูล {attribute} จำเป็นต้องกรอก",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "ข้อมูล {attribute} ต้องเป็นรูปภาพ",
            "in": "ข้อมูล ที่ถูกเลือกใน {attribute} ไม่ถูกต้อง",
            "in_array": "ข้อมูล {attribute} ไม่มีอยู่ภายในค่าของ {other}",
            "integer": "ข้อมูล {attribute} ต้องเป็นตัวเลข",
            "ip": "ข้อมูล {attribute} ต้องเป็น IP",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "ข้อมูล {attribute} ต้องเป็นอักขระ JSON ที่สมบูรณ์",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "ข้อมูล {attribute} ต้องมีจำนวนไม่เกิน {max}",
                "file": "ข้อมูล {attribute} ต้องมีจำนวนไม่เกิน {max} กิโลไบต์",
                "string": "ข้อมูล {attribute} ต้องมีจำนวนไม่เกิน {max} ตัวอักษร",
                "array": "ข้อมูล {attribute} ต้องมีจำนวนไม่เกิน {max} ค่า"
            },
            "mimes": "ข้อมูล {attribute} ต้องเป็นชนิดไฟล์: {values}",
            "min": {
                "numeric": "ข้อมูล {attribute} ต้องมีจำนวนอย่างน้อย {min}",
                "file": "ข้อมูล {attribute} ต้องมีจำนวนอย่างน้อย {min} กิโลไบต์",
                "string": "ข้อมูล {attribute} ต้องมีจำนวนอย่างน้อย {min} ตัวอักษร",
                "array": "ข้อมูล {attribute} ต้องมีจำนวนอย่างน้อย {min} ค่า"
            },
            "not_in": "ข้อมูล ที่เลือกจาก {attribute} ไม่ถูกต้อง",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "ข้อมูล {attribute} ต้องเป็นตัวเลข",
            "present": "ข้อมูล {attribute} ต้องเป็นปัจจุบัน",
            "regex": "ข้อมูล {attribute} มีรูปแบบไม่ถูกต้อง",
            "required": "ข้อมูล {attribute} จำเป็นต้องกรอก",
            "required_if": "ข้อมูล {attribute} จำเป็นต้องกรอกเมื่อ {other} เป็น {value}",
            "required_unless": "ข้อมูล {attribute} จำเป็นต้องกรอกเว้นแต่ {other} เป็น {values}",
            "required_with": "ข้อมูล {attribute} จำเป็นต้องกรอกเมื่อ {values} มีค่า",
            "required_with_all": "ข้อมูล {attribute} จำเป็นต้องกรอกเมื่อ {values} มีค่าทั้งหมด",
            "required_without": "ข้อมูล {attribute} จำเป็นต้องกรอกเมื่อ {values} ไม่มีค่า",
            "required_without_all": "ข้อมูล {attribute} จำเป็นต้องกรอกเมื่อ {values} ไม่มีค่าทั้งหมด",
            "same": "ข้อมูล {attribute} และ {other} ต้องถูกต้อง",
            "size": {
                "numeric": "ข้อมูล {attribute} ต้องเท่ากับ {size}",
                "file": "ข้อมูล {attribute} ต้องเท่ากับ {size} กิโลไบต์",
                "string": "ข้อมูล {attribute} ต้องเท่ากับ {size} ตัวอักษร",
                "array": "ข้อมูล {attribute} ต้องเท่ากับ {size} ค่า"
            },
            "string": "ข้อมูล {attribute} ต้องเป็นอักขระ",
            "timezone": "ข้อมูล {attribute} ต้องเป็นข้อมูลเขตเวลาที่ถูกต้อง",
            "unique": "ข้อมูล {attribute} ไม่สามารถใช้ได้",
            "url": "ข้อมูล {attribute} ไม่ถูกต้อง",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "บทบาทที่เกี่ยวข้อง",
                            "dependencies": "สิ่งที่จำเป็นต้องมี",
                            "display_name": "ชื่อที่แสดง",
                            "group": "กลุ่ม",
                            "group_sort": "เรียงตามกลุ่ม",
                            "groups": {
                                "name": "ชื่อกลุ่ม"
                            },
                            "name": "ชื่อ",
                            "system": "ระบบ?"
                        },
                        "roles": {
                            "associated_permissions": "สิทธิ์ที่เกี่ยวข้อง",
                            "name": "ชื่อ",
                            "sort": "เรียง"
                        },
                        "users": {
                            "active": "เปิดใช้งาน",
                            "associated_roles": "บทบาทที่เกี่ยวข้อง",
                            "confirmed": "ยืนยันตัวตน",
                            "email": "ที่อยู่อีเมล",
                            "name": "ชื่อ",
                            "other_permissions": "สิทธิ์อื่นๆ",
                            "password": "รหัสผ่าน",
                            "password_confirmation": "ยืนยันรหัสผ่าน",
                            "send_confirmation_email": "ส่งอีเมลยืนยันตัวตน"
                        }
                    }
                },
                "frontend": {
                    "email": "ที่อยู่อีเมล",
                    "name": "ชื่อ",
                    "password": "รหัสผ่าน",
                    "password_confirmation": "ยืนยันรหัสผ่าน",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "รหัสผ่านเดิม",
                    "new_password": "รหัสผ่านใหม่",
                    "new_password_confirmation": "ยืนยันรหัสผ่านใหม่"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "บทบาทนี้มีอยู่แล้ว กรุณาเลือกชื่ออื่นที่แตกต่าง",
                        "cant_delete_admin": "คุณไม่สามารถลบบทบาทผู้ดูแลระบบได้",
                        "create_error": "มีข้อผิดพลาดในการสร้างบทบาทนี้ กรุณาลองใหม่อีกครั้ง",
                        "delete_error": "มีข้อผิดพลาดในการลบบทบาทนี้ กรุณาลองใหม่อีกครั้ง",
                        "has_users": "คุณไม่สามารถลบบทบาทที่มีผู้ใช้สวมบทบาทนี้อยู่",
                        "needs_permission": "คุณต้องเลือกอย่างน้อยหนึ่งสิทธิ์ให้กับบทบาทนี้",
                        "not_found": "ไม่พบบทบาทนี้",
                        "update_error": "มีข้อผิดพลาดในการแก้ไขบทบาทนี้ กรุณาลองใหม่อีกครั้ง"
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "คุณไม่สามารถกระทำกับตนเองได้",
                        "cant_delete_admin": "You can not delete the super administrator.",
                        "cant_delete_self": "คุณไม่สามารถลบตนเองได้",
                        "cant_delete_own_session": "You can not delete your own session.",
                        "cant_restore": "ผู้ใช้นี้ไม่สามารถทำการลบได้ เนื่องจากไม่สามารถจะกู้คืนผู้ใช้นี้ได้",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "มีข้อผิดพลาดในการสร้างผู้ใช้นี้ กรุณาลองใหม่อีกครั้ง",
                        "delete_error": "มีข้อผิดพลาดในการลบผู้ใช้นี้ กรุณาลองใหม่อีกครั้ง",
                        "delete_first": "ผู้ใช้นี้ต้องทำการลบออกไปก่อน ก่อนที่จะทำการทำลบทื้งอย่างถาวร",
                        "email_error": "อีเมลนี้เป็นของผู้ใช้คนอื่น",
                        "mark_error": "มีข้อผิดพลาดในการแก้ไขผู้ใช้นี้ กรุณาลองใหม่อีกครั้ง",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "ไม่พบผู้ใช้นี้",
                        "restore_error": "มีข้อผิดพลาดในการกู้คืนผู้ใช้นี้ กรุณาลองใหม่อีกครั้ง",
                        "role_needed_create": "คุณต้องเลือกอย่างน้อยหนึ่งบทบาท",
                        "role_needed": "คุณต้องเลือกอย่างน้อยหนึ่งบทบาท",
                        "session_wrong_driver": "Your session driver must be set to database to use this feature.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "มีข้อผิดพลาดในการแก้ไขผู้ใช้นี้ กรุณาลองใหม่อีกครั้ง",
                        "update_password_error": "มีข้อผิดพลาดในการเปลี่ยนรหัสผ่านของผู้ใช้นี้ กรุณาลองใหม่อีกครั้ง"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "บัญชีผู้ใช้ของคุณได้รับการยืนยันแล้ว",
                        "confirm": "ยีนยันบัญชีผู้ใช้ของคุณ!",
                        "created_confirm": "บัญชีผู้ใช้ของคุณถูกสร้างสำเร็จแล้ว ระบบได้ส่งอีเมลสำหรับยืนยันตัวตนให้คุณ",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "รหัสที่ใช้ยืนยันตัวตนไม่ถูกต้อง",
                        "not_found": "ไม่พบรหัสที่ใช้ยืนยันตัวตนนี้",
                        "pending": "Your account is currently pending approval.",
                        "resend": "บัญชีผู้ใช้ของคุณยังไม่ได้รับการยืนยันตัวตน กรุณาคลิกลิงก์ในอีเมลของคุณ หรือ <a href=\"{url}\">คลิกที่นี่</a> เพื่อส่งอีเมลยืนยันตัวตนอีกครั้ง",
                        "success": "บัญชีผู้ใช้ของคุณได้รับการยืนยันตัวตนสำเร็จแล้ว!",
                        "resent": "อีเมลยืนยันตัวตนฉบับใหม่ได้ถูกส่งไปยังปลายทางแล้ว"
                    },
                    "deactivated": "บัญชีผู้ใช้ของคุณถูกพักการใช้งาน",
                    "email_taken": "อีเมลนี้ถูกใช้ในระบบแล้ว",
                    "password": {
                        "change_mismatch": "รหัสผ่านเดิมไม่ถูกต้อง",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "Registration is currently closed."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; ก่อนหน้า",
            "next": "ถัดไป &raquo;"
        },
        "roles": {
            "administrator": "แอดมิน",
            "user": "ผู้ใช้"
        },
        "navs": {
            "general": {
                "home": "หน้าแรก",
                "logout": "ออกจากระบบ"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "แผงควบคุม",
                "login": "เข้าสู่ระบบ",
                "macros": "Macros",
                "register": "ลงทะเบียน",
                "user": {
                    "account": "บัญชีของฉัน",
                    "administration": "หน้าแอดมิน",
                    "change_password": "เปลี่ยนรหัสผ่าน",
                    "my_information": "ข้อมูลของฉัน",
                    "profile": "ข้อมูลส่วนตัว"
                }
            }
        }
    },
    "tr": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "Bu kullanıcıyı kalıcı olarak silmek istediğinize emin misiniz? Bu kullanıcı IDsini referans alan yerlerde hata oluşma ihtimali vardır. Sonuçlar kendi sorumluluğunuzdadır. İşlem geri alınamaz.",
                        "if_confirmed_off": "(Onay kapalıysa)",
                        "restore_user_confirm": "Bu kullanıcı orijinal durumuna geri yüklensin mi?"
                    }
                },
                "dashboard": {
                    "title": "Yönetim Panosu",
                    "welcome": "Hoşgeldiniz"
                },
                "general": {
                    "all_rights_reserved": "Tüm Hakları Saklıdır.",
                    "are_you_sure": "Bunu yapmak istediğinize emin misiniz?",
                    "boilerplate_link": "Laravel Boilerplate",
                    "continue": "Devam et",
                    "member_since": "Üyelik zamanı",
                    "minutes": " dakika",
                    "search_placeholder": "Ara...",
                    "timeout": "Etkinliğiniz olmadığı için güvenlik nedeniyle oturumunuz belirtilen sürede kapandı ",
                    "see_all": {
                        "messages": "Tüm mesajları görüntüle",
                        "notifications": "Tümünü görüntüle",
                        "tasks": "Tüm görevleri görüntüle"
                    },
                    "status": {
                        "online": "Çevrimiçi",
                        "offline": "Çevrimdışı"
                    },
                    "you_have": {
                        "messages": "{0} Mesajınız yok ::: {1} Mesajınız var ::: [2,Inf] {number} mesajınız var",
                        "notifications": "{0} Bildirim yok ::: {1} 1 Bildirim var ::: [2,Inf] {number} Bildirim var",
                        "tasks": "{0} Göreviniz yok ::: {1} 1 Görev var ::: [2,Inf] {number} görev var"
                    }
                },
                "search": {
                    "empty": "Lütfen arama kelimesi girin.",
                    "incomplete": "Arama mantığı yazılıyor.",
                    "title": "Arama Sonuçları",
                    "results": "Sorgu için arama sonuçları: {query}"
                },
                "welcome": "<p>MaviRota Rezervasyon sistemine hoşgeldiniz.</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "HATA!",
                    "greeting": "Merhaba!",
                    "regards": "Saygılarımızla,",
                    "trouble_clicking_button": "\"{action_text}\" düğmesini tıklamakta zorlanıyorsanız, aşağıdaki URL'yi kopyalayıp web tarayıcınıza yapıştırın:",
                    "thank_you_for_using_app": "Uygulamamızı kullandığınız için teşekkürler!",
                    "password_reset_subject": "Parolayı Sıfırla",
                    "password_cause_of_email": "Bu e-postayı, hesabınız için bir şifre sıfırlama isteği aldığımız için aldınız.",
                    "password_if_not_requested": "Şifre sıfırlamasını istemediyseniz, başka işlem yapmanız gerekmez.",
                    "reset_password": "Şifrenizi sıfırlamak için buraya tıklayın",
                    "click_to_confirm": "Hesabınızı onaylamak için burayı tıklayın:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Yetki esasına dayalı - ",
                        "role": "Role dayalı - "
                    },
                    "js_injected_from_controller": "Bir denetleyiciden enjekte edilen Javascript",
                    "using_blade_extensions": "Blade uzantıları kullan",
                    "using_access_helper": {
                        "array_permissions": "Erişim Yardımcısı, kullanıcının tamamına sahip olması gereken Yetki İsmi veya ID'si Dizileri ile kullanılıyor",
                        "array_permissions_not": "Erişim Yardımcısı, kullanıcının tamamına sahip olması GEREKMEYEN Yetki İsmi veya ID'si Dizileri ile kullanılıyor",
                        "array_roles": "Erişim Yardımcısı, kullanıcının tamamına sahip olması gereken ROL İsmi veya ID'si Dizileri ile kullanılıyor",
                        "array_roles_not": "Erişim Yardımcısı, kullanıcının tamamına sahip olması GEREKMEYEN Yetki İsmi veya ID'si Dizileri ile kullanılıyor",
                        "permission_id": "Erişim Yardımcısı, Yetki ID'si ile kullanılıyor",
                        "permission_name": "Erişim Yardımcısı, Yetki İsmi ile kullanılıyor",
                        "role_id": "Erişim Yardımcısı, ROL ID'si ile kullanılıyor",
                        "role_name": "Erişim Yardımcısı, ROL İsmi ile kullanılıyor"
                    },
                    "view_console_it_works": "Konsolu görüntüleyin, 'it works!' ibaresini FrontendController@index den geldiği için görebilirsiniz.",
                    "you_can_see_because": "'{role}' rolüne sahip olduğunuz için bunu görüntülemektesiniz!",
                    "you_can_see_because_permission": "'{permission}' yetkisine sahip olduğunuz için bunu görüntülemektesiniz!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "E-postanızı değiştirirseniz, yeni e-posta adresinizi teyit edene kadar oturumunuz kapatılır.",
                    "email_changed_notice": "Tekrar tekrar oturum açabilmeniz için yeni e-posta adresinizi onaylamanız gerekir.",
                    "profile_updated": "Profil başarıyla güncellendi.",
                    "password_updated": "Şifre başarıyla güncellendi."
                },
                "welcome_to": "{place} 'e Hoşgeldiniz"
            }
        },
        "auth": {
            "failed": "Bu kimlik bilgileri kayıtlarımızla eşleşmiyor.",
            "general_error": "Bunu yapmak için erişiminiz yok.",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} kabul edilen bir oturum açma türü değil."
            },
            "throttle": "Çok fazla giriş denemesi. Lütfen {seconds} saniye sonra yeniden deneyin.",
            "unknown": "Bilinmeyen bir hata oluştu"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Erişim Yönetimi",
                    "roles": {
                        "all": "Tüm Roller",
                        "create": "Rol Oluştur",
                        "edit": "Rol Düzenle",
                        "management": "Rol Yönetimi",
                        "main": "Roller"
                    },
                    "users": {
                        "all": "Tüm Kullanıcılar",
                        "change-password": "Parolayı Değiştir",
                        "create": "Kullanıcı Oluştur",
                        "deactivated": "Pasif Kullanıcılar",
                        "deleted": "Silinmiş Kullanıcılar",
                        "edit": "Kullanıcıyı Düzenle",
                        "main": "Kullanıcılar",
                        "view": "Kullanıcıyı Görüntüle"
                    }
                },
                "log-viewer": {
                    "main": "Log Görüntüleyici",
                    "dashboard": "Kokpit",
                    "logs": "Loglar"
                },
                "sidebar": {
                    "dashboard": "Kokpit",
                    "general": "Genel",
                    "system": "Sistem"
                }
            },
            "language-picker": {
                "language": "Dil",
                "langs": {
                    "ar": "Arapça (Arabic)",
                    "zh": "Basitleştirilmiş Çince (Chinese Simplified)",
                    "zh-TW": "Geleneksel Çince (Chinese Traditional)",
                    "da": "Danimarka (Danish)",
                    "de": "Almanca (German)",
                    "el": "Yunanca (Greek)",
                    "en": "İngilizce (English)",
                    "es": "İspanyolca (Spanish)",
                    "fa": "Farsça (Persian)",
                    "fr": "Fransızca (French)",
                    "he": "İbranice (Hebrew)",
                    "id": "Endonezya (Indonesian)",
                    "it": "İtalyanca (Italian)",
                    "ja": "Japonca (Japanese)",
                    "nl": "Hollandaca (Dutch)",
                    "no": "Norveçli (Norwegian)",
                    "pt_BR": "Brezilya Portekizcesi (Brazilian Portuguese)",
                    "ru": "Rusça (Russian)",
                    "sv": "İsveççe (Swedish)",
                    "th": "Tay (Thai)",
                    "tr": "Türkçe (Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "Etkinleştir",
                        "change_password": "Parolayı Değiştir",
                        "clear_session": "Oturumu Temizle",
                        "confirm": "Onayla",
                        "deactivate": "Devre dışı bırak",
                        "delete_permanently": "Kalıcı Olarak Sil",
                        "login_as": "Kullanıcı {user} olarak oturum aç",
                        "resend_email": "Onay E-postasını Yeniden Gönder",
                        "restore_user": "Kullanıcıyı Kurtar",
                        "unconfirm": "Onaylama",
                        "unlink": "Bağlantıyı Kaldır"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "Hesabı Onayla",
                    "reset_password": "Parolayı Sıfırla"
                }
            },
            "general": {
                "cancel": "Vazgeç",
                "continue": "Devam",
                "crud": {
                    "create": "Oluştur",
                    "delete": "Sil",
                    "edit": "Düzenle",
                    "update": "Güncelle",
                    "view": "Görüntüle"
                },
                "save": "Kaydet",
                "view": "Görüntüle"
            }
        },
        "passwords": {
            "password": "Parolalar en az altı karakter olmalıdır ve onayla eşleşmelidir.",
            "reset": "Şifreniz sıfırlandı!",
            "sent": "Parola sıfırlama bağlantınızı e-posta ile gönderdik!",
            "token": "Bu parola sıfırlama simgesi geçersiz.",
            "user": "Bu e-posta adresine sahip bir kullanıcı bulamıyoruz."
        },
        "http": {
            "404": {
                "title": "Sayfa Bulunamadı",
                "description": "Maalesef, görüntülemeye çalıştığınız sayfa mevcut değil."
            },
            "503": {
                "title": "Hemen döneceğiz.",
                "description": "Hemen döneceğiz."
            }
        },
        "labels": {
            "general": {
                "all": "Hepsi",
                "yes": "Evet",
                "no": "Hayır",
                "custom": "Özel",
                "actions": "İşlemler",
                "active": "Etkin",
                "buttons": {
                    "save": "Kaydet",
                    "update": "Güncelle"
                },
                "hide": "Gizle",
                "inactive": "Etkin değil",
                "none": "Hiçbiri",
                "show": "Göster",
                "toggle_navigation": "Navigasyon Açık"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "Rol Oluştur",
                        "edit": "Rol Düzenle",
                        "management": "Rol Yönetimi",
                        "table": {
                            "number_of_users": "Kullanıcı Sayısı",
                            "permissions": "İzinler",
                            "role": "Rol",
                            "sort": "Sıralama",
                            "total": "rol toplam ::: roller toplam"
                        }
                    },
                    "users": {
                        "active": "Aktif Kullanıcılar",
                        "all_permissions": "Tüm İzinler",
                        "change_password": "Parolayı Değiştir",
                        "change_password_for": "Kullanıcı {user} parolasını değiştir",
                        "create": "Kullanıcı Oluştur",
                        "deactivated": "Devre Dışı Bırakılan Kullanıcılar",
                        "deleted": "Silinmiş Kullanıcılar",
                        "edit": "Kullanıcı Düzenle",
                        "management": "Kullanıcı Yönetimi",
                        "no_permissions": "İzin yok.",
                        "no_roles": "Ayarlanacak Rol yok.",
                        "permissions": "İzinler",
                        "table": {
                            "confirmed": "Onaylandı",
                            "created": "Oluşturuldu",
                            "email": "E-posta",
                            "id": "ID",
                            "last_updated": "Son Güncelleme",
                            "name": "İsim",
                            "first_name": "Ad",
                            "last_name": "Soyad",
                            "no_deactivated": "Devre Dışı Bırakılan Kullanıcı Yok",
                            "no_deleted": "Silinmiş Kullanıcı Yok",
                            "roles": "Roller",
                            "social": "Social",
                            "total": "toplam kullanıcı ::: toplam kullanıcılar"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "Genel Bakış",
                                "history": "Geçmiş"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "Avatar",
                                    "confirmed": "Onaylandı",
                                    "created_at": "Oluşturulma",
                                    "deleted_at": "Silinme",
                                    "email": "E-posta",
                                    "last_updated": "Son Güncellenme",
                                    "name": "İsim",
                                    "first_name": "Ad",
                                    "last_name": "Soyad",
                                    "status": "Durum"
                                }
                            }
                        },
                        "view": "Kullanıcıyı Göster"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "Giriş",
                    "login_button": "Giriş",
                    "login_with": "Şununla Gir {social_media}",
                    "register_box_title": "Kayıt",
                    "register_button": "Kayıt",
                    "remember_me": "Beni Hatırla"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "Parolanızı mı Unuttunuz?",
                    "reset_password_box_title": "Parola Sıfırla",
                    "reset_password_button": "Parola Sıfırla",
                    "send_password_reset_link_button": "Parolayı Sıfırlama Bağlantısı Gönder"
                },
                "user": {
                    "passwords": {
                        "change": "Parolayı değiştir"
                    },
                    "profile": {
                        "avatar": "Avatar",
                        "created_at": "Oluşturulma",
                        "edit_information": "Bilgileri Düzenle",
                        "email": "E-posta",
                        "last_updated": "Son Güncelleme",
                        "name": "İsim",
                        "first_name": "Ad",
                        "last_name": "Soyad",
                        "update_information": "Bilgileri Güncelle"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "Rol başarılı bir şekilde oluşturuldu.",
                    "deleted": "Rol başarıyla silindi.",
                    "updated": "Rol başarıyla güncellendi."
                },
                "users": {
                    "cant_resend_confirmation": "Uygulama şu anda kullanıcıları manuel olarak onaylamak üzere ayarlanmıştır.",
                    "confirmation_email": "Kayıtlı e-posta adresine yeni bir onay e-postası gönderildi.",
                    "confirmed": "Kullanıcı başarıyla onaylandı.",
                    "created": "Kullanıcı başarıyla oluşturuldu.",
                    "deleted": "Kullanıcı başarıyla silindi.",
                    "deleted_permanently": "Kullanıcı kalıcı olarak silindi.",
                    "restored": "Kullanıcı başarıyla geri yüklendi.",
                    "session_cleared": "Kullanıcının oturumu başarıyla temizlendi.",
                    "social_deleted": "Sosyal hesap başarıyla silindi",
                    "unconfirmed": "Kullanıcı onaylanmadı",
                    "updated": "Kullanıcı başarıyla güncellendi.",
                    "updated_password": "Kullanıcının şifresi başarıyla güncellendi."
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Bilgileriniz başarıyla gönderildi. Kısa süre içinde mail adresinizden size dönüş yapacağız."
                }
            }
        },
        "validation": {
            "accepted": "{attribute} kabul edilmelidir.",
            "active_url": "{attribute} geçerli bir URL olmalıdır.",
            "after": "{attribute} değeri, {date} tarihinden daha sonraki bir tarih olmalıdır.",
            "after_or_equal": "{attribute} değeri, {date} tarihinden daha sonraki veya aynı tarih olmalıdır.",
            "alpha": "{attribute} sadece harflerden oluşmalıdır.",
            "alpha_dash": "{attribute} sadece harfler, rakamlar ve tirelerden oluşmalıdır.",
            "alpha_num": "{attribute} sadece harfler ve rakamlar içermelidir.",
            "array": "{attribute} dizi olmalıdır.",
            "before": "{attribute} değeri, {date} tarihinden daha önceki bir tarih olmalıdır.",
            "before_or_equal": "{attribute} değeri, {date} tarihinden daha önceki veya aynı tarih olmalıdır.",
            "between": {
                "numeric": "{attribute} {min} - {max} arasında olmalıdır.",
                "file": "{attribute} {min} - {max} arasındaki kilobayt değeri olmalıdır.",
                "string": "{attribute} {min} - {max} arasında karakterden oluşmalıdır.",
                "array": "{attribute} {min} - {max} arasında nesneye sahip olmalıdır."
            },
            "boolean": "{attribute} alanı sadece doğru veya yanlış olabilir.",
            "confirmed": "{attribute} tekrarı eşleşmiyor.",
            "date": "{attribute} geçerli bir tarih olmalıdır.",
            "date_format": "{attribute} {format} biçimi ile eşleşmiyor.",
            "different": "{attribute} ile {other} birbirinden farklı olmalıdır.",
            "digits": "{attribute} {digits} rakam olmalıdır.",
            "digits_between": "{attribute} {min} ile {max} arasında rakam olmalıdır.",
            "dimensions": "{attribute} geçersiz resim ölçülerine sahiptir.",
            "distinct": "{attribute} alanı tekrarlanan bir değere sahiptir.",
            "email": "{attribute} doğru bir e-posta olmalıdır.",
            "exists": "Seçili olan {attribute} geçersiz.",
            "file": "{attribute} dosya olmalıdır.",
            "filled": "{attribute} alanı bir değer içermelidir.",
            "image": "{attribute} resim dosyası olmalıdır.",
            "in": "{attribute} değeri geçersiz.",
            "in_array": "{attribute} değeri {other} içinde mevcut değil.",
            "integer": "{attribute} rakam olmalıdır.",
            "ip": "{attribute} geçerli bir IP adresi olmalıdır.",
            "ipv4": "{attribute} geçerli bir IPV4 adresi olmalıdır.",
            "ipv6": "{attribute} geçerli bir IPV6 adresi olmalıdır.",
            "json": "{attribute} geçerli bir JSON dizesi olmalıdır.",
            "max": {
                "numeric": "{attribute} değeri {max} değerinden büyük olmamalıdır.",
                "file": "{attribute} değeri {max} kilobayt değerinden büyük olmamalıdır.",
                "string": "{attribute} değeri en fazla {max} karakter uzunluğunda olmalıdır.",
                "array": "{attribute} değeri {max} adedinden fazla nesneye sahip olmamalıdır."
            },
            "mimes": "{attribute} dosya biçimi {values} olmalıdır.",
            "mimetypes": "{attribute} dosya biçimi {values} olmalıdır.",
            "min": {
                "numeric": "{attribute} değeri en az {min} değerinde olmalıdır.",
                "file": "{attribute} değeri en az {min} kilobayt değerinde olmalıdır.",
                "string": "{attribute} değeri en az {min} karakter uzunluğunda olmalıdır.",
                "array": "{attribute} en az {min} nesneye sahip olmalıdır."
            },
            "not_in": "Seçili {attribute} geçersiz.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} rakam olmalıdır.",
            "present": "{attribute} alanı var olmalıdır.",
            "regex": "{attribute} biçimi geçersiz.",
            "required": "{attribute} alanı gereklidir.",
            "required_if": "{attribute} alanı, {other} {value} değerine sahip olduğunda zorunludur.",
            "required_unless": "{attribute} alanı, {other} {values} değerine sahip olmadığında zorunludur.",
            "required_with": "{attribute} alanı {values} varken zorunludur.",
            "required_with_all": "{attribute} alanı {values} varken zorunludur.",
            "required_without": "{attribute} alanı {values} yokken zorunludur.",
            "required_without_all": "{attribute} alanı {values} yokken zorunludur.",
            "same": "{attribute} ile {other} eşleşmelidir.",
            "size": {
                "numeric": "{attribute} {size} olmalıdır.",
                "file": "{attribute} {size} kilobayt olmalıdır.",
                "string": "{attribute} {size} karakter olmalıdır.",
                "array": "{attribute} {size} nesneye sahip olmalıdır."
            },
            "string": "{attribute} karakterlerden oluşmalıdır.",
            "timezone": "{attribute} geçerli bir zaman bölgesi olmalıdır.",
            "unique": "{attribute} daha önceden kayıt edilmiş.",
            "uploaded": "{attribute} yüklenirken hata oluştu.",
            "url": "{attribute} biçimi geçersiz.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "İlişkilendirilmiş Roller",
                            "dependencies": "Bağımlılıklar",
                            "display_name": "Görüntülenen İsim",
                            "group": "Grup",
                            "group_sort": "Grup Sıralama",
                            "groups": {
                                "name": "Grup İsmi"
                            },
                            "name": "İsim",
                            "first_name": "Ad",
                            "last_name": "Soyad",
                            "system": "Sistem"
                        },
                        "roles": {
                            "associated_permissions": "İlişkilendirilmiş Yetkiler",
                            "name": "İsim",
                            "sort": "Sırala"
                        },
                        "users": {
                            "active": "Aktif",
                            "associated_roles": "İlişkilendirilmiş Roller",
                            "confirmed": "Onaylandı",
                            "email": "E-posta Adresi",
                            "name": "İsim",
                            "last_name": "Soyad",
                            "first_name": "Ad",
                            "other_permissions": "Diğer Yetkiler",
                            "password": "Parola",
                            "password_confirmation": "Parola Onayı",
                            "send_confirmation_email": "Onay E-Postası gönder"
                        }
                    }
                },
                "frontend": {
                    "email": "E-posta Adresi",
                    "first_name": "Ad",
                    "last_name": "Soyad",
                    "name": "Full Name",
                    "password": "Parola",
                    "password_confirmation": "Parola Onay",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "Eski Parola",
                    "new_password": "Yeni Parola",
                    "new_password_confirmation": "Yeni Parola Onay"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "Bu rol zaten var. Lütfen farklı bir isim seçin.",
                        "cant_delete_admin": "Yönetici rolünü silemezsiniz.",
                        "create_error": "Bu rolü oluştururken bir sorun oluştu. Lütfen tekrar deneyin.",
                        "delete_error": "Bu rolü silerken bir sorun oluştu. Lütfen tekrar deneyin.",
                        "has_users": "İlişkili kullanıcı içeren bir rolü silemezsiniz.",
                        "needs_permission": "Bu rol için en az bir yetki seçmelisiniz.",
                        "not_found": "Bu rol yok.",
                        "update_error": "Bu rolü güncelleştirirken bir sorun oluştu. Lütfen tekrar deneyin."
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "Kendinize bu işlemi yapamazsınız.",
                        "cant_delete_admin": "Süper yöneticiyi silemezsiniz.",
                        "cant_delete_self": "Kendinizi silemezsiniz.",
                        "cant_delete_own_session": "Kendi oturumunuzu silemezsiniz.",
                        "cant_restore": "Bu kullanıcı silinmediği için geri yüklenemez.",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "Bu kullanıcı oluşturulurken bir sorun oluştu. Lütfen tekrar deneyin.",
                        "delete_error": "Bu kullanıcı silinirken bir sorun oluştu. Lütfen tekrar deneyin.",
                        "delete_first": "Bu kullanıcı kalıcı olarak yokedilmeden önce önce silinmelidir.",
                        "email_error": "Bu e-posta adresi farklı bir kullanıcıya ait.",
                        "mark_error": "Bu kullanıcıyı güncellerken bir sorun oluştu. Lütfen tekrar deneyin.",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "Bu kullanıcı bulunamadı.",
                        "restore_error": "Bu kullanıcı geri yüklenirken bir sorun oluştu. Lütfen tekrar deneyin.",
                        "role_needed_create": "En az bir rol seçmelisiniz.",
                        "role_needed": "En az bir rol seçmelisiniz.",
                        "session_wrong_driver": "Bu özelliği kullanabilmeniz için oturumların veritabanında saklanması gerekir.",
                        "social_delete_error": "There was a problem removing the social account from the user.",
                        "update_error": "Bu kullanıcı güncellenirken bir hata oluştu. Lütfen tekrar deneyin.",
                        "update_password_error": "Bu kullanıcının şifresini değiştirirken bir sorun oluştu. Lütfen tekrar deneyin."
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "Hesabınız zaten doğrulanmış.",
                        "confirm": "Hesabınızı onaylayın!",
                        "created_confirm": "Hesabınız başarıyla oluşturuldu. Hesabınızı onaylamak için size bir e-posta gönderdik.",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "Onay kodunuz uyuşmuyor.",
                        "not_found": "Onay kodu mevcut değil.",
                        "pending": "Your account is currently pending approval.",
                        "resend": "Hesabınız doğrulanmadı. Lütfen e-postanızdaki onay bağlantısını tıklayın veya onay e-postasını yeniden göndermek için <a href=\"{url}\">buraya tıklayın</a>",
                        "success": "Hesabınız başarıyla onaylandı!",
                        "resent": "Kayıtlı e-posta adresine yeni bir onay e-postası gönderildi."
                    },
                    "deactivated": "Hesabınız devreden çıkarıldı.",
                    "email_taken": "Bu e-posta adresi zaten alınmış.",
                    "password": {
                        "change_mismatch": "Bu şifre eski şifrenizle uyuşmuyor.",
                        "reset_problem": "Şifrenizi sıfırlarken bir sorun oluştu. Lütfen şifre sıfırlama e-postasını tekrar gönderin."
                    },
                    "registration_disabled": "Kayıt şu anda kapalıdır."
                }
            }
        },
        "pagination": {
            "previous": "&laquo; Önceki",
            "next": "Sonraki &raquo;"
        },
        "roles": {
            "administrator": "Yönetici",
            "user": "Kullanıcı"
        },
        "navs": {
            "general": {
                "home": "Anasayfa",
                "logout": "Çıkış"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "Kokpit",
                "login": "Giriş",
                "macros": "Makrolar",
                "register": "Kayıt",
                "user": {
                    "account": "Hesabım",
                    "administration": "Yönetim",
                    "change_password": "Parolayı Değiştir",
                    "my_information": "Bilgilerim",
                    "profile": "Profil"
                }
            }
        }
    },
    "zh": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "您确定要永久删除此用户吗？引用此用户ID的应用程序中的任何地方都很可能是错误。继续自行承担风险。这不能被撤消。",
                        "if_confirmed_off": "(已确认则无效)",
                        "restore_user_confirm": "将此用户恢复到其原始状态？"
                    }
                },
                "dashboard": {
                    "title": "管理仪表板",
                    "welcome": "欢迎"
                },
                "general": {
                    "all_rights_reserved": "保留所有权利。",
                    "are_you_sure": "你确定这样做吗？",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "继续",
                    "member_since": "会员自",
                    "minutes": " 分钟",
                    "search_placeholder": "搜索...",
                    "timeout": "出于安全原因已自动注销，因为你没有操作超过 ",
                    "see_all": {
                        "messages": "查看所有消息",
                        "notifications": "查看所有提醒",
                        "tasks": "查看所有任务"
                    },
                    "status": {
                        "online": "在线",
                        "offline": "离线"
                    },
                    "you_have": {
                        "messages": "{0} 你没有消息 ::: {1} 你有 1 条消息 ::: [2,Inf] 你有 {number} 条消息",
                        "notifications": "{0} 你没有提醒 ::: {1} 你有 1 条提醒 ::: [2,Inf] 你有 {number} 条提醒",
                        "tasks": "{0} 你没有任务 ::: {1} 你有 1 个任务 ::: [2,Inf] 你有 {number} 个任务"
                    }
                },
                "search": {
                    "empty": "请输入搜索关键词。",
                    "incomplete": "您必须为此系统编写您自己的搜索逻辑。",
                    "title": "搜索结果",
                    "results": "搜索 {query} 的结果"
                },
                "welcome": "<p>这是 AdminLTE 模板 <a href=\"https://almsaeedstudio.com/\" target=\"_blank\">https://almsaeedstudio.com/</a>. 这是精简版，仅包含必要的样式和脚本，请下载完整版本来开始添加元素到你的控制面板。</p>\n<p>\n    所有功能为在左边显示<strong>访问管理</strong>错误。本样板包含完整的用户/角色/权限 访问控制库\n</p>\n<p>请留意，本样板仍在开发中，可能仍有一些没有顾忌的错误或者问题，我会尽我全力在接到错误报告后修复它们。\n</p>\n<p>希望你喜欢我的工作，请访问 <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> 获取更多信息，并 <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">在此提交issue</a>.</p>\n<p><strong>本项目非常苛刻地与Laravel mater分支的更新频率同步， 所以感谢所有人给予的任何帮助.\n</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "你的账户已经被确认",
                    "error": "哎呀！",
                    "greeting": "你好！",
                    "regards": "问候,",
                    "trouble_clicking_button": "如果您在点击 \"{action_text}\" 按钮时遇到问题, 请将以下网址复制并粘贴到您的网络浏览器中:",
                    "thank_you_for_using_app": "谢谢您使用我们的应用程序！",
                    "password_reset_subject": "重置密码",
                    "password_cause_of_email": "您收到此电子邮件是因为我们收到了您帐户的密码重设请求",
                    "password_if_not_requested": "如果您没有请求重置密码，则无需进一步操作",
                    "reset_password": "点击这里重置密码",
                    "click_to_confirm": "点击此处确认您的帐户:"
                },
                "contact": {
                    "email_body_title": "你有一个新的联系请求， 详情如下：",
                    "subject": "一个新提交的 {app_name} 联系请求"
                }
            },
            "frontend": {
                "test": "测试",
                "tests": {
                    "based_on": {
                        "permission": "基于权限 - ",
                        "role": "基于角色 - "
                    },
                    "js_injected_from_controller": "从控制器注入的Javascript",
                    "using_blade_extensions": "使用Blade扩展",
                    "using_access_helper": {
                        "array_permissions": "访问控制-用户拥有的权限Name或权限ID数组必须完全匹配.",
                        "array_permissions_not": "访问控制-用户拥有的权限Name或权限ID数组不必完全匹配",
                        "array_roles": "访问控制-用户拥有的角色Name或角色ID数组必须完全匹配",
                        "array_roles_not": "访问控制-用户拥有的角色Name或角色ID数组不必完全匹配",
                        "permission_id": "访问控制-用户拥有指定权限ID",
                        "permission_name": "访问控制-用户拥有指定权限Name",
                        "role_id": "访问控制-用户拥有指定角色ID",
                        "role_name": "访问控制-用户拥有指定角色Name"
                    },
                    "view_console_it_works": "检查 console, 你应该看到来自 FrontendController@index 的 'it works!' ",
                    "you_can_see_because": "看到这条信息是因为你拥有角色 '{role}'!",
                    "you_can_see_because_permission": "看条这条信息是因为你拥有权限 '{permission}'!"
                },
                "general": {
                    "joined": "加入"
                },
                "user": {
                    "change_email_notice": "如果你更改你的邮件地址，你会被登出系统直到你确认你的新邮件地址。",
                    "email_changed_notice": "在登录之前，你必须确认你的新邮件地址。",
                    "profile_updated": "个人资料更新成功。",
                    "password_updated": "密码修改成功。"
                },
                "welcome_to": "欢迎来到 {place}"
            }
        },
        "auth": {
            "failed": "用户名或密码错误。",
            "general_error": "你没有权限执行此操作。",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} 不是可接受的登录类型。"
            },
            "throttle": "尝试登录次数过多. 请 {seconds} 秒后再试。",
            "unknown": "未知错误"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "权限管理",
                    "roles": {
                        "all": "所有角色",
                        "create": "新建角色",
                        "edit": "编辑角色",
                        "management": "角色管理",
                        "main": "角色"
                    },
                    "users": {
                        "all": "所有用户",
                        "change-password": "更改密码",
                        "create": "新建用户",
                        "deactivated": "未激活的用户",
                        "deleted": "已删除的用户",
                        "edit": "编辑用户",
                        "main": "用户",
                        "view": "查看用户"
                    }
                },
                "log-viewer": {
                    "main": "日志查看器",
                    "dashboard": "指示板",
                    "logs": "日志"
                },
                "sidebar": {
                    "dashboard": "指示板",
                    "general": "常规",
                    "system": "系统"
                }
            },
            "language-picker": {
                "language": "语言",
                "langs": {
                    "ar": "阿拉伯语（Arabic）",
                    "zh": "中文-简体（Chinese Simplified）",
                    "zh-TW": "中文-繁体（Chinese Traditional）",
                    "da": "丹麦语（Danish）",
                    "de": "德语（German）",
                    "el": "希腊语（Greek）",
                    "en": "英语（English）",
                    "es": "西班牙语（Spanish）",
                    "fa": "波斯语 (Persian)",
                    "fr": "法语（French）",
                    "he": "希伯来语 (Hebrew)",
                    "id": "印度尼西亚语（Indonesian）",
                    "it": "意大利语（Italian）",
                    "ja": "日语（Japanese）",
                    "nl": "荷兰语（Dutch）",
                    "pt_BR": "巴西葡萄牙语（Brazilian Portuguese）",
                    "ru": "俄语（Russian）",
                    "sv": "瑞典语（Swedish）",
                    "th": "泰语（Thai）",
                    "tr": "土耳其语(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "激活",
                        "change_password": "更改密码",
                        "clear_session": "清除会话",
                        "confirm": "确认",
                        "deactivate": "停用",
                        "delete_permanently": "永久删除",
                        "login_as": "登录为 {user}",
                        "resend_email": "重新发送确认电子邮件",
                        "restore_user": "恢复用户",
                        "unconfirm": "取消确认",
                        "unlink": "取消链接"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "确认帐户",
                    "reset_password": "重置密码"
                }
            },
            "general": {
                "cancel": "取消",
                "continue": "继续",
                "crud": {
                    "create": "创建",
                    "delete": "删除",
                    "edit": "编辑",
                    "update": "更新",
                    "view": "查看"
                },
                "save": "保存",
                "view": "查看"
            }
        },
        "passwords": {
            "password": "密码至少是六位字符并且匹配。",
            "reset": "密码重置成功！",
            "sent": "密码重置邮件已发送！",
            "token": "密码重置令牌无效。",
            "user": "找不到该邮箱对应的用户。"
        },
        "http": {
            "404": {
                "title": "页面未找到",
                "description": "抱歉，您试图访问的页面不存在。"
            },
            "503": {
                "title": "马上回来。",
                "description": "马上回来。"
            }
        },
        "labels": {
            "general": {
                "all": "全部",
                "yes": "是",
                "no": "否",
                "custom": "自定义",
                "actions": "操作",
                "active": "激活",
                "buttons": {
                    "save": "保存",
                    "update": "更新"
                },
                "hide": "隐藏",
                "inactive": "禁用",
                "none": "空",
                "show": "显示",
                "toggle_navigation": "切换导航"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "新建角色",
                        "edit": "编辑角色",
                        "management": "角色管理",
                        "table": {
                            "number_of_users": "用户数",
                            "permissions": "权限",
                            "role": "角色",
                            "sort": "排序",
                            "total": "角色总计"
                        }
                    },
                    "users": {
                        "active": "激活用户",
                        "all_permissions": "所有权限",
                        "change_password": "更改密码",
                        "change_password_for": "为 {user} 更改密码",
                        "create": "新建用户",
                        "deactivated": "已停用的用户",
                        "deleted": "已删除的用户",
                        "edit": "编辑用户",
                        "management": "用户管理",
                        "no_permissions": "没有权限",
                        "no_roles": "没有角色可设置",
                        "permissions": "权限",
                        "table": {
                            "confirmed": "确认",
                            "created": "创建",
                            "email": "电子邮件",
                            "id": "ID",
                            "last_updated": "最后更新",
                            "name": "名称",
                            "no_deactivated": "没有停用的用户",
                            "no_deleted": "没有删除的用户",
                            "roles": "角色",
                            "social": "Social",
                            "total": "用户总计"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "概述",
                                "history": "历史"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "头像",
                                    "confirmed": "已确认",
                                    "created_at": "创建于",
                                    "deleted_at": "删除于",
                                    "email": "电子邮件",
                                    "last_updated": "最后更新",
                                    "name": "名称",
                                    "status": "状态"
                                }
                            }
                        },
                        "view": "查看用户"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "登录",
                    "login_button": "登录",
                    "login_with": "使用 {social_media} 登录",
                    "register_box_title": "注册",
                    "register_button": "注册",
                    "remember_me": "记住我"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "忘记密码了？",
                    "reset_password_box_title": "重置密码",
                    "reset_password_button": "重置密码",
                    "send_password_reset_link_button": "发送密码重置链接"
                },
                "macros": {
                    "country": {
                        "alpha": "Country Alpha Codes",
                        "alpha2": "Country Alpha 2 Codes",
                        "alpha3": "Country Alpha 3 Codes",
                        "numeric": "Country Numeric Codes"
                    },
                    "macro_examples": "Macro Examples",
                    "state": {
                        "mexico": "Mexico State List",
                        "us": {
                            "us": "US States",
                            "outlying": "US Outlying Territories",
                            "armed": "US Armed Forces"
                        }
                    },
                    "territories": {
                        "canada": "Canada Province & Territories List"
                    },
                    "timezone": "时区"
                },
                "user": {
                    "passwords": {
                        "change": "更改密码"
                    },
                    "profile": {
                        "avatar": "头像",
                        "created_at": "创建于",
                        "edit_information": "编辑信息",
                        "email": "电子邮件",
                        "last_updated": "最后更新",
                        "name": "名称",
                        "update_information": "更新信息"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "角色已成功创建。",
                    "deleted": "角色已成功删除。",
                    "updated": "角色已成功更新。"
                },
                "users": {
                    "cant_resend_confirmation": "系统已经设置为手动审核用户模式。",
                    "confirmation_email": "新的确认电子邮件已发送到文件上的地址。",
                    "confirmed": "用户已成功确认。",
                    "created": "用户已成功创建。",
                    "deleted": "用户已成功删除。",
                    "deleted_permanently": "用户被永久删除。",
                    "restored": "用户已成功还原。",
                    "session_cleared": "用户会话已成功清除。",
                    "social_deleted": "成功移除社交账号。",
                    "unconfirmed": "用户已被取消确认。",
                    "updated": "用户已成功更新。",
                    "updated_password": "用户密码已成功更新。"
                }
            },
            "frontend": {
                "contact": {
                    "sent": "您的信息已经成功提交！ 我们会尽快回复到您提供的电子邮箱。"
                }
            }
        },
        "validation": {
            "accepted": "{attribute} 必须接受。",
            "active_url": "{attribute} 不是一个有效的网址。",
            "after": "{attribute} 必须要晚于 {date}。",
            "after_or_equal": "{attribute} 必须要等于 {date} 或更晚。",
            "alpha": "{attribute} 只能由字母组成。",
            "alpha_dash": "{attribute} 只能由字母、数字和斜杠组成。",
            "alpha_num": "{attribute} 只能由字母和数字组成。",
            "array": "{attribute} 必须是一个数组。",
            "before": "{attribute} 必须要早于 {date}。",
            "before_or_equal": "{attribute} 必须要等于 {date} 或更早。",
            "between": {
                "numeric": "{attribute} 必须介于 {min} - {max} 之间。",
                "file": "{attribute} 必须介于 {min} - {max} kb 之间。",
                "string": "{attribute} 必须介于 {min} - {max} 个字符之间。",
                "array": "{attribute} 必须只有 {min} - {max} 个单元。"
            },
            "boolean": "{attribute} 必须为布尔值。",
            "confirmed": "{attribute} 两次输入不一致。",
            "date": "{attribute} 不是一个有效的日期。",
            "date_format": "{attribute} 的格式必须为 {format}。",
            "different": "{attribute} 和 {other} 必须不同。",
            "digits": "{attribute} 必须是 {digits} 位的数字。",
            "digits_between": "{attribute} 必须是介于 {min} 和 {max} 位的数字。",
            "dimensions": "{attribute} 图片尺寸不正确。",
            "distinct": "{attribute} 已经存在。",
            "email": "{attribute} 不是一个合法的邮箱。",
            "exists": "{attribute} 不存在。",
            "file": "{attribute} 必须是文件。",
            "filled": "{attribute} 不能为空。",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} 必须是图片。",
            "in": "已选的属性 {attribute} 非法。",
            "in_array": "{attribute} 没有在 {other} 中。",
            "integer": "{attribute} 必须是整数。",
            "ip": "{attribute} 必须是有效的 IP 地址。",
            "ipv4": "{attribute} 必须是合法的 IPv4 地址.",
            "ipv6": "{attribute} 必须是合法的 IPv6 地址.",
            "json": "{attribute} 必须是正确的 JSON 格式。",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} 不能大于 {max}。",
                "file": "{attribute} 不能大于 {max} kb。",
                "string": "{attribute} 不能大于 {max} 个字符。",
                "array": "{attribute} 最多只有 {max} 个单元。"
            },
            "mimes": "{attribute} 必须是一个 {values} 类型的文件。",
            "mimetypes": "{attribute} 必须是一个 {values} 类型的文件。",
            "min": {
                "numeric": "{attribute} 必须大于等于 {min}。",
                "file": "{attribute} 大小不能小于 {min} kb。",
                "string": "{attribute} 至少为 {min} 个字符。",
                "array": "{attribute} 至少有 {min} 个单元。"
            },
            "not_in": "已选的属性 {attribute} 非法。",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} 必须是一个数字。",
            "present": "{attribute} 必须存在。",
            "regex": "{attribute} 格式不正确。",
            "required": "{attribute} 不能为空。",
            "required_if": "当 {other} 为 {value} 时 {attribute} 不能为空。",
            "required_unless": "当 {other} 不为 {value} 时 {attribute} 不能为空。",
            "required_with": "当 {values} 存在时 {attribute} 不能为空。",
            "required_with_all": "当 {values} 存在时 {attribute} 不能为空。",
            "required_without": "当 {values} 不存在时 {attribute} 不能为空。",
            "required_without_all": "当 {values} 都不存在时 {attribute} 不能为空。",
            "same": "{attribute} 和 {other} 必须相同。",
            "size": {
                "numeric": "{attribute} 大小必须为 {size}。",
                "file": "{attribute} 大小必须为 {size} kb。",
                "string": "{attribute} 必须是 {size} 个字符。",
                "array": "{attribute} 必须为 {size} 个单元。"
            },
            "string": "{attribute} 必须是一个字符串。",
            "timezone": "{attribute} 必须是一个合法的时区值。",
            "unique": "{attribute} 已经存在。",
            "uploaded": "{attribute} 上传失败。",
            "url": "{attribute} 格式不正确。",
            "custom": {
                "attribute-name": {
                    "rule-name": "定制信息"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "关联的角色",
                            "dependencies": "依赖关系",
                            "display_name": "显示名称",
                            "group": "群组",
                            "group_sort": "组排序",
                            "groups": {
                                "name": "组名称"
                            },
                            "name": "名称",
                            "system": "系统?"
                        },
                        "roles": {
                            "associated_permissions": "关联的权限",
                            "name": "名称",
                            "sort": "排序"
                        },
                        "users": {
                            "active": "激活",
                            "associated_roles": "关联的角色",
                            "confirmed": "已确认",
                            "email": "电子邮件地址",
                            "name": "名称",
                            "other_permissions": "其他权限",
                            "password": "密码",
                            "password_confirmation": "确认密码",
                            "send_confirmation_email": "发送确认电子邮件"
                        }
                    }
                },
                "frontend": {
                    "email": "电子邮件",
                    "name": "用户名",
                    "password": "密码",
                    "password_confirmation": "确认密码",
                    "phone": "电话",
                    "message": "消息",
                    "old_password": "旧密码",
                    "new_password": "新密码",
                    "new_password_confirmation": "确认新密码"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "该角色已存在。请选择其他名称。",
                        "cant_delete_admin": "您无法删除管理员角色。",
                        "create_error": "创建此角色时出现问题。请再试一次。",
                        "delete_error": "删除此角色时出现问题。请再试一次。",
                        "has_users": "您无法删除已关联用户的角色。",
                        "needs_permission": "您必须为此角色至少选择一个权限。",
                        "not_found": "该角色不存在。",
                        "update_error": "更新此角色时出现问题。请再试一次。"
                    },
                    "users": {
                        "already_confirmed": "用户已经确认过了。",
                        "cant_confirm": "确认用户过程中出现问题。",
                        "cant_deactivate_self": "你不能停用自己。",
                        "cant_delete_admin": "你不能删除超级管理员。",
                        "cant_delete_self": "你不能删除自己",
                        "cant_delete_own_session": "你不能删除自己的会话",
                        "cant_restore": "此用户未删除，因此无法恢复。",
                        "cant_unconfirm_admin": "你不能取消超级用户的确认。",
                        "cant_unconfirm_self": "你不能取消自己的确认。",
                        "create_error": "创建此用户时出现问题。请再试一次。",
                        "delete_error": "删除此用户时出现问题。请再试一次。",
                        "delete_first": "此用户必须先删除，才能永久销毁。",
                        "email_error": "该电子邮件地址已被其它用户使用。",
                        "mark_error": "更新此用户时出现问题。请再试一次。",
                        "not_confirmed": "用户未确认。",
                        "not_found": "该用户不存在。",
                        "restore_error": "还原此用户时出现问题。请再试一次。",
                        "role_needed_create": "你必须选择至少一个角色。",
                        "role_needed": "你必须选择至少一个角色。",
                        "session_wrong_driver": "你必须将会话驱动设置为database才能使用该功能。",
                        "social_delete_error": "删除社交网络用户时出现问题。",
                        "update_error": "更新此用户时出现问题。请再试一次。",
                        "update_password_error": "更改此用户密码时出现问题。请再试一次。"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "您的帐户已确认。",
                        "confirm": "确认您的帐户！",
                        "created_confirm": "您的帐户已成功创建。我们已向您发送电子邮件以确认您的帐户。",
                        "created_pending": "你的账户已经成功创建，并等待处理。 账户成功处理后会发送电子邮件确认。",
                        "mismatch": "您的确认码不匹配。",
                        "not_found": "该确认码不存在。",
                        "pending": "您的账户正在等待处理",
                        "resend": "您的帐户未确认。请点击您的电子邮件中的确认链接，或 <a href=\"{url}\">点击此处</a> 重新发送确认电子邮件。",
                        "success": "您的帐户已成功确认！",
                        "resent": "新的确认电子邮件已发送到文件上的地址。"
                    },
                    "deactivated": "您的帐户已被停用。",
                    "email_taken": "该电子邮件地址已被占用。",
                    "password": {
                        "change_mismatch": "这不是你的旧密码。",
                        "reset_problem": "重置密码过程中出现错误。请重新发送密码重置邮件。"
                    },
                    "registration_disabled": "注册目前已关闭。"
                }
            }
        },
        "pagination": {
            "previous": "&laquo; 上一页",
            "next": "下一页 &raquo;"
        },
        "roles": {
            "administrator": "管理员",
            "user": "用户"
        },
        "navs": {
            "general": {
                "home": "首页",
                "logout": "退出"
            },
            "frontend": {
                "contact": "联系",
                "dashboard": "指示板",
                "login": "登录",
                "macros": "宏",
                "register": "注册",
                "user": {
                    "account": "我的账户",
                    "administration": "管理",
                    "change_password": "更改密码",
                    "my_information": "我的信息",
                    "profile": "个人资料"
                }
            }
        }
    },
    "zh-TW": {
        "strings": {
            "backend": {
                "access": {
                    "users": {
                        "delete_user_confirm": "您確定要永久刪除此用戶嗎？引用此用戶ID的應用程序中的任何地方都很可能是錯誤。繼續自行承擔風險。這不能被撤消。 ",
                        "if_confirmed_off": "(確認關閉)",
                        "restore_user_confirm": "將此用戶恢復到其原始狀態？ "
                    }
                },
                "dashboard": {
                    "title": "管理儀表板",
                    "welcome": "歡迎"
                },
                "general": {
                    "all_rights_reserved": "保留所有權利。 ",
                    "are_you_sure": "你確定嗎？ ",
                    "boilerplate_link": "Laravel 5 Boilerplate",
                    "continue": "繼續",
                    "member_since": "會員自",
                    "minutes": " 分鐘",
                    "search_placeholder": "搜索...",
                    "timeout": "您因為沒有活動而被自動註銷為了安全原因",
                    "see_all": {
                        "messages": "查看所有郵件",
                        "notifications": "查看全部",
                        "tasks": "查看所有任務"
                    },
                    "status": {
                        "online": "在線",
                        "offline": "離線"
                    },
                    "you_have": {
                        "messages": "{0} 您沒有消息 ::: {1} 您有1個消息 ::: [2,Inf] 您有 {number} 個消息",
                        "notifications": "{0} 您沒有通知 ::: {1} 您有1個通知 ::: [2,Inf] 您有 {number} 個通知",
                        "tasks": "{0} 你沒有任務 ::: {1} 你有1個任務 ::: [2,Inf] 你有 {number} 個任務"
                    }
                },
                "search": {
                    "empty": "請輸入搜索字詞。 ",
                    "incomplete": "您必須為此系統編寫您自己的搜索邏輯。 ",
                    "title": "搜索結果",
                    "results": "搜索結果 {query}"
                },
                "welcome": "<p>This is the CoreUI theme by <a href=\"https://coreui.io/\" target=\"_blank\">creativeLabs</a>. This is a stripped down version with only the necessary styles and scripts to get it running. Download the full version to start adding components to your dashboard.</p>\n<p>All the functionality is for show with the exception of the <strong>Access</strong> to the left. This boilerplate comes with a fully functional access control library to manage users/roles/permissions.</p>\n<p>Keep in mind it is a work in progress and their may be bugs or other issues I have not come across. I will do my best to fix them as I receive them.</p>\n<p>Hope you enjoy all of the work I have put into this. Please visit the <a href=\"https://github.com/rappasoft/laravel-5-boilerplate\" target=\"_blank\">GitHub</a> page for more information and report any <a href=\"https://github.com/rappasoft/Laravel-5-Boilerplate/issues\" target=\"_blank\">issues here</a>.</p>\n<p><strong>This project is very demanding to keep up with given the rate at which the master Laravel branch changes, so any help is appreciated.</strong></p>\n<p>- Anthony Rappa</p>"
            },
            "emails": {
                "auth": {
                    "account_confirmed": "Your account has been confirmed.",
                    "error": "Whoops!",
                    "greeting": "你好!",
                    "regards": "問候,",
                    "trouble_clicking_button": "如果您在點擊 \"{action_text}\" 按鈕時遇到問題, 請將以下網址複製並粘貼到您的網絡瀏覽器中:",
                    "thank_you_for_using_app": "謝謝您使用我們的應用程序！ ",
                    "password_reset_subject": "重置密碼",
                    "password_cause_of_email": "您收到此電子郵件是因為我們收到了您帳戶的密碼重設要求",
                    "password_if_not_requested": "如果您沒有請求重置密碼，則無需進一步操作",
                    "reset_password": "點擊這裡重置密碼",
                    "click_to_confirm": "點擊此處確認您的帳戶:"
                },
                "contact": {
                    "email_body_title": "You have a new contact form request: Below are the details:",
                    "subject": "A new {app_name} contact form submission!"
                }
            },
            "frontend": {
                "test": "Test",
                "tests": {
                    "based_on": {
                        "permission": "Permission Based - ",
                        "role": "Role Based - "
                    },
                    "js_injected_from_controller": "Javascript Injected from a Controller",
                    "using_blade_extensions": "Using Blade Extensions",
                    "using_access_helper": {
                        "array_permissions": "Using Access Helper with Array of Permission Names or ID's where the user does have to possess all.",
                        "array_permissions_not": "Using Access Helper with Array of Permission Names or ID's where the user does not have to possess all.",
                        "array_roles": "Using Access Helper with Array of Role Names or ID's where the user does have to possess all.",
                        "array_roles_not": "Using Access Helper with Array of Role Names or ID's where the user does not have to possess all.",
                        "permission_id": "Using Access Helper with Permission ID",
                        "permission_name": "Using Access Helper with Permission Name",
                        "role_id": "Using Access Helper with Role ID",
                        "role_name": "Using Access Helper with Role Name"
                    },
                    "view_console_it_works": "View console, you should see 'it works!' which is coming from FrontendController@index",
                    "you_can_see_because": "You can see this because you have the role of '{role}'!",
                    "you_can_see_because_permission": "You can see this because you have the permission of '{permission}'!"
                },
                "general": {
                    "joined": "Joined"
                },
                "user": {
                    "change_email_notice": "If you change your e-mail you will be logged out until you confirm your new e-mail address.",
                    "email_changed_notice": "You must confirm your new e-mail address before you can log in again.",
                    "profile_updated": "Profile successfully updated.",
                    "password_updated": "Password successfully updated."
                },
                "welcome_to": "Welcome to {place}"
            }
        },
        "auth": {
            "failed": "賬戶不存在，請重新輸入。 ",
            "general_error": "沒有操作權限。 ",
            "password_used": "You can not set a password that you have previously used.",
            "socialite": {
                "unacceptable": "{provider} 的登錄方式失敗。 "
            },
            "throttle": "登錄失敗次數過多。請在 {seconds} 秒後重試。 ",
            "unknown": "出現未知錯誤"
        },
        "menus": {
            "backend": {
                "access": {
                    "title": "Access",
                    "roles": {
                        "all": "All Roles",
                        "create": "Create Role",
                        "edit": "Edit Role",
                        "management": "Role Management",
                        "main": "Roles"
                    },
                    "users": {
                        "all": "All Users",
                        "change-password": "Change Password",
                        "create": "Create User",
                        "deactivated": "Deactivated Users",
                        "deleted": "Deleted Users",
                        "edit": "Edit User",
                        "main": "Users",
                        "view": "View User"
                    }
                },
                "log-viewer": {
                    "main": "Log Viewer",
                    "dashboard": "Dashboard",
                    "logs": "Logs"
                },
                "sidebar": {
                    "dashboard": "Dashboard",
                    "general": "General",
                    "system": "System"
                }
            },
            "language-picker": {
                "language": "語言",
                "langs": {
                    "ar": "(Arabic)",
                    "zh": "中文（Chinese Simplified）",
                    "zh-TW": "中文（Chinese Traditional）",
                    "da": "丹麥語（Danish）",
                    "de": "德語（German）",
                    "el": "希臘語（Greek）",
                    "en": "英語（English）",
                    "es": "西班牙語（Spanish）",
                    "fa": "波斯語 (Persian) ",
                    "fr": "法語（French）",
                    "he": "希伯來語 (Hebrew)",
                    "id": "印度尼西亞語（Indonesian）",
                    "it": "意大利語（Italian）",
                    "ja": "日語（Japanese）",
                    "nl": "荷蘭語（Dutch）",
                    "no": "挪威 (Norwegian)",
                    "pt_BR": "巴西葡萄牙語（Brazilian Portuguese）",
                    "ru": "俄語（Russian）",
                    "sv": "瑞典語（Swedish）",
                    "th": "泰語（Thai）",
                    "tr": "(Turkish)"
                }
            }
        },
        "buttons": {
            "backend": {
                "access": {
                    "users": {
                        "activate": "激活",
                        "change_password": "更改密碼",
                        "deactivate": "停用",
                        "delete_permanently": "永久刪除",
                        "login_as": "Login As {user}",
                        "resend_email": "重新發送確認電子郵件",
                        "restore_user": "還原用戶",
                        "unconfirm": "Un-confirm",
                        "unlink": "Unlink"
                    }
                }
            },
            "emails": {
                "auth": {
                    "confirm_account": "確認帳戶",
                    "reset_password": "重置密碼"
                }
            },
            "general": {
                "cancel": "取消",
                "crud": {
                    "create": "創建",
                    "delete": "刪除",
                    "edit": "編輯",
                    "update": "更新",
                    "view": "查看"
                },
                "save": "保存",
                "view": "查看"
            }
        },
        "passwords": {
            "password": "密碼必須至少為六個字符，並與確認相匹配。 ",
            "reset": "您的密碼已重置！ ",
            "sent": "我們已通過電子郵件發送您的密碼重置鏈接！ ",
            "token": "此密碼重置令牌無效。 ",
            "user": "我們找不到具有該電子郵件地址的用戶"
        },
        "http": {
            "404": {
                "title": "找不到頁面",
                "description": "抱歉，您嘗試查看的頁面不存在。 "
            },
            "503": {
                "title": "馬上回來。 ",
                "description": "馬上回來。 "
            }
        },
        "labels": {
            "general": {
                "all": "全部",
                "yes": "是",
                "no": "否",
                "custom": "自定義",
                "actions": "動作",
                "active": "活動",
                "buttons": {
                    "save": "保存",
                    "update": "更新"
                },
                "hide": "隱藏",
                "inactive": "非活動",
                "none": "無",
                "show": "顯示",
                "toggle_navigation": "切換導航"
            },
            "backend": {
                "access": {
                    "roles": {
                        "create": "創建角色",
                        "edit": "編輯角色",
                        "management": "角色管理",
                        "table": {
                            "number_of_users": "用戶數",
                            "permissions": "權限",
                            "role": "角色",
                            "sort": "排序",
                            "total": "角色總數 ::: 角色總數"
                        }
                    },
                    "users": {
                        "active": "活動用戶",
                        "all_permissions": "所有權限",
                        "change_password": "更改密碼",
                        "change_password_for": "更改密碼 {user}",
                        "create": "已刪除的用戶",
                        "deactivated": "已停用的用戶",
                        "deleted": "已刪除的用戶",
                        "edit": "編輯用戶",
                        "management": "用戶管理",
                        "no_permissions": "無權限",
                        "no_roles": "無角色",
                        "permissions": "權限",
                        "table": {
                            "confirmed": "確認",
                            "created": "創建",
                            "email": "電子郵件",
                            "id": "ID",
                            "last_updated": "最後更新",
                            "name": "名稱",
                            "no_deactivated": "沒有停用的用戶",
                            "no_deleted": "未刪除用戶",
                            "roles": "角色",
                            "social": "Social",
                            "total": "用戶總計 ::: 用戶總計"
                        },
                        "tabs": {
                            "titles": {
                                "overview": "概述",
                                "history": "歷史"
                            },
                            "content": {
                                "overview": {
                                    "avatar": "頭像",
                                    "confirmed": "已確認",
                                    "created_at": "創建於",
                                    "deleted_at": "已刪除",
                                    "email": "電子郵件",
                                    "last_updated": "最後更新",
                                    "name": "名稱",
                                    "status": "狀態"
                                }
                            }
                        },
                        "view": "查看用戶"
                    }
                }
            },
            "frontend": {
                "auth": {
                    "login_box_title": "登錄",
                    "login_button": "登錄",
                    "login_with": "使用 {social_media} 登錄",
                    "register_box_title": "註冊",
                    "register_button": "註冊",
                    "remember_me": "記住我"
                },
                "contact": {
                    "box_title": "Contact Us",
                    "button": "Send Information"
                },
                "passwords": {
                    "forgot_password": "忘記密碼？ ",
                    "reset_password_box_title": "重置密碼",
                    "reset_password_button": "重置密碼",
                    "send_password_reset_link_button": "發送密碼重置鏈接"
                },
                "user": {
                    "passwords": {
                        "change": "更改密碼"
                    },
                    "profile": {
                        "avatar": "頭像",
                        "created_at": "創建於",
                        "edit_information": "編輯信息",
                        "email": "電子郵件",
                        "last_updated": "最後更新",
                        "name": "名稱",
                        "update_information": "更新信息"
                    }
                }
            }
        },
        "alerts": {
            "backend": {
                "roles": {
                    "created": "角色已成功創建。 ",
                    "deleted": "角色已成功刪除。 ",
                    "updated": "角色已成功更新。 "
                },
                "users": {
                    "cant_resend_confirmation": "The application is currently set to manually approve users.",
                    "confirmation_email": "新的確認電子郵件已發送到文件上的地址。 ",
                    "confirmed": "The user was successfully confirmed.",
                    "created": "用戶已成功創建。 ",
                    "deleted": "用戶已成功刪除。 ",
                    "deleted_permanently": "用戶被永久刪除。 ",
                    "restored": "用戶已成功還原。 ",
                    "updated": "用戶已成功更新。 ",
                    "updated_pa​​ssword": "用戶密碼已成功更新。"
                }
            },
            "frontend": {
                "contact": {
                    "sent": "Your information was successfully sent. We will respond back to the e-mail provided as soon as we can."
                }
            }
        },
        "validation": {
            "accepted": "必須接受 {attribute}。",
            "active_url": "{attribute} 並非一個有效的網址。",
            "after": "{attribute} 必須要晚於 {date}。",
            "after_or_equal": "{attribute} 必須要等於 {date} 或更晚",
            "alpha": "{attribute} 只能以字母組成。",
            "alpha_dash": "{attribute} 只能以字母、數字及斜線組成。",
            "alpha_num": "{attribute} 只能以字母及數字組成。",
            "array": "{attribute} 必須為陣列。",
            "before": "{attribute} 必須要早於 {date}。",
            "before_or_equal": "{attribute} 必須要等於 {date} 或更早。",
            "between": {
                "numeric": "{attribute} 必須介於 {min} 至 {max} 之間。",
                "file": "{attribute} 必須介於 {min} 至 {max} kb 之間。 ",
                "string": "{attribute} 必須介於 {min} 至 {max} 個字元之間。",
                "array": "{attribute}: 必須有 {min} - {max} 個元素。"
            },
            "boolean": "{attribute} 必須為bool值。",
            "confirmed": "{attribute} 確認欄位的輸入不一致。",
            "date": "{attribute} 並非一個有效的日期。",
            "date_format": "{attribute} 不符合 {format} 的格式。",
            "different": "{attribute} 與 {other} 必須不同。",
            "digits": "{attribute} 必須是 {digits} 位數字。",
            "digits_between": "{attribute} 必須介於 {min} 至 {max} 位數字。",
            "dimensions": "{attribute} 圖片尺寸不正確。",
            "distinct": "{attribute} 已經存在。",
            "email": "{attribute} 必須是有效的電子郵件地址。",
            "exists": "所選擇的 {attribute} 選項無效。",
            "file": "{attribute} 必須是一個檔案。",
            "filled": "{attribute} 不能留空。",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "{attribute} 必須是一張圖片。",
            "in": "所選擇的 {attribute} 選項無效。",
            "in_array": "{attribute} 沒有在 {other} 中。",
            "integer": "{attribute} 必須是一個整數。",
            "ip": "{attribute} 必須是一個有效的 IP 位址。",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "{attribute} 必須是正確的 JSON 字串。",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "{attribute} 不能大於 {max}。",
                "file": "{attribute} 不能大於 {max} kb。",
                "string": "{attribute} 不能多於 {max} 個字元。",
                "array": "{attribute} 最多有 {max} 個元素。"
            },
            "mimes": "{attribute} 必須為 {values} 的檔案。",
            "mimetypes": "{attribute} 必須為 {values} 的檔案。",
            "min": {
                "numeric": "{attribute} 不能小於 {min}。",
                "file": "{attribute} 不能小於 {min} kb。",
                "string": "{attribute} 不能小於 {min} 個字元。",
                "array": "{attribute} 至少有 {min} 個元素。"
            },
            "not_in": "所揀選的 {attribute} 選項無效。",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute} 必須為一個數字。",
            "present": "{attribute} 必須存在。",
            "regex": "{attribute} 的格式錯誤。",
            "required": "{attribute} 不能留空。",
            "required_if": "當 {other} 是 {value} 時 {attribute} 不能留空。",
            "required_unless": "當 {other} 不是 {value} 時 {attribute} 不能留空。",
            "required_with": "當 {values} 出現時 {attribute} 不能留空。",
            "required_with_all": "當 {values} 出現時 {attribute} 不能為空。",
            "required_without": "當 {values} 留空時 {attribute} field 不能留空。",
            "required_without_all": "當 {values} 都不出現時 {attribute} 不能留空。",
            "same": "{attribute} 與 {other} 必須相同。",
            "size": {
                "numeric": "{attribute} 的大小必須是 {size}。",
                "file": "{attribute} 的大小必須是 {size} kb。",
                "string": "{attribute} 必須是 {size} 個字元。",
                "array": "{attribute} 必須是 {size} 個元素。"
            },
            "string": "{attribute} 必須是一個字串。",
            "timezone": "{attribute} 必須是一個正確的時區值。",
            "unique": "{attribute} 已經存在。",
            "uploaded": "{attribute} 上傳失敗。",
            "url": "{attribute} 的格式錯誤。",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "backend": {
                    "access": {
                        "permissions": {
                            "associated_roles": "Associated Roles",
                            "dependencies": "Dependencies",
                            "display_name": "Display Name",
                            "group": "Group",
                            "group_sort": "Group Sort",
                            "groups": {
                                "name": "Group Name"
                            },
                            "name": "Name",
                            "system": "System?"
                        },
                        "roles": {
                            "associated_permissions": "Associated Permissions",
                            "name": "Name",
                            "sort": "Sort"
                        },
                        "users": {
                            "active": "Active",
                            "associated_roles": "Associated Roles",
                            "confirmed": "Confirmed",
                            "email": "E-mail Address",
                            "name": "Name",
                            "other_permissions": "Other Permissions",
                            "password": "Password",
                            "password_confirmation": "Password Confirmation",
                            "send_confirmation_email": "Send Confirmation E-mail"
                        }
                    }
                },
                "frontend": {
                    "email": "電子郵件",
                    "name": "用戶名",
                    "password": "密碼",
                    "password_confirmation": "密碼（確認）",
                    "phone": "Phone",
                    "message": "Message",
                    "old_password": "舊密碼",
                    "new_password": "新密碼",
                    "new_password_confirmation": "新密碼（確認）"
                }
            }
        },
        "exceptions": {
            "backend": {
                "access": {
                    "roles": {
                        "already_exists": "該角色已存在。請選擇其他名稱。 ",
                        "cant_delete_admin": "您無法刪除管理員角色。 ",
                        "create_error": "創建此角色時出現問題。請再試一次。 ",
                        "delete_error": "刪除此角色時出現問題。請再試一次。 ",
                        "has_users": "您無法刪除與關聯用戶的角色。 ",
                        "needs_permission": "您必須為此角色至少選擇一個權限。 ",
                        "not_found": "該角色不存在。 ",
                        "update_error": "更新此角色時出現問題。請再試一次。 "
                    },
                    "users": {
                        "already_confirmed": "This user is already confirmed.",
                        "cant_confirm": "There was a problem confirming the user account.",
                        "cant_deactivate_self": "你不能停用自己。 ",
                        "cant_delete_self": "你不能刪除自己。 ",
                        "cant_restore": "此用戶未刪除，因此無法恢復。 ",
                        "cant_unconfirm_admin": "You can not un-confirm the super administrator.",
                        "cant_unconfirm_self": "You can not un-confirm yourself.",
                        "create_error": "創建此用戶時出現問題。請再試一次。 ",
                        "delete_error": "刪除此用戶時出現問題。請再試一次。 ",
                        "delete_first": "此用戶必須先刪除，才能永久銷毀。 ",
                        "email_error": "該電子郵件地址已被其它用戶使用。 ",
                        "mark_error": "更新此用戶時出現問題。請再試一次。 ",
                        "not_confirmed": "This user is not confirmed.",
                        "not_found": "該用戶不存在。 ",
                        "restore_error": "還原此用戶時出現問題。請再試一次。 ",
                        "role_needed_create": "你必須選擇至少一個角色。 ",
                        "role_needed": "您必須至少選擇一個角色。 ",
                        "update_error": "更新此用戶時出現問題。請再試一次。 ",
                        "update_password_error": "更改此用戶密碼時出現問題。請再試一次。 "
                    }
                }
            },
            "frontend": {
                "auth": {
                    "confirmation": {
                        "already_confirmed": "您的帳戶已確認。 ",
                        "confirm": "確認您的帳戶！ ",
                        "created_confirm": "您的帳戶已成功創建。我們已向您發送電子郵件以確認您的帳戶。 ",
                        "created_pending": "Your account was successfully created and is pending approval. An e-mail will be sent when your account is approved.",
                        "mismatch": "您的確認碼不匹配。 ",
                        "not_found": "該確認碼不存在。 ",
                        "pending": "Your account is currently pending approval.",
                        "resend": "您的帳戶未確認。請點擊您的電子郵件中的確認鏈接，或<a href=\"{url}\">點擊此處</a> 重新發送確認電子郵件。 ",
                        "success": "您的帳戶已成功確認！ ",
                        "resent": "新的確認電子郵件已發送到文件上的地址。 "
                    },
                    "deactivated": "您的帳戶已被停用。 ",
                    "email_taken": "該電子郵件地址已被佔用。 ",
                    "password": {
                        "change_mismatch": "這不是你的舊密碼。 ",
                        "reset_problem": "There was a problem resetting your password. Please resend the password reset email."
                    },
                    "registration_disabled": "注册目前已关闭。"
                }
            }
        },
        "pagination": {
            "previous": "&laquo; 上一頁",
            "next": "下一頁 &raquo;"
        },
        "roles": {
            "administrator": "管理員",
            "user": "用戶"
        },
        "navs": {
            "general": {
                "home": "首頁",
                "logout": "退出"
            },
            "frontend": {
                "contact": "Contact",
                "dashboard": "儀表板",
                "login": "登錄",
                "macros": "宏",
                "register": "註冊",
                "user": {
                    "account": "我的帳戶",
                    "administration": "管理",
                    "change_password": "更改密碼",
                    "my_information": "我的信息",
                    "profile": "個人資料"
                }
            }
        }
    }
}
